/***************** PrimeUIX Tokens (Auto-Generated) *****************/
export interface TokenMetaData {
    description: string;
    tokens: {
        name: string;
        token: string;
        variable: string;
        description: string;
    }[];
}

export interface Tokens {
    accordion: TokenMetaData;
    autocomplete: TokenMetaData;
    avatar: TokenMetaData;
    badge: TokenMetaData;
    blockui: TokenMetaData;
    breadcrumb: TokenMetaData;
    button: TokenMetaData;
    card: TokenMetaData;
    carousel: TokenMetaData;
    cascadeselect: TokenMetaData;
    checkbox: TokenMetaData;
    chip: TokenMetaData;
    colorpicker: TokenMetaData;
    confirmdialog: TokenMetaData;
    confirmpopup: TokenMetaData;
    contextmenu: TokenMetaData;
    datatable: TokenMetaData;
    dataview: TokenMetaData;
    datepicker: TokenMetaData;
    dialog: TokenMetaData;
    divider: TokenMetaData;
    dock: TokenMetaData;
    drawer: TokenMetaData;
    editor: TokenMetaData;
    fieldset: TokenMetaData;
    fileupload: TokenMetaData;
    floatlabel: TokenMetaData;
    galleria: TokenMetaData;
    iconfield: TokenMetaData;
    iftalabel: TokenMetaData;
    image: TokenMetaData;
    imagecompare: TokenMetaData;
    themes: TokenMetaData;
    inlinemessage: TokenMetaData;
    inplace: TokenMetaData;
    inputchips: TokenMetaData;
    inputgroup: TokenMetaData;
    inputnumber: TokenMetaData;
    inputotp: TokenMetaData;
    inputtext: TokenMetaData;
    knob: TokenMetaData;
    listbox: TokenMetaData;
    megamenu: TokenMetaData;
    menu: TokenMetaData;
    menubar: TokenMetaData;
    message: TokenMetaData;
    metergroup: TokenMetaData;
    multiselect: TokenMetaData;
    orderlist: TokenMetaData;
    organizationchart: TokenMetaData;
    overlaybadge: TokenMetaData;
    paginator: TokenMetaData;
    panel: TokenMetaData;
    panelmenu: TokenMetaData;
    password: TokenMetaData;
    picklist: TokenMetaData;
    popover: TokenMetaData;
    progressbar: TokenMetaData;
    progressspinner: TokenMetaData;
    radiobutton: TokenMetaData;
    rating: TokenMetaData;
    ripple: TokenMetaData;
    scrollpanel: TokenMetaData;
    select: TokenMetaData;
    selectbutton: TokenMetaData;
    skeleton: TokenMetaData;
    slider: TokenMetaData;
    speeddial: TokenMetaData;
    splitbutton: TokenMetaData;
    splitter: TokenMetaData;
    stepper: TokenMetaData;
    steps: TokenMetaData;
    tabmenu: TokenMetaData;
    tabs: TokenMetaData;
    tabview: TokenMetaData;
    tag: TokenMetaData;
    terminal: TokenMetaData;
    textarea: TokenMetaData;
    tieredmenu: TokenMetaData;
    timeline: TokenMetaData;
    toast: TokenMetaData;
    togglebutton: TokenMetaData;
    toggleswitch: TokenMetaData;
    toolbar: TokenMetaData;
    tooltip: TokenMetaData;
    tree: TokenMetaData;
    treeselect: TokenMetaData;
    treetable: TokenMetaData;
    virtualscroller: TokenMetaData;
}

export default {
    accordion: {
        description: 'Accordion Design Tokens',
        tokens: [
            {
                name: 'accordion.root.transitionDuration',
                token: 'accordion.transition.duration',
                variable: '--p-accordion-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'accordion.panel.borderWidth',
                token: 'accordion.panel.border.width',
                variable: '--p-accordion-panel-border-width',
                description: 'Border width of panel'
            },
            {
                name: 'accordion.panel.borderColor',
                token: 'accordion.panel.border.color',
                variable: '--p-accordion-panel-border-color',
                description: 'Border color of panel'
            },
            {
                name: 'accordion.header.color',
                token: 'accordion.header.color',
                variable: '--p-accordion-header-color',
                description: 'Color of header'
            },
            {
                name: 'accordion.header.hoverColor',
                token: 'accordion.header.hover.color',
                variable: '--p-accordion-header-hover-color',
                description: 'Hover color of header'
            },
            {
                name: 'accordion.header.activeColor',
                token: 'accordion.header.active.color',
                variable: '--p-accordion-header-active-color',
                description: 'Active color of header'
            },
            {
                name: 'accordion.header.padding',
                token: 'accordion.header.padding',
                variable: '--p-accordion-header-padding',
                description: 'Padding of header'
            },
            {
                name: 'accordion.header.fontWeight',
                token: 'accordion.header.font.weight',
                variable: '--p-accordion-header-font-weight',
                description: 'Font weight of header'
            },
            {
                name: 'accordion.header.borderRadius',
                token: 'accordion.header.border.radius',
                variable: '--p-accordion-header-border-radius',
                description: 'Border radius of header'
            },
            {
                name: 'accordion.header.borderWidth',
                token: 'accordion.header.border.width',
                variable: '--p-accordion-header-border-width',
                description: 'Border width of header'
            },
            {
                name: 'accordion.header.borderColor',
                token: 'accordion.header.border.color',
                variable: '--p-accordion-header-border-color',
                description: 'Border color of header'
            },
            {
                name: 'accordion.header.background',
                token: 'accordion.header.background',
                variable: '--p-accordion-header-background',
                description: 'Background of header'
            },
            {
                name: 'accordion.header.hoverBackground',
                token: 'accordion.header.hover.background',
                variable: '--p-accordion-header-hover-background',
                description: 'Hover background of header'
            },
            {
                name: 'accordion.header.activeBackground',
                token: 'accordion.header.active.background',
                variable: '--p-accordion-header-active-background',
                description: 'Active background of header'
            },
            {
                name: 'accordion.header.activeHoverBackground',
                token: 'accordion.header.active.hover.background',
                variable: '--p-accordion-header-active-hover-background',
                description: 'Active hover background of header'
            },
            {
                name: 'accordion.header.focusRing.width',
                token: 'accordion.header.focus.ring.width',
                variable: '--p-accordion-header-focus-ring-width',
                description: 'Focus ring width of header'
            },
            {
                name: 'accordion.header.focusRing.style',
                token: 'accordion.header.focus.ring.style',
                variable: '--p-accordion-header-focus-ring-style',
                description: 'Focus ring style of header'
            },
            {
                name: 'accordion.header.focusRing.color',
                token: 'accordion.header.focus.ring.color',
                variable: '--p-accordion-header-focus-ring-color',
                description: 'Focus ring color of header'
            },
            {
                name: 'accordion.header.focusRing.offset',
                token: 'accordion.header.focus.ring.offset',
                variable: '--p-accordion-header-focus-ring-offset',
                description: 'Focus ring offset of header'
            },
            {
                name: 'accordion.header.focusRing.shadow',
                token: 'accordion.header.focus.ring.shadow',
                variable: '--p-accordion-header-focus-ring-shadow',
                description: 'Focus ring shadow of header'
            },
            {
                name: 'accordion.header.toggleIcon.color',
                token: 'accordion.header.toggle.icon.color',
                variable: '--p-accordion-header-toggle-icon-color',
                description: 'Toggle icon color of header'
            },
            {
                name: 'accordion.header.toggleIcon.hoverColor',
                token: 'accordion.header.toggle.icon.hover.color',
                variable: '--p-accordion-header-toggle-icon-hover-color',
                description: 'Toggle icon hover color of header'
            },
            {
                name: 'accordion.header.toggleIcon.activeColor',
                token: 'accordion.header.toggle.icon.active.color',
                variable: '--p-accordion-header-toggle-icon-active-color',
                description: 'Toggle icon active color of header'
            },
            {
                name: 'accordion.header.toggleIcon.activeHoverColor',
                token: 'accordion.header.toggle.icon.active.hover.color',
                variable: '--p-accordion-header-toggle-icon-active-hover-color',
                description: 'Toggle icon active hover color of header'
            },
            {
                name: 'accordion.header.first.topBorderRadius',
                token: 'accordion.header.first.top.border.radius',
                variable: '--p-accordion-header-first-top-border-radius',
                description: 'First top border radius of header'
            },
            {
                name: 'accordion.header.first.borderWidth',
                token: 'accordion.header.first.border.width',
                variable: '--p-accordion-header-first-border-width',
                description: 'First border width of header'
            },
            {
                name: 'accordion.header.last.bottomBorderRadius',
                token: 'accordion.header.last.bottom.border.radius',
                variable: '--p-accordion-header-last-bottom-border-radius',
                description: 'Last bottom border radius of header'
            },
            {
                name: 'accordion.header.last.activeBottomBorderRadius',
                token: 'accordion.header.last.active.bottom.border.radius',
                variable: '--p-accordion-header-last-active-bottom-border-radius',
                description: 'Last active bottom border radius of header'
            },
            {
                name: 'accordion.content.borderWidth',
                token: 'accordion.content.border.width',
                variable: '--p-accordion-content-border-width',
                description: 'Border width of content'
            },
            {
                name: 'accordion.content.borderColor',
                token: 'accordion.content.border.color',
                variable: '--p-accordion-content-border-color',
                description: 'Border color of content'
            },
            {
                name: 'accordion.content.background',
                token: 'accordion.content.background',
                variable: '--p-accordion-content-background',
                description: 'Background of content'
            },
            {
                name: 'accordion.content.color',
                token: 'accordion.content.color',
                variable: '--p-accordion-content-color',
                description: 'Color of content'
            },
            {
                name: 'accordion.content.padding',
                token: 'accordion.content.padding',
                variable: '--p-accordion-content-padding',
                description: 'Padding of content'
            }
        ]
    },
    autocomplete: {
        description: 'AutoComplete Design Tokens',
        tokens: [
            {
                name: 'autocomplete.root.background',
                token: 'autocomplete.background',
                variable: '--p-autocomplete-background',
                description: 'Background of root'
            },
            {
                name: 'autocomplete.root.disabledBackground',
                token: 'autocomplete.disabled.background',
                variable: '--p-autocomplete-disabled-background',
                description: 'Disabled background of root'
            },
            {
                name: 'autocomplete.root.filledBackground',
                token: 'autocomplete.filled.background',
                variable: '--p-autocomplete-filled-background',
                description: 'Filled background of root'
            },
            {
                name: 'autocomplete.root.filledHoverBackground',
                token: 'autocomplete.filled.hover.background',
                variable: '--p-autocomplete-filled-hover-background',
                description: 'Filled hover background of root'
            },
            {
                name: 'autocomplete.root.filledFocusBackground',
                token: 'autocomplete.filled.focus.background',
                variable: '--p-autocomplete-filled-focus-background',
                description: 'Filled focus background of root'
            },
            {
                name: 'autocomplete.root.borderColor',
                token: 'autocomplete.border.color',
                variable: '--p-autocomplete-border-color',
                description: 'Border color of root'
            },
            {
                name: 'autocomplete.root.hoverBorderColor',
                token: 'autocomplete.hover.border.color',
                variable: '--p-autocomplete-hover-border-color',
                description: 'Hover border color of root'
            },
            {
                name: 'autocomplete.root.focusBorderColor',
                token: 'autocomplete.focus.border.color',
                variable: '--p-autocomplete-focus-border-color',
                description: 'Focus border color of root'
            },
            {
                name: 'autocomplete.root.invalidBorderColor',
                token: 'autocomplete.invalid.border.color',
                variable: '--p-autocomplete-invalid-border-color',
                description: 'Invalid border color of root'
            },
            {
                name: 'autocomplete.root.color',
                token: 'autocomplete.color',
                variable: '--p-autocomplete-color',
                description: 'Color of root'
            },
            {
                name: 'autocomplete.root.disabledColor',
                token: 'autocomplete.disabled.color',
                variable: '--p-autocomplete-disabled-color',
                description: 'Disabled color of root'
            },
            {
                name: 'autocomplete.root.placeholderColor',
                token: 'autocomplete.placeholder.color',
                variable: '--p-autocomplete-placeholder-color',
                description: 'Placeholder color of root'
            },
            {
                name: 'autocomplete.root.invalidPlaceholderColor',
                token: 'autocomplete.invalid.placeholder.color',
                variable: '--p-autocomplete-invalid-placeholder-color',
                description: 'Invalid placeholder color of root'
            },
            {
                name: 'autocomplete.root.shadow',
                token: 'autocomplete.shadow',
                variable: '--p-autocomplete-shadow',
                description: 'Shadow of root'
            },
            {
                name: 'autocomplete.root.paddingX',
                token: 'autocomplete.padding.x',
                variable: '--p-autocomplete-padding-x',
                description: 'Padding x of root'
            },
            {
                name: 'autocomplete.root.paddingY',
                token: 'autocomplete.padding.y',
                variable: '--p-autocomplete-padding-y',
                description: 'Padding y of root'
            },
            {
                name: 'autocomplete.root.borderRadius',
                token: 'autocomplete.border.radius',
                variable: '--p-autocomplete-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'autocomplete.root.focusRing.width',
                token: 'autocomplete.focus.ring.width',
                variable: '--p-autocomplete-focus-ring-width',
                description: 'Focus ring width of root'
            },
            {
                name: 'autocomplete.root.focusRing.style',
                token: 'autocomplete.focus.ring.style',
                variable: '--p-autocomplete-focus-ring-style',
                description: 'Focus ring style of root'
            },
            {
                name: 'autocomplete.root.focusRing.color',
                token: 'autocomplete.focus.ring.color',
                variable: '--p-autocomplete-focus-ring-color',
                description: 'Focus ring color of root'
            },
            {
                name: 'autocomplete.root.focusRing.offset',
                token: 'autocomplete.focus.ring.offset',
                variable: '--p-autocomplete-focus-ring-offset',
                description: 'Focus ring offset of root'
            },
            {
                name: 'autocomplete.root.focusRing.shadow',
                token: 'autocomplete.focus.ring.shadow',
                variable: '--p-autocomplete-focus-ring-shadow',
                description: 'Focus ring shadow of root'
            },
            {
                name: 'autocomplete.root.transitionDuration',
                token: 'autocomplete.transition.duration',
                variable: '--p-autocomplete-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'autocomplete.overlay.background',
                token: 'autocomplete.overlay.background',
                variable: '--p-autocomplete-overlay-background',
                description: 'Background of overlay'
            },
            {
                name: 'autocomplete.overlay.borderColor',
                token: 'autocomplete.overlay.border.color',
                variable: '--p-autocomplete-overlay-border-color',
                description: 'Border color of overlay'
            },
            {
                name: 'autocomplete.overlay.borderRadius',
                token: 'autocomplete.overlay.border.radius',
                variable: '--p-autocomplete-overlay-border-radius',
                description: 'Border radius of overlay'
            },
            {
                name: 'autocomplete.overlay.color',
                token: 'autocomplete.overlay.color',
                variable: '--p-autocomplete-overlay-color',
                description: 'Color of overlay'
            },
            {
                name: 'autocomplete.overlay.shadow',
                token: 'autocomplete.overlay.shadow',
                variable: '--p-autocomplete-overlay-shadow',
                description: 'Shadow of overlay'
            },
            {
                name: 'autocomplete.list.padding',
                token: 'autocomplete.list.padding',
                variable: '--p-autocomplete-list-padding',
                description: 'Padding of list'
            },
            {
                name: 'autocomplete.list.gap',
                token: 'autocomplete.list.gap',
                variable: '--p-autocomplete-list-gap',
                description: 'Gap of list'
            },
            {
                name: 'autocomplete.option.focusBackground',
                token: 'autocomplete.option.focus.background',
                variable: '--p-autocomplete-option-focus-background',
                description: 'Focus background of option'
            },
            {
                name: 'autocomplete.option.selectedBackground',
                token: 'autocomplete.option.selected.background',
                variable: '--p-autocomplete-option-selected-background',
                description: 'Selected background of option'
            },
            {
                name: 'autocomplete.option.selectedFocusBackground',
                token: 'autocomplete.option.selected.focus.background',
                variable: '--p-autocomplete-option-selected-focus-background',
                description: 'Selected focus background of option'
            },
            {
                name: 'autocomplete.option.color',
                token: 'autocomplete.option.color',
                variable: '--p-autocomplete-option-color',
                description: 'Color of option'
            },
            {
                name: 'autocomplete.option.focusColor',
                token: 'autocomplete.option.focus.color',
                variable: '--p-autocomplete-option-focus-color',
                description: 'Focus color of option'
            },
            {
                name: 'autocomplete.option.selectedColor',
                token: 'autocomplete.option.selected.color',
                variable: '--p-autocomplete-option-selected-color',
                description: 'Selected color of option'
            },
            {
                name: 'autocomplete.option.selectedFocusColor',
                token: 'autocomplete.option.selected.focus.color',
                variable: '--p-autocomplete-option-selected-focus-color',
                description: 'Selected focus color of option'
            },
            {
                name: 'autocomplete.option.padding',
                token: 'autocomplete.option.padding',
                variable: '--p-autocomplete-option-padding',
                description: 'Padding of option'
            },
            {
                name: 'autocomplete.option.borderRadius',
                token: 'autocomplete.option.border.radius',
                variable: '--p-autocomplete-option-border-radius',
                description: 'Border radius of option'
            },
            {
                name: 'autocomplete.optionGroup.background',
                token: 'autocomplete.option.group.background',
                variable: '--p-autocomplete-option-group-background',
                description: 'Background of option group'
            },
            {
                name: 'autocomplete.optionGroup.color',
                token: 'autocomplete.option.group.color',
                variable: '--p-autocomplete-option-group-color',
                description: 'Color of option group'
            },
            {
                name: 'autocomplete.optionGroup.fontWeight',
                token: 'autocomplete.option.group.font.weight',
                variable: '--p-autocomplete-option-group-font-weight',
                description: 'Font weight of option group'
            },
            {
                name: 'autocomplete.optionGroup.padding',
                token: 'autocomplete.option.group.padding',
                variable: '--p-autocomplete-option-group-padding',
                description: 'Padding of option group'
            },
            {
                name: 'autocomplete.dropdown.width',
                token: 'autocomplete.dropdown.width',
                variable: '--p-autocomplete-dropdown-width',
                description: 'Width of dropdown'
            },
            {
                name: 'autocomplete.dropdown.sm.width',
                token: 'autocomplete.dropdown.sm.width',
                variable: '--p-autocomplete-dropdown-sm-width',
                description: 'Sm width of dropdown'
            },
            {
                name: 'autocomplete.dropdown.lg.width',
                token: 'autocomplete.dropdown.lg.width',
                variable: '--p-autocomplete-dropdown-lg-width',
                description: 'Lg width of dropdown'
            },
            {
                name: 'autocomplete.dropdown.borderColor',
                token: 'autocomplete.dropdown.border.color',
                variable: '--p-autocomplete-dropdown-border-color',
                description: 'Border color of dropdown'
            },
            {
                name: 'autocomplete.dropdown.hoverBorderColor',
                token: 'autocomplete.dropdown.hover.border.color',
                variable: '--p-autocomplete-dropdown-hover-border-color',
                description: 'Hover border color of dropdown'
            },
            {
                name: 'autocomplete.dropdown.activeBorderColor',
                token: 'autocomplete.dropdown.active.border.color',
                variable: '--p-autocomplete-dropdown-active-border-color',
                description: 'Active border color of dropdown'
            },
            {
                name: 'autocomplete.dropdown.borderRadius',
                token: 'autocomplete.dropdown.border.radius',
                variable: '--p-autocomplete-dropdown-border-radius',
                description: 'Border radius of dropdown'
            },
            {
                name: 'autocomplete.dropdown.focusRing.width',
                token: 'autocomplete.dropdown.focus.ring.width',
                variable: '--p-autocomplete-dropdown-focus-ring-width',
                description: 'Focus ring width of dropdown'
            },
            {
                name: 'autocomplete.dropdown.focusRing.style',
                token: 'autocomplete.dropdown.focus.ring.style',
                variable: '--p-autocomplete-dropdown-focus-ring-style',
                description: 'Focus ring style of dropdown'
            },
            {
                name: 'autocomplete.dropdown.focusRing.color',
                token: 'autocomplete.dropdown.focus.ring.color',
                variable: '--p-autocomplete-dropdown-focus-ring-color',
                description: 'Focus ring color of dropdown'
            },
            {
                name: 'autocomplete.dropdown.focusRing.offset',
                token: 'autocomplete.dropdown.focus.ring.offset',
                variable: '--p-autocomplete-dropdown-focus-ring-offset',
                description: 'Focus ring offset of dropdown'
            },
            {
                name: 'autocomplete.dropdown.focusRing.shadow',
                token: 'autocomplete.dropdown.focus.ring.shadow',
                variable: '--p-autocomplete-dropdown-focus-ring-shadow',
                description: 'Focus ring shadow of dropdown'
            },
            {
                name: 'autocomplete.dropdown.background',
                token: 'autocomplete.dropdown.background',
                variable: '--p-autocomplete-dropdown-background',
                description: 'Background of dropdown'
            },
            {
                name: 'autocomplete.dropdown.hoverBackground',
                token: 'autocomplete.dropdown.hover.background',
                variable: '--p-autocomplete-dropdown-hover-background',
                description: 'Hover background of dropdown'
            },
            {
                name: 'autocomplete.dropdown.activeBackground',
                token: 'autocomplete.dropdown.active.background',
                variable: '--p-autocomplete-dropdown-active-background',
                description: 'Active background of dropdown'
            },
            {
                name: 'autocomplete.dropdown.color',
                token: 'autocomplete.dropdown.color',
                variable: '--p-autocomplete-dropdown-color',
                description: 'Color of dropdown'
            },
            {
                name: 'autocomplete.dropdown.hoverColor',
                token: 'autocomplete.dropdown.hover.color',
                variable: '--p-autocomplete-dropdown-hover-color',
                description: 'Hover color of dropdown'
            },
            {
                name: 'autocomplete.dropdown.activeColor',
                token: 'autocomplete.dropdown.active.color',
                variable: '--p-autocomplete-dropdown-active-color',
                description: 'Active color of dropdown'
            },
            {
                name: 'autocomplete.chip.borderRadius',
                token: 'autocomplete.chip.border.radius',
                variable: '--p-autocomplete-chip-border-radius',
                description: 'Border radius of chip'
            },
            {
                name: 'autocomplete.chip.focusBackground',
                token: 'autocomplete.chip.focus.background',
                variable: '--p-autocomplete-chip-focus-background',
                description: 'Focus background of chip'
            },
            {
                name: 'autocomplete.chip.focusColor',
                token: 'autocomplete.chip.focus.color',
                variable: '--p-autocomplete-chip-focus-color',
                description: 'Focus color of chip'
            },
            {
                name: 'autocomplete.emptyMessage.padding',
                token: 'autocomplete.empty.message.padding',
                variable: '--p-autocomplete-empty-message-padding',
                description: 'Padding of empty message'
            }
        ]
    },
    avatar: {
        description: 'Avatar Design Tokens',
        tokens: [
            {
                name: 'avatar.root.width',
                token: 'avatar.width',
                variable: '--p-avatar-width',
                description: 'Width of root'
            },
            {
                name: 'avatar.root.height',
                token: 'avatar.height',
                variable: '--p-avatar-height',
                description: 'Height of root'
            },
            {
                name: 'avatar.root.fontSize',
                token: 'avatar.font.size',
                variable: '--p-avatar-font-size',
                description: 'Font size of root'
            },
            {
                name: 'avatar.root.background',
                token: 'avatar.background',
                variable: '--p-avatar-background',
                description: 'Background of root'
            },
            {
                name: 'avatar.root.color',
                token: 'avatar.color',
                variable: '--p-avatar-color',
                description: 'Color of root'
            },
            {
                name: 'avatar.root.borderRadius',
                token: 'avatar.border.radius',
                variable: '--p-avatar-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'avatar.icon.size',
                token: 'avatar.icon.size',
                variable: '--p-avatar-icon-size',
                description: 'Size of icon'
            },
            {
                name: 'avatar.group.borderColor',
                token: 'avatar.group.border.color',
                variable: '--p-avatar-group-border-color',
                description: 'Border color of group'
            },
            {
                name: 'avatar.group.offset',
                token: 'avatar.group.offset',
                variable: '--p-avatar-group-offset',
                description: 'Offset of group'
            },
            {
                name: 'avatar.lg.width',
                token: 'avatar.lg.width',
                variable: '--p-avatar-lg-width',
                description: 'Width of lg'
            },
            {
                name: 'avatar.lg.height',
                token: 'avatar.lg.height',
                variable: '--p-avatar-lg-height',
                description: 'Height of lg'
            },
            {
                name: 'avatar.lg.fontSize',
                token: 'avatar.lg.font.size',
                variable: '--p-avatar-lg-font-size',
                description: 'Font size of lg'
            },
            {
                name: 'avatar.lg.icon.size',
                token: 'avatar.lg.icon.size',
                variable: '--p-avatar-lg-icon-size',
                description: 'Icon size of lg'
            },
            {
                name: 'avatar.lg.group.offset',
                token: 'avatar.lg.group.offset',
                variable: '--p-avatar-lg-group-offset',
                description: 'Group offset of lg'
            },
            {
                name: 'avatar.xl.width',
                token: 'avatar.xl.width',
                variable: '--p-avatar-xl-width',
                description: 'Width of xl'
            },
            {
                name: 'avatar.xl.height',
                token: 'avatar.xl.height',
                variable: '--p-avatar-xl-height',
                description: 'Height of xl'
            },
            {
                name: 'avatar.xl.fontSize',
                token: 'avatar.xl.font.size',
                variable: '--p-avatar-xl-font-size',
                description: 'Font size of xl'
            },
            {
                name: 'avatar.xl.icon.size',
                token: 'avatar.xl.icon.size',
                variable: '--p-avatar-xl-icon-size',
                description: 'Icon size of xl'
            },
            {
                name: 'avatar.xl.group.offset',
                token: 'avatar.xl.group.offset',
                variable: '--p-avatar-xl-group-offset',
                description: 'Group offset of xl'
            }
        ]
    },
    badge: {
        description: 'Badge Design Tokens',
        tokens: [
            {
                name: 'badge.root.borderRadius',
                token: 'badge.border.radius',
                variable: '--p-badge-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'badge.root.padding',
                token: 'badge.padding',
                variable: '--p-badge-padding',
                description: 'Padding of root'
            },
            {
                name: 'badge.root.fontSize',
                token: 'badge.font.size',
                variable: '--p-badge-font-size',
                description: 'Font size of root'
            },
            {
                name: 'badge.root.fontWeight',
                token: 'badge.font.weight',
                variable: '--p-badge-font-weight',
                description: 'Font weight of root'
            },
            {
                name: 'badge.root.minWidth',
                token: 'badge.min.width',
                variable: '--p-badge-min-width',
                description: 'Min width of root'
            },
            {
                name: 'badge.root.height',
                token: 'badge.height',
                variable: '--p-badge-height',
                description: 'Height of root'
            },
            {
                name: 'badge.dot.size',
                token: 'badge.dot.size',
                variable: '--p-badge-dot-size',
                description: 'Size of dot'
            },
            {
                name: 'badge.sm.fontSize',
                token: 'badge.sm.font.size',
                variable: '--p-badge-sm-font-size',
                description: 'Font size of sm'
            },
            {
                name: 'badge.sm.minWidth',
                token: 'badge.sm.min.width',
                variable: '--p-badge-sm-min-width',
                description: 'Min width of sm'
            },
            {
                name: 'badge.sm.height',
                token: 'badge.sm.height',
                variable: '--p-badge-sm-height',
                description: 'Height of sm'
            },
            {
                name: 'badge.lg.fontSize',
                token: 'badge.lg.font.size',
                variable: '--p-badge-lg-font-size',
                description: 'Font size of lg'
            },
            {
                name: 'badge.lg.minWidth',
                token: 'badge.lg.min.width',
                variable: '--p-badge-lg-min-width',
                description: 'Min width of lg'
            },
            {
                name: 'badge.lg.height',
                token: 'badge.lg.height',
                variable: '--p-badge-lg-height',
                description: 'Height of lg'
            },
            {
                name: 'badge.xl.fontSize',
                token: 'badge.xl.font.size',
                variable: '--p-badge-xl-font-size',
                description: 'Font size of xl'
            },
            {
                name: 'badge.xl.minWidth',
                token: 'badge.xl.min.width',
                variable: '--p-badge-xl-min-width',
                description: 'Min width of xl'
            },
            {
                name: 'badge.xl.height',
                token: 'badge.xl.height',
                variable: '--p-badge-xl-height',
                description: 'Height of xl'
            },
            {
                name: 'badge.primary.background',
                token: 'badge.primary.background',
                variable: '--p-badge-primary-background',
                description: 'Background of primary'
            },
            {
                name: 'badge.primary.color',
                token: 'badge.primary.color',
                variable: '--p-badge-primary-color',
                description: 'Color of primary'
            },
            {
                name: 'badge.secondary.background',
                token: 'badge.secondary.background',
                variable: '--p-badge-secondary-background',
                description: 'Background of secondary'
            },
            {
                name: 'badge.secondary.color',
                token: 'badge.secondary.color',
                variable: '--p-badge-secondary-color',
                description: 'Color of secondary'
            },
            {
                name: 'badge.success.background',
                token: 'badge.success.background',
                variable: '--p-badge-success-background',
                description: 'Background of success'
            },
            {
                name: 'badge.success.color',
                token: 'badge.success.color',
                variable: '--p-badge-success-color',
                description: 'Color of success'
            },
            {
                name: 'badge.info.background',
                token: 'badge.info.background',
                variable: '--p-badge-info-background',
                description: 'Background of info'
            },
            {
                name: 'badge.info.color',
                token: 'badge.info.color',
                variable: '--p-badge-info-color',
                description: 'Color of info'
            },
            {
                name: 'badge.warn.background',
                token: 'badge.warn.background',
                variable: '--p-badge-warn-background',
                description: 'Background of warn'
            },
            {
                name: 'badge.warn.color',
                token: 'badge.warn.color',
                variable: '--p-badge-warn-color',
                description: 'Color of warn'
            },
            {
                name: 'badge.danger.background',
                token: 'badge.danger.background',
                variable: '--p-badge-danger-background',
                description: 'Background of danger'
            },
            {
                name: 'badge.danger.color',
                token: 'badge.danger.color',
                variable: '--p-badge-danger-color',
                description: 'Color of danger'
            },
            {
                name: 'badge.contrast.background',
                token: 'badge.contrast.background',
                variable: '--p-badge-contrast-background',
                description: 'Background of contrast'
            },
            {
                name: 'badge.contrast.color',
                token: 'badge.contrast.color',
                variable: '--p-badge-contrast-color',
                description: 'Color of contrast'
            }
        ]
    },
    blockui: {
        description: 'BlockUI Design Tokens',
        tokens: [
            {
                name: 'blockui.root.borderRadius',
                token: 'blockui.border.radius',
                variable: '--p-blockui-border-radius',
                description: 'Border radius of root'
            }
        ]
    },
    breadcrumb: {
        description: 'Breadcrumb Design Tokens',
        tokens: [
            {
                name: 'breadcrumb.root.padding',
                token: 'breadcrumb.padding',
                variable: '--p-breadcrumb-padding',
                description: 'Padding of root'
            },
            {
                name: 'breadcrumb.root.background',
                token: 'breadcrumb.background',
                variable: '--p-breadcrumb-background',
                description: 'Background of root'
            },
            {
                name: 'breadcrumb.root.gap',
                token: 'breadcrumb.gap',
                variable: '--p-breadcrumb-gap',
                description: 'Gap of root'
            },
            {
                name: 'breadcrumb.root.transitionDuration',
                token: 'breadcrumb.transition.duration',
                variable: '--p-breadcrumb-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'breadcrumb.item.color',
                token: 'breadcrumb.item.color',
                variable: '--p-breadcrumb-item-color',
                description: 'Color of item'
            },
            {
                name: 'breadcrumb.item.hoverColor',
                token: 'breadcrumb.item.hover.color',
                variable: '--p-breadcrumb-item-hover-color',
                description: 'Hover color of item'
            },
            {
                name: 'breadcrumb.item.borderRadius',
                token: 'breadcrumb.item.border.radius',
                variable: '--p-breadcrumb-item-border-radius',
                description: 'Border radius of item'
            },
            {
                name: 'breadcrumb.item.gap',
                token: 'breadcrumb.item.gap',
                variable: '--p-breadcrumb-item-gap',
                description: 'Gap of item'
            },
            {
                name: 'breadcrumb.item.icon.color',
                token: 'breadcrumb.item.icon.color',
                variable: '--p-breadcrumb-item-icon-color',
                description: 'Icon color of item'
            },
            {
                name: 'breadcrumb.item.icon.hoverColor',
                token: 'breadcrumb.item.icon.hover.color',
                variable: '--p-breadcrumb-item-icon-hover-color',
                description: 'Icon hover color of item'
            },
            {
                name: 'breadcrumb.item.focusRing.width',
                token: 'breadcrumb.item.focus.ring.width',
                variable: '--p-breadcrumb-item-focus-ring-width',
                description: 'Focus ring width of item'
            },
            {
                name: 'breadcrumb.item.focusRing.style',
                token: 'breadcrumb.item.focus.ring.style',
                variable: '--p-breadcrumb-item-focus-ring-style',
                description: 'Focus ring style of item'
            },
            {
                name: 'breadcrumb.item.focusRing.color',
                token: 'breadcrumb.item.focus.ring.color',
                variable: '--p-breadcrumb-item-focus-ring-color',
                description: 'Focus ring color of item'
            },
            {
                name: 'breadcrumb.item.focusRing.offset',
                token: 'breadcrumb.item.focus.ring.offset',
                variable: '--p-breadcrumb-item-focus-ring-offset',
                description: 'Focus ring offset of item'
            },
            {
                name: 'breadcrumb.item.focusRing.shadow',
                token: 'breadcrumb.item.focus.ring.shadow',
                variable: '--p-breadcrumb-item-focus-ring-shadow',
                description: 'Focus ring shadow of item'
            },
            {
                name: 'breadcrumb.separator.color',
                token: 'breadcrumb.separator.color',
                variable: '--p-breadcrumb-separator-color',
                description: 'Color of separator'
            }
        ]
    },
    button: {
        description: 'Button Design Tokens',
        tokens: [
            {
                name: 'button.root.borderRadius',
                token: 'button.border.radius',
                variable: '--p-button-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'button.root.roundedBorderRadius',
                token: 'button.rounded.border.radius',
                variable: '--p-button-rounded-border-radius',
                description: 'Rounded border radius of root'
            },
            {
                name: 'button.root.gap',
                token: 'button.gap',
                variable: '--p-button-gap',
                description: 'Gap of root'
            },
            {
                name: 'button.root.paddingX',
                token: 'button.padding.x',
                variable: '--p-button-padding-x',
                description: 'Padding x of root'
            },
            {
                name: 'button.root.paddingY',
                token: 'button.padding.y',
                variable: '--p-button-padding-y',
                description: 'Padding y of root'
            },
            {
                name: 'button.root.iconOnlyWidth',
                token: 'button.icon.only.width',
                variable: '--p-button-icon-only-width',
                description: 'Icon only width of root'
            },
            {
                name: 'button.root.sm.fontSize',
                token: 'button.sm.font.size',
                variable: '--p-button-sm-font-size',
                description: 'Sm font size of root'
            },
            {
                name: 'button.root.sm.paddingX',
                token: 'button.sm.padding.x',
                variable: '--p-button-sm-padding-x',
                description: 'Sm padding x of root'
            },
            {
                name: 'button.root.sm.paddingY',
                token: 'button.sm.padding.y',
                variable: '--p-button-sm-padding-y',
                description: 'Sm padding y of root'
            },
            {
                name: 'button.root.sm.iconOnlyWidth',
                token: 'button.sm.icon.only.width',
                variable: '--p-button-sm-icon-only-width',
                description: 'Sm icon only width of root'
            },
            {
                name: 'button.root.lg.fontSize',
                token: 'button.lg.font.size',
                variable: '--p-button-lg-font-size',
                description: 'Lg font size of root'
            },
            {
                name: 'button.root.lg.paddingX',
                token: 'button.lg.padding.x',
                variable: '--p-button-lg-padding-x',
                description: 'Lg padding x of root'
            },
            {
                name: 'button.root.lg.paddingY',
                token: 'button.lg.padding.y',
                variable: '--p-button-lg-padding-y',
                description: 'Lg padding y of root'
            },
            {
                name: 'button.root.lg.iconOnlyWidth',
                token: 'button.lg.icon.only.width',
                variable: '--p-button-lg-icon-only-width',
                description: 'Lg icon only width of root'
            },
            {
                name: 'button.root.label.fontWeight',
                token: 'button.label.font.weight',
                variable: '--p-button-label-font-weight',
                description: 'Label font weight of root'
            },
            {
                name: 'button.root.raisedShadow',
                token: 'button.raised.shadow',
                variable: '--p-button-raised-shadow',
                description: 'Raised shadow of root'
            },
            {
                name: 'button.root.focusRing.width',
                token: 'button.focus.ring.width',
                variable: '--p-button-focus-ring-width',
                description: 'Focus ring width of root'
            },
            {
                name: 'button.root.focusRing.style',
                token: 'button.focus.ring.style',
                variable: '--p-button-focus-ring-style',
                description: 'Focus ring style of root'
            },
            {
                name: 'button.root.focusRing.offset',
                token: 'button.focus.ring.offset',
                variable: '--p-button-focus-ring-offset',
                description: 'Focus ring offset of root'
            },
            {
                name: 'button.root.badgeSize',
                token: 'button.badge.size',
                variable: '--p-button-badge-size',
                description: 'Badge size of root'
            },
            {
                name: 'button.root.transitionDuration',
                token: 'button.transition.duration',
                variable: '--p-button-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'button.root.primary.background',
                token: 'button.primary.background',
                variable: '--p-button-primary-background',
                description: 'Primary background of root'
            },
            {
                name: 'button.root.primary.hoverBackground',
                token: 'button.primary.hover.background',
                variable: '--p-button-primary-hover-background',
                description: 'Primary hover background of root'
            },
            {
                name: 'button.root.primary.activeBackground',
                token: 'button.primary.active.background',
                variable: '--p-button-primary-active-background',
                description: 'Primary active background of root'
            },
            {
                name: 'button.root.primary.borderColor',
                token: 'button.primary.border.color',
                variable: '--p-button-primary-border-color',
                description: 'Primary border color of root'
            },
            {
                name: 'button.root.primary.hoverBorderColor',
                token: 'button.primary.hover.border.color',
                variable: '--p-button-primary-hover-border-color',
                description: 'Primary hover border color of root'
            },
            {
                name: 'button.root.primary.activeBorderColor',
                token: 'button.primary.active.border.color',
                variable: '--p-button-primary-active-border-color',
                description: 'Primary active border color of root'
            },
            {
                name: 'button.root.primary.color',
                token: 'button.primary.color',
                variable: '--p-button-primary-color',
                description: 'Primary color of root'
            },
            {
                name: 'button.root.primary.hoverColor',
                token: 'button.primary.hover.color',
                variable: '--p-button-primary-hover-color',
                description: 'Primary hover color of root'
            },
            {
                name: 'button.root.primary.activeColor',
                token: 'button.primary.active.color',
                variable: '--p-button-primary-active-color',
                description: 'Primary active color of root'
            },
            {
                name: 'button.root.primary.focusRing.color',
                token: 'button.primary.focus.ring.color',
                variable: '--p-button-primary-focus-ring-color',
                description: 'Primary focus ring color of root'
            },
            {
                name: 'button.root.primary.focusRing.shadow',
                token: 'button.primary.focus.ring.shadow',
                variable: '--p-button-primary-focus-ring-shadow',
                description: 'Primary focus ring shadow of root'
            },
            {
                name: 'button.root.secondary.background',
                token: 'button.secondary.background',
                variable: '--p-button-secondary-background',
                description: 'Secondary background of root'
            },
            {
                name: 'button.root.secondary.hoverBackground',
                token: 'button.secondary.hover.background',
                variable: '--p-button-secondary-hover-background',
                description: 'Secondary hover background of root'
            },
            {
                name: 'button.root.secondary.activeBackground',
                token: 'button.secondary.active.background',
                variable: '--p-button-secondary-active-background',
                description: 'Secondary active background of root'
            },
            {
                name: 'button.root.secondary.borderColor',
                token: 'button.secondary.border.color',
                variable: '--p-button-secondary-border-color',
                description: 'Secondary border color of root'
            },
            {
                name: 'button.root.secondary.hoverBorderColor',
                token: 'button.secondary.hover.border.color',
                variable: '--p-button-secondary-hover-border-color',
                description: 'Secondary hover border color of root'
            },
            {
                name: 'button.root.secondary.activeBorderColor',
                token: 'button.secondary.active.border.color',
                variable: '--p-button-secondary-active-border-color',
                description: 'Secondary active border color of root'
            },
            {
                name: 'button.root.secondary.color',
                token: 'button.secondary.color',
                variable: '--p-button-secondary-color',
                description: 'Secondary color of root'
            },
            {
                name: 'button.root.secondary.hoverColor',
                token: 'button.secondary.hover.color',
                variable: '--p-button-secondary-hover-color',
                description: 'Secondary hover color of root'
            },
            {
                name: 'button.root.secondary.activeColor',
                token: 'button.secondary.active.color',
                variable: '--p-button-secondary-active-color',
                description: 'Secondary active color of root'
            },
            {
                name: 'button.root.secondary.focusRing.color',
                token: 'button.secondary.focus.ring.color',
                variable: '--p-button-secondary-focus-ring-color',
                description: 'Secondary focus ring color of root'
            },
            {
                name: 'button.root.secondary.focusRing.shadow',
                token: 'button.secondary.focus.ring.shadow',
                variable: '--p-button-secondary-focus-ring-shadow',
                description: 'Secondary focus ring shadow of root'
            },
            {
                name: 'button.root.info.background',
                token: 'button.info.background',
                variable: '--p-button-info-background',
                description: 'Info background of root'
            },
            {
                name: 'button.root.info.hoverBackground',
                token: 'button.info.hover.background',
                variable: '--p-button-info-hover-background',
                description: 'Info hover background of root'
            },
            {
                name: 'button.root.info.activeBackground',
                token: 'button.info.active.background',
                variable: '--p-button-info-active-background',
                description: 'Info active background of root'
            },
            {
                name: 'button.root.info.borderColor',
                token: 'button.info.border.color',
                variable: '--p-button-info-border-color',
                description: 'Info border color of root'
            },
            {
                name: 'button.root.info.hoverBorderColor',
                token: 'button.info.hover.border.color',
                variable: '--p-button-info-hover-border-color',
                description: 'Info hover border color of root'
            },
            {
                name: 'button.root.info.activeBorderColor',
                token: 'button.info.active.border.color',
                variable: '--p-button-info-active-border-color',
                description: 'Info active border color of root'
            },
            {
                name: 'button.root.info.color',
                token: 'button.info.color',
                variable: '--p-button-info-color',
                description: 'Info color of root'
            },
            {
                name: 'button.root.info.hoverColor',
                token: 'button.info.hover.color',
                variable: '--p-button-info-hover-color',
                description: 'Info hover color of root'
            },
            {
                name: 'button.root.info.activeColor',
                token: 'button.info.active.color',
                variable: '--p-button-info-active-color',
                description: 'Info active color of root'
            },
            {
                name: 'button.root.info.focusRing.color',
                token: 'button.info.focus.ring.color',
                variable: '--p-button-info-focus-ring-color',
                description: 'Info focus ring color of root'
            },
            {
                name: 'button.root.info.focusRing.shadow',
                token: 'button.info.focus.ring.shadow',
                variable: '--p-button-info-focus-ring-shadow',
                description: 'Info focus ring shadow of root'
            },
            {
                name: 'button.root.success.background',
                token: 'button.success.background',
                variable: '--p-button-success-background',
                description: 'Success background of root'
            },
            {
                name: 'button.root.success.hoverBackground',
                token: 'button.success.hover.background',
                variable: '--p-button-success-hover-background',
                description: 'Success hover background of root'
            },
            {
                name: 'button.root.success.activeBackground',
                token: 'button.success.active.background',
                variable: '--p-button-success-active-background',
                description: 'Success active background of root'
            },
            {
                name: 'button.root.success.borderColor',
                token: 'button.success.border.color',
                variable: '--p-button-success-border-color',
                description: 'Success border color of root'
            },
            {
                name: 'button.root.success.hoverBorderColor',
                token: 'button.success.hover.border.color',
                variable: '--p-button-success-hover-border-color',
                description: 'Success hover border color of root'
            },
            {
                name: 'button.root.success.activeBorderColor',
                token: 'button.success.active.border.color',
                variable: '--p-button-success-active-border-color',
                description: 'Success active border color of root'
            },
            {
                name: 'button.root.success.color',
                token: 'button.success.color',
                variable: '--p-button-success-color',
                description: 'Success color of root'
            },
            {
                name: 'button.root.success.hoverColor',
                token: 'button.success.hover.color',
                variable: '--p-button-success-hover-color',
                description: 'Success hover color of root'
            },
            {
                name: 'button.root.success.activeColor',
                token: 'button.success.active.color',
                variable: '--p-button-success-active-color',
                description: 'Success active color of root'
            },
            {
                name: 'button.root.success.focusRing.color',
                token: 'button.success.focus.ring.color',
                variable: '--p-button-success-focus-ring-color',
                description: 'Success focus ring color of root'
            },
            {
                name: 'button.root.success.focusRing.shadow',
                token: 'button.success.focus.ring.shadow',
                variable: '--p-button-success-focus-ring-shadow',
                description: 'Success focus ring shadow of root'
            },
            {
                name: 'button.root.warn.background',
                token: 'button.warn.background',
                variable: '--p-button-warn-background',
                description: 'Warn background of root'
            },
            {
                name: 'button.root.warn.hoverBackground',
                token: 'button.warn.hover.background',
                variable: '--p-button-warn-hover-background',
                description: 'Warn hover background of root'
            },
            {
                name: 'button.root.warn.activeBackground',
                token: 'button.warn.active.background',
                variable: '--p-button-warn-active-background',
                description: 'Warn active background of root'
            },
            {
                name: 'button.root.warn.borderColor',
                token: 'button.warn.border.color',
                variable: '--p-button-warn-border-color',
                description: 'Warn border color of root'
            },
            {
                name: 'button.root.warn.hoverBorderColor',
                token: 'button.warn.hover.border.color',
                variable: '--p-button-warn-hover-border-color',
                description: 'Warn hover border color of root'
            },
            {
                name: 'button.root.warn.activeBorderColor',
                token: 'button.warn.active.border.color',
                variable: '--p-button-warn-active-border-color',
                description: 'Warn active border color of root'
            },
            {
                name: 'button.root.warn.color',
                token: 'button.warn.color',
                variable: '--p-button-warn-color',
                description: 'Warn color of root'
            },
            {
                name: 'button.root.warn.hoverColor',
                token: 'button.warn.hover.color',
                variable: '--p-button-warn-hover-color',
                description: 'Warn hover color of root'
            },
            {
                name: 'button.root.warn.activeColor',
                token: 'button.warn.active.color',
                variable: '--p-button-warn-active-color',
                description: 'Warn active color of root'
            },
            {
                name: 'button.root.warn.focusRing.color',
                token: 'button.warn.focus.ring.color',
                variable: '--p-button-warn-focus-ring-color',
                description: 'Warn focus ring color of root'
            },
            {
                name: 'button.root.warn.focusRing.shadow',
                token: 'button.warn.focus.ring.shadow',
                variable: '--p-button-warn-focus-ring-shadow',
                description: 'Warn focus ring shadow of root'
            },
            {
                name: 'button.root.help.background',
                token: 'button.help.background',
                variable: '--p-button-help-background',
                description: 'Help background of root'
            },
            {
                name: 'button.root.help.hoverBackground',
                token: 'button.help.hover.background',
                variable: '--p-button-help-hover-background',
                description: 'Help hover background of root'
            },
            {
                name: 'button.root.help.activeBackground',
                token: 'button.help.active.background',
                variable: '--p-button-help-active-background',
                description: 'Help active background of root'
            },
            {
                name: 'button.root.help.borderColor',
                token: 'button.help.border.color',
                variable: '--p-button-help-border-color',
                description: 'Help border color of root'
            },
            {
                name: 'button.root.help.hoverBorderColor',
                token: 'button.help.hover.border.color',
                variable: '--p-button-help-hover-border-color',
                description: 'Help hover border color of root'
            },
            {
                name: 'button.root.help.activeBorderColor',
                token: 'button.help.active.border.color',
                variable: '--p-button-help-active-border-color',
                description: 'Help active border color of root'
            },
            {
                name: 'button.root.help.color',
                token: 'button.help.color',
                variable: '--p-button-help-color',
                description: 'Help color of root'
            },
            {
                name: 'button.root.help.hoverColor',
                token: 'button.help.hover.color',
                variable: '--p-button-help-hover-color',
                description: 'Help hover color of root'
            },
            {
                name: 'button.root.help.activeColor',
                token: 'button.help.active.color',
                variable: '--p-button-help-active-color',
                description: 'Help active color of root'
            },
            {
                name: 'button.root.help.focusRing.color',
                token: 'button.help.focus.ring.color',
                variable: '--p-button-help-focus-ring-color',
                description: 'Help focus ring color of root'
            },
            {
                name: 'button.root.help.focusRing.shadow',
                token: 'button.help.focus.ring.shadow',
                variable: '--p-button-help-focus-ring-shadow',
                description: 'Help focus ring shadow of root'
            },
            {
                name: 'button.root.danger.background',
                token: 'button.danger.background',
                variable: '--p-button-danger-background',
                description: 'Danger background of root'
            },
            {
                name: 'button.root.danger.hoverBackground',
                token: 'button.danger.hover.background',
                variable: '--p-button-danger-hover-background',
                description: 'Danger hover background of root'
            },
            {
                name: 'button.root.danger.activeBackground',
                token: 'button.danger.active.background',
                variable: '--p-button-danger-active-background',
                description: 'Danger active background of root'
            },
            {
                name: 'button.root.danger.borderColor',
                token: 'button.danger.border.color',
                variable: '--p-button-danger-border-color',
                description: 'Danger border color of root'
            },
            {
                name: 'button.root.danger.hoverBorderColor',
                token: 'button.danger.hover.border.color',
                variable: '--p-button-danger-hover-border-color',
                description: 'Danger hover border color of root'
            },
            {
                name: 'button.root.danger.activeBorderColor',
                token: 'button.danger.active.border.color',
                variable: '--p-button-danger-active-border-color',
                description: 'Danger active border color of root'
            },
            {
                name: 'button.root.danger.color',
                token: 'button.danger.color',
                variable: '--p-button-danger-color',
                description: 'Danger color of root'
            },
            {
                name: 'button.root.danger.hoverColor',
                token: 'button.danger.hover.color',
                variable: '--p-button-danger-hover-color',
                description: 'Danger hover color of root'
            },
            {
                name: 'button.root.danger.activeColor',
                token: 'button.danger.active.color',
                variable: '--p-button-danger-active-color',
                description: 'Danger active color of root'
            },
            {
                name: 'button.root.danger.focusRing.color',
                token: 'button.danger.focus.ring.color',
                variable: '--p-button-danger-focus-ring-color',
                description: 'Danger focus ring color of root'
            },
            {
                name: 'button.root.danger.focusRing.shadow',
                token: 'button.danger.focus.ring.shadow',
                variable: '--p-button-danger-focus-ring-shadow',
                description: 'Danger focus ring shadow of root'
            },
            {
                name: 'button.root.contrast.background',
                token: 'button.contrast.background',
                variable: '--p-button-contrast-background',
                description: 'Contrast background of root'
            },
            {
                name: 'button.root.contrast.hoverBackground',
                token: 'button.contrast.hover.background',
                variable: '--p-button-contrast-hover-background',
                description: 'Contrast hover background of root'
            },
            {
                name: 'button.root.contrast.activeBackground',
                token: 'button.contrast.active.background',
                variable: '--p-button-contrast-active-background',
                description: 'Contrast active background of root'
            },
            {
                name: 'button.root.contrast.borderColor',
                token: 'button.contrast.border.color',
                variable: '--p-button-contrast-border-color',
                description: 'Contrast border color of root'
            },
            {
                name: 'button.root.contrast.hoverBorderColor',
                token: 'button.contrast.hover.border.color',
                variable: '--p-button-contrast-hover-border-color',
                description: 'Contrast hover border color of root'
            },
            {
                name: 'button.root.contrast.activeBorderColor',
                token: 'button.contrast.active.border.color',
                variable: '--p-button-contrast-active-border-color',
                description: 'Contrast active border color of root'
            },
            {
                name: 'button.root.contrast.color',
                token: 'button.contrast.color',
                variable: '--p-button-contrast-color',
                description: 'Contrast color of root'
            },
            {
                name: 'button.root.contrast.hoverColor',
                token: 'button.contrast.hover.color',
                variable: '--p-button-contrast-hover-color',
                description: 'Contrast hover color of root'
            },
            {
                name: 'button.root.contrast.activeColor',
                token: 'button.contrast.active.color',
                variable: '--p-button-contrast-active-color',
                description: 'Contrast active color of root'
            },
            {
                name: 'button.root.contrast.focusRing.color',
                token: 'button.contrast.focus.ring.color',
                variable: '--p-button-contrast-focus-ring-color',
                description: 'Contrast focus ring color of root'
            },
            {
                name: 'button.root.contrast.focusRing.shadow',
                token: 'button.contrast.focus.ring.shadow',
                variable: '--p-button-contrast-focus-ring-shadow',
                description: 'Contrast focus ring shadow of root'
            },
            {
                name: 'button.outlined.primary.hoverBackground',
                token: 'button.outlined.primary.hover.background',
                variable: '--p-button-outlined-primary-hover-background',
                description: 'Primary hover background of outlined'
            },
            {
                name: 'button.outlined.primary.activeBackground',
                token: 'button.outlined.primary.active.background',
                variable: '--p-button-outlined-primary-active-background',
                description: 'Primary active background of outlined'
            },
            {
                name: 'button.outlined.primary.borderColor',
                token: 'button.outlined.primary.border.color',
                variable: '--p-button-outlined-primary-border-color',
                description: 'Primary border color of outlined'
            },
            {
                name: 'button.outlined.primary.color',
                token: 'button.outlined.primary.color',
                variable: '--p-button-outlined-primary-color',
                description: 'Primary color of outlined'
            },
            {
                name: 'button.outlined.secondary.hoverBackground',
                token: 'button.outlined.secondary.hover.background',
                variable: '--p-button-outlined-secondary-hover-background',
                description: 'Secondary hover background of outlined'
            },
            {
                name: 'button.outlined.secondary.activeBackground',
                token: 'button.outlined.secondary.active.background',
                variable: '--p-button-outlined-secondary-active-background',
                description: 'Secondary active background of outlined'
            },
            {
                name: 'button.outlined.secondary.borderColor',
                token: 'button.outlined.secondary.border.color',
                variable: '--p-button-outlined-secondary-border-color',
                description: 'Secondary border color of outlined'
            },
            {
                name: 'button.outlined.secondary.color',
                token: 'button.outlined.secondary.color',
                variable: '--p-button-outlined-secondary-color',
                description: 'Secondary color of outlined'
            },
            {
                name: 'button.outlined.success.hoverBackground',
                token: 'button.outlined.success.hover.background',
                variable: '--p-button-outlined-success-hover-background',
                description: 'Success hover background of outlined'
            },
            {
                name: 'button.outlined.success.activeBackground',
                token: 'button.outlined.success.active.background',
                variable: '--p-button-outlined-success-active-background',
                description: 'Success active background of outlined'
            },
            {
                name: 'button.outlined.success.borderColor',
                token: 'button.outlined.success.border.color',
                variable: '--p-button-outlined-success-border-color',
                description: 'Success border color of outlined'
            },
            {
                name: 'button.outlined.success.color',
                token: 'button.outlined.success.color',
                variable: '--p-button-outlined-success-color',
                description: 'Success color of outlined'
            },
            {
                name: 'button.outlined.info.hoverBackground',
                token: 'button.outlined.info.hover.background',
                variable: '--p-button-outlined-info-hover-background',
                description: 'Info hover background of outlined'
            },
            {
                name: 'button.outlined.info.activeBackground',
                token: 'button.outlined.info.active.background',
                variable: '--p-button-outlined-info-active-background',
                description: 'Info active background of outlined'
            },
            {
                name: 'button.outlined.info.borderColor',
                token: 'button.outlined.info.border.color',
                variable: '--p-button-outlined-info-border-color',
                description: 'Info border color of outlined'
            },
            {
                name: 'button.outlined.info.color',
                token: 'button.outlined.info.color',
                variable: '--p-button-outlined-info-color',
                description: 'Info color of outlined'
            },
            {
                name: 'button.outlined.warn.hoverBackground',
                token: 'button.outlined.warn.hover.background',
                variable: '--p-button-outlined-warn-hover-background',
                description: 'Warn hover background of outlined'
            },
            {
                name: 'button.outlined.warn.activeBackground',
                token: 'button.outlined.warn.active.background',
                variable: '--p-button-outlined-warn-active-background',
                description: 'Warn active background of outlined'
            },
            {
                name: 'button.outlined.warn.borderColor',
                token: 'button.outlined.warn.border.color',
                variable: '--p-button-outlined-warn-border-color',
                description: 'Warn border color of outlined'
            },
            {
                name: 'button.outlined.warn.color',
                token: 'button.outlined.warn.color',
                variable: '--p-button-outlined-warn-color',
                description: 'Warn color of outlined'
            },
            {
                name: 'button.outlined.help.hoverBackground',
                token: 'button.outlined.help.hover.background',
                variable: '--p-button-outlined-help-hover-background',
                description: 'Help hover background of outlined'
            },
            {
                name: 'button.outlined.help.activeBackground',
                token: 'button.outlined.help.active.background',
                variable: '--p-button-outlined-help-active-background',
                description: 'Help active background of outlined'
            },
            {
                name: 'button.outlined.help.borderColor',
                token: 'button.outlined.help.border.color',
                variable: '--p-button-outlined-help-border-color',
                description: 'Help border color of outlined'
            },
            {
                name: 'button.outlined.help.color',
                token: 'button.outlined.help.color',
                variable: '--p-button-outlined-help-color',
                description: 'Help color of outlined'
            },
            {
                name: 'button.outlined.danger.hoverBackground',
                token: 'button.outlined.danger.hover.background',
                variable: '--p-button-outlined-danger-hover-background',
                description: 'Danger hover background of outlined'
            },
            {
                name: 'button.outlined.danger.activeBackground',
                token: 'button.outlined.danger.active.background',
                variable: '--p-button-outlined-danger-active-background',
                description: 'Danger active background of outlined'
            },
            {
                name: 'button.outlined.danger.borderColor',
                token: 'button.outlined.danger.border.color',
                variable: '--p-button-outlined-danger-border-color',
                description: 'Danger border color of outlined'
            },
            {
                name: 'button.outlined.danger.color',
                token: 'button.outlined.danger.color',
                variable: '--p-button-outlined-danger-color',
                description: 'Danger color of outlined'
            },
            {
                name: 'button.outlined.contrast.hoverBackground',
                token: 'button.outlined.contrast.hover.background',
                variable: '--p-button-outlined-contrast-hover-background',
                description: 'Contrast hover background of outlined'
            },
            {
                name: 'button.outlined.contrast.activeBackground',
                token: 'button.outlined.contrast.active.background',
                variable: '--p-button-outlined-contrast-active-background',
                description: 'Contrast active background of outlined'
            },
            {
                name: 'button.outlined.contrast.borderColor',
                token: 'button.outlined.contrast.border.color',
                variable: '--p-button-outlined-contrast-border-color',
                description: 'Contrast border color of outlined'
            },
            {
                name: 'button.outlined.contrast.color',
                token: 'button.outlined.contrast.color',
                variable: '--p-button-outlined-contrast-color',
                description: 'Contrast color of outlined'
            },
            {
                name: 'button.outlined.plain.hoverBackground',
                token: 'button.outlined.plain.hover.background',
                variable: '--p-button-outlined-plain-hover-background',
                description: 'Plain hover background of outlined'
            },
            {
                name: 'button.outlined.plain.activeBackground',
                token: 'button.outlined.plain.active.background',
                variable: '--p-button-outlined-plain-active-background',
                description: 'Plain active background of outlined'
            },
            {
                name: 'button.outlined.plain.borderColor',
                token: 'button.outlined.plain.border.color',
                variable: '--p-button-outlined-plain-border-color',
                description: 'Plain border color of outlined'
            },
            {
                name: 'button.outlined.plain.color',
                token: 'button.outlined.plain.color',
                variable: '--p-button-outlined-plain-color',
                description: 'Plain color of outlined'
            },
            {
                name: 'button.text.primary.hoverBackground',
                token: 'button.text.primary.hover.background',
                variable: '--p-button-text-primary-hover-background',
                description: 'Primary hover background of text'
            },
            {
                name: 'button.text.primary.activeBackground',
                token: 'button.text.primary.active.background',
                variable: '--p-button-text-primary-active-background',
                description: 'Primary active background of text'
            },
            {
                name: 'button.text.primary.color',
                token: 'button.text.primary.color',
                variable: '--p-button-text-primary-color',
                description: 'Primary color of text'
            },
            {
                name: 'button.text.secondary.hoverBackground',
                token: 'button.text.secondary.hover.background',
                variable: '--p-button-text-secondary-hover-background',
                description: 'Secondary hover background of text'
            },
            {
                name: 'button.text.secondary.activeBackground',
                token: 'button.text.secondary.active.background',
                variable: '--p-button-text-secondary-active-background',
                description: 'Secondary active background of text'
            },
            {
                name: 'button.text.secondary.color',
                token: 'button.text.secondary.color',
                variable: '--p-button-text-secondary-color',
                description: 'Secondary color of text'
            },
            {
                name: 'button.text.success.hoverBackground',
                token: 'button.text.success.hover.background',
                variable: '--p-button-text-success-hover-background',
                description: 'Success hover background of text'
            },
            {
                name: 'button.text.success.activeBackground',
                token: 'button.text.success.active.background',
                variable: '--p-button-text-success-active-background',
                description: 'Success active background of text'
            },
            {
                name: 'button.text.success.color',
                token: 'button.text.success.color',
                variable: '--p-button-text-success-color',
                description: 'Success color of text'
            },
            {
                name: 'button.text.info.hoverBackground',
                token: 'button.text.info.hover.background',
                variable: '--p-button-text-info-hover-background',
                description: 'Info hover background of text'
            },
            {
                name: 'button.text.info.activeBackground',
                token: 'button.text.info.active.background',
                variable: '--p-button-text-info-active-background',
                description: 'Info active background of text'
            },
            {
                name: 'button.text.info.color',
                token: 'button.text.info.color',
                variable: '--p-button-text-info-color',
                description: 'Info color of text'
            },
            {
                name: 'button.text.warn.hoverBackground',
                token: 'button.text.warn.hover.background',
                variable: '--p-button-text-warn-hover-background',
                description: 'Warn hover background of text'
            },
            {
                name: 'button.text.warn.activeBackground',
                token: 'button.text.warn.active.background',
                variable: '--p-button-text-warn-active-background',
                description: 'Warn active background of text'
            },
            {
                name: 'button.text.warn.color',
                token: 'button.text.warn.color',
                variable: '--p-button-text-warn-color',
                description: 'Warn color of text'
            },
            {
                name: 'button.text.help.hoverBackground',
                token: 'button.text.help.hover.background',
                variable: '--p-button-text-help-hover-background',
                description: 'Help hover background of text'
            },
            {
                name: 'button.text.help.activeBackground',
                token: 'button.text.help.active.background',
                variable: '--p-button-text-help-active-background',
                description: 'Help active background of text'
            },
            {
                name: 'button.text.help.color',
                token: 'button.text.help.color',
                variable: '--p-button-text-help-color',
                description: 'Help color of text'
            },
            {
                name: 'button.text.danger.hoverBackground',
                token: 'button.text.danger.hover.background',
                variable: '--p-button-text-danger-hover-background',
                description: 'Danger hover background of text'
            },
            {
                name: 'button.text.danger.activeBackground',
                token: 'button.text.danger.active.background',
                variable: '--p-button-text-danger-active-background',
                description: 'Danger active background of text'
            },
            {
                name: 'button.text.danger.color',
                token: 'button.text.danger.color',
                variable: '--p-button-text-danger-color',
                description: 'Danger color of text'
            },
            {
                name: 'button.text.contrast.hoverBackground',
                token: 'button.text.contrast.hover.background',
                variable: '--p-button-text-contrast-hover-background',
                description: 'Contrast hover background of text'
            },
            {
                name: 'button.text.contrast.activeBackground',
                token: 'button.text.contrast.active.background',
                variable: '--p-button-text-contrast-active-background',
                description: 'Contrast active background of text'
            },
            {
                name: 'button.text.contrast.color',
                token: 'button.text.contrast.color',
                variable: '--p-button-text-contrast-color',
                description: 'Contrast color of text'
            },
            {
                name: 'button.text.plain.hoverBackground',
                token: 'button.text.plain.hover.background',
                variable: '--p-button-text-plain-hover-background',
                description: 'Plain hover background of text'
            },
            {
                name: 'button.text.plain.activeBackground',
                token: 'button.text.plain.active.background',
                variable: '--p-button-text-plain-active-background',
                description: 'Plain active background of text'
            },
            {
                name: 'button.text.plain.color',
                token: 'button.text.plain.color',
                variable: '--p-button-text-plain-color',
                description: 'Plain color of text'
            },
            {
                name: 'button.link.color',
                token: 'button.link.color',
                variable: '--p-button-link-color',
                description: 'Color of link'
            },
            {
                name: 'button.link.hoverColor',
                token: 'button.link.hover.color',
                variable: '--p-button-link-hover-color',
                description: 'Hover color of link'
            },
            {
                name: 'button.link.activeColor',
                token: 'button.link.active.color',
                variable: '--p-button-link-active-color',
                description: 'Active color of link'
            }
        ]
    },
    card: {
        description: 'Card Design Tokens',
        tokens: [
            {
                name: 'card.root.background',
                token: 'card.background',
                variable: '--p-card-background',
                description: 'Background of root'
            },
            {
                name: 'card.root.borderRadius',
                token: 'card.border.radius',
                variable: '--p-card-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'card.root.color',
                token: 'card.color',
                variable: '--p-card-color',
                description: 'Color of root'
            },
            {
                name: 'card.root.shadow',
                token: 'card.shadow',
                variable: '--p-card-shadow',
                description: 'Shadow of root'
            },
            {
                name: 'card.body.padding',
                token: 'card.body.padding',
                variable: '--p-card-body-padding',
                description: 'Padding of body'
            },
            {
                name: 'card.body.gap',
                token: 'card.body.gap',
                variable: '--p-card-body-gap',
                description: 'Gap of body'
            },
            {
                name: 'card.caption.gap',
                token: 'card.caption.gap',
                variable: '--p-card-caption-gap',
                description: 'Gap of caption'
            },
            {
                name: 'card.title.fontSize',
                token: 'card.title.font.size',
                variable: '--p-card-title-font-size',
                description: 'Font size of title'
            },
            {
                name: 'card.title.fontWeight',
                token: 'card.title.font.weight',
                variable: '--p-card-title-font-weight',
                description: 'Font weight of title'
            },
            {
                name: 'card.subtitle.color',
                token: 'card.subtitle.color',
                variable: '--p-card-subtitle-color',
                description: 'Color of subtitle'
            }
        ]
    },
    carousel: {
        description: 'Carousel Design Tokens',
        tokens: [
            {
                name: 'carousel.root.transitionDuration',
                token: 'carousel.transition.duration',
                variable: '--p-carousel-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'carousel.content.gap',
                token: 'carousel.content.gap',
                variable: '--p-carousel-content-gap',
                description: 'Gap of content'
            },
            {
                name: 'carousel.indicatorList.padding',
                token: 'carousel.indicator.list.padding',
                variable: '--p-carousel-indicator-list-padding',
                description: 'Padding of indicator list'
            },
            {
                name: 'carousel.indicatorList.gap',
                token: 'carousel.indicator.list.gap',
                variable: '--p-carousel-indicator-list-gap',
                description: 'Gap of indicator list'
            },
            {
                name: 'carousel.indicator.width',
                token: 'carousel.indicator.width',
                variable: '--p-carousel-indicator-width',
                description: 'Width of indicator'
            },
            {
                name: 'carousel.indicator.height',
                token: 'carousel.indicator.height',
                variable: '--p-carousel-indicator-height',
                description: 'Height of indicator'
            },
            {
                name: 'carousel.indicator.borderRadius',
                token: 'carousel.indicator.border.radius',
                variable: '--p-carousel-indicator-border-radius',
                description: 'Border radius of indicator'
            },
            {
                name: 'carousel.indicator.focusRing.width',
                token: 'carousel.indicator.focus.ring.width',
                variable: '--p-carousel-indicator-focus-ring-width',
                description: 'Focus ring width of indicator'
            },
            {
                name: 'carousel.indicator.focusRing.style',
                token: 'carousel.indicator.focus.ring.style',
                variable: '--p-carousel-indicator-focus-ring-style',
                description: 'Focus ring style of indicator'
            },
            {
                name: 'carousel.indicator.focusRing.color',
                token: 'carousel.indicator.focus.ring.color',
                variable: '--p-carousel-indicator-focus-ring-color',
                description: 'Focus ring color of indicator'
            },
            {
                name: 'carousel.indicator.focusRing.offset',
                token: 'carousel.indicator.focus.ring.offset',
                variable: '--p-carousel-indicator-focus-ring-offset',
                description: 'Focus ring offset of indicator'
            },
            {
                name: 'carousel.indicator.focusRing.shadow',
                token: 'carousel.indicator.focus.ring.shadow',
                variable: '--p-carousel-indicator-focus-ring-shadow',
                description: 'Focus ring shadow of indicator'
            },
            {
                name: 'carousel.indicator.background',
                token: 'carousel.indicator.background',
                variable: '--p-carousel-indicator-background',
                description: 'Background of indicator'
            },
            {
                name: 'carousel.indicator.hoverBackground',
                token: 'carousel.indicator.hover.background',
                variable: '--p-carousel-indicator-hover-background',
                description: 'Hover background of indicator'
            },
            {
                name: 'carousel.indicator.activeBackground',
                token: 'carousel.indicator.active.background',
                variable: '--p-carousel-indicator-active-background',
                description: 'Active background of indicator'
            }
        ]
    },
    cascadeselect: {
        description: 'CascadeSelect Design Tokens',
        tokens: [
            {
                name: 'cascadeselect.root.background',
                token: 'cascadeselect.background',
                variable: '--p-cascadeselect-background',
                description: 'Background of root'
            },
            {
                name: 'cascadeselect.root.disabledBackground',
                token: 'cascadeselect.disabled.background',
                variable: '--p-cascadeselect-disabled-background',
                description: 'Disabled background of root'
            },
            {
                name: 'cascadeselect.root.filledBackground',
                token: 'cascadeselect.filled.background',
                variable: '--p-cascadeselect-filled-background',
                description: 'Filled background of root'
            },
            {
                name: 'cascadeselect.root.filledHoverBackground',
                token: 'cascadeselect.filled.hover.background',
                variable: '--p-cascadeselect-filled-hover-background',
                description: 'Filled hover background of root'
            },
            {
                name: 'cascadeselect.root.filledFocusBackground',
                token: 'cascadeselect.filled.focus.background',
                variable: '--p-cascadeselect-filled-focus-background',
                description: 'Filled focus background of root'
            },
            {
                name: 'cascadeselect.root.borderColor',
                token: 'cascadeselect.border.color',
                variable: '--p-cascadeselect-border-color',
                description: 'Border color of root'
            },
            {
                name: 'cascadeselect.root.hoverBorderColor',
                token: 'cascadeselect.hover.border.color',
                variable: '--p-cascadeselect-hover-border-color',
                description: 'Hover border color of root'
            },
            {
                name: 'cascadeselect.root.focusBorderColor',
                token: 'cascadeselect.focus.border.color',
                variable: '--p-cascadeselect-focus-border-color',
                description: 'Focus border color of root'
            },
            {
                name: 'cascadeselect.root.invalidBorderColor',
                token: 'cascadeselect.invalid.border.color',
                variable: '--p-cascadeselect-invalid-border-color',
                description: 'Invalid border color of root'
            },
            {
                name: 'cascadeselect.root.color',
                token: 'cascadeselect.color',
                variable: '--p-cascadeselect-color',
                description: 'Color of root'
            },
            {
                name: 'cascadeselect.root.disabledColor',
                token: 'cascadeselect.disabled.color',
                variable: '--p-cascadeselect-disabled-color',
                description: 'Disabled color of root'
            },
            {
                name: 'cascadeselect.root.placeholderColor',
                token: 'cascadeselect.placeholder.color',
                variable: '--p-cascadeselect-placeholder-color',
                description: 'Placeholder color of root'
            },
            {
                name: 'cascadeselect.root.invalidPlaceholderColor',
                token: 'cascadeselect.invalid.placeholder.color',
                variable: '--p-cascadeselect-invalid-placeholder-color',
                description: 'Invalid placeholder color of root'
            },
            {
                name: 'cascadeselect.root.shadow',
                token: 'cascadeselect.shadow',
                variable: '--p-cascadeselect-shadow',
                description: 'Shadow of root'
            },
            {
                name: 'cascadeselect.root.paddingX',
                token: 'cascadeselect.padding.x',
                variable: '--p-cascadeselect-padding-x',
                description: 'Padding x of root'
            },
            {
                name: 'cascadeselect.root.paddingY',
                token: 'cascadeselect.padding.y',
                variable: '--p-cascadeselect-padding-y',
                description: 'Padding y of root'
            },
            {
                name: 'cascadeselect.root.borderRadius',
                token: 'cascadeselect.border.radius',
                variable: '--p-cascadeselect-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'cascadeselect.root.focusRing.width',
                token: 'cascadeselect.focus.ring.width',
                variable: '--p-cascadeselect-focus-ring-width',
                description: 'Focus ring width of root'
            },
            {
                name: 'cascadeselect.root.focusRing.style',
                token: 'cascadeselect.focus.ring.style',
                variable: '--p-cascadeselect-focus-ring-style',
                description: 'Focus ring style of root'
            },
            {
                name: 'cascadeselect.root.focusRing.color',
                token: 'cascadeselect.focus.ring.color',
                variable: '--p-cascadeselect-focus-ring-color',
                description: 'Focus ring color of root'
            },
            {
                name: 'cascadeselect.root.focusRing.offset',
                token: 'cascadeselect.focus.ring.offset',
                variable: '--p-cascadeselect-focus-ring-offset',
                description: 'Focus ring offset of root'
            },
            {
                name: 'cascadeselect.root.focusRing.shadow',
                token: 'cascadeselect.focus.ring.shadow',
                variable: '--p-cascadeselect-focus-ring-shadow',
                description: 'Focus ring shadow of root'
            },
            {
                name: 'cascadeselect.root.transitionDuration',
                token: 'cascadeselect.transition.duration',
                variable: '--p-cascadeselect-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'cascadeselect.root.sm.fontSize',
                token: 'cascadeselect.sm.font.size',
                variable: '--p-cascadeselect-sm-font-size',
                description: 'Sm font size of root'
            },
            {
                name: 'cascadeselect.root.sm.paddingX',
                token: 'cascadeselect.sm.padding.x',
                variable: '--p-cascadeselect-sm-padding-x',
                description: 'Sm padding x of root'
            },
            {
                name: 'cascadeselect.root.sm.paddingY',
                token: 'cascadeselect.sm.padding.y',
                variable: '--p-cascadeselect-sm-padding-y',
                description: 'Sm padding y of root'
            },
            {
                name: 'cascadeselect.root.lg.fontSize',
                token: 'cascadeselect.lg.font.size',
                variable: '--p-cascadeselect-lg-font-size',
                description: 'Lg font size of root'
            },
            {
                name: 'cascadeselect.root.lg.paddingX',
                token: 'cascadeselect.lg.padding.x',
                variable: '--p-cascadeselect-lg-padding-x',
                description: 'Lg padding x of root'
            },
            {
                name: 'cascadeselect.root.lg.paddingY',
                token: 'cascadeselect.lg.padding.y',
                variable: '--p-cascadeselect-lg-padding-y',
                description: 'Lg padding y of root'
            },
            {
                name: 'cascadeselect.dropdown.width',
                token: 'cascadeselect.dropdown.width',
                variable: '--p-cascadeselect-dropdown-width',
                description: 'Width of dropdown'
            },
            {
                name: 'cascadeselect.dropdown.color',
                token: 'cascadeselect.dropdown.color',
                variable: '--p-cascadeselect-dropdown-color',
                description: 'Color of dropdown'
            },
            {
                name: 'cascadeselect.overlay.background',
                token: 'cascadeselect.overlay.background',
                variable: '--p-cascadeselect-overlay-background',
                description: 'Background of overlay'
            },
            {
                name: 'cascadeselect.overlay.borderColor',
                token: 'cascadeselect.overlay.border.color',
                variable: '--p-cascadeselect-overlay-border-color',
                description: 'Border color of overlay'
            },
            {
                name: 'cascadeselect.overlay.borderRadius',
                token: 'cascadeselect.overlay.border.radius',
                variable: '--p-cascadeselect-overlay-border-radius',
                description: 'Border radius of overlay'
            },
            {
                name: 'cascadeselect.overlay.color',
                token: 'cascadeselect.overlay.color',
                variable: '--p-cascadeselect-overlay-color',
                description: 'Color of overlay'
            },
            {
                name: 'cascadeselect.overlay.shadow',
                token: 'cascadeselect.overlay.shadow',
                variable: '--p-cascadeselect-overlay-shadow',
                description: 'Shadow of overlay'
            },
            {
                name: 'cascadeselect.list.padding',
                token: 'cascadeselect.list.padding',
                variable: '--p-cascadeselect-list-padding',
                description: 'Padding of list'
            },
            {
                name: 'cascadeselect.list.gap',
                token: 'cascadeselect.list.gap',
                variable: '--p-cascadeselect-list-gap',
                description: 'Gap of list'
            },
            {
                name: 'cascadeselect.list.mobileIndent',
                token: 'cascadeselect.list.mobile.indent',
                variable: '--p-cascadeselect-list-mobile-indent',
                description: 'Mobile indent of list'
            },
            {
                name: 'cascadeselect.option.focusBackground',
                token: 'cascadeselect.option.focus.background',
                variable: '--p-cascadeselect-option-focus-background',
                description: 'Focus background of option'
            },
            {
                name: 'cascadeselect.option.selectedBackground',
                token: 'cascadeselect.option.selected.background',
                variable: '--p-cascadeselect-option-selected-background',
                description: 'Selected background of option'
            },
            {
                name: 'cascadeselect.option.selectedFocusBackground',
                token: 'cascadeselect.option.selected.focus.background',
                variable: '--p-cascadeselect-option-selected-focus-background',
                description: 'Selected focus background of option'
            },
            {
                name: 'cascadeselect.option.color',
                token: 'cascadeselect.option.color',
                variable: '--p-cascadeselect-option-color',
                description: 'Color of option'
            },
            {
                name: 'cascadeselect.option.focusColor',
                token: 'cascadeselect.option.focus.color',
                variable: '--p-cascadeselect-option-focus-color',
                description: 'Focus color of option'
            },
            {
                name: 'cascadeselect.option.selectedColor',
                token: 'cascadeselect.option.selected.color',
                variable: '--p-cascadeselect-option-selected-color',
                description: 'Selected color of option'
            },
            {
                name: 'cascadeselect.option.selectedFocusColor',
                token: 'cascadeselect.option.selected.focus.color',
                variable: '--p-cascadeselect-option-selected-focus-color',
                description: 'Selected focus color of option'
            },
            {
                name: 'cascadeselect.option.padding',
                token: 'cascadeselect.option.padding',
                variable: '--p-cascadeselect-option-padding',
                description: 'Padding of option'
            },
            {
                name: 'cascadeselect.option.borderRadius',
                token: 'cascadeselect.option.border.radius',
                variable: '--p-cascadeselect-option-border-radius',
                description: 'Border radius of option'
            },
            {
                name: 'cascadeselect.option.icon.color',
                token: 'cascadeselect.option.icon.color',
                variable: '--p-cascadeselect-option-icon-color',
                description: 'Icon color of option'
            },
            {
                name: 'cascadeselect.option.icon.focusColor',
                token: 'cascadeselect.option.icon.focus.color',
                variable: '--p-cascadeselect-option-icon-focus-color',
                description: 'Icon focus color of option'
            },
            {
                name: 'cascadeselect.option.icon.size',
                token: 'cascadeselect.option.icon.size',
                variable: '--p-cascadeselect-option-icon-size',
                description: 'Icon size of option'
            },
            {
                name: 'cascadeselect.clearIcon.color',
                token: 'cascadeselect.clear.icon.color',
                variable: '--p-cascadeselect-clear-icon-color',
                description: 'Color of clear icon'
            }
        ]
    },
    checkbox: {
        description: 'Checkbox Design Tokens',
        tokens: [
            {
                name: 'checkbox.root.borderRadius',
                token: 'checkbox.border.radius',
                variable: '--p-checkbox-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'checkbox.root.width',
                token: 'checkbox.width',
                variable: '--p-checkbox-width',
                description: 'Width of root'
            },
            {
                name: 'checkbox.root.height',
                token: 'checkbox.height',
                variable: '--p-checkbox-height',
                description: 'Height of root'
            },
            {
                name: 'checkbox.root.background',
                token: 'checkbox.background',
                variable: '--p-checkbox-background',
                description: 'Background of root'
            },
            {
                name: 'checkbox.root.checkedBackground',
                token: 'checkbox.checked.background',
                variable: '--p-checkbox-checked-background',
                description: 'Checked background of root'
            },
            {
                name: 'checkbox.root.checkedHoverBackground',
                token: 'checkbox.checked.hover.background',
                variable: '--p-checkbox-checked-hover-background',
                description: 'Checked hover background of root'
            },
            {
                name: 'checkbox.root.disabledBackground',
                token: 'checkbox.disabled.background',
                variable: '--p-checkbox-disabled-background',
                description: 'Disabled background of root'
            },
            {
                name: 'checkbox.root.filledBackground',
                token: 'checkbox.filled.background',
                variable: '--p-checkbox-filled-background',
                description: 'Filled background of root'
            },
            {
                name: 'checkbox.root.borderColor',
                token: 'checkbox.border.color',
                variable: '--p-checkbox-border-color',
                description: 'Border color of root'
            },
            {
                name: 'checkbox.root.hoverBorderColor',
                token: 'checkbox.hover.border.color',
                variable: '--p-checkbox-hover-border-color',
                description: 'Hover border color of root'
            },
            {
                name: 'checkbox.root.focusBorderColor',
                token: 'checkbox.focus.border.color',
                variable: '--p-checkbox-focus-border-color',
                description: 'Focus border color of root'
            },
            {
                name: 'checkbox.root.checkedBorderColor',
                token: 'checkbox.checked.border.color',
                variable: '--p-checkbox-checked-border-color',
                description: 'Checked border color of root'
            },
            {
                name: 'checkbox.root.checkedHoverBorderColor',
                token: 'checkbox.checked.hover.border.color',
                variable: '--p-checkbox-checked-hover-border-color',
                description: 'Checked hover border color of root'
            },
            {
                name: 'checkbox.root.checkedFocusBorderColor',
                token: 'checkbox.checked.focus.border.color',
                variable: '--p-checkbox-checked-focus-border-color',
                description: 'Checked focus border color of root'
            },
            {
                name: 'checkbox.root.checkedDisabledBorderColor',
                token: 'checkbox.checked.disabled.border.color',
                variable: '--p-checkbox-checked-disabled-border-color',
                description: 'Checked disabled border color of root'
            },
            {
                name: 'checkbox.root.invalidBorderColor',
                token: 'checkbox.invalid.border.color',
                variable: '--p-checkbox-invalid-border-color',
                description: 'Invalid border color of root'
            },
            {
                name: 'checkbox.root.shadow',
                token: 'checkbox.shadow',
                variable: '--p-checkbox-shadow',
                description: 'Shadow of root'
            },
            {
                name: 'checkbox.root.focusRing.width',
                token: 'checkbox.focus.ring.width',
                variable: '--p-checkbox-focus-ring-width',
                description: 'Focus ring width of root'
            },
            {
                name: 'checkbox.root.focusRing.style',
                token: 'checkbox.focus.ring.style',
                variable: '--p-checkbox-focus-ring-style',
                description: 'Focus ring style of root'
            },
            {
                name: 'checkbox.root.focusRing.color',
                token: 'checkbox.focus.ring.color',
                variable: '--p-checkbox-focus-ring-color',
                description: 'Focus ring color of root'
            },
            {
                name: 'checkbox.root.focusRing.offset',
                token: 'checkbox.focus.ring.offset',
                variable: '--p-checkbox-focus-ring-offset',
                description: 'Focus ring offset of root'
            },
            {
                name: 'checkbox.root.focusRing.shadow',
                token: 'checkbox.focus.ring.shadow',
                variable: '--p-checkbox-focus-ring-shadow',
                description: 'Focus ring shadow of root'
            },
            {
                name: 'checkbox.root.transitionDuration',
                token: 'checkbox.transition.duration',
                variable: '--p-checkbox-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'checkbox.root.sm.width',
                token: 'checkbox.sm.width',
                variable: '--p-checkbox-sm-width',
                description: 'Sm width of root'
            },
            {
                name: 'checkbox.root.sm.height',
                token: 'checkbox.sm.height',
                variable: '--p-checkbox-sm-height',
                description: 'Sm height of root'
            },
            {
                name: 'checkbox.root.lg.width',
                token: 'checkbox.lg.width',
                variable: '--p-checkbox-lg-width',
                description: 'Lg width of root'
            },
            {
                name: 'checkbox.root.lg.height',
                token: 'checkbox.lg.height',
                variable: '--p-checkbox-lg-height',
                description: 'Lg height of root'
            },
            {
                name: 'checkbox.icon.size',
                token: 'checkbox.icon.size',
                variable: '--p-checkbox-icon-size',
                description: 'Size of icon'
            },
            {
                name: 'checkbox.icon.color',
                token: 'checkbox.icon.color',
                variable: '--p-checkbox-icon-color',
                description: 'Color of icon'
            },
            {
                name: 'checkbox.icon.checkedColor',
                token: 'checkbox.icon.checked.color',
                variable: '--p-checkbox-icon-checked-color',
                description: 'Checked color of icon'
            },
            {
                name: 'checkbox.icon.checkedHoverColor',
                token: 'checkbox.icon.checked.hover.color',
                variable: '--p-checkbox-icon-checked-hover-color',
                description: 'Checked hover color of icon'
            },
            {
                name: 'checkbox.icon.disabledColor',
                token: 'checkbox.icon.disabled.color',
                variable: '--p-checkbox-icon-disabled-color',
                description: 'Disabled color of icon'
            },
            {
                name: 'checkbox.icon.sm.size',
                token: 'checkbox.icon.sm.size',
                variable: '--p-checkbox-icon-sm-size',
                description: 'Sm size of icon'
            },
            {
                name: 'checkbox.icon.lg.size',
                token: 'checkbox.icon.lg.size',
                variable: '--p-checkbox-icon-lg-size',
                description: 'Lg size of icon'
            }
        ]
    },
    chip: {
        description: 'Chip Design Tokens',
        tokens: [
            {
                name: 'chip.root.borderRadius',
                token: 'chip.border.radius',
                variable: '--p-chip-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'chip.root.paddingX',
                token: 'chip.padding.x',
                variable: '--p-chip-padding-x',
                description: 'Padding x of root'
            },
            {
                name: 'chip.root.paddingY',
                token: 'chip.padding.y',
                variable: '--p-chip-padding-y',
                description: 'Padding y of root'
            },
            {
                name: 'chip.root.gap',
                token: 'chip.gap',
                variable: '--p-chip-gap',
                description: 'Gap of root'
            },
            {
                name: 'chip.root.transitionDuration',
                token: 'chip.transition.duration',
                variable: '--p-chip-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'chip.root.background',
                token: 'chip.background',
                variable: '--p-chip-background',
                description: 'Background of root'
            },
            {
                name: 'chip.root.color',
                token: 'chip.color',
                variable: '--p-chip-color',
                description: 'Color of root'
            },
            {
                name: 'chip.image.width',
                token: 'chip.image.width',
                variable: '--p-chip-image-width',
                description: 'Width of image'
            },
            {
                name: 'chip.image.height',
                token: 'chip.image.height',
                variable: '--p-chip-image-height',
                description: 'Height of image'
            },
            {
                name: 'chip.icon.size',
                token: 'chip.icon.size',
                variable: '--p-chip-icon-size',
                description: 'Size of icon'
            },
            {
                name: 'chip.icon.color',
                token: 'chip.icon.color',
                variable: '--p-chip-icon-color',
                description: 'Color of icon'
            },
            {
                name: 'chip.removeIcon.size',
                token: 'chip.remove.icon.size',
                variable: '--p-chip-remove-icon-size',
                description: 'Size of remove icon'
            },
            {
                name: 'chip.removeIcon.focusRing.width',
                token: 'chip.remove.icon.focus.ring.width',
                variable: '--p-chip-remove-icon-focus-ring-width',
                description: 'Focus ring width of remove icon'
            },
            {
                name: 'chip.removeIcon.focusRing.style',
                token: 'chip.remove.icon.focus.ring.style',
                variable: '--p-chip-remove-icon-focus-ring-style',
                description: 'Focus ring style of remove icon'
            },
            {
                name: 'chip.removeIcon.focusRing.color',
                token: 'chip.remove.icon.focus.ring.color',
                variable: '--p-chip-remove-icon-focus-ring-color',
                description: 'Focus ring color of remove icon'
            },
            {
                name: 'chip.removeIcon.focusRing.offset',
                token: 'chip.remove.icon.focus.ring.offset',
                variable: '--p-chip-remove-icon-focus-ring-offset',
                description: 'Focus ring offset of remove icon'
            },
            {
                name: 'chip.removeIcon.focusRing.shadow',
                token: 'chip.remove.icon.focus.ring.shadow',
                variable: '--p-chip-remove-icon-focus-ring-shadow',
                description: 'Focus ring shadow of remove icon'
            },
            {
                name: 'chip.removeIcon.color',
                token: 'chip.remove.icon.color',
                variable: '--p-chip-remove-icon-color',
                description: 'Color of remove icon'
            }
        ]
    },
    colorpicker: {
        description: 'ColorPicker Design Tokens',
        tokens: [
            {
                name: 'colorpicker.root.transitionDuration',
                token: 'colorpicker.transition.duration',
                variable: '--p-colorpicker-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'colorpicker.preview.width',
                token: 'colorpicker.preview.width',
                variable: '--p-colorpicker-preview-width',
                description: 'Width of preview'
            },
            {
                name: 'colorpicker.preview.height',
                token: 'colorpicker.preview.height',
                variable: '--p-colorpicker-preview-height',
                description: 'Height of preview'
            },
            {
                name: 'colorpicker.preview.borderRadius',
                token: 'colorpicker.preview.border.radius',
                variable: '--p-colorpicker-preview-border-radius',
                description: 'Border radius of preview'
            },
            {
                name: 'colorpicker.preview.focusRing.width',
                token: 'colorpicker.preview.focus.ring.width',
                variable: '--p-colorpicker-preview-focus-ring-width',
                description: 'Focus ring width of preview'
            },
            {
                name: 'colorpicker.preview.focusRing.style',
                token: 'colorpicker.preview.focus.ring.style',
                variable: '--p-colorpicker-preview-focus-ring-style',
                description: 'Focus ring style of preview'
            },
            {
                name: 'colorpicker.preview.focusRing.color',
                token: 'colorpicker.preview.focus.ring.color',
                variable: '--p-colorpicker-preview-focus-ring-color',
                description: 'Focus ring color of preview'
            },
            {
                name: 'colorpicker.preview.focusRing.offset',
                token: 'colorpicker.preview.focus.ring.offset',
                variable: '--p-colorpicker-preview-focus-ring-offset',
                description: 'Focus ring offset of preview'
            },
            {
                name: 'colorpicker.preview.focusRing.shadow',
                token: 'colorpicker.preview.focus.ring.shadow',
                variable: '--p-colorpicker-preview-focus-ring-shadow',
                description: 'Focus ring shadow of preview'
            },
            {
                name: 'colorpicker.panel.shadow',
                token: 'colorpicker.panel.shadow',
                variable: '--p-colorpicker-panel-shadow',
                description: 'Shadow of panel'
            },
            {
                name: 'colorpicker.panel.borderRadius',
                token: 'colorpicker.panel.border.radius',
                variable: '--p-colorpicker-panel-border-radius',
                description: 'Border radius of panel'
            },
            {
                name: 'colorpicker.panel.background',
                token: 'colorpicker.panel.background',
                variable: '--p-colorpicker-panel-background',
                description: 'Background of panel'
            },
            {
                name: 'colorpicker.panel.borderColor',
                token: 'colorpicker.panel.border.color',
                variable: '--p-colorpicker-panel-border-color',
                description: 'Border color of panel'
            },
            {
                name: 'colorpicker.handle.color',
                token: 'colorpicker.handle.color',
                variable: '--p-colorpicker-handle-color',
                description: 'Color of handle'
            }
        ]
    },
    confirmdialog: {
        description: 'ConfirmDialog Design Tokens',
        tokens: [
            {
                name: 'confirmdialog.icon.size',
                token: 'confirmdialog.icon.size',
                variable: '--p-confirmdialog-icon-size',
                description: 'Size of icon'
            },
            {
                name: 'confirmdialog.icon.color',
                token: 'confirmdialog.icon.color',
                variable: '--p-confirmdialog-icon-color',
                description: 'Color of icon'
            },
            {
                name: 'confirmdialog.content.gap',
                token: 'confirmdialog.content.gap',
                variable: '--p-confirmdialog-content-gap',
                description: 'Gap of content'
            }
        ]
    },
    confirmpopup: {
        description: 'ConfirmPopup Design Tokens',
        tokens: [
            {
                name: 'confirmpopup.root.background',
                token: 'confirmpopup.background',
                variable: '--p-confirmpopup-background',
                description: 'Background of root'
            },
            {
                name: 'confirmpopup.root.borderColor',
                token: 'confirmpopup.border.color',
                variable: '--p-confirmpopup-border-color',
                description: 'Border color of root'
            },
            {
                name: 'confirmpopup.root.color',
                token: 'confirmpopup.color',
                variable: '--p-confirmpopup-color',
                description: 'Color of root'
            },
            {
                name: 'confirmpopup.root.borderRadius',
                token: 'confirmpopup.border.radius',
                variable: '--p-confirmpopup-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'confirmpopup.root.shadow',
                token: 'confirmpopup.shadow',
                variable: '--p-confirmpopup-shadow',
                description: 'Shadow of root'
            },
            {
                name: 'confirmpopup.root.gutter',
                token: 'confirmpopup.gutter',
                variable: '--p-confirmpopup-gutter',
                description: 'Gutter of root'
            },
            {
                name: 'confirmpopup.root.arrowOffset',
                token: 'confirmpopup.arrow.offset',
                variable: '--p-confirmpopup-arrow-offset',
                description: 'Arrow offset of root'
            },
            {
                name: 'confirmpopup.content.padding',
                token: 'confirmpopup.content.padding',
                variable: '--p-confirmpopup-content-padding',
                description: 'Padding of content'
            },
            {
                name: 'confirmpopup.content.gap',
                token: 'confirmpopup.content.gap',
                variable: '--p-confirmpopup-content-gap',
                description: 'Gap of content'
            },
            {
                name: 'confirmpopup.icon.size',
                token: 'confirmpopup.icon.size',
                variable: '--p-confirmpopup-icon-size',
                description: 'Size of icon'
            },
            {
                name: 'confirmpopup.icon.color',
                token: 'confirmpopup.icon.color',
                variable: '--p-confirmpopup-icon-color',
                description: 'Color of icon'
            },
            {
                name: 'confirmpopup.footer.gap',
                token: 'confirmpopup.footer.gap',
                variable: '--p-confirmpopup-footer-gap',
                description: 'Gap of footer'
            },
            {
                name: 'confirmpopup.footer.padding',
                token: 'confirmpopup.footer.padding',
                variable: '--p-confirmpopup-footer-padding',
                description: 'Padding of footer'
            }
        ]
    },
    contextmenu: {
        description: 'ContextMenu Design Tokens',
        tokens: [
            {
                name: 'contextmenu.root.background',
                token: 'contextmenu.background',
                variable: '--p-contextmenu-background',
                description: 'Background of root'
            },
            {
                name: 'contextmenu.root.borderColor',
                token: 'contextmenu.border.color',
                variable: '--p-contextmenu-border-color',
                description: 'Border color of root'
            },
            {
                name: 'contextmenu.root.color',
                token: 'contextmenu.color',
                variable: '--p-contextmenu-color',
                description: 'Color of root'
            },
            {
                name: 'contextmenu.root.borderRadius',
                token: 'contextmenu.border.radius',
                variable: '--p-contextmenu-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'contextmenu.root.shadow',
                token: 'contextmenu.shadow',
                variable: '--p-contextmenu-shadow',
                description: 'Shadow of root'
            },
            {
                name: 'contextmenu.root.transitionDuration',
                token: 'contextmenu.transition.duration',
                variable: '--p-contextmenu-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'contextmenu.list.padding',
                token: 'contextmenu.list.padding',
                variable: '--p-contextmenu-list-padding',
                description: 'Padding of list'
            },
            {
                name: 'contextmenu.list.gap',
                token: 'contextmenu.list.gap',
                variable: '--p-contextmenu-list-gap',
                description: 'Gap of list'
            },
            {
                name: 'contextmenu.item.focusBackground',
                token: 'contextmenu.item.focus.background',
                variable: '--p-contextmenu-item-focus-background',
                description: 'Focus background of item'
            },
            {
                name: 'contextmenu.item.activeBackground',
                token: 'contextmenu.item.active.background',
                variable: '--p-contextmenu-item-active-background',
                description: 'Active background of item'
            },
            {
                name: 'contextmenu.item.color',
                token: 'contextmenu.item.color',
                variable: '--p-contextmenu-item-color',
                description: 'Color of item'
            },
            {
                name: 'contextmenu.item.focusColor',
                token: 'contextmenu.item.focus.color',
                variable: '--p-contextmenu-item-focus-color',
                description: 'Focus color of item'
            },
            {
                name: 'contextmenu.item.activeColor',
                token: 'contextmenu.item.active.color',
                variable: '--p-contextmenu-item-active-color',
                description: 'Active color of item'
            },
            {
                name: 'contextmenu.item.padding',
                token: 'contextmenu.item.padding',
                variable: '--p-contextmenu-item-padding',
                description: 'Padding of item'
            },
            {
                name: 'contextmenu.item.borderRadius',
                token: 'contextmenu.item.border.radius',
                variable: '--p-contextmenu-item-border-radius',
                description: 'Border radius of item'
            },
            {
                name: 'contextmenu.item.gap',
                token: 'contextmenu.item.gap',
                variable: '--p-contextmenu-item-gap',
                description: 'Gap of item'
            },
            {
                name: 'contextmenu.item.icon.color',
                token: 'contextmenu.item.icon.color',
                variable: '--p-contextmenu-item-icon-color',
                description: 'Icon color of item'
            },
            {
                name: 'contextmenu.item.icon.focusColor',
                token: 'contextmenu.item.icon.focus.color',
                variable: '--p-contextmenu-item-icon-focus-color',
                description: 'Icon focus color of item'
            },
            {
                name: 'contextmenu.item.icon.activeColor',
                token: 'contextmenu.item.icon.active.color',
                variable: '--p-contextmenu-item-icon-active-color',
                description: 'Icon active color of item'
            },
            {
                name: 'contextmenu.submenu.mobileIndent',
                token: 'contextmenu.submenu.mobile.indent',
                variable: '--p-contextmenu-submenu-mobile-indent',
                description: 'Mobile indent of submenu'
            },
            {
                name: 'contextmenu.submenuIcon.size',
                token: 'contextmenu.submenu.icon.size',
                variable: '--p-contextmenu-submenu-icon-size',
                description: 'Size of submenu icon'
            },
            {
                name: 'contextmenu.submenuIcon.color',
                token: 'contextmenu.submenu.icon.color',
                variable: '--p-contextmenu-submenu-icon-color',
                description: 'Color of submenu icon'
            },
            {
                name: 'contextmenu.submenuIcon.focusColor',
                token: 'contextmenu.submenu.icon.focus.color',
                variable: '--p-contextmenu-submenu-icon-focus-color',
                description: 'Focus color of submenu icon'
            },
            {
                name: 'contextmenu.submenuIcon.activeColor',
                token: 'contextmenu.submenu.icon.active.color',
                variable: '--p-contextmenu-submenu-icon-active-color',
                description: 'Active color of submenu icon'
            },
            {
                name: 'contextmenu.separator.borderColor',
                token: 'contextmenu.separator.border.color',
                variable: '--p-contextmenu-separator-border-color',
                description: 'Border color of separator'
            }
        ]
    },
    datatable: {
        description: 'DataTable Design Tokens',
        tokens: [
            {
                name: 'datatable.root.transitionDuration',
                token: 'datatable.transition.duration',
                variable: '--p-datatable-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'datatable.root.borderColor',
                token: 'datatable.border.color',
                variable: '--p-datatable-border-color',
                description: 'Border color of root'
            },
            {
                name: 'datatable.header.background',
                token: 'datatable.header.background',
                variable: '--p-datatable-header-background',
                description: 'Background of header'
            },
            {
                name: 'datatable.header.borderColor',
                token: 'datatable.header.border.color',
                variable: '--p-datatable-header-border-color',
                description: 'Border color of header'
            },
            {
                name: 'datatable.header.color',
                token: 'datatable.header.color',
                variable: '--p-datatable-header-color',
                description: 'Color of header'
            },
            {
                name: 'datatable.header.borderWidth',
                token: 'datatable.header.border.width',
                variable: '--p-datatable-header-border-width',
                description: 'Border width of header'
            },
            {
                name: 'datatable.header.padding',
                token: 'datatable.header.padding',
                variable: '--p-datatable-header-padding',
                description: 'Padding of header'
            },
            {
                name: 'datatable.header.sm.padding',
                token: 'datatable.header.sm.padding',
                variable: '--p-datatable-header-sm-padding',
                description: 'Sm padding of header'
            },
            {
                name: 'datatable.header.lg.padding',
                token: 'datatable.header.lg.padding',
                variable: '--p-datatable-header-lg-padding',
                description: 'Lg padding of header'
            },
            {
                name: 'datatable.headerCell.background',
                token: 'datatable.header.cell.background',
                variable: '--p-datatable-header-cell-background',
                description: 'Background of header cell'
            },
            {
                name: 'datatable.headerCell.hoverBackground',
                token: 'datatable.header.cell.hover.background',
                variable: '--p-datatable-header-cell-hover-background',
                description: 'Hover background of header cell'
            },
            {
                name: 'datatable.headerCell.selectedBackground',
                token: 'datatable.header.cell.selected.background',
                variable: '--p-datatable-header-cell-selected-background',
                description: 'Selected background of header cell'
            },
            {
                name: 'datatable.headerCell.borderColor',
                token: 'datatable.header.cell.border.color',
                variable: '--p-datatable-header-cell-border-color',
                description: 'Border color of header cell'
            },
            {
                name: 'datatable.headerCell.color',
                token: 'datatable.header.cell.color',
                variable: '--p-datatable-header-cell-color',
                description: 'Color of header cell'
            },
            {
                name: 'datatable.headerCell.hoverColor',
                token: 'datatable.header.cell.hover.color',
                variable: '--p-datatable-header-cell-hover-color',
                description: 'Hover color of header cell'
            },
            {
                name: 'datatable.headerCell.selectedColor',
                token: 'datatable.header.cell.selected.color',
                variable: '--p-datatable-header-cell-selected-color',
                description: 'Selected color of header cell'
            },
            {
                name: 'datatable.headerCell.gap',
                token: 'datatable.header.cell.gap',
                variable: '--p-datatable-header-cell-gap',
                description: 'Gap of header cell'
            },
            {
                name: 'datatable.headerCell.padding',
                token: 'datatable.header.cell.padding',
                variable: '--p-datatable-header-cell-padding',
                description: 'Padding of header cell'
            },
            {
                name: 'datatable.headerCell.focusRing.width',
                token: 'datatable.header.cell.focus.ring.width',
                variable: '--p-datatable-header-cell-focus-ring-width',
                description: 'Focus ring width of header cell'
            },
            {
                name: 'datatable.headerCell.focusRing.style',
                token: 'datatable.header.cell.focus.ring.style',
                variable: '--p-datatable-header-cell-focus-ring-style',
                description: 'Focus ring style of header cell'
            },
            {
                name: 'datatable.headerCell.focusRing.color',
                token: 'datatable.header.cell.focus.ring.color',
                variable: '--p-datatable-header-cell-focus-ring-color',
                description: 'Focus ring color of header cell'
            },
            {
                name: 'datatable.headerCell.focusRing.offset',
                token: 'datatable.header.cell.focus.ring.offset',
                variable: '--p-datatable-header-cell-focus-ring-offset',
                description: 'Focus ring offset of header cell'
            },
            {
                name: 'datatable.headerCell.focusRing.shadow',
                token: 'datatable.header.cell.focus.ring.shadow',
                variable: '--p-datatable-header-cell-focus-ring-shadow',
                description: 'Focus ring shadow of header cell'
            },
            {
                name: 'datatable.headerCell.sm.padding',
                token: 'datatable.header.cell.sm.padding',
                variable: '--p-datatable-header-cell-sm-padding',
                description: 'Sm padding of header cell'
            },
            {
                name: 'datatable.headerCell.lg.padding',
                token: 'datatable.header.cell.lg.padding',
                variable: '--p-datatable-header-cell-lg-padding',
                description: 'Lg padding of header cell'
            },
            {
                name: 'datatable.columnTitle.fontWeight',
                token: 'datatable.column.title.font.weight',
                variable: '--p-datatable-column-title-font-weight',
                description: 'Font weight of column title'
            },
            {
                name: 'datatable.row.background',
                token: 'datatable.row.background',
                variable: '--p-datatable-row-background',
                description: 'Background of row'
            },
            {
                name: 'datatable.row.hoverBackground',
                token: 'datatable.row.hover.background',
                variable: '--p-datatable-row-hover-background',
                description: 'Hover background of row'
            },
            {
                name: 'datatable.row.selectedBackground',
                token: 'datatable.row.selected.background',
                variable: '--p-datatable-row-selected-background',
                description: 'Selected background of row'
            },
            {
                name: 'datatable.row.color',
                token: 'datatable.row.color',
                variable: '--p-datatable-row-color',
                description: 'Color of row'
            },
            {
                name: 'datatable.row.hoverColor',
                token: 'datatable.row.hover.color',
                variable: '--p-datatable-row-hover-color',
                description: 'Hover color of row'
            },
            {
                name: 'datatable.row.selectedColor',
                token: 'datatable.row.selected.color',
                variable: '--p-datatable-row-selected-color',
                description: 'Selected color of row'
            },
            {
                name: 'datatable.row.focusRing.width',
                token: 'datatable.row.focus.ring.width',
                variable: '--p-datatable-row-focus-ring-width',
                description: 'Focus ring width of row'
            },
            {
                name: 'datatable.row.focusRing.style',
                token: 'datatable.row.focus.ring.style',
                variable: '--p-datatable-row-focus-ring-style',
                description: 'Focus ring style of row'
            },
            {
                name: 'datatable.row.focusRing.color',
                token: 'datatable.row.focus.ring.color',
                variable: '--p-datatable-row-focus-ring-color',
                description: 'Focus ring color of row'
            },
            {
                name: 'datatable.row.focusRing.offset',
                token: 'datatable.row.focus.ring.offset',
                variable: '--p-datatable-row-focus-ring-offset',
                description: 'Focus ring offset of row'
            },
            {
                name: 'datatable.row.focusRing.shadow',
                token: 'datatable.row.focus.ring.shadow',
                variable: '--p-datatable-row-focus-ring-shadow',
                description: 'Focus ring shadow of row'
            },
            {
                name: 'datatable.row.stripedBackground',
                token: 'datatable.row.striped.background',
                variable: '--p-datatable-row-striped-background',
                description: 'Striped background of row'
            },
            {
                name: 'datatable.bodyCell.borderColor',
                token: 'datatable.body.cell.border.color',
                variable: '--p-datatable-body-cell-border-color',
                description: 'Border color of body cell'
            },
            {
                name: 'datatable.bodyCell.padding',
                token: 'datatable.body.cell.padding',
                variable: '--p-datatable-body-cell-padding',
                description: 'Padding of body cell'
            },
            {
                name: 'datatable.bodyCell.sm.padding',
                token: 'datatable.body.cell.sm.padding',
                variable: '--p-datatable-body-cell-sm-padding',
                description: 'Sm padding of body cell'
            },
            {
                name: 'datatable.bodyCell.lg.padding',
                token: 'datatable.body.cell.lg.padding',
                variable: '--p-datatable-body-cell-lg-padding',
                description: 'Lg padding of body cell'
            },
            {
                name: 'datatable.bodyCell.selectedBorderColor',
                token: 'datatable.body.cell.selected.border.color',
                variable: '--p-datatable-body-cell-selected-border-color',
                description: 'Selected border color of body cell'
            },
            {
                name: 'datatable.footerCell.background',
                token: 'datatable.footer.cell.background',
                variable: '--p-datatable-footer-cell-background',
                description: 'Background of footer cell'
            },
            {
                name: 'datatable.footerCell.borderColor',
                token: 'datatable.footer.cell.border.color',
                variable: '--p-datatable-footer-cell-border-color',
                description: 'Border color of footer cell'
            },
            {
                name: 'datatable.footerCell.color',
                token: 'datatable.footer.cell.color',
                variable: '--p-datatable-footer-cell-color',
                description: 'Color of footer cell'
            },
            {
                name: 'datatable.footerCell.padding',
                token: 'datatable.footer.cell.padding',
                variable: '--p-datatable-footer-cell-padding',
                description: 'Padding of footer cell'
            },
            {
                name: 'datatable.footerCell.sm.padding',
                token: 'datatable.footer.cell.sm.padding',
                variable: '--p-datatable-footer-cell-sm-padding',
                description: 'Sm padding of footer cell'
            },
            {
                name: 'datatable.footerCell.lg.padding',
                token: 'datatable.footer.cell.lg.padding',
                variable: '--p-datatable-footer-cell-lg-padding',
                description: 'Lg padding of footer cell'
            },
            {
                name: 'datatable.columnFooter.fontWeight',
                token: 'datatable.column.footer.font.weight',
                variable: '--p-datatable-column-footer-font-weight',
                description: 'Font weight of column footer'
            },
            {
                name: 'datatable.footer.background',
                token: 'datatable.footer.background',
                variable: '--p-datatable-footer-background',
                description: 'Background of footer'
            },
            {
                name: 'datatable.footer.borderColor',
                token: 'datatable.footer.border.color',
                variable: '--p-datatable-footer-border-color',
                description: 'Border color of footer'
            },
            {
                name: 'datatable.footer.color',
                token: 'datatable.footer.color',
                variable: '--p-datatable-footer-color',
                description: 'Color of footer'
            },
            {
                name: 'datatable.footer.borderWidth',
                token: 'datatable.footer.border.width',
                variable: '--p-datatable-footer-border-width',
                description: 'Border width of footer'
            },
            {
                name: 'datatable.footer.padding',
                token: 'datatable.footer.padding',
                variable: '--p-datatable-footer-padding',
                description: 'Padding of footer'
            },
            {
                name: 'datatable.footer.sm.padding',
                token: 'datatable.footer.sm.padding',
                variable: '--p-datatable-footer-sm-padding',
                description: 'Sm padding of footer'
            },
            {
                name: 'datatable.footer.lg.padding',
                token: 'datatable.footer.lg.padding',
                variable: '--p-datatable-footer-lg-padding',
                description: 'Lg padding of footer'
            },
            {
                name: 'datatable.dropPoint.color',
                token: 'datatable.drop.point.color',
                variable: '--p-datatable-drop-point-color',
                description: 'Color of drop point'
            },
            {
                name: 'datatable.columnResizer.width',
                token: 'datatable.column.resizer.width',
                variable: '--p-datatable-column-resizer-width',
                description: 'Width of column resizer'
            },
            {
                name: 'datatable.resizeIndicator.width',
                token: 'datatable.resize.indicator.width',
                variable: '--p-datatable-resize-indicator-width',
                description: 'Width of resize indicator'
            },
            {
                name: 'datatable.resizeIndicator.color',
                token: 'datatable.resize.indicator.color',
                variable: '--p-datatable-resize-indicator-color',
                description: 'Color of resize indicator'
            },
            {
                name: 'datatable.sortIcon.color',
                token: 'datatable.sort.icon.color',
                variable: '--p-datatable-sort-icon-color',
                description: 'Color of sort icon'
            },
            {
                name: 'datatable.sortIcon.hoverColor',
                token: 'datatable.sort.icon.hover.color',
                variable: '--p-datatable-sort-icon-hover-color',
                description: 'Hover color of sort icon'
            },
            {
                name: 'datatable.sortIcon.size',
                token: 'datatable.sort.icon.size',
                variable: '--p-datatable-sort-icon-size',
                description: 'Size of sort icon'
            },
            {
                name: 'datatable.loadingIcon.size',
                token: 'datatable.loading.icon.size',
                variable: '--p-datatable-loading-icon-size',
                description: 'Size of loading icon'
            },
            {
                name: 'datatable.rowToggleButton.hoverBackground',
                token: 'datatable.row.toggle.button.hover.background',
                variable: '--p-datatable-row-toggle-button-hover-background',
                description: 'Hover background of row toggle button'
            },
            {
                name: 'datatable.rowToggleButton.selectedHoverBackground',
                token: 'datatable.row.toggle.button.selected.hover.background',
                variable: '--p-datatable-row-toggle-button-selected-hover-background',
                description: 'Selected hover background of row toggle button'
            },
            {
                name: 'datatable.rowToggleButton.color',
                token: 'datatable.row.toggle.button.color',
                variable: '--p-datatable-row-toggle-button-color',
                description: 'Color of row toggle button'
            },
            {
                name: 'datatable.rowToggleButton.hoverColor',
                token: 'datatable.row.toggle.button.hover.color',
                variable: '--p-datatable-row-toggle-button-hover-color',
                description: 'Hover color of row toggle button'
            },
            {
                name: 'datatable.rowToggleButton.selectedHoverColor',
                token: 'datatable.row.toggle.button.selected.hover.color',
                variable: '--p-datatable-row-toggle-button-selected-hover-color',
                description: 'Selected hover color of row toggle button'
            },
            {
                name: 'datatable.rowToggleButton.size',
                token: 'datatable.row.toggle.button.size',
                variable: '--p-datatable-row-toggle-button-size',
                description: 'Size of row toggle button'
            },
            {
                name: 'datatable.rowToggleButton.borderRadius',
                token: 'datatable.row.toggle.button.border.radius',
                variable: '--p-datatable-row-toggle-button-border-radius',
                description: 'Border radius of row toggle button'
            },
            {
                name: 'datatable.rowToggleButton.focusRing.width',
                token: 'datatable.row.toggle.button.focus.ring.width',
                variable: '--p-datatable-row-toggle-button-focus-ring-width',
                description: 'Focus ring width of row toggle button'
            },
            {
                name: 'datatable.rowToggleButton.focusRing.style',
                token: 'datatable.row.toggle.button.focus.ring.style',
                variable: '--p-datatable-row-toggle-button-focus-ring-style',
                description: 'Focus ring style of row toggle button'
            },
            {
                name: 'datatable.rowToggleButton.focusRing.color',
                token: 'datatable.row.toggle.button.focus.ring.color',
                variable: '--p-datatable-row-toggle-button-focus-ring-color',
                description: 'Focus ring color of row toggle button'
            },
            {
                name: 'datatable.rowToggleButton.focusRing.offset',
                token: 'datatable.row.toggle.button.focus.ring.offset',
                variable: '--p-datatable-row-toggle-button-focus-ring-offset',
                description: 'Focus ring offset of row toggle button'
            },
            {
                name: 'datatable.rowToggleButton.focusRing.shadow',
                token: 'datatable.row.toggle.button.focus.ring.shadow',
                variable: '--p-datatable-row-toggle-button-focus-ring-shadow',
                description: 'Focus ring shadow of row toggle button'
            },
            {
                name: 'datatable.filter.inlineGap',
                token: 'datatable.filter.inline.gap',
                variable: '--p-datatable-filter-inline-gap',
                description: 'Inline gap of filter'
            },
            {
                name: 'datatable.filter.overlaySelect.background',
                token: 'datatable.filter.overlay.select.background',
                variable: '--p-datatable-filter-overlay-select-background',
                description: 'Overlay select background of filter'
            },
            {
                name: 'datatable.filter.overlaySelect.borderColor',
                token: 'datatable.filter.overlay.select.border.color',
                variable: '--p-datatable-filter-overlay-select-border-color',
                description: 'Overlay select border color of filter'
            },
            {
                name: 'datatable.filter.overlaySelect.borderRadius',
                token: 'datatable.filter.overlay.select.border.radius',
                variable: '--p-datatable-filter-overlay-select-border-radius',
                description: 'Overlay select border radius of filter'
            },
            {
                name: 'datatable.filter.overlaySelect.color',
                token: 'datatable.filter.overlay.select.color',
                variable: '--p-datatable-filter-overlay-select-color',
                description: 'Overlay select color of filter'
            },
            {
                name: 'datatable.filter.overlaySelect.shadow',
                token: 'datatable.filter.overlay.select.shadow',
                variable: '--p-datatable-filter-overlay-select-shadow',
                description: 'Overlay select shadow of filter'
            },
            {
                name: 'datatable.filter.overlayPopover.background',
                token: 'datatable.filter.overlay.popover.background',
                variable: '--p-datatable-filter-overlay-popover-background',
                description: 'Overlay popover background of filter'
            },
            {
                name: 'datatable.filter.overlayPopover.borderColor',
                token: 'datatable.filter.overlay.popover.border.color',
                variable: '--p-datatable-filter-overlay-popover-border-color',
                description: 'Overlay popover border color of filter'
            },
            {
                name: 'datatable.filter.overlayPopover.borderRadius',
                token: 'datatable.filter.overlay.popover.border.radius',
                variable: '--p-datatable-filter-overlay-popover-border-radius',
                description: 'Overlay popover border radius of filter'
            },
            {
                name: 'datatable.filter.overlayPopover.color',
                token: 'datatable.filter.overlay.popover.color',
                variable: '--p-datatable-filter-overlay-popover-color',
                description: 'Overlay popover color of filter'
            },
            {
                name: 'datatable.filter.overlayPopover.shadow',
                token: 'datatable.filter.overlay.popover.shadow',
                variable: '--p-datatable-filter-overlay-popover-shadow',
                description: 'Overlay popover shadow of filter'
            },
            {
                name: 'datatable.filter.overlayPopover.padding',
                token: 'datatable.filter.overlay.popover.padding',
                variable: '--p-datatable-filter-overlay-popover-padding',
                description: 'Overlay popover padding of filter'
            },
            {
                name: 'datatable.filter.overlayPopover.gap',
                token: 'datatable.filter.overlay.popover.gap',
                variable: '--p-datatable-filter-overlay-popover-gap',
                description: 'Overlay popover gap of filter'
            },
            {
                name: 'datatable.filter.rule.borderColor',
                token: 'datatable.filter.rule.border.color',
                variable: '--p-datatable-filter-rule-border-color',
                description: 'Rule border color of filter'
            },
            {
                name: 'datatable.filter.constraintList.padding',
                token: 'datatable.filter.constraint.list.padding',
                variable: '--p-datatable-filter-constraint-list-padding',
                description: 'Constraint list padding of filter'
            },
            {
                name: 'datatable.filter.constraintList.gap',
                token: 'datatable.filter.constraint.list.gap',
                variable: '--p-datatable-filter-constraint-list-gap',
                description: 'Constraint list gap of filter'
            },
            {
                name: 'datatable.filter.constraint.focusBackground',
                token: 'datatable.filter.constraint.focus.background',
                variable: '--p-datatable-filter-constraint-focus-background',
                description: 'Constraint focus background of filter'
            },
            {
                name: 'datatable.filter.constraint.selectedBackground',
                token: 'datatable.filter.constraint.selected.background',
                variable: '--p-datatable-filter-constraint-selected-background',
                description: 'Constraint selected background of filter'
            },
            {
                name: 'datatable.filter.constraint.selectedFocusBackground',
                token: 'datatable.filter.constraint.selected.focus.background',
                variable: '--p-datatable-filter-constraint-selected-focus-background',
                description: 'Constraint selected focus background of filter'
            },
            {
                name: 'datatable.filter.constraint.color',
                token: 'datatable.filter.constraint.color',
                variable: '--p-datatable-filter-constraint-color',
                description: 'Constraint color of filter'
            },
            {
                name: 'datatable.filter.constraint.focusColor',
                token: 'datatable.filter.constraint.focus.color',
                variable: '--p-datatable-filter-constraint-focus-color',
                description: 'Constraint focus color of filter'
            },
            {
                name: 'datatable.filter.constraint.selectedColor',
                token: 'datatable.filter.constraint.selected.color',
                variable: '--p-datatable-filter-constraint-selected-color',
                description: 'Constraint selected color of filter'
            },
            {
                name: 'datatable.filter.constraint.selectedFocusColor',
                token: 'datatable.filter.constraint.selected.focus.color',
                variable: '--p-datatable-filter-constraint-selected-focus-color',
                description: 'Constraint selected focus color of filter'
            },
            {
                name: 'datatable.filter.constraint.separator.borderColor',
                token: 'datatable.filter.constraint.separator.border.color',
                variable: '--p-datatable-filter-constraint-separator-border-color',
                description: 'Constraint separator border color of filter'
            },
            {
                name: 'datatable.filter.constraint.padding',
                token: 'datatable.filter.constraint.padding',
                variable: '--p-datatable-filter-constraint-padding',
                description: 'Constraint padding of filter'
            },
            {
                name: 'datatable.filter.constraint.borderRadius',
                token: 'datatable.filter.constraint.border.radius',
                variable: '--p-datatable-filter-constraint-border-radius',
                description: 'Constraint border radius of filter'
            },
            {
                name: 'datatable.paginatorTop.borderColor',
                token: 'datatable.paginator.top.border.color',
                variable: '--p-datatable-paginator-top-border-color',
                description: 'Border color of paginator top'
            },
            {
                name: 'datatable.paginatorTop.borderWidth',
                token: 'datatable.paginator.top.border.width',
                variable: '--p-datatable-paginator-top-border-width',
                description: 'Border width of paginator top'
            },
            {
                name: 'datatable.paginatorBottom.borderColor',
                token: 'datatable.paginator.bottom.border.color',
                variable: '--p-datatable-paginator-bottom-border-color',
                description: 'Border color of paginator bottom'
            },
            {
                name: 'datatable.paginatorBottom.borderWidth',
                token: 'datatable.paginator.bottom.border.width',
                variable: '--p-datatable-paginator-bottom-border-width',
                description: 'Border width of paginator bottom'
            }
        ]
    },
    dataview: {
        description: 'DataView Design Tokens',
        tokens: [
            {
                name: 'dataview.root.borderColor',
                token: 'dataview.border.color',
                variable: '--p-dataview-border-color',
                description: 'Border color of root'
            },
            {
                name: 'dataview.root.borderWidth',
                token: 'dataview.border.width',
                variable: '--p-dataview-border-width',
                description: 'Border width of root'
            },
            {
                name: 'dataview.root.borderRadius',
                token: 'dataview.border.radius',
                variable: '--p-dataview-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'dataview.root.padding',
                token: 'dataview.padding',
                variable: '--p-dataview-padding',
                description: 'Padding of root'
            },
            {
                name: 'dataview.header.background',
                token: 'dataview.header.background',
                variable: '--p-dataview-header-background',
                description: 'Background of header'
            },
            {
                name: 'dataview.header.color',
                token: 'dataview.header.color',
                variable: '--p-dataview-header-color',
                description: 'Color of header'
            },
            {
                name: 'dataview.header.borderColor',
                token: 'dataview.header.border.color',
                variable: '--p-dataview-header-border-color',
                description: 'Border color of header'
            },
            {
                name: 'dataview.header.borderWidth',
                token: 'dataview.header.border.width',
                variable: '--p-dataview-header-border-width',
                description: 'Border width of header'
            },
            {
                name: 'dataview.header.padding',
                token: 'dataview.header.padding',
                variable: '--p-dataview-header-padding',
                description: 'Padding of header'
            },
            {
                name: 'dataview.header.borderRadius',
                token: 'dataview.header.border.radius',
                variable: '--p-dataview-header-border-radius',
                description: 'Border radius of header'
            },
            {
                name: 'dataview.content.background',
                token: 'dataview.content.background',
                variable: '--p-dataview-content-background',
                description: 'Background of content'
            },
            {
                name: 'dataview.content.color',
                token: 'dataview.content.color',
                variable: '--p-dataview-content-color',
                description: 'Color of content'
            },
            {
                name: 'dataview.content.borderColor',
                token: 'dataview.content.border.color',
                variable: '--p-dataview-content-border-color',
                description: 'Border color of content'
            },
            {
                name: 'dataview.content.borderWidth',
                token: 'dataview.content.border.width',
                variable: '--p-dataview-content-border-width',
                description: 'Border width of content'
            },
            {
                name: 'dataview.content.padding',
                token: 'dataview.content.padding',
                variable: '--p-dataview-content-padding',
                description: 'Padding of content'
            },
            {
                name: 'dataview.content.borderRadius',
                token: 'dataview.content.border.radius',
                variable: '--p-dataview-content-border-radius',
                description: 'Border radius of content'
            },
            {
                name: 'dataview.footer.background',
                token: 'dataview.footer.background',
                variable: '--p-dataview-footer-background',
                description: 'Background of footer'
            },
            {
                name: 'dataview.footer.color',
                token: 'dataview.footer.color',
                variable: '--p-dataview-footer-color',
                description: 'Color of footer'
            },
            {
                name: 'dataview.footer.borderColor',
                token: 'dataview.footer.border.color',
                variable: '--p-dataview-footer-border-color',
                description: 'Border color of footer'
            },
            {
                name: 'dataview.footer.borderWidth',
                token: 'dataview.footer.border.width',
                variable: '--p-dataview-footer-border-width',
                description: 'Border width of footer'
            },
            {
                name: 'dataview.footer.padding',
                token: 'dataview.footer.padding',
                variable: '--p-dataview-footer-padding',
                description: 'Padding of footer'
            },
            {
                name: 'dataview.footer.borderRadius',
                token: 'dataview.footer.border.radius',
                variable: '--p-dataview-footer-border-radius',
                description: 'Border radius of footer'
            },
            {
                name: 'dataview.paginatorTop.borderColor',
                token: 'dataview.paginator.top.border.color',
                variable: '--p-dataview-paginator-top-border-color',
                description: 'Border color of paginator top'
            },
            {
                name: 'dataview.paginatorTop.borderWidth',
                token: 'dataview.paginator.top.border.width',
                variable: '--p-dataview-paginator-top-border-width',
                description: 'Border width of paginator top'
            },
            {
                name: 'dataview.paginatorBottom.borderColor',
                token: 'dataview.paginator.bottom.border.color',
                variable: '--p-dataview-paginator-bottom-border-color',
                description: 'Border color of paginator bottom'
            },
            {
                name: 'dataview.paginatorBottom.borderWidth',
                token: 'dataview.paginator.bottom.border.width',
                variable: '--p-dataview-paginator-bottom-border-width',
                description: 'Border width of paginator bottom'
            }
        ]
    },
    datepicker: {
        description: 'DatePicker Design Tokens',
        tokens: [
            {
                name: 'datepicker.root.transitionDuration',
                token: 'datepicker.transition.duration',
                variable: '--p-datepicker-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'datepicker.panel.background',
                token: 'datepicker.panel.background',
                variable: '--p-datepicker-panel-background',
                description: 'Background of panel'
            },
            {
                name: 'datepicker.panel.borderColor',
                token: 'datepicker.panel.border.color',
                variable: '--p-datepicker-panel-border-color',
                description: 'Border color of panel'
            },
            {
                name: 'datepicker.panel.color',
                token: 'datepicker.panel.color',
                variable: '--p-datepicker-panel-color',
                description: 'Color of panel'
            },
            {
                name: 'datepicker.panel.borderRadius',
                token: 'datepicker.panel.border.radius',
                variable: '--p-datepicker-panel-border-radius',
                description: 'Border radius of panel'
            },
            {
                name: 'datepicker.panel.shadow',
                token: 'datepicker.panel.shadow',
                variable: '--p-datepicker-panel-shadow',
                description: 'Shadow of panel'
            },
            {
                name: 'datepicker.panel.padding',
                token: 'datepicker.panel.padding',
                variable: '--p-datepicker-panel-padding',
                description: 'Padding of panel'
            },
            {
                name: 'datepicker.header.background',
                token: 'datepicker.header.background',
                variable: '--p-datepicker-header-background',
                description: 'Background of header'
            },
            {
                name: 'datepicker.header.borderColor',
                token: 'datepicker.header.border.color',
                variable: '--p-datepicker-header-border-color',
                description: 'Border color of header'
            },
            {
                name: 'datepicker.header.color',
                token: 'datepicker.header.color',
                variable: '--p-datepicker-header-color',
                description: 'Color of header'
            },
            {
                name: 'datepicker.header.padding',
                token: 'datepicker.header.padding',
                variable: '--p-datepicker-header-padding',
                description: 'Padding of header'
            },
            {
                name: 'datepicker.title.gap',
                token: 'datepicker.title.gap',
                variable: '--p-datepicker-title-gap',
                description: 'Gap of title'
            },
            {
                name: 'datepicker.title.fontWeight',
                token: 'datepicker.title.font.weight',
                variable: '--p-datepicker-title-font-weight',
                description: 'Font weight of title'
            },
            {
                name: 'datepicker.dropdown.width',
                token: 'datepicker.dropdown.width',
                variable: '--p-datepicker-dropdown-width',
                description: 'Width of dropdown'
            },
            {
                name: 'datepicker.dropdown.sm.width',
                token: 'datepicker.dropdown.sm.width',
                variable: '--p-datepicker-dropdown-sm-width',
                description: 'Sm width of dropdown'
            },
            {
                name: 'datepicker.dropdown.lg.width',
                token: 'datepicker.dropdown.lg.width',
                variable: '--p-datepicker-dropdown-lg-width',
                description: 'Lg width of dropdown'
            },
            {
                name: 'datepicker.dropdown.borderColor',
                token: 'datepicker.dropdown.border.color',
                variable: '--p-datepicker-dropdown-border-color',
                description: 'Border color of dropdown'
            },
            {
                name: 'datepicker.dropdown.hoverBorderColor',
                token: 'datepicker.dropdown.hover.border.color',
                variable: '--p-datepicker-dropdown-hover-border-color',
                description: 'Hover border color of dropdown'
            },
            {
                name: 'datepicker.dropdown.activeBorderColor',
                token: 'datepicker.dropdown.active.border.color',
                variable: '--p-datepicker-dropdown-active-border-color',
                description: 'Active border color of dropdown'
            },
            {
                name: 'datepicker.dropdown.borderRadius',
                token: 'datepicker.dropdown.border.radius',
                variable: '--p-datepicker-dropdown-border-radius',
                description: 'Border radius of dropdown'
            },
            {
                name: 'datepicker.dropdown.focusRing.width',
                token: 'datepicker.dropdown.focus.ring.width',
                variable: '--p-datepicker-dropdown-focus-ring-width',
                description: 'Focus ring width of dropdown'
            },
            {
                name: 'datepicker.dropdown.focusRing.style',
                token: 'datepicker.dropdown.focus.ring.style',
                variable: '--p-datepicker-dropdown-focus-ring-style',
                description: 'Focus ring style of dropdown'
            },
            {
                name: 'datepicker.dropdown.focusRing.color',
                token: 'datepicker.dropdown.focus.ring.color',
                variable: '--p-datepicker-dropdown-focus-ring-color',
                description: 'Focus ring color of dropdown'
            },
            {
                name: 'datepicker.dropdown.focusRing.offset',
                token: 'datepicker.dropdown.focus.ring.offset',
                variable: '--p-datepicker-dropdown-focus-ring-offset',
                description: 'Focus ring offset of dropdown'
            },
            {
                name: 'datepicker.dropdown.focusRing.shadow',
                token: 'datepicker.dropdown.focus.ring.shadow',
                variable: '--p-datepicker-dropdown-focus-ring-shadow',
                description: 'Focus ring shadow of dropdown'
            },
            {
                name: 'datepicker.dropdown.background',
                token: 'datepicker.dropdown.background',
                variable: '--p-datepicker-dropdown-background',
                description: 'Background of dropdown'
            },
            {
                name: 'datepicker.dropdown.hoverBackground',
                token: 'datepicker.dropdown.hover.background',
                variable: '--p-datepicker-dropdown-hover-background',
                description: 'Hover background of dropdown'
            },
            {
                name: 'datepicker.dropdown.activeBackground',
                token: 'datepicker.dropdown.active.background',
                variable: '--p-datepicker-dropdown-active-background',
                description: 'Active background of dropdown'
            },
            {
                name: 'datepicker.dropdown.color',
                token: 'datepicker.dropdown.color',
                variable: '--p-datepicker-dropdown-color',
                description: 'Color of dropdown'
            },
            {
                name: 'datepicker.dropdown.hoverColor',
                token: 'datepicker.dropdown.hover.color',
                variable: '--p-datepicker-dropdown-hover-color',
                description: 'Hover color of dropdown'
            },
            {
                name: 'datepicker.dropdown.activeColor',
                token: 'datepicker.dropdown.active.color',
                variable: '--p-datepicker-dropdown-active-color',
                description: 'Active color of dropdown'
            },
            {
                name: 'datepicker.inputIcon.color',
                token: 'datepicker.input.icon.color',
                variable: '--p-datepicker-input-icon-color',
                description: 'Color of input icon'
            },
            {
                name: 'datepicker.selectMonth.hoverBackground',
                token: 'datepicker.select.month.hover.background',
                variable: '--p-datepicker-select-month-hover-background',
                description: 'Hover background of select month'
            },
            {
                name: 'datepicker.selectMonth.color',
                token: 'datepicker.select.month.color',
                variable: '--p-datepicker-select-month-color',
                description: 'Color of select month'
            },
            {
                name: 'datepicker.selectMonth.hoverColor',
                token: 'datepicker.select.month.hover.color',
                variable: '--p-datepicker-select-month-hover-color',
                description: 'Hover color of select month'
            },
            {
                name: 'datepicker.selectMonth.padding',
                token: 'datepicker.select.month.padding',
                variable: '--p-datepicker-select-month-padding',
                description: 'Padding of select month'
            },
            {
                name: 'datepicker.selectMonth.borderRadius',
                token: 'datepicker.select.month.border.radius',
                variable: '--p-datepicker-select-month-border-radius',
                description: 'Border radius of select month'
            },
            {
                name: 'datepicker.selectYear.hoverBackground',
                token: 'datepicker.select.year.hover.background',
                variable: '--p-datepicker-select-year-hover-background',
                description: 'Hover background of select year'
            },
            {
                name: 'datepicker.selectYear.color',
                token: 'datepicker.select.year.color',
                variable: '--p-datepicker-select-year-color',
                description: 'Color of select year'
            },
            {
                name: 'datepicker.selectYear.hoverColor',
                token: 'datepicker.select.year.hover.color',
                variable: '--p-datepicker-select-year-hover-color',
                description: 'Hover color of select year'
            },
            {
                name: 'datepicker.selectYear.padding',
                token: 'datepicker.select.year.padding',
                variable: '--p-datepicker-select-year-padding',
                description: 'Padding of select year'
            },
            {
                name: 'datepicker.selectYear.borderRadius',
                token: 'datepicker.select.year.border.radius',
                variable: '--p-datepicker-select-year-border-radius',
                description: 'Border radius of select year'
            },
            {
                name: 'datepicker.group.borderColor',
                token: 'datepicker.group.border.color',
                variable: '--p-datepicker-group-border-color',
                description: 'Border color of group'
            },
            {
                name: 'datepicker.group.gap',
                token: 'datepicker.group.gap',
                variable: '--p-datepicker-group-gap',
                description: 'Gap of group'
            },
            {
                name: 'datepicker.dayView.margin',
                token: 'datepicker.day.view.margin',
                variable: '--p-datepicker-day-view-margin',
                description: 'Margin of day view'
            },
            {
                name: 'datepicker.weekDay.padding',
                token: 'datepicker.week.day.padding',
                variable: '--p-datepicker-week-day-padding',
                description: 'Padding of week day'
            },
            {
                name: 'datepicker.weekDay.fontWeight',
                token: 'datepicker.week.day.font.weight',
                variable: '--p-datepicker-week-day-font-weight',
                description: 'Font weight of week day'
            },
            {
                name: 'datepicker.weekDay.color',
                token: 'datepicker.week.day.color',
                variable: '--p-datepicker-week-day-color',
                description: 'Color of week day'
            },
            {
                name: 'datepicker.date.hoverBackground',
                token: 'datepicker.date.hover.background',
                variable: '--p-datepicker-date-hover-background',
                description: 'Hover background of date'
            },
            {
                name: 'datepicker.date.selectedBackground',
                token: 'datepicker.date.selected.background',
                variable: '--p-datepicker-date-selected-background',
                description: 'Selected background of date'
            },
            {
                name: 'datepicker.date.rangeSelectedBackground',
                token: 'datepicker.date.range.selected.background',
                variable: '--p-datepicker-date-range-selected-background',
                description: 'Range selected background of date'
            },
            {
                name: 'datepicker.date.color',
                token: 'datepicker.date.color',
                variable: '--p-datepicker-date-color',
                description: 'Color of date'
            },
            {
                name: 'datepicker.date.hoverColor',
                token: 'datepicker.date.hover.color',
                variable: '--p-datepicker-date-hover-color',
                description: 'Hover color of date'
            },
            {
                name: 'datepicker.date.selectedColor',
                token: 'datepicker.date.selected.color',
                variable: '--p-datepicker-date-selected-color',
                description: 'Selected color of date'
            },
            {
                name: 'datepicker.date.rangeSelectedColor',
                token: 'datepicker.date.range.selected.color',
                variable: '--p-datepicker-date-range-selected-color',
                description: 'Range selected color of date'
            },
            {
                name: 'datepicker.date.width',
                token: 'datepicker.date.width',
                variable: '--p-datepicker-date-width',
                description: 'Width of date'
            },
            {
                name: 'datepicker.date.height',
                token: 'datepicker.date.height',
                variable: '--p-datepicker-date-height',
                description: 'Height of date'
            },
            {
                name: 'datepicker.date.borderRadius',
                token: 'datepicker.date.border.radius',
                variable: '--p-datepicker-date-border-radius',
                description: 'Border radius of date'
            },
            {
                name: 'datepicker.date.padding',
                token: 'datepicker.date.padding',
                variable: '--p-datepicker-date-padding',
                description: 'Padding of date'
            },
            {
                name: 'datepicker.date.focusRing.width',
                token: 'datepicker.date.focus.ring.width',
                variable: '--p-datepicker-date-focus-ring-width',
                description: 'Focus ring width of date'
            },
            {
                name: 'datepicker.date.focusRing.style',
                token: 'datepicker.date.focus.ring.style',
                variable: '--p-datepicker-date-focus-ring-style',
                description: 'Focus ring style of date'
            },
            {
                name: 'datepicker.date.focusRing.color',
                token: 'datepicker.date.focus.ring.color',
                variable: '--p-datepicker-date-focus-ring-color',
                description: 'Focus ring color of date'
            },
            {
                name: 'datepicker.date.focusRing.offset',
                token: 'datepicker.date.focus.ring.offset',
                variable: '--p-datepicker-date-focus-ring-offset',
                description: 'Focus ring offset of date'
            },
            {
                name: 'datepicker.date.focusRing.shadow',
                token: 'datepicker.date.focus.ring.shadow',
                variable: '--p-datepicker-date-focus-ring-shadow',
                description: 'Focus ring shadow of date'
            },
            {
                name: 'datepicker.monthView.margin',
                token: 'datepicker.month.view.margin',
                variable: '--p-datepicker-month-view-margin',
                description: 'Margin of month view'
            },
            {
                name: 'datepicker.month.padding',
                token: 'datepicker.month.padding',
                variable: '--p-datepicker-month-padding',
                description: 'Padding of month'
            },
            {
                name: 'datepicker.month.borderRadius',
                token: 'datepicker.month.border.radius',
                variable: '--p-datepicker-month-border-radius',
                description: 'Border radius of month'
            },
            {
                name: 'datepicker.yearView.margin',
                token: 'datepicker.year.view.margin',
                variable: '--p-datepicker-year-view-margin',
                description: 'Margin of year view'
            },
            {
                name: 'datepicker.year.padding',
                token: 'datepicker.year.padding',
                variable: '--p-datepicker-year-padding',
                description: 'Padding of year'
            },
            {
                name: 'datepicker.year.borderRadius',
                token: 'datepicker.year.border.radius',
                variable: '--p-datepicker-year-border-radius',
                description: 'Border radius of year'
            },
            {
                name: 'datepicker.buttonbar.padding',
                token: 'datepicker.buttonbar.padding',
                variable: '--p-datepicker-buttonbar-padding',
                description: 'Padding of buttonbar'
            },
            {
                name: 'datepicker.buttonbar.borderColor',
                token: 'datepicker.buttonbar.border.color',
                variable: '--p-datepicker-buttonbar-border-color',
                description: 'Border color of buttonbar'
            },
            {
                name: 'datepicker.timePicker.padding',
                token: 'datepicker.time.picker.padding',
                variable: '--p-datepicker-time-picker-padding',
                description: 'Padding of time picker'
            },
            {
                name: 'datepicker.timePicker.borderColor',
                token: 'datepicker.time.picker.border.color',
                variable: '--p-datepicker-time-picker-border-color',
                description: 'Border color of time picker'
            },
            {
                name: 'datepicker.timePicker.gap',
                token: 'datepicker.time.picker.gap',
                variable: '--p-datepicker-time-picker-gap',
                description: 'Gap of time picker'
            },
            {
                name: 'datepicker.timePicker.buttonGap',
                token: 'datepicker.time.picker.button.gap',
                variable: '--p-datepicker-time-picker-button-gap',
                description: 'Button gap of time picker'
            },
            {
                name: 'datepicker.today.background',
                token: 'datepicker.today.background',
                variable: '--p-datepicker-today-background',
                description: 'Background of today'
            },
            {
                name: 'datepicker.today.color',
                token: 'datepicker.today.color',
                variable: '--p-datepicker-today-color',
                description: 'Color of today'
            }
        ]
    },
    dialog: {
        description: 'Dialog Design Tokens',
        tokens: [
            {
                name: 'dialog.root.background',
                token: 'dialog.background',
                variable: '--p-dialog-background',
                description: 'Background of root'
            },
            {
                name: 'dialog.root.borderColor',
                token: 'dialog.border.color',
                variable: '--p-dialog-border-color',
                description: 'Border color of root'
            },
            {
                name: 'dialog.root.color',
                token: 'dialog.color',
                variable: '--p-dialog-color',
                description: 'Color of root'
            },
            {
                name: 'dialog.root.borderRadius',
                token: 'dialog.border.radius',
                variable: '--p-dialog-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'dialog.root.shadow',
                token: 'dialog.shadow',
                variable: '--p-dialog-shadow',
                description: 'Shadow of root'
            },
            {
                name: 'dialog.header.padding',
                token: 'dialog.header.padding',
                variable: '--p-dialog-header-padding',
                description: 'Padding of header'
            },
            {
                name: 'dialog.header.gap',
                token: 'dialog.header.gap',
                variable: '--p-dialog-header-gap',
                description: 'Gap of header'
            },
            {
                name: 'dialog.title.fontSize',
                token: 'dialog.title.font.size',
                variable: '--p-dialog-title-font-size',
                description: 'Font size of title'
            },
            {
                name: 'dialog.title.fontWeight',
                token: 'dialog.title.font.weight',
                variable: '--p-dialog-title-font-weight',
                description: 'Font weight of title'
            },
            {
                name: 'dialog.content.padding',
                token: 'dialog.content.padding',
                variable: '--p-dialog-content-padding',
                description: 'Padding of content'
            },
            {
                name: 'dialog.footer.padding',
                token: 'dialog.footer.padding',
                variable: '--p-dialog-footer-padding',
                description: 'Padding of footer'
            },
            {
                name: 'dialog.footer.gap',
                token: 'dialog.footer.gap',
                variable: '--p-dialog-footer-gap',
                description: 'Gap of footer'
            }
        ]
    },
    divider: {
        description: 'Divider Design Tokens',
        tokens: [
            {
                name: 'divider.root.borderColor',
                token: 'divider.border.color',
                variable: '--p-divider-border-color',
                description: 'Border color of root'
            },
            {
                name: 'divider.content.background',
                token: 'divider.content.background',
                variable: '--p-divider-content-background',
                description: 'Background of content'
            },
            {
                name: 'divider.content.color',
                token: 'divider.content.color',
                variable: '--p-divider-content-color',
                description: 'Color of content'
            },
            {
                name: 'divider.horizontal.margin',
                token: 'divider.horizontal.margin',
                variable: '--p-divider-horizontal-margin',
                description: 'Margin of horizontal'
            },
            {
                name: 'divider.horizontal.padding',
                token: 'divider.horizontal.padding',
                variable: '--p-divider-horizontal-padding',
                description: 'Padding of horizontal'
            },
            {
                name: 'divider.horizontal.content.padding',
                token: 'divider.horizontal.content.padding',
                variable: '--p-divider-horizontal-content-padding',
                description: 'Content padding of horizontal'
            },
            {
                name: 'divider.vertical.margin',
                token: 'divider.vertical.margin',
                variable: '--p-divider-vertical-margin',
                description: 'Margin of vertical'
            },
            {
                name: 'divider.vertical.padding',
                token: 'divider.vertical.padding',
                variable: '--p-divider-vertical-padding',
                description: 'Padding of vertical'
            },
            {
                name: 'divider.vertical.content.padding',
                token: 'divider.vertical.content.padding',
                variable: '--p-divider-vertical-content-padding',
                description: 'Content padding of vertical'
            }
        ]
    },
    dock: {
        description: 'Dock Design Tokens',
        tokens: [
            {
                name: 'dock.root.background',
                token: 'dock.background',
                variable: '--p-dock-background',
                description: 'Background of root'
            },
            {
                name: 'dock.root.borderColor',
                token: 'dock.border.color',
                variable: '--p-dock-border-color',
                description: 'Border color of root'
            },
            {
                name: 'dock.root.padding',
                token: 'dock.padding',
                variable: '--p-dock-padding',
                description: 'Padding of root'
            },
            {
                name: 'dock.root.borderRadius',
                token: 'dock.border.radius',
                variable: '--p-dock-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'dock.item.borderRadius',
                token: 'dock.item.border.radius',
                variable: '--p-dock-item-border-radius',
                description: 'Border radius of item'
            },
            {
                name: 'dock.item.padding',
                token: 'dock.item.padding',
                variable: '--p-dock-item-padding',
                description: 'Padding of item'
            },
            {
                name: 'dock.item.size',
                token: 'dock.item.size',
                variable: '--p-dock-item-size',
                description: 'Size of item'
            },
            {
                name: 'dock.item.focusRing.width',
                token: 'dock.item.focus.ring.width',
                variable: '--p-dock-item-focus-ring-width',
                description: 'Focus ring width of item'
            },
            {
                name: 'dock.item.focusRing.style',
                token: 'dock.item.focus.ring.style',
                variable: '--p-dock-item-focus-ring-style',
                description: 'Focus ring style of item'
            },
            {
                name: 'dock.item.focusRing.color',
                token: 'dock.item.focus.ring.color',
                variable: '--p-dock-item-focus-ring-color',
                description: 'Focus ring color of item'
            },
            {
                name: 'dock.item.focusRing.offset',
                token: 'dock.item.focus.ring.offset',
                variable: '--p-dock-item-focus-ring-offset',
                description: 'Focus ring offset of item'
            },
            {
                name: 'dock.item.focusRing.shadow',
                token: 'dock.item.focus.ring.shadow',
                variable: '--p-dock-item-focus-ring-shadow',
                description: 'Focus ring shadow of item'
            }
        ]
    },
    drawer: {
        description: 'Drawer Design Tokens',
        tokens: [
            {
                name: 'drawer.root.background',
                token: 'drawer.background',
                variable: '--p-drawer-background',
                description: 'Background of root'
            },
            {
                name: 'drawer.root.borderColor',
                token: 'drawer.border.color',
                variable: '--p-drawer-border-color',
                description: 'Border color of root'
            },
            {
                name: 'drawer.root.color',
                token: 'drawer.color',
                variable: '--p-drawer-color',
                description: 'Color of root'
            },
            {
                name: 'drawer.root.shadow',
                token: 'drawer.shadow',
                variable: '--p-drawer-shadow',
                description: 'Shadow of root'
            },
            {
                name: 'drawer.header.padding',
                token: 'drawer.header.padding',
                variable: '--p-drawer-header-padding',
                description: 'Padding of header'
            },
            {
                name: 'drawer.title.fontSize',
                token: 'drawer.title.font.size',
                variable: '--p-drawer-title-font-size',
                description: 'Font size of title'
            },
            {
                name: 'drawer.title.fontWeight',
                token: 'drawer.title.font.weight',
                variable: '--p-drawer-title-font-weight',
                description: 'Font weight of title'
            },
            {
                name: 'drawer.content.padding',
                token: 'drawer.content.padding',
                variable: '--p-drawer-content-padding',
                description: 'Padding of content'
            },
            {
                name: 'drawer.footer.padding',
                token: 'drawer.footer.padding',
                variable: '--p-drawer-footer-padding',
                description: 'Padding of footer'
            }
        ]
    },
    editor: {
        description: 'Editor Design Tokens',
        tokens: [
            {
                name: 'editor.toolbar.background',
                token: 'editor.toolbar.background',
                variable: '--p-editor-toolbar-background',
                description: 'Background of toolbar'
            },
            {
                name: 'editor.toolbar.borderColor',
                token: 'editor.toolbar.border.color',
                variable: '--p-editor-toolbar-border-color',
                description: 'Border color of toolbar'
            },
            {
                name: 'editor.toolbar.borderRadius',
                token: 'editor.toolbar.border.radius',
                variable: '--p-editor-toolbar-border-radius',
                description: 'Border radius of toolbar'
            },
            {
                name: 'editor.toolbarItem.color',
                token: 'editor.toolbar.item.color',
                variable: '--p-editor-toolbar-item-color',
                description: 'Color of toolbar item'
            },
            {
                name: 'editor.toolbarItem.hoverColor',
                token: 'editor.toolbar.item.hover.color',
                variable: '--p-editor-toolbar-item-hover-color',
                description: 'Hover color of toolbar item'
            },
            {
                name: 'editor.toolbarItem.activeColor',
                token: 'editor.toolbar.item.active.color',
                variable: '--p-editor-toolbar-item-active-color',
                description: 'Active color of toolbar item'
            },
            {
                name: 'editor.toolbarItem.padding',
                token: 'editor.toolbar.item.padding',
                variable: '--p-editor-toolbar-item-padding',
                description: 'Padding of toolbar item'
            },
            {
                name: 'editor.overlay.background',
                token: 'editor.overlay.background',
                variable: '--p-editor-overlay-background',
                description: 'Background of overlay'
            },
            {
                name: 'editor.overlay.borderColor',
                token: 'editor.overlay.border.color',
                variable: '--p-editor-overlay-border-color',
                description: 'Border color of overlay'
            },
            {
                name: 'editor.overlay.borderRadius',
                token: 'editor.overlay.border.radius',
                variable: '--p-editor-overlay-border-radius',
                description: 'Border radius of overlay'
            },
            {
                name: 'editor.overlay.color',
                token: 'editor.overlay.color',
                variable: '--p-editor-overlay-color',
                description: 'Color of overlay'
            },
            {
                name: 'editor.overlay.shadow',
                token: 'editor.overlay.shadow',
                variable: '--p-editor-overlay-shadow',
                description: 'Shadow of overlay'
            },
            {
                name: 'editor.overlay.padding',
                token: 'editor.overlay.padding',
                variable: '--p-editor-overlay-padding',
                description: 'Padding of overlay'
            },
            {
                name: 'editor.overlayOption.focusBackground',
                token: 'editor.overlay.option.focus.background',
                variable: '--p-editor-overlay-option-focus-background',
                description: 'Focus background of overlay option'
            },
            {
                name: 'editor.overlayOption.color',
                token: 'editor.overlay.option.color',
                variable: '--p-editor-overlay-option-color',
                description: 'Color of overlay option'
            },
            {
                name: 'editor.overlayOption.focusColor',
                token: 'editor.overlay.option.focus.color',
                variable: '--p-editor-overlay-option-focus-color',
                description: 'Focus color of overlay option'
            },
            {
                name: 'editor.overlayOption.padding',
                token: 'editor.overlay.option.padding',
                variable: '--p-editor-overlay-option-padding',
                description: 'Padding of overlay option'
            },
            {
                name: 'editor.overlayOption.borderRadius',
                token: 'editor.overlay.option.border.radius',
                variable: '--p-editor-overlay-option-border-radius',
                description: 'Border radius of overlay option'
            },
            {
                name: 'editor.content.background',
                token: 'editor.content.background',
                variable: '--p-editor-content-background',
                description: 'Background of content'
            },
            {
                name: 'editor.content.borderColor',
                token: 'editor.content.border.color',
                variable: '--p-editor-content-border-color',
                description: 'Border color of content'
            },
            {
                name: 'editor.content.color',
                token: 'editor.content.color',
                variable: '--p-editor-content-color',
                description: 'Color of content'
            },
            {
                name: 'editor.content.borderRadius',
                token: 'editor.content.border.radius',
                variable: '--p-editor-content-border-radius',
                description: 'Border radius of content'
            }
        ]
    },
    fieldset: {
        description: 'Fieldset Design Tokens',
        tokens: [
            {
                name: 'fieldset.root.background',
                token: 'fieldset.background',
                variable: '--p-fieldset-background',
                description: 'Background of root'
            },
            {
                name: 'fieldset.root.borderColor',
                token: 'fieldset.border.color',
                variable: '--p-fieldset-border-color',
                description: 'Border color of root'
            },
            {
                name: 'fieldset.root.borderRadius',
                token: 'fieldset.border.radius',
                variable: '--p-fieldset-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'fieldset.root.color',
                token: 'fieldset.color',
                variable: '--p-fieldset-color',
                description: 'Color of root'
            },
            {
                name: 'fieldset.root.padding',
                token: 'fieldset.padding',
                variable: '--p-fieldset-padding',
                description: 'Padding of root'
            },
            {
                name: 'fieldset.root.transitionDuration',
                token: 'fieldset.transition.duration',
                variable: '--p-fieldset-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'fieldset.legend.background',
                token: 'fieldset.legend.background',
                variable: '--p-fieldset-legend-background',
                description: 'Background of legend'
            },
            {
                name: 'fieldset.legend.hoverBackground',
                token: 'fieldset.legend.hover.background',
                variable: '--p-fieldset-legend-hover-background',
                description: 'Hover background of legend'
            },
            {
                name: 'fieldset.legend.color',
                token: 'fieldset.legend.color',
                variable: '--p-fieldset-legend-color',
                description: 'Color of legend'
            },
            {
                name: 'fieldset.legend.hoverColor',
                token: 'fieldset.legend.hover.color',
                variable: '--p-fieldset-legend-hover-color',
                description: 'Hover color of legend'
            },
            {
                name: 'fieldset.legend.borderRadius',
                token: 'fieldset.legend.border.radius',
                variable: '--p-fieldset-legend-border-radius',
                description: 'Border radius of legend'
            },
            {
                name: 'fieldset.legend.borderWidth',
                token: 'fieldset.legend.border.width',
                variable: '--p-fieldset-legend-border-width',
                description: 'Border width of legend'
            },
            {
                name: 'fieldset.legend.borderColor',
                token: 'fieldset.legend.border.color',
                variable: '--p-fieldset-legend-border-color',
                description: 'Border color of legend'
            },
            {
                name: 'fieldset.legend.padding',
                token: 'fieldset.legend.padding',
                variable: '--p-fieldset-legend-padding',
                description: 'Padding of legend'
            },
            {
                name: 'fieldset.legend.gap',
                token: 'fieldset.legend.gap',
                variable: '--p-fieldset-legend-gap',
                description: 'Gap of legend'
            },
            {
                name: 'fieldset.legend.fontWeight',
                token: 'fieldset.legend.font.weight',
                variable: '--p-fieldset-legend-font-weight',
                description: 'Font weight of legend'
            },
            {
                name: 'fieldset.legend.focusRing.width',
                token: 'fieldset.legend.focus.ring.width',
                variable: '--p-fieldset-legend-focus-ring-width',
                description: 'Focus ring width of legend'
            },
            {
                name: 'fieldset.legend.focusRing.style',
                token: 'fieldset.legend.focus.ring.style',
                variable: '--p-fieldset-legend-focus-ring-style',
                description: 'Focus ring style of legend'
            },
            {
                name: 'fieldset.legend.focusRing.color',
                token: 'fieldset.legend.focus.ring.color',
                variable: '--p-fieldset-legend-focus-ring-color',
                description: 'Focus ring color of legend'
            },
            {
                name: 'fieldset.legend.focusRing.offset',
                token: 'fieldset.legend.focus.ring.offset',
                variable: '--p-fieldset-legend-focus-ring-offset',
                description: 'Focus ring offset of legend'
            },
            {
                name: 'fieldset.legend.focusRing.shadow',
                token: 'fieldset.legend.focus.ring.shadow',
                variable: '--p-fieldset-legend-focus-ring-shadow',
                description: 'Focus ring shadow of legend'
            },
            {
                name: 'fieldset.toggleIcon.color',
                token: 'fieldset.toggle.icon.color',
                variable: '--p-fieldset-toggle-icon-color',
                description: 'Color of toggle icon'
            },
            {
                name: 'fieldset.toggleIcon.hoverColor',
                token: 'fieldset.toggle.icon.hover.color',
                variable: '--p-fieldset-toggle-icon-hover-color',
                description: 'Hover color of toggle icon'
            },
            {
                name: 'fieldset.content.padding',
                token: 'fieldset.content.padding',
                variable: '--p-fieldset-content-padding',
                description: 'Padding of content'
            }
        ]
    },
    fileupload: {
        description: 'FileUpload Design Tokens',
        tokens: [
            {
                name: 'fileupload.root.background',
                token: 'fileupload.background',
                variable: '--p-fileupload-background',
                description: 'Background of root'
            },
            {
                name: 'fileupload.root.borderColor',
                token: 'fileupload.border.color',
                variable: '--p-fileupload-border-color',
                description: 'Border color of root'
            },
            {
                name: 'fileupload.root.color',
                token: 'fileupload.color',
                variable: '--p-fileupload-color',
                description: 'Color of root'
            },
            {
                name: 'fileupload.root.borderRadius',
                token: 'fileupload.border.radius',
                variable: '--p-fileupload-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'fileupload.root.transitionDuration',
                token: 'fileupload.transition.duration',
                variable: '--p-fileupload-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'fileupload.header.background',
                token: 'fileupload.header.background',
                variable: '--p-fileupload-header-background',
                description: 'Background of header'
            },
            {
                name: 'fileupload.header.color',
                token: 'fileupload.header.color',
                variable: '--p-fileupload-header-color',
                description: 'Color of header'
            },
            {
                name: 'fileupload.header.padding',
                token: 'fileupload.header.padding',
                variable: '--p-fileupload-header-padding',
                description: 'Padding of header'
            },
            {
                name: 'fileupload.header.borderColor',
                token: 'fileupload.header.border.color',
                variable: '--p-fileupload-header-border-color',
                description: 'Border color of header'
            },
            {
                name: 'fileupload.header.borderWidth',
                token: 'fileupload.header.border.width',
                variable: '--p-fileupload-header-border-width',
                description: 'Border width of header'
            },
            {
                name: 'fileupload.header.borderRadius',
                token: 'fileupload.header.border.radius',
                variable: '--p-fileupload-header-border-radius',
                description: 'Border radius of header'
            },
            {
                name: 'fileupload.header.gap',
                token: 'fileupload.header.gap',
                variable: '--p-fileupload-header-gap',
                description: 'Gap of header'
            },
            {
                name: 'fileupload.content.highlightBorderColor',
                token: 'fileupload.content.highlight.border.color',
                variable: '--p-fileupload-content-highlight-border-color',
                description: 'Highlight border color of content'
            },
            {
                name: 'fileupload.content.padding',
                token: 'fileupload.content.padding',
                variable: '--p-fileupload-content-padding',
                description: 'Padding of content'
            },
            {
                name: 'fileupload.content.gap',
                token: 'fileupload.content.gap',
                variable: '--p-fileupload-content-gap',
                description: 'Gap of content'
            },
            {
                name: 'fileupload.file.padding',
                token: 'fileupload.file.padding',
                variable: '--p-fileupload-file-padding',
                description: 'Padding of file'
            },
            {
                name: 'fileupload.file.gap',
                token: 'fileupload.file.gap',
                variable: '--p-fileupload-file-gap',
                description: 'Gap of file'
            },
            {
                name: 'fileupload.file.borderColor',
                token: 'fileupload.file.border.color',
                variable: '--p-fileupload-file-border-color',
                description: 'Border color of file'
            },
            {
                name: 'fileupload.file.info.gap',
                token: 'fileupload.file.info.gap',
                variable: '--p-fileupload-file-info-gap',
                description: 'Info gap of file'
            },
            {
                name: 'fileupload.fileList.gap',
                token: 'fileupload.file.list.gap',
                variable: '--p-fileupload-file-list-gap',
                description: 'Gap of file list'
            },
            {
                name: 'fileupload.progressbar.height',
                token: 'fileupload.progressbar.height',
                variable: '--p-fileupload-progressbar-height',
                description: 'Height of progressbar'
            },
            {
                name: 'fileupload.basic.gap',
                token: 'fileupload.basic.gap',
                variable: '--p-fileupload-basic-gap',
                description: 'Gap of basic'
            }
        ]
    },
    floatlabel: {
        description: 'FloatLabel Design Tokens',
        tokens: [
            {
                name: 'floatlabel.root.color',
                token: 'floatlabel.color',
                variable: '--p-floatlabel-color',
                description: 'Color of root'
            },
            {
                name: 'floatlabel.root.focusColor',
                token: 'floatlabel.focus.color',
                variable: '--p-floatlabel-focus-color',
                description: 'Focus color of root'
            },
            {
                name: 'floatlabel.root.activeColor',
                token: 'floatlabel.active.color',
                variable: '--p-floatlabel-active-color',
                description: 'Active color of root'
            },
            {
                name: 'floatlabel.root.invalidColor',
                token: 'floatlabel.invalid.color',
                variable: '--p-floatlabel-invalid-color',
                description: 'Invalid color of root'
            },
            {
                name: 'floatlabel.root.transitionDuration',
                token: 'floatlabel.transition.duration',
                variable: '--p-floatlabel-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'floatlabel.root.positionX',
                token: 'floatlabel.position.x',
                variable: '--p-floatlabel-position-x',
                description: 'Position x of root'
            },
            {
                name: 'floatlabel.root.positionY',
                token: 'floatlabel.position.y',
                variable: '--p-floatlabel-position-y',
                description: 'Position y of root'
            },
            {
                name: 'floatlabel.root.fontWeight',
                token: 'floatlabel.font.weight',
                variable: '--p-floatlabel-font-weight',
                description: 'Font weight of root'
            },
            {
                name: 'floatlabel.root.active.fontSize',
                token: 'floatlabel.active.font.size',
                variable: '--p-floatlabel-active-font-size',
                description: 'Active font size of root'
            },
            {
                name: 'floatlabel.root.active.fontWeight',
                token: 'floatlabel.active.font.weight',
                variable: '--p-floatlabel-active-font-weight',
                description: 'Active font weight of root'
            },
            {
                name: 'floatlabel.over.active.top',
                token: 'floatlabel.over.active.top',
                variable: '--p-floatlabel-over-active-top',
                description: 'Active top of over'
            },
            {
                name: 'floatlabel.in.input.paddingTop',
                token: 'floatlabel.in.input.padding.top',
                variable: '--p-floatlabel-in-input-padding-top',
                description: 'Input padding top of in'
            },
            {
                name: 'floatlabel.in.input.paddingBottom',
                token: 'floatlabel.in.input.padding.bottom',
                variable: '--p-floatlabel-in-input-padding-bottom',
                description: 'Input padding bottom of in'
            },
            {
                name: 'floatlabel.in.active.top',
                token: 'floatlabel.in.active.top',
                variable: '--p-floatlabel-in-active-top',
                description: 'Active top of in'
            },
            {
                name: 'floatlabel.on.borderRadius',
                token: 'floatlabel.on.border.radius',
                variable: '--p-floatlabel-on-border-radius',
                description: 'Border radius of on'
            },
            {
                name: 'floatlabel.on.active.background',
                token: 'floatlabel.on.active.background',
                variable: '--p-floatlabel-on-active-background',
                description: 'Active background of on'
            },
            {
                name: 'floatlabel.on.active.padding',
                token: 'floatlabel.on.active.padding',
                variable: '--p-floatlabel-on-active-padding',
                description: 'Active padding of on'
            }
        ]
    },
    galleria: {
        description: 'Galleria Design Tokens',
        tokens: [
            {
                name: 'galleria.root.borderWidth',
                token: 'galleria.border.width',
                variable: '--p-galleria-border-width',
                description: 'Border width of root'
            },
            {
                name: 'galleria.root.borderColor',
                token: 'galleria.border.color',
                variable: '--p-galleria-border-color',
                description: 'Border color of root'
            },
            {
                name: 'galleria.root.borderRadius',
                token: 'galleria.border.radius',
                variable: '--p-galleria-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'galleria.root.transitionDuration',
                token: 'galleria.transition.duration',
                variable: '--p-galleria-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'galleria.navButton.background',
                token: 'galleria.nav.button.background',
                variable: '--p-galleria-nav-button-background',
                description: 'Background of nav button'
            },
            {
                name: 'galleria.navButton.hoverBackground',
                token: 'galleria.nav.button.hover.background',
                variable: '--p-galleria-nav-button-hover-background',
                description: 'Hover background of nav button'
            },
            {
                name: 'galleria.navButton.color',
                token: 'galleria.nav.button.color',
                variable: '--p-galleria-nav-button-color',
                description: 'Color of nav button'
            },
            {
                name: 'galleria.navButton.hoverColor',
                token: 'galleria.nav.button.hover.color',
                variable: '--p-galleria-nav-button-hover-color',
                description: 'Hover color of nav button'
            },
            {
                name: 'galleria.navButton.size',
                token: 'galleria.nav.button.size',
                variable: '--p-galleria-nav-button-size',
                description: 'Size of nav button'
            },
            {
                name: 'galleria.navButton.gutter',
                token: 'galleria.nav.button.gutter',
                variable: '--p-galleria-nav-button-gutter',
                description: 'Gutter of nav button'
            },
            {
                name: 'galleria.navButton.prev.borderRadius',
                token: 'galleria.nav.button.prev.border.radius',
                variable: '--p-galleria-nav-button-prev-border-radius',
                description: 'Prev border radius of nav button'
            },
            {
                name: 'galleria.navButton.next.borderRadius',
                token: 'galleria.nav.button.next.border.radius',
                variable: '--p-galleria-nav-button-next-border-radius',
                description: 'Next border radius of nav button'
            },
            {
                name: 'galleria.navButton.focusRing.width',
                token: 'galleria.nav.button.focus.ring.width',
                variable: '--p-galleria-nav-button-focus-ring-width',
                description: 'Focus ring width of nav button'
            },
            {
                name: 'galleria.navButton.focusRing.style',
                token: 'galleria.nav.button.focus.ring.style',
                variable: '--p-galleria-nav-button-focus-ring-style',
                description: 'Focus ring style of nav button'
            },
            {
                name: 'galleria.navButton.focusRing.color',
                token: 'galleria.nav.button.focus.ring.color',
                variable: '--p-galleria-nav-button-focus-ring-color',
                description: 'Focus ring color of nav button'
            },
            {
                name: 'galleria.navButton.focusRing.offset',
                token: 'galleria.nav.button.focus.ring.offset',
                variable: '--p-galleria-nav-button-focus-ring-offset',
                description: 'Focus ring offset of nav button'
            },
            {
                name: 'galleria.navButton.focusRing.shadow',
                token: 'galleria.nav.button.focus.ring.shadow',
                variable: '--p-galleria-nav-button-focus-ring-shadow',
                description: 'Focus ring shadow of nav button'
            },
            {
                name: 'galleria.navIcon.size',
                token: 'galleria.nav.icon.size',
                variable: '--p-galleria-nav-icon-size',
                description: 'Size of nav icon'
            },
            {
                name: 'galleria.thumbnailsContent.background',
                token: 'galleria.thumbnails.content.background',
                variable: '--p-galleria-thumbnails-content-background',
                description: 'Background of thumbnails content'
            },
            {
                name: 'galleria.thumbnailsContent.padding',
                token: 'galleria.thumbnails.content.padding',
                variable: '--p-galleria-thumbnails-content-padding',
                description: 'Padding of thumbnails content'
            },
            {
                name: 'galleria.thumbnailNavButton.size',
                token: 'galleria.thumbnail.nav.button.size',
                variable: '--p-galleria-thumbnail-nav-button-size',
                description: 'Size of thumbnail nav button'
            },
            {
                name: 'galleria.thumbnailNavButton.borderRadius',
                token: 'galleria.thumbnail.nav.button.border.radius',
                variable: '--p-galleria-thumbnail-nav-button-border-radius',
                description: 'Border radius of thumbnail nav button'
            },
            {
                name: 'galleria.thumbnailNavButton.gutter',
                token: 'galleria.thumbnail.nav.button.gutter',
                variable: '--p-galleria-thumbnail-nav-button-gutter',
                description: 'Gutter of thumbnail nav button'
            },
            {
                name: 'galleria.thumbnailNavButton.focusRing.width',
                token: 'galleria.thumbnail.nav.button.focus.ring.width',
                variable: '--p-galleria-thumbnail-nav-button-focus-ring-width',
                description: 'Focus ring width of thumbnail nav button'
            },
            {
                name: 'galleria.thumbnailNavButton.focusRing.style',
                token: 'galleria.thumbnail.nav.button.focus.ring.style',
                variable: '--p-galleria-thumbnail-nav-button-focus-ring-style',
                description: 'Focus ring style of thumbnail nav button'
            },
            {
                name: 'galleria.thumbnailNavButton.focusRing.color',
                token: 'galleria.thumbnail.nav.button.focus.ring.color',
                variable: '--p-galleria-thumbnail-nav-button-focus-ring-color',
                description: 'Focus ring color of thumbnail nav button'
            },
            {
                name: 'galleria.thumbnailNavButton.focusRing.offset',
                token: 'galleria.thumbnail.nav.button.focus.ring.offset',
                variable: '--p-galleria-thumbnail-nav-button-focus-ring-offset',
                description: 'Focus ring offset of thumbnail nav button'
            },
            {
                name: 'galleria.thumbnailNavButton.focusRing.shadow',
                token: 'galleria.thumbnail.nav.button.focus.ring.shadow',
                variable: '--p-galleria-thumbnail-nav-button-focus-ring-shadow',
                description: 'Focus ring shadow of thumbnail nav button'
            },
            {
                name: 'galleria.thumbnailNavButton.hoverBackground',
                token: 'galleria.thumbnail.nav.button.hover.background',
                variable: '--p-galleria-thumbnail-nav-button-hover-background',
                description: 'Hover background of thumbnail nav button'
            },
            {
                name: 'galleria.thumbnailNavButton.color',
                token: 'galleria.thumbnail.nav.button.color',
                variable: '--p-galleria-thumbnail-nav-button-color',
                description: 'Color of thumbnail nav button'
            },
            {
                name: 'galleria.thumbnailNavButton.hoverColor',
                token: 'galleria.thumbnail.nav.button.hover.color',
                variable: '--p-galleria-thumbnail-nav-button-hover-color',
                description: 'Hover color of thumbnail nav button'
            },
            {
                name: 'galleria.thumbnailNavButtonIcon.size',
                token: 'galleria.thumbnail.nav.button.icon.size',
                variable: '--p-galleria-thumbnail-nav-button-icon-size',
                description: 'Size of thumbnail nav button icon'
            },
            {
                name: 'galleria.caption.background',
                token: 'galleria.caption.background',
                variable: '--p-galleria-caption-background',
                description: 'Background of caption'
            },
            {
                name: 'galleria.caption.color',
                token: 'galleria.caption.color',
                variable: '--p-galleria-caption-color',
                description: 'Color of caption'
            },
            {
                name: 'galleria.caption.padding',
                token: 'galleria.caption.padding',
                variable: '--p-galleria-caption-padding',
                description: 'Padding of caption'
            },
            {
                name: 'galleria.indicatorList.gap',
                token: 'galleria.indicator.list.gap',
                variable: '--p-galleria-indicator-list-gap',
                description: 'Gap of indicator list'
            },
            {
                name: 'galleria.indicatorList.padding',
                token: 'galleria.indicator.list.padding',
                variable: '--p-galleria-indicator-list-padding',
                description: 'Padding of indicator list'
            },
            {
                name: 'galleria.indicatorButton.width',
                token: 'galleria.indicator.button.width',
                variable: '--p-galleria-indicator-button-width',
                description: 'Width of indicator button'
            },
            {
                name: 'galleria.indicatorButton.height',
                token: 'galleria.indicator.button.height',
                variable: '--p-galleria-indicator-button-height',
                description: 'Height of indicator button'
            },
            {
                name: 'galleria.indicatorButton.activeBackground',
                token: 'galleria.indicator.button.active.background',
                variable: '--p-galleria-indicator-button-active-background',
                description: 'Active background of indicator button'
            },
            {
                name: 'galleria.indicatorButton.borderRadius',
                token: 'galleria.indicator.button.border.radius',
                variable: '--p-galleria-indicator-button-border-radius',
                description: 'Border radius of indicator button'
            },
            {
                name: 'galleria.indicatorButton.focusRing.width',
                token: 'galleria.indicator.button.focus.ring.width',
                variable: '--p-galleria-indicator-button-focus-ring-width',
                description: 'Focus ring width of indicator button'
            },
            {
                name: 'galleria.indicatorButton.focusRing.style',
                token: 'galleria.indicator.button.focus.ring.style',
                variable: '--p-galleria-indicator-button-focus-ring-style',
                description: 'Focus ring style of indicator button'
            },
            {
                name: 'galleria.indicatorButton.focusRing.color',
                token: 'galleria.indicator.button.focus.ring.color',
                variable: '--p-galleria-indicator-button-focus-ring-color',
                description: 'Focus ring color of indicator button'
            },
            {
                name: 'galleria.indicatorButton.focusRing.offset',
                token: 'galleria.indicator.button.focus.ring.offset',
                variable: '--p-galleria-indicator-button-focus-ring-offset',
                description: 'Focus ring offset of indicator button'
            },
            {
                name: 'galleria.indicatorButton.focusRing.shadow',
                token: 'galleria.indicator.button.focus.ring.shadow',
                variable: '--p-galleria-indicator-button-focus-ring-shadow',
                description: 'Focus ring shadow of indicator button'
            },
            {
                name: 'galleria.indicatorButton.background',
                token: 'galleria.indicator.button.background',
                variable: '--p-galleria-indicator-button-background',
                description: 'Background of indicator button'
            },
            {
                name: 'galleria.indicatorButton.hoverBackground',
                token: 'galleria.indicator.button.hover.background',
                variable: '--p-galleria-indicator-button-hover-background',
                description: 'Hover background of indicator button'
            },
            {
                name: 'galleria.insetIndicatorList.background',
                token: 'galleria.inset.indicator.list.background',
                variable: '--p-galleria-inset-indicator-list-background',
                description: 'Background of inset indicator list'
            },
            {
                name: 'galleria.insetIndicatorButton.background',
                token: 'galleria.inset.indicator.button.background',
                variable: '--p-galleria-inset-indicator-button-background',
                description: 'Background of inset indicator button'
            },
            {
                name: 'galleria.insetIndicatorButton.hoverBackground',
                token: 'galleria.inset.indicator.button.hover.background',
                variable: '--p-galleria-inset-indicator-button-hover-background',
                description: 'Hover background of inset indicator button'
            },
            {
                name: 'galleria.insetIndicatorButton.activeBackground',
                token: 'galleria.inset.indicator.button.active.background',
                variable: '--p-galleria-inset-indicator-button-active-background',
                description: 'Active background of inset indicator button'
            },
            {
                name: 'galleria.closeButton.size',
                token: 'galleria.close.button.size',
                variable: '--p-galleria-close-button-size',
                description: 'Size of close button'
            },
            {
                name: 'galleria.closeButton.gutter',
                token: 'galleria.close.button.gutter',
                variable: '--p-galleria-close-button-gutter',
                description: 'Gutter of close button'
            },
            {
                name: 'galleria.closeButton.background',
                token: 'galleria.close.button.background',
                variable: '--p-galleria-close-button-background',
                description: 'Background of close button'
            },
            {
                name: 'galleria.closeButton.hoverBackground',
                token: 'galleria.close.button.hover.background',
                variable: '--p-galleria-close-button-hover-background',
                description: 'Hover background of close button'
            },
            {
                name: 'galleria.closeButton.color',
                token: 'galleria.close.button.color',
                variable: '--p-galleria-close-button-color',
                description: 'Color of close button'
            },
            {
                name: 'galleria.closeButton.hoverColor',
                token: 'galleria.close.button.hover.color',
                variable: '--p-galleria-close-button-hover-color',
                description: 'Hover color of close button'
            },
            {
                name: 'galleria.closeButton.borderRadius',
                token: 'galleria.close.button.border.radius',
                variable: '--p-galleria-close-button-border-radius',
                description: 'Border radius of close button'
            },
            {
                name: 'galleria.closeButton.focusRing.width',
                token: 'galleria.close.button.focus.ring.width',
                variable: '--p-galleria-close-button-focus-ring-width',
                description: 'Focus ring width of close button'
            },
            {
                name: 'galleria.closeButton.focusRing.style',
                token: 'galleria.close.button.focus.ring.style',
                variable: '--p-galleria-close-button-focus-ring-style',
                description: 'Focus ring style of close button'
            },
            {
                name: 'galleria.closeButton.focusRing.color',
                token: 'galleria.close.button.focus.ring.color',
                variable: '--p-galleria-close-button-focus-ring-color',
                description: 'Focus ring color of close button'
            },
            {
                name: 'galleria.closeButton.focusRing.offset',
                token: 'galleria.close.button.focus.ring.offset',
                variable: '--p-galleria-close-button-focus-ring-offset',
                description: 'Focus ring offset of close button'
            },
            {
                name: 'galleria.closeButton.focusRing.shadow',
                token: 'galleria.close.button.focus.ring.shadow',
                variable: '--p-galleria-close-button-focus-ring-shadow',
                description: 'Focus ring shadow of close button'
            },
            {
                name: 'galleria.closeButtonIcon.size',
                token: 'galleria.close.button.icon.size',
                variable: '--p-galleria-close-button-icon-size',
                description: 'Size of close button icon'
            }
        ]
    },
    iconfield: {
        description: 'IconField Design Tokens',
        tokens: [
            {
                name: 'iconfield.icon.color',
                token: 'iconfield.icon.color',
                variable: '--p-iconfield-icon-color',
                description: 'Color of icon'
            }
        ]
    },
    iftalabel: {
        description: 'IftaLabel Design Tokens',
        tokens: [
            {
                name: 'iftalabel.root.color',
                token: 'iftalabel.color',
                variable: '--p-iftalabel-color',
                description: 'Color of root'
            },
            {
                name: 'iftalabel.root.focusColor',
                token: 'iftalabel.focus.color',
                variable: '--p-iftalabel-focus-color',
                description: 'Focus color of root'
            },
            {
                name: 'iftalabel.root.invalidColor',
                token: 'iftalabel.invalid.color',
                variable: '--p-iftalabel-invalid-color',
                description: 'Invalid color of root'
            },
            {
                name: 'iftalabel.root.transitionDuration',
                token: 'iftalabel.transition.duration',
                variable: '--p-iftalabel-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'iftalabel.root.positionX',
                token: 'iftalabel.position.x',
                variable: '--p-iftalabel-position-x',
                description: 'Position x of root'
            },
            {
                name: 'iftalabel.root.top',
                token: 'iftalabel.top',
                variable: '--p-iftalabel-top',
                description: 'Top of root'
            },
            {
                name: 'iftalabel.root.fontSize',
                token: 'iftalabel.font.size',
                variable: '--p-iftalabel-font-size',
                description: 'Font size of root'
            },
            {
                name: 'iftalabel.root.fontWeight',
                token: 'iftalabel.font.weight',
                variable: '--p-iftalabel-font-weight',
                description: 'Font weight of root'
            },
            {
                name: 'iftalabel.input.paddingTop',
                token: 'iftalabel.input.padding.top',
                variable: '--p-iftalabel-input-padding-top',
                description: 'Padding top of input'
            },
            {
                name: 'iftalabel.input.paddingBottom',
                token: 'iftalabel.input.padding.bottom',
                variable: '--p-iftalabel-input-padding-bottom',
                description: 'Padding bottom of input'
            }
        ]
    },
    image: {
        description: 'Image Design Tokens',
        tokens: [
            {
                name: 'image.root.transitionDuration',
                token: 'image.transition.duration',
                variable: '--p-image-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'image.preview.icon.size',
                token: 'image.preview.icon.size',
                variable: '--p-image-preview-icon-size',
                description: 'Icon size of preview'
            },
            {
                name: 'image.preview.mask.background',
                token: 'image.preview.mask.background',
                variable: '--p-image-preview-mask-background',
                description: 'Mask background of preview'
            },
            {
                name: 'image.preview.mask.color',
                token: 'image.preview.mask.color',
                variable: '--p-image-preview-mask-color',
                description: 'Mask color of preview'
            },
            {
                name: 'image.toolbar.position.left',
                token: 'image.toolbar.position.left',
                variable: '--p-image-toolbar-position-left',
                description: 'Position left of toolbar'
            },
            {
                name: 'image.toolbar.position.right',
                token: 'image.toolbar.position.right',
                variable: '--p-image-toolbar-position-right',
                description: 'Position right of toolbar'
            },
            {
                name: 'image.toolbar.position.top',
                token: 'image.toolbar.position.top',
                variable: '--p-image-toolbar-position-top',
                description: 'Position top of toolbar'
            },
            {
                name: 'image.toolbar.position.bottom',
                token: 'image.toolbar.position.bottom',
                variable: '--p-image-toolbar-position-bottom',
                description: 'Position bottom of toolbar'
            },
            {
                name: 'image.toolbar.blur',
                token: 'image.toolbar.blur',
                variable: '--p-image-toolbar-blur',
                description: 'Blur of toolbar'
            },
            {
                name: 'image.toolbar.background',
                token: 'image.toolbar.background',
                variable: '--p-image-toolbar-background',
                description: 'Background of toolbar'
            },
            {
                name: 'image.toolbar.borderColor',
                token: 'image.toolbar.border.color',
                variable: '--p-image-toolbar-border-color',
                description: 'Border color of toolbar'
            },
            {
                name: 'image.toolbar.borderWidth',
                token: 'image.toolbar.border.width',
                variable: '--p-image-toolbar-border-width',
                description: 'Border width of toolbar'
            },
            {
                name: 'image.toolbar.borderRadius',
                token: 'image.toolbar.border.radius',
                variable: '--p-image-toolbar-border-radius',
                description: 'Border radius of toolbar'
            },
            {
                name: 'image.toolbar.padding',
                token: 'image.toolbar.padding',
                variable: '--p-image-toolbar-padding',
                description: 'Padding of toolbar'
            },
            {
                name: 'image.toolbar.gap',
                token: 'image.toolbar.gap',
                variable: '--p-image-toolbar-gap',
                description: 'Gap of toolbar'
            },
            {
                name: 'image.action.hoverBackground',
                token: 'image.action.hover.background',
                variable: '--p-image-action-hover-background',
                description: 'Hover background of action'
            },
            {
                name: 'image.action.color',
                token: 'image.action.color',
                variable: '--p-image-action-color',
                description: 'Color of action'
            },
            {
                name: 'image.action.hoverColor',
                token: 'image.action.hover.color',
                variable: '--p-image-action-hover-color',
                description: 'Hover color of action'
            },
            {
                name: 'image.action.size',
                token: 'image.action.size',
                variable: '--p-image-action-size',
                description: 'Size of action'
            },
            {
                name: 'image.action.iconSize',
                token: 'image.action.icon.size',
                variable: '--p-image-action-icon-size',
                description: 'Icon size of action'
            },
            {
                name: 'image.action.borderRadius',
                token: 'image.action.border.radius',
                variable: '--p-image-action-border-radius',
                description: 'Border radius of action'
            },
            {
                name: 'image.action.focusRing.width',
                token: 'image.action.focus.ring.width',
                variable: '--p-image-action-focus-ring-width',
                description: 'Focus ring width of action'
            },
            {
                name: 'image.action.focusRing.style',
                token: 'image.action.focus.ring.style',
                variable: '--p-image-action-focus-ring-style',
                description: 'Focus ring style of action'
            },
            {
                name: 'image.action.focusRing.color',
                token: 'image.action.focus.ring.color',
                variable: '--p-image-action-focus-ring-color',
                description: 'Focus ring color of action'
            },
            {
                name: 'image.action.focusRing.offset',
                token: 'image.action.focus.ring.offset',
                variable: '--p-image-action-focus-ring-offset',
                description: 'Focus ring offset of action'
            },
            {
                name: 'image.action.focusRing.shadow',
                token: 'image.action.focus.ring.shadow',
                variable: '--p-image-action-focus-ring-shadow',
                description: 'Focus ring shadow of action'
            }
        ]
    },
    imagecompare: {
        description: 'ImageCompare Design Tokens',
        tokens: [
            {
                name: 'imagecompare.handle.size',
                token: 'imagecompare.handle.size',
                variable: '--p-imagecompare-handle-size',
                description: 'Size of handle'
            },
            {
                name: 'imagecompare.handle.hoverSize',
                token: 'imagecompare.handle.hover.size',
                variable: '--p-imagecompare-handle-hover-size',
                description: 'Hover size of handle'
            },
            {
                name: 'imagecompare.handle.background',
                token: 'imagecompare.handle.background',
                variable: '--p-imagecompare-handle-background',
                description: 'Background of handle'
            },
            {
                name: 'imagecompare.handle.hoverBackground',
                token: 'imagecompare.handle.hover.background',
                variable: '--p-imagecompare-handle-hover-background',
                description: 'Hover background of handle'
            },
            {
                name: 'imagecompare.handle.borderColor',
                token: 'imagecompare.handle.border.color',
                variable: '--p-imagecompare-handle-border-color',
                description: 'Border color of handle'
            },
            {
                name: 'imagecompare.handle.hoverBorderColor',
                token: 'imagecompare.handle.hover.border.color',
                variable: '--p-imagecompare-handle-hover-border-color',
                description: 'Hover border color of handle'
            },
            {
                name: 'imagecompare.handle.borderWidth',
                token: 'imagecompare.handle.border.width',
                variable: '--p-imagecompare-handle-border-width',
                description: 'Border width of handle'
            },
            {
                name: 'imagecompare.handle.borderRadius',
                token: 'imagecompare.handle.border.radius',
                variable: '--p-imagecompare-handle-border-radius',
                description: 'Border radius of handle'
            },
            {
                name: 'imagecompare.handle.transitionDuration',
                token: 'imagecompare.handle.transition.duration',
                variable: '--p-imagecompare-handle-transition-duration',
                description: 'Transition duration of handle'
            },
            {
                name: 'imagecompare.handle.focusRing.width',
                token: 'imagecompare.handle.focus.ring.width',
                variable: '--p-imagecompare-handle-focus-ring-width',
                description: 'Focus ring width of handle'
            },
            {
                name: 'imagecompare.handle.focusRing.style',
                token: 'imagecompare.handle.focus.ring.style',
                variable: '--p-imagecompare-handle-focus-ring-style',
                description: 'Focus ring style of handle'
            },
            {
                name: 'imagecompare.handle.focusRing.color',
                token: 'imagecompare.handle.focus.ring.color',
                variable: '--p-imagecompare-handle-focus-ring-color',
                description: 'Focus ring color of handle'
            },
            {
                name: 'imagecompare.handle.focusRing.offset',
                token: 'imagecompare.handle.focus.ring.offset',
                variable: '--p-imagecompare-handle-focus-ring-offset',
                description: 'Focus ring offset of handle'
            },
            {
                name: 'imagecompare.handle.focusRing.shadow',
                token: 'imagecompare.handle.focus.ring.shadow',
                variable: '--p-imagecompare-handle-focus-ring-shadow',
                description: 'Focus ring shadow of handle'
            }
        ]
    },
    themes: {
        description: '',
        tokens: []
    },
    inlinemessage: {
        description: 'InlineMessage Design Tokens',
        tokens: [
            {
                name: 'inlinemessage.root.padding',
                token: 'inlinemessage.padding',
                variable: '--p-inlinemessage-padding',
                description: 'Padding of root'
            },
            {
                name: 'inlinemessage.root.borderRadius',
                token: 'inlinemessage.border.radius',
                variable: '--p-inlinemessage-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'inlinemessage.root.gap',
                token: 'inlinemessage.gap',
                variable: '--p-inlinemessage-gap',
                description: 'Gap of root'
            },
            {
                name: 'inlinemessage.text.fontWeight',
                token: 'inlinemessage.text.font.weight',
                variable: '--p-inlinemessage-text-font-weight',
                description: 'Font weight of text'
            },
            {
                name: 'inlinemessage.icon.size',
                token: 'inlinemessage.icon.size',
                variable: '--p-inlinemessage-icon-size',
                description: 'Size of icon'
            },
            {
                name: 'inlinemessage.info.background',
                token: 'inlinemessage.info.background',
                variable: '--p-inlinemessage-info-background',
                description: 'Background of info'
            },
            {
                name: 'inlinemessage.info.borderColor',
                token: 'inlinemessage.info.border.color',
                variable: '--p-inlinemessage-info-border-color',
                description: 'Border color of info'
            },
            {
                name: 'inlinemessage.info.color',
                token: 'inlinemessage.info.color',
                variable: '--p-inlinemessage-info-color',
                description: 'Color of info'
            },
            {
                name: 'inlinemessage.info.shadow',
                token: 'inlinemessage.info.shadow',
                variable: '--p-inlinemessage-info-shadow',
                description: 'Shadow of info'
            },
            {
                name: 'inlinemessage.success.background',
                token: 'inlinemessage.success.background',
                variable: '--p-inlinemessage-success-background',
                description: 'Background of success'
            },
            {
                name: 'inlinemessage.success.borderColor',
                token: 'inlinemessage.success.border.color',
                variable: '--p-inlinemessage-success-border-color',
                description: 'Border color of success'
            },
            {
                name: 'inlinemessage.success.color',
                token: 'inlinemessage.success.color',
                variable: '--p-inlinemessage-success-color',
                description: 'Color of success'
            },
            {
                name: 'inlinemessage.success.shadow',
                token: 'inlinemessage.success.shadow',
                variable: '--p-inlinemessage-success-shadow',
                description: 'Shadow of success'
            },
            {
                name: 'inlinemessage.warn.background',
                token: 'inlinemessage.warn.background',
                variable: '--p-inlinemessage-warn-background',
                description: 'Background of warn'
            },
            {
                name: 'inlinemessage.warn.borderColor',
                token: 'inlinemessage.warn.border.color',
                variable: '--p-inlinemessage-warn-border-color',
                description: 'Border color of warn'
            },
            {
                name: 'inlinemessage.warn.color',
                token: 'inlinemessage.warn.color',
                variable: '--p-inlinemessage-warn-color',
                description: 'Color of warn'
            },
            {
                name: 'inlinemessage.warn.shadow',
                token: 'inlinemessage.warn.shadow',
                variable: '--p-inlinemessage-warn-shadow',
                description: 'Shadow of warn'
            },
            {
                name: 'inlinemessage.error.background',
                token: 'inlinemessage.error.background',
                variable: '--p-inlinemessage-error-background',
                description: 'Background of error'
            },
            {
                name: 'inlinemessage.error.borderColor',
                token: 'inlinemessage.error.border.color',
                variable: '--p-inlinemessage-error-border-color',
                description: 'Border color of error'
            },
            {
                name: 'inlinemessage.error.color',
                token: 'inlinemessage.error.color',
                variable: '--p-inlinemessage-error-color',
                description: 'Color of error'
            },
            {
                name: 'inlinemessage.error.shadow',
                token: 'inlinemessage.error.shadow',
                variable: '--p-inlinemessage-error-shadow',
                description: 'Shadow of error'
            },
            {
                name: 'inlinemessage.secondary.background',
                token: 'inlinemessage.secondary.background',
                variable: '--p-inlinemessage-secondary-background',
                description: 'Background of secondary'
            },
            {
                name: 'inlinemessage.secondary.borderColor',
                token: 'inlinemessage.secondary.border.color',
                variable: '--p-inlinemessage-secondary-border-color',
                description: 'Border color of secondary'
            },
            {
                name: 'inlinemessage.secondary.color',
                token: 'inlinemessage.secondary.color',
                variable: '--p-inlinemessage-secondary-color',
                description: 'Color of secondary'
            },
            {
                name: 'inlinemessage.secondary.shadow',
                token: 'inlinemessage.secondary.shadow',
                variable: '--p-inlinemessage-secondary-shadow',
                description: 'Shadow of secondary'
            },
            {
                name: 'inlinemessage.contrast.background',
                token: 'inlinemessage.contrast.background',
                variable: '--p-inlinemessage-contrast-background',
                description: 'Background of contrast'
            },
            {
                name: 'inlinemessage.contrast.borderColor',
                token: 'inlinemessage.contrast.border.color',
                variable: '--p-inlinemessage-contrast-border-color',
                description: 'Border color of contrast'
            },
            {
                name: 'inlinemessage.contrast.color',
                token: 'inlinemessage.contrast.color',
                variable: '--p-inlinemessage-contrast-color',
                description: 'Color of contrast'
            },
            {
                name: 'inlinemessage.contrast.shadow',
                token: 'inlinemessage.contrast.shadow',
                variable: '--p-inlinemessage-contrast-shadow',
                description: 'Shadow of contrast'
            }
        ]
    },
    inplace: {
        description: 'Inplace Design Tokens',
        tokens: [
            {
                name: 'inplace.root.padding',
                token: 'inplace.padding',
                variable: '--p-inplace-padding',
                description: 'Padding of root'
            },
            {
                name: 'inplace.root.borderRadius',
                token: 'inplace.border.radius',
                variable: '--p-inplace-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'inplace.root.focusRing.width',
                token: 'inplace.focus.ring.width',
                variable: '--p-inplace-focus-ring-width',
                description: 'Focus ring width of root'
            },
            {
                name: 'inplace.root.focusRing.style',
                token: 'inplace.focus.ring.style',
                variable: '--p-inplace-focus-ring-style',
                description: 'Focus ring style of root'
            },
            {
                name: 'inplace.root.focusRing.color',
                token: 'inplace.focus.ring.color',
                variable: '--p-inplace-focus-ring-color',
                description: 'Focus ring color of root'
            },
            {
                name: 'inplace.root.focusRing.offset',
                token: 'inplace.focus.ring.offset',
                variable: '--p-inplace-focus-ring-offset',
                description: 'Focus ring offset of root'
            },
            {
                name: 'inplace.root.focusRing.shadow',
                token: 'inplace.focus.ring.shadow',
                variable: '--p-inplace-focus-ring-shadow',
                description: 'Focus ring shadow of root'
            },
            {
                name: 'inplace.root.transitionDuration',
                token: 'inplace.transition.duration',
                variable: '--p-inplace-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'inplace.display.hoverBackground',
                token: 'inplace.display.hover.background',
                variable: '--p-inplace-display-hover-background',
                description: 'Hover background of display'
            },
            {
                name: 'inplace.display.hoverColor',
                token: 'inplace.display.hover.color',
                variable: '--p-inplace-display-hover-color',
                description: 'Hover color of display'
            }
        ]
    },
    inputchips: {
        description: 'InputChips Design Tokens',
        tokens: [
            {
                name: 'inputchips.root.background',
                token: 'inputchips.background',
                variable: '--p-inputchips-background',
                description: 'Background of root'
            },
            {
                name: 'inputchips.root.disabledBackground',
                token: 'inputchips.disabled.background',
                variable: '--p-inputchips-disabled-background',
                description: 'Disabled background of root'
            },
            {
                name: 'inputchips.root.filledBackground',
                token: 'inputchips.filled.background',
                variable: '--p-inputchips-filled-background',
                description: 'Filled background of root'
            },
            {
                name: 'inputchips.root.filledFocusBackground',
                token: 'inputchips.filled.focus.background',
                variable: '--p-inputchips-filled-focus-background',
                description: 'Filled focus background of root'
            },
            {
                name: 'inputchips.root.borderColor',
                token: 'inputchips.border.color',
                variable: '--p-inputchips-border-color',
                description: 'Border color of root'
            },
            {
                name: 'inputchips.root.hoverBorderColor',
                token: 'inputchips.hover.border.color',
                variable: '--p-inputchips-hover-border-color',
                description: 'Hover border color of root'
            },
            {
                name: 'inputchips.root.focusBorderColor',
                token: 'inputchips.focus.border.color',
                variable: '--p-inputchips-focus-border-color',
                description: 'Focus border color of root'
            },
            {
                name: 'inputchips.root.invalidBorderColor',
                token: 'inputchips.invalid.border.color',
                variable: '--p-inputchips-invalid-border-color',
                description: 'Invalid border color of root'
            },
            {
                name: 'inputchips.root.color',
                token: 'inputchips.color',
                variable: '--p-inputchips-color',
                description: 'Color of root'
            },
            {
                name: 'inputchips.root.disabledColor',
                token: 'inputchips.disabled.color',
                variable: '--p-inputchips-disabled-color',
                description: 'Disabled color of root'
            },
            {
                name: 'inputchips.root.placeholderColor',
                token: 'inputchips.placeholder.color',
                variable: '--p-inputchips-placeholder-color',
                description: 'Placeholder color of root'
            },
            {
                name: 'inputchips.root.shadow',
                token: 'inputchips.shadow',
                variable: '--p-inputchips-shadow',
                description: 'Shadow of root'
            },
            {
                name: 'inputchips.root.paddingX',
                token: 'inputchips.padding.x',
                variable: '--p-inputchips-padding-x',
                description: 'Padding x of root'
            },
            {
                name: 'inputchips.root.paddingY',
                token: 'inputchips.padding.y',
                variable: '--p-inputchips-padding-y',
                description: 'Padding y of root'
            },
            {
                name: 'inputchips.root.borderRadius',
                token: 'inputchips.border.radius',
                variable: '--p-inputchips-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'inputchips.root.focusRing.width',
                token: 'inputchips.focus.ring.width',
                variable: '--p-inputchips-focus-ring-width',
                description: 'Focus ring width of root'
            },
            {
                name: 'inputchips.root.focusRing.style',
                token: 'inputchips.focus.ring.style',
                variable: '--p-inputchips-focus-ring-style',
                description: 'Focus ring style of root'
            },
            {
                name: 'inputchips.root.focusRing.color',
                token: 'inputchips.focus.ring.color',
                variable: '--p-inputchips-focus-ring-color',
                description: 'Focus ring color of root'
            },
            {
                name: 'inputchips.root.focusRing.offset',
                token: 'inputchips.focus.ring.offset',
                variable: '--p-inputchips-focus-ring-offset',
                description: 'Focus ring offset of root'
            },
            {
                name: 'inputchips.root.focusRing.shadow',
                token: 'inputchips.focus.ring.shadow',
                variable: '--p-inputchips-focus-ring-shadow',
                description: 'Focus ring shadow of root'
            },
            {
                name: 'inputchips.root.transitionDuration',
                token: 'inputchips.transition.duration',
                variable: '--p-inputchips-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'inputchips.chip.borderRadius',
                token: 'inputchips.chip.border.radius',
                variable: '--p-inputchips-chip-border-radius',
                description: 'Border radius of chip'
            },
            {
                name: 'inputchips.chip.focusBackground',
                token: 'inputchips.chip.focus.background',
                variable: '--p-inputchips-chip-focus-background',
                description: 'Focus background of chip'
            },
            {
                name: 'inputchips.chip.color',
                token: 'inputchips.chip.color',
                variable: '--p-inputchips-chip-color',
                description: 'Color of chip'
            }
        ]
    },
    inputgroup: {
        description: 'InputGroup Design Tokens',
        tokens: [
            {
                name: 'inputgroup.addon.background',
                token: 'inputgroup.addon.background',
                variable: '--p-inputgroup-addon-background',
                description: 'Background of addon'
            },
            {
                name: 'inputgroup.addon.borderColor',
                token: 'inputgroup.addon.border.color',
                variable: '--p-inputgroup-addon-border-color',
                description: 'Border color of addon'
            },
            {
                name: 'inputgroup.addon.color',
                token: 'inputgroup.addon.color',
                variable: '--p-inputgroup-addon-color',
                description: 'Color of addon'
            },
            {
                name: 'inputgroup.addon.borderRadius',
                token: 'inputgroup.addon.border.radius',
                variable: '--p-inputgroup-addon-border-radius',
                description: 'Border radius of addon'
            },
            {
                name: 'inputgroup.addon.padding',
                token: 'inputgroup.addon.padding',
                variable: '--p-inputgroup-addon-padding',
                description: 'Padding of addon'
            },
            {
                name: 'inputgroup.addon.minWidth',
                token: 'inputgroup.addon.min.width',
                variable: '--p-inputgroup-addon-min-width',
                description: 'Min width of addon'
            }
        ]
    },
    inputnumber: {
        description: 'InputNumber Design Tokens',
        tokens: [
            {
                name: 'inputnumber.root.transitionDuration',
                token: 'inputnumber.transition.duration',
                variable: '--p-inputnumber-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'inputnumber.button.width',
                token: 'inputnumber.button.width',
                variable: '--p-inputnumber-button-width',
                description: 'Width of button'
            },
            {
                name: 'inputnumber.button.borderRadius',
                token: 'inputnumber.button.border.radius',
                variable: '--p-inputnumber-button-border-radius',
                description: 'Border radius of button'
            },
            {
                name: 'inputnumber.button.verticalPadding',
                token: 'inputnumber.button.vertical.padding',
                variable: '--p-inputnumber-button-vertical-padding',
                description: 'Vertical padding of button'
            },
            {
                name: 'inputnumber.button.background',
                token: 'inputnumber.button.background',
                variable: '--p-inputnumber-button-background',
                description: 'Background of button'
            },
            {
                name: 'inputnumber.button.hoverBackground',
                token: 'inputnumber.button.hover.background',
                variable: '--p-inputnumber-button-hover-background',
                description: 'Hover background of button'
            },
            {
                name: 'inputnumber.button.activeBackground',
                token: 'inputnumber.button.active.background',
                variable: '--p-inputnumber-button-active-background',
                description: 'Active background of button'
            },
            {
                name: 'inputnumber.button.borderColor',
                token: 'inputnumber.button.border.color',
                variable: '--p-inputnumber-button-border-color',
                description: 'Border color of button'
            },
            {
                name: 'inputnumber.button.hoverBorderColor',
                token: 'inputnumber.button.hover.border.color',
                variable: '--p-inputnumber-button-hover-border-color',
                description: 'Hover border color of button'
            },
            {
                name: 'inputnumber.button.activeBorderColor',
                token: 'inputnumber.button.active.border.color',
                variable: '--p-inputnumber-button-active-border-color',
                description: 'Active border color of button'
            },
            {
                name: 'inputnumber.button.color',
                token: 'inputnumber.button.color',
                variable: '--p-inputnumber-button-color',
                description: 'Color of button'
            },
            {
                name: 'inputnumber.button.hoverColor',
                token: 'inputnumber.button.hover.color',
                variable: '--p-inputnumber-button-hover-color',
                description: 'Hover color of button'
            },
            {
                name: 'inputnumber.button.activeColor',
                token: 'inputnumber.button.active.color',
                variable: '--p-inputnumber-button-active-color',
                description: 'Active color of button'
            }
        ]
    },
    inputotp: {
        description: 'InputOTP Design Tokens',
        tokens: [
            {
                name: 'inputotp.root.gap',
                token: 'inputotp.gap',
                variable: '--p-inputotp-gap',
                description: 'Gap of root'
            },
            {
                name: 'inputotp.input.width',
                token: 'inputotp.input.width',
                variable: '--p-inputotp-input-width',
                description: 'Width of input'
            },
            {
                name: 'inputotp.input.sm.width',
                token: 'inputotp.input.sm.width',
                variable: '--p-inputotp-input-sm-width',
                description: 'Width of input in small screens'
            },
            {
                name: 'inputotp.input.lg.width',
                token: 'inputotp.input.lg.width',
                variable: '--p-inputotp-input-lg-width',
                description: 'Width of input in large screens'
            }
        ]
    },
    inputtext: {
        description: 'InputText Design Tokens',
        tokens: [
            {
                name: 'inputtext.root.background',
                token: 'inputtext.background',
                variable: '--p-inputtext-background',
                description: 'Background of root'
            },
            {
                name: 'inputtext.root.disabledBackground',
                token: 'inputtext.disabled.background',
                variable: '--p-inputtext-disabled-background',
                description: 'Disabled background of root'
            },
            {
                name: 'inputtext.root.filledBackground',
                token: 'inputtext.filled.background',
                variable: '--p-inputtext-filled-background',
                description: 'Filled background of root'
            },
            {
                name: 'inputtext.root.filledHoverBackground',
                token: 'inputtext.filled.hover.background',
                variable: '--p-inputtext-filled-hover-background',
                description: 'Filled hover background of root'
            },
            {
                name: 'inputtext.root.filledFocusBackground',
                token: 'inputtext.filled.focus.background',
                variable: '--p-inputtext-filled-focus-background',
                description: 'Filled focus background of root'
            },
            {
                name: 'inputtext.root.borderColor',
                token: 'inputtext.border.color',
                variable: '--p-inputtext-border-color',
                description: 'Border color of root'
            },
            {
                name: 'inputtext.root.hoverBorderColor',
                token: 'inputtext.hover.border.color',
                variable: '--p-inputtext-hover-border-color',
                description: 'Hover border color of root'
            },
            {
                name: 'inputtext.root.focusBorderColor',
                token: 'inputtext.focus.border.color',
                variable: '--p-inputtext-focus-border-color',
                description: 'Focus border color of root'
            },
            {
                name: 'inputtext.root.invalidBorderColor',
                token: 'inputtext.invalid.border.color',
                variable: '--p-inputtext-invalid-border-color',
                description: 'Invalid border color of root'
            },
            {
                name: 'inputtext.root.color',
                token: 'inputtext.color',
                variable: '--p-inputtext-color',
                description: 'Color of root'
            },
            {
                name: 'inputtext.root.disabledColor',
                token: 'inputtext.disabled.color',
                variable: '--p-inputtext-disabled-color',
                description: 'Disabled color of root'
            },
            {
                name: 'inputtext.root.placeholderColor',
                token: 'inputtext.placeholder.color',
                variable: '--p-inputtext-placeholder-color',
                description: 'Placeholder color of root'
            },
            {
                name: 'inputtext.root.invalidPlaceholderColor',
                token: 'inputtext.invalid.placeholder.color',
                variable: '--p-inputtext-invalid-placeholder-color',
                description: 'Invalid placeholder color of root'
            },
            {
                name: 'inputtext.root.shadow',
                token: 'inputtext.shadow',
                variable: '--p-inputtext-shadow',
                description: 'Shadow of root'
            },
            {
                name: 'inputtext.root.paddingX',
                token: 'inputtext.padding.x',
                variable: '--p-inputtext-padding-x',
                description: 'Padding x of root'
            },
            {
                name: 'inputtext.root.paddingY',
                token: 'inputtext.padding.y',
                variable: '--p-inputtext-padding-y',
                description: 'Padding y of root'
            },
            {
                name: 'inputtext.root.borderRadius',
                token: 'inputtext.border.radius',
                variable: '--p-inputtext-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'inputtext.root.focusRing.width',
                token: 'inputtext.focus.ring.width',
                variable: '--p-inputtext-focus-ring-width',
                description: 'Focus ring width of root'
            },
            {
                name: 'inputtext.root.focusRing.style',
                token: 'inputtext.focus.ring.style',
                variable: '--p-inputtext-focus-ring-style',
                description: 'Focus ring style of root'
            },
            {
                name: 'inputtext.root.focusRing.color',
                token: 'inputtext.focus.ring.color',
                variable: '--p-inputtext-focus-ring-color',
                description: 'Focus ring color of root'
            },
            {
                name: 'inputtext.root.focusRing.offset',
                token: 'inputtext.focus.ring.offset',
                variable: '--p-inputtext-focus-ring-offset',
                description: 'Focus ring offset of root'
            },
            {
                name: 'inputtext.root.focusRing.shadow',
                token: 'inputtext.focus.ring.shadow',
                variable: '--p-inputtext-focus-ring-shadow',
                description: 'Focus ring shadow of root'
            },
            {
                name: 'inputtext.root.transitionDuration',
                token: 'inputtext.transition.duration',
                variable: '--p-inputtext-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'inputtext.root.sm.fontSize',
                token: 'inputtext.sm.font.size',
                variable: '--p-inputtext-sm-font-size',
                description: 'Sm font size of root'
            },
            {
                name: 'inputtext.root.sm.paddingX',
                token: 'inputtext.sm.padding.x',
                variable: '--p-inputtext-sm-padding-x',
                description: 'Sm padding x of root'
            },
            {
                name: 'inputtext.root.sm.paddingY',
                token: 'inputtext.sm.padding.y',
                variable: '--p-inputtext-sm-padding-y',
                description: 'Sm padding y of root'
            },
            {
                name: 'inputtext.root.lg.fontSize',
                token: 'inputtext.lg.font.size',
                variable: '--p-inputtext-lg-font-size',
                description: 'Lg font size of root'
            },
            {
                name: 'inputtext.root.lg.paddingX',
                token: 'inputtext.lg.padding.x',
                variable: '--p-inputtext-lg-padding-x',
                description: 'Lg padding x of root'
            },
            {
                name: 'inputtext.root.lg.paddingY',
                token: 'inputtext.lg.padding.y',
                variable: '--p-inputtext-lg-padding-y',
                description: 'Lg padding y of root'
            }
        ]
    },
    knob: {
        description: 'Knob Design Tokens',
        tokens: [
            {
                name: 'knob.root.transitionDuration',
                token: 'knob.transition.duration',
                variable: '--p-knob-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'knob.root.focusRing.width',
                token: 'knob.focus.ring.width',
                variable: '--p-knob-focus-ring-width',
                description: 'Focus ring width of root'
            },
            {
                name: 'knob.root.focusRing.style',
                token: 'knob.focus.ring.style',
                variable: '--p-knob-focus-ring-style',
                description: 'Focus ring style of root'
            },
            {
                name: 'knob.root.focusRing.color',
                token: 'knob.focus.ring.color',
                variable: '--p-knob-focus-ring-color',
                description: 'Focus ring color of root'
            },
            {
                name: 'knob.root.focusRing.offset',
                token: 'knob.focus.ring.offset',
                variable: '--p-knob-focus-ring-offset',
                description: 'Focus ring offset of root'
            },
            {
                name: 'knob.root.focusRing.shadow',
                token: 'knob.focus.ring.shadow',
                variable: '--p-knob-focus-ring-shadow',
                description: 'Focus ring shadow of root'
            },
            {
                name: 'knob.value.background',
                token: 'knob.value.background',
                variable: '--p-knob-value-background',
                description: 'Background of value'
            },
            {
                name: 'knob.range.background',
                token: 'knob.range.background',
                variable: '--p-knob-range-background',
                description: 'Background of range'
            },
            {
                name: 'knob.text.color',
                token: 'knob.text.color',
                variable: '--p-knob-text-color',
                description: 'Color of text'
            }
        ]
    },
    listbox: {
        description: 'Listbox Design Tokens',
        tokens: [
            {
                name: 'listbox.root.background',
                token: 'listbox.background',
                variable: '--p-listbox-background',
                description: 'Background of root'
            },
            {
                name: 'listbox.root.disabledBackground',
                token: 'listbox.disabled.background',
                variable: '--p-listbox-disabled-background',
                description: 'Disabled background of root'
            },
            {
                name: 'listbox.root.borderColor',
                token: 'listbox.border.color',
                variable: '--p-listbox-border-color',
                description: 'Border color of root'
            },
            {
                name: 'listbox.root.invalidBorderColor',
                token: 'listbox.invalid.border.color',
                variable: '--p-listbox-invalid-border-color',
                description: 'Invalid border color of root'
            },
            {
                name: 'listbox.root.color',
                token: 'listbox.color',
                variable: '--p-listbox-color',
                description: 'Color of root'
            },
            {
                name: 'listbox.root.disabledColor',
                token: 'listbox.disabled.color',
                variable: '--p-listbox-disabled-color',
                description: 'Disabled color of root'
            },
            {
                name: 'listbox.root.shadow',
                token: 'listbox.shadow',
                variable: '--p-listbox-shadow',
                description: 'Shadow of root'
            },
            {
                name: 'listbox.root.borderRadius',
                token: 'listbox.border.radius',
                variable: '--p-listbox-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'listbox.root.transitionDuration',
                token: 'listbox.transition.duration',
                variable: '--p-listbox-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'listbox.list.padding',
                token: 'listbox.list.padding',
                variable: '--p-listbox-list-padding',
                description: 'Padding of list'
            },
            {
                name: 'listbox.list.gap',
                token: 'listbox.list.gap',
                variable: '--p-listbox-list-gap',
                description: 'Gap of list'
            },
            {
                name: 'listbox.list.header.padding',
                token: 'listbox.list.header.padding',
                variable: '--p-listbox-list-header-padding',
                description: 'Header padding of list'
            },
            {
                name: 'listbox.option.focusBackground',
                token: 'listbox.option.focus.background',
                variable: '--p-listbox-option-focus-background',
                description: 'Focus background of option'
            },
            {
                name: 'listbox.option.selectedBackground',
                token: 'listbox.option.selected.background',
                variable: '--p-listbox-option-selected-background',
                description: 'Selected background of option'
            },
            {
                name: 'listbox.option.selectedFocusBackground',
                token: 'listbox.option.selected.focus.background',
                variable: '--p-listbox-option-selected-focus-background',
                description: 'Selected focus background of option'
            },
            {
                name: 'listbox.option.color',
                token: 'listbox.option.color',
                variable: '--p-listbox-option-color',
                description: 'Color of option'
            },
            {
                name: 'listbox.option.focusColor',
                token: 'listbox.option.focus.color',
                variable: '--p-listbox-option-focus-color',
                description: 'Focus color of option'
            },
            {
                name: 'listbox.option.selectedColor',
                token: 'listbox.option.selected.color',
                variable: '--p-listbox-option-selected-color',
                description: 'Selected color of option'
            },
            {
                name: 'listbox.option.selectedFocusColor',
                token: 'listbox.option.selected.focus.color',
                variable: '--p-listbox-option-selected-focus-color',
                description: 'Selected focus color of option'
            },
            {
                name: 'listbox.option.padding',
                token: 'listbox.option.padding',
                variable: '--p-listbox-option-padding',
                description: 'Padding of option'
            },
            {
                name: 'listbox.option.borderRadius',
                token: 'listbox.option.border.radius',
                variable: '--p-listbox-option-border-radius',
                description: 'Border radius of option'
            },
            {
                name: 'listbox.option.stripedBackground',
                token: 'listbox.option.striped.background',
                variable: '--p-listbox-option-striped-background',
                description: 'Striped background of option'
            },
            {
                name: 'listbox.optionGroup.background',
                token: 'listbox.option.group.background',
                variable: '--p-listbox-option-group-background',
                description: 'Background of option group'
            },
            {
                name: 'listbox.optionGroup.color',
                token: 'listbox.option.group.color',
                variable: '--p-listbox-option-group-color',
                description: 'Color of option group'
            },
            {
                name: 'listbox.optionGroup.fontWeight',
                token: 'listbox.option.group.font.weight',
                variable: '--p-listbox-option-group-font-weight',
                description: 'Font weight of option group'
            },
            {
                name: 'listbox.optionGroup.padding',
                token: 'listbox.option.group.padding',
                variable: '--p-listbox-option-group-padding',
                description: 'Padding of option group'
            },
            {
                name: 'listbox.checkmark.color',
                token: 'listbox.checkmark.color',
                variable: '--p-listbox-checkmark-color',
                description: 'Color of checkmark'
            },
            {
                name: 'listbox.checkmark.gutterStart',
                token: 'listbox.checkmark.gutter.start',
                variable: '--p-listbox-checkmark-gutter-start',
                description: 'Gutter start of checkmark'
            },
            {
                name: 'listbox.checkmark.gutterEnd',
                token: 'listbox.checkmark.gutter.end',
                variable: '--p-listbox-checkmark-gutter-end',
                description: 'Gutter end of checkmark'
            },
            {
                name: 'listbox.emptyMessage.padding',
                token: 'listbox.empty.message.padding',
                variable: '--p-listbox-empty-message-padding',
                description: 'Padding of empty message'
            }
        ]
    },
    megamenu: {
        description: 'MegaMenu Design Tokens',
        tokens: [
            {
                name: 'megamenu.root.background',
                token: 'megamenu.background',
                variable: '--p-megamenu-background',
                description: 'Background of root'
            },
            {
                name: 'megamenu.root.borderColor',
                token: 'megamenu.border.color',
                variable: '--p-megamenu-border-color',
                description: 'Border color of root'
            },
            {
                name: 'megamenu.root.borderRadius',
                token: 'megamenu.border.radius',
                variable: '--p-megamenu-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'megamenu.root.color',
                token: 'megamenu.color',
                variable: '--p-megamenu-color',
                description: 'Color of root'
            },
            {
                name: 'megamenu.root.gap',
                token: 'megamenu.gap',
                variable: '--p-megamenu-gap',
                description: 'Gap of root'
            },
            {
                name: 'megamenu.root.verticalOrientation.padding',
                token: 'megamenu.vertical.orientation.padding',
                variable: '--p-megamenu-vertical-orientation-padding',
                description: 'Vertical orientation padding of root'
            },
            {
                name: 'megamenu.root.verticalOrientation.gap',
                token: 'megamenu.vertical.orientation.gap',
                variable: '--p-megamenu-vertical-orientation-gap',
                description: 'Vertical orientation gap of root'
            },
            {
                name: 'megamenu.root.horizontalOrientation.padding',
                token: 'megamenu.horizontal.orientation.padding',
                variable: '--p-megamenu-horizontal-orientation-padding',
                description: 'Horizontal orientation padding of root'
            },
            {
                name: 'megamenu.root.horizontalOrientation.gap',
                token: 'megamenu.horizontal.orientation.gap',
                variable: '--p-megamenu-horizontal-orientation-gap',
                description: 'Horizontal orientation gap of root'
            },
            {
                name: 'megamenu.root.transitionDuration',
                token: 'megamenu.transition.duration',
                variable: '--p-megamenu-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'megamenu.baseItem.borderRadius',
                token: 'megamenu.base.item.border.radius',
                variable: '--p-megamenu-base-item-border-radius',
                description: 'Border radius of base item'
            },
            {
                name: 'megamenu.baseItem.padding',
                token: 'megamenu.base.item.padding',
                variable: '--p-megamenu-base-item-padding',
                description: 'Padding of base item'
            },
            {
                name: 'megamenu.item.focusBackground',
                token: 'megamenu.item.focus.background',
                variable: '--p-megamenu-item-focus-background',
                description: 'Focus background of item'
            },
            {
                name: 'megamenu.item.activeBackground',
                token: 'megamenu.item.active.background',
                variable: '--p-megamenu-item-active-background',
                description: 'Active background of item'
            },
            {
                name: 'megamenu.item.color',
                token: 'megamenu.item.color',
                variable: '--p-megamenu-item-color',
                description: 'Color of item'
            },
            {
                name: 'megamenu.item.focusColor',
                token: 'megamenu.item.focus.color',
                variable: '--p-megamenu-item-focus-color',
                description: 'Focus color of item'
            },
            {
                name: 'megamenu.item.activeColor',
                token: 'megamenu.item.active.color',
                variable: '--p-megamenu-item-active-color',
                description: 'Active color of item'
            },
            {
                name: 'megamenu.item.padding',
                token: 'megamenu.item.padding',
                variable: '--p-megamenu-item-padding',
                description: 'Padding of item'
            },
            {
                name: 'megamenu.item.borderRadius',
                token: 'megamenu.item.border.radius',
                variable: '--p-megamenu-item-border-radius',
                description: 'Border radius of item'
            },
            {
                name: 'megamenu.item.gap',
                token: 'megamenu.item.gap',
                variable: '--p-megamenu-item-gap',
                description: 'Gap of item'
            },
            {
                name: 'megamenu.item.icon.color',
                token: 'megamenu.item.icon.color',
                variable: '--p-megamenu-item-icon-color',
                description: 'Icon color of item'
            },
            {
                name: 'megamenu.item.icon.focusColor',
                token: 'megamenu.item.icon.focus.color',
                variable: '--p-megamenu-item-icon-focus-color',
                description: 'Icon focus color of item'
            },
            {
                name: 'megamenu.item.icon.activeColor',
                token: 'megamenu.item.icon.active.color',
                variable: '--p-megamenu-item-icon-active-color',
                description: 'Icon active color of item'
            },
            {
                name: 'megamenu.overlay.padding',
                token: 'megamenu.overlay.padding',
                variable: '--p-megamenu-overlay-padding',
                description: 'Padding of overlay'
            },
            {
                name: 'megamenu.overlay.background',
                token: 'megamenu.overlay.background',
                variable: '--p-megamenu-overlay-background',
                description: 'Background of overlay'
            },
            {
                name: 'megamenu.overlay.borderColor',
                token: 'megamenu.overlay.border.color',
                variable: '--p-megamenu-overlay-border-color',
                description: 'Border color of overlay'
            },
            {
                name: 'megamenu.overlay.borderRadius',
                token: 'megamenu.overlay.border.radius',
                variable: '--p-megamenu-overlay-border-radius',
                description: 'Border radius of overlay'
            },
            {
                name: 'megamenu.overlay.color',
                token: 'megamenu.overlay.color',
                variable: '--p-megamenu-overlay-color',
                description: 'Color of overlay'
            },
            {
                name: 'megamenu.overlay.shadow',
                token: 'megamenu.overlay.shadow',
                variable: '--p-megamenu-overlay-shadow',
                description: 'Shadow of overlay'
            },
            {
                name: 'megamenu.overlay.gap',
                token: 'megamenu.overlay.gap',
                variable: '--p-megamenu-overlay-gap',
                description: 'Gap of overlay'
            },
            {
                name: 'megamenu.submenu.padding',
                token: 'megamenu.submenu.padding',
                variable: '--p-megamenu-submenu-padding',
                description: 'Padding of submenu'
            },
            {
                name: 'megamenu.submenu.gap',
                token: 'megamenu.submenu.gap',
                variable: '--p-megamenu-submenu-gap',
                description: 'Gap of submenu'
            },
            {
                name: 'megamenu.submenuLabel.padding',
                token: 'megamenu.submenu.label.padding',
                variable: '--p-megamenu-submenu-label-padding',
                description: 'Padding of submenu label'
            },
            {
                name: 'megamenu.submenuLabel.fontWeight',
                token: 'megamenu.submenu.label.font.weight',
                variable: '--p-megamenu-submenu-label-font-weight',
                description: 'Font weight of submenu label'
            },
            {
                name: 'megamenu.submenuLabel.background',
                token: 'megamenu.submenu.label.background',
                variable: '--p-megamenu-submenu-label-background',
                description: 'Background of submenu label'
            },
            {
                name: 'megamenu.submenuLabel.color',
                token: 'megamenu.submenu.label.color',
                variable: '--p-megamenu-submenu-label-color',
                description: 'Color of submenu label'
            },
            {
                name: 'megamenu.submenuIcon.size',
                token: 'megamenu.submenu.icon.size',
                variable: '--p-megamenu-submenu-icon-size',
                description: 'Size of submenu icon'
            },
            {
                name: 'megamenu.submenuIcon.color',
                token: 'megamenu.submenu.icon.color',
                variable: '--p-megamenu-submenu-icon-color',
                description: 'Color of submenu icon'
            },
            {
                name: 'megamenu.submenuIcon.focusColor',
                token: 'megamenu.submenu.icon.focus.color',
                variable: '--p-megamenu-submenu-icon-focus-color',
                description: 'Focus color of submenu icon'
            },
            {
                name: 'megamenu.submenuIcon.activeColor',
                token: 'megamenu.submenu.icon.active.color',
                variable: '--p-megamenu-submenu-icon-active-color',
                description: 'Active color of submenu icon'
            },
            {
                name: 'megamenu.separator.borderColor',
                token: 'megamenu.separator.border.color',
                variable: '--p-megamenu-separator-border-color',
                description: 'Border color of separator'
            },
            {
                name: 'megamenu.mobileButton.borderRadius',
                token: 'megamenu.mobile.button.border.radius',
                variable: '--p-megamenu-mobile-button-border-radius',
                description: 'Border radius of mobile button'
            },
            {
                name: 'megamenu.mobileButton.size',
                token: 'megamenu.mobile.button.size',
                variable: '--p-megamenu-mobile-button-size',
                description: 'Size of mobile button'
            },
            {
                name: 'megamenu.mobileButton.color',
                token: 'megamenu.mobile.button.color',
                variable: '--p-megamenu-mobile-button-color',
                description: 'Color of mobile button'
            },
            {
                name: 'megamenu.mobileButton.hoverColor',
                token: 'megamenu.mobile.button.hover.color',
                variable: '--p-megamenu-mobile-button-hover-color',
                description: 'Hover color of mobile button'
            },
            {
                name: 'megamenu.mobileButton.hoverBackground',
                token: 'megamenu.mobile.button.hover.background',
                variable: '--p-megamenu-mobile-button-hover-background',
                description: 'Hover background of mobile button'
            },
            {
                name: 'megamenu.mobileButton.focusRing.width',
                token: 'megamenu.mobile.button.focus.ring.width',
                variable: '--p-megamenu-mobile-button-focus-ring-width',
                description: 'Focus ring width of mobile button'
            },
            {
                name: 'megamenu.mobileButton.focusRing.style',
                token: 'megamenu.mobile.button.focus.ring.style',
                variable: '--p-megamenu-mobile-button-focus-ring-style',
                description: 'Focus ring style of mobile button'
            },
            {
                name: 'megamenu.mobileButton.focusRing.color',
                token: 'megamenu.mobile.button.focus.ring.color',
                variable: '--p-megamenu-mobile-button-focus-ring-color',
                description: 'Focus ring color of mobile button'
            },
            {
                name: 'megamenu.mobileButton.focusRing.offset',
                token: 'megamenu.mobile.button.focus.ring.offset',
                variable: '--p-megamenu-mobile-button-focus-ring-offset',
                description: 'Focus ring offset of mobile button'
            },
            {
                name: 'megamenu.mobileButton.focusRing.shadow',
                token: 'megamenu.mobile.button.focus.ring.shadow',
                variable: '--p-megamenu-mobile-button-focus-ring-shadow',
                description: 'Focus ring shadow of mobile button'
            }
        ]
    },
    menu: {
        description: 'Menu Design Tokens',
        tokens: [
            {
                name: 'menu.root.background',
                token: 'menu.background',
                variable: '--p-menu-background',
                description: 'Background of root'
            },
            {
                name: 'menu.root.borderColor',
                token: 'menu.border.color',
                variable: '--p-menu-border-color',
                description: 'Border color of root'
            },
            {
                name: 'menu.root.color',
                token: 'menu.color',
                variable: '--p-menu-color',
                description: 'Color of root'
            },
            {
                name: 'menu.root.borderRadius',
                token: 'menu.border.radius',
                variable: '--p-menu-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'menu.root.shadow',
                token: 'menu.shadow',
                variable: '--p-menu-shadow',
                description: 'Shadow of root'
            },
            {
                name: 'menu.root.transitionDuration',
                token: 'menu.transition.duration',
                variable: '--p-menu-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'menu.list.padding',
                token: 'menu.list.padding',
                variable: '--p-menu-list-padding',
                description: 'Padding of list'
            },
            {
                name: 'menu.list.gap',
                token: 'menu.list.gap',
                variable: '--p-menu-list-gap',
                description: 'Gap of list'
            },
            {
                name: 'menu.item.focusBackground',
                token: 'menu.item.focus.background',
                variable: '--p-menu-item-focus-background',
                description: 'Focus background of item'
            },
            {
                name: 'menu.item.color',
                token: 'menu.item.color',
                variable: '--p-menu-item-color',
                description: 'Color of item'
            },
            {
                name: 'menu.item.focusColor',
                token: 'menu.item.focus.color',
                variable: '--p-menu-item-focus-color',
                description: 'Focus color of item'
            },
            {
                name: 'menu.item.padding',
                token: 'menu.item.padding',
                variable: '--p-menu-item-padding',
                description: 'Padding of item'
            },
            {
                name: 'menu.item.borderRadius',
                token: 'menu.item.border.radius',
                variable: '--p-menu-item-border-radius',
                description: 'Border radius of item'
            },
            {
                name: 'menu.item.gap',
                token: 'menu.item.gap',
                variable: '--p-menu-item-gap',
                description: 'Gap of item'
            },
            {
                name: 'menu.item.icon.color',
                token: 'menu.item.icon.color',
                variable: '--p-menu-item-icon-color',
                description: 'Icon color of item'
            },
            {
                name: 'menu.item.icon.focusColor',
                token: 'menu.item.icon.focus.color',
                variable: '--p-menu-item-icon-focus-color',
                description: 'Icon focus color of item'
            },
            {
                name: 'menu.submenuLabel.padding',
                token: 'menu.submenu.label.padding',
                variable: '--p-menu-submenu-label-padding',
                description: 'Padding of submenu label'
            },
            {
                name: 'menu.submenuLabel.fontWeight',
                token: 'menu.submenu.label.font.weight',
                variable: '--p-menu-submenu-label-font-weight',
                description: 'Font weight of submenu label'
            },
            {
                name: 'menu.submenuLabel.background',
                token: 'menu.submenu.label.background',
                variable: '--p-menu-submenu-label-background',
                description: 'Background of submenu label'
            },
            {
                name: 'menu.submenuLabel.color',
                token: 'menu.submenu.label.color',
                variable: '--p-menu-submenu-label-color',
                description: 'Color of submenu label'
            },
            {
                name: 'menu.separator.borderColor',
                token: 'menu.separator.border.color',
                variable: '--p-menu-separator-border-color',
                description: 'Border color of separator'
            }
        ]
    },
    menubar: {
        description: 'Menubar Design Tokens',
        tokens: [
            {
                name: 'menubar.root.background',
                token: 'menubar.background',
                variable: '--p-menubar-background',
                description: 'Background of root'
            },
            {
                name: 'menubar.root.borderColor',
                token: 'menubar.border.color',
                variable: '--p-menubar-border-color',
                description: 'Border color of root'
            },
            {
                name: 'menubar.root.borderRadius',
                token: 'menubar.border.radius',
                variable: '--p-menubar-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'menubar.root.color',
                token: 'menubar.color',
                variable: '--p-menubar-color',
                description: 'Color of root'
            },
            {
                name: 'menubar.root.gap',
                token: 'menubar.gap',
                variable: '--p-menubar-gap',
                description: 'Gap of root'
            },
            {
                name: 'menubar.root.padding',
                token: 'menubar.padding',
                variable: '--p-menubar-padding',
                description: 'Padding of root'
            },
            {
                name: 'menubar.root.transitionDuration',
                token: 'menubar.transition.duration',
                variable: '--p-menubar-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'menubar.baseItem.borderRadius',
                token: 'menubar.base.item.border.radius',
                variable: '--p-menubar-base-item-border-radius',
                description: 'Border radius of base item'
            },
            {
                name: 'menubar.baseItem.padding',
                token: 'menubar.base.item.padding',
                variable: '--p-menubar-base-item-padding',
                description: 'Padding of base item'
            },
            {
                name: 'menubar.item.focusBackground',
                token: 'menubar.item.focus.background',
                variable: '--p-menubar-item-focus-background',
                description: 'Focus background of item'
            },
            {
                name: 'menubar.item.activeBackground',
                token: 'menubar.item.active.background',
                variable: '--p-menubar-item-active-background',
                description: 'Active background of item'
            },
            {
                name: 'menubar.item.color',
                token: 'menubar.item.color',
                variable: '--p-menubar-item-color',
                description: 'Color of item'
            },
            {
                name: 'menubar.item.focusColor',
                token: 'menubar.item.focus.color',
                variable: '--p-menubar-item-focus-color',
                description: 'Focus color of item'
            },
            {
                name: 'menubar.item.activeColor',
                token: 'menubar.item.active.color',
                variable: '--p-menubar-item-active-color',
                description: 'Active color of item'
            },
            {
                name: 'menubar.item.padding',
                token: 'menubar.item.padding',
                variable: '--p-menubar-item-padding',
                description: 'Padding of item'
            },
            {
                name: 'menubar.item.borderRadius',
                token: 'menubar.item.border.radius',
                variable: '--p-menubar-item-border-radius',
                description: 'Border radius of item'
            },
            {
                name: 'menubar.item.gap',
                token: 'menubar.item.gap',
                variable: '--p-menubar-item-gap',
                description: 'Gap of item'
            },
            {
                name: 'menubar.item.icon.color',
                token: 'menubar.item.icon.color',
                variable: '--p-menubar-item-icon-color',
                description: 'Icon color of item'
            },
            {
                name: 'menubar.item.icon.focusColor',
                token: 'menubar.item.icon.focus.color',
                variable: '--p-menubar-item-icon-focus-color',
                description: 'Icon focus color of item'
            },
            {
                name: 'menubar.item.icon.activeColor',
                token: 'menubar.item.icon.active.color',
                variable: '--p-menubar-item-icon-active-color',
                description: 'Icon active color of item'
            },
            {
                name: 'menubar.submenu.padding',
                token: 'menubar.submenu.padding',
                variable: '--p-menubar-submenu-padding',
                description: 'Padding of submenu'
            },
            {
                name: 'menubar.submenu.gap',
                token: 'menubar.submenu.gap',
                variable: '--p-menubar-submenu-gap',
                description: 'Gap of submenu'
            },
            {
                name: 'menubar.submenu.background',
                token: 'menubar.submenu.background',
                variable: '--p-menubar-submenu-background',
                description: 'Background of submenu'
            },
            {
                name: 'menubar.submenu.borderColor',
                token: 'menubar.submenu.border.color',
                variable: '--p-menubar-submenu-border-color',
                description: 'Border color of submenu'
            },
            {
                name: 'menubar.submenu.borderRadius',
                token: 'menubar.submenu.border.radius',
                variable: '--p-menubar-submenu-border-radius',
                description: 'Border radius of submenu'
            },
            {
                name: 'menubar.submenu.shadow',
                token: 'menubar.submenu.shadow',
                variable: '--p-menubar-submenu-shadow',
                description: 'Shadow of submenu'
            },
            {
                name: 'menubar.submenu.mobileIndent',
                token: 'menubar.submenu.mobile.indent',
                variable: '--p-menubar-submenu-mobile-indent',
                description: 'Mobile indent of submenu'
            },
            {
                name: 'menubar.submenu.icon.size',
                token: 'menubar.submenu.icon.size',
                variable: '--p-menubar-submenu-icon-size',
                description: 'Icon size of submenu'
            },
            {
                name: 'menubar.submenu.icon.color',
                token: 'menubar.submenu.icon.color',
                variable: '--p-menubar-submenu-icon-color',
                description: 'Icon color of submenu'
            },
            {
                name: 'menubar.submenu.icon.focusColor',
                token: 'menubar.submenu.icon.focus.color',
                variable: '--p-menubar-submenu-icon-focus-color',
                description: 'Icon focus color of submenu'
            },
            {
                name: 'menubar.submenu.icon.activeColor',
                token: 'menubar.submenu.icon.active.color',
                variable: '--p-menubar-submenu-icon-active-color',
                description: 'Icon active color of submenu'
            },
            {
                name: 'menubar.separator.borderColor',
                token: 'menubar.separator.border.color',
                variable: '--p-menubar-separator-border-color',
                description: 'Border color of separator'
            },
            {
                name: 'menubar.mobileButton.borderRadius',
                token: 'menubar.mobile.button.border.radius',
                variable: '--p-menubar-mobile-button-border-radius',
                description: 'Border radius of mobile button'
            },
            {
                name: 'menubar.mobileButton.size',
                token: 'menubar.mobile.button.size',
                variable: '--p-menubar-mobile-button-size',
                description: 'Size of mobile button'
            },
            {
                name: 'menubar.mobileButton.color',
                token: 'menubar.mobile.button.color',
                variable: '--p-menubar-mobile-button-color',
                description: 'Color of mobile button'
            },
            {
                name: 'menubar.mobileButton.hoverColor',
                token: 'menubar.mobile.button.hover.color',
                variable: '--p-menubar-mobile-button-hover-color',
                description: 'Hover color of mobile button'
            },
            {
                name: 'menubar.mobileButton.hoverBackground',
                token: 'menubar.mobile.button.hover.background',
                variable: '--p-menubar-mobile-button-hover-background',
                description: 'Hover background of mobile button'
            },
            {
                name: 'menubar.mobileButton.focusRing.width',
                token: 'menubar.mobile.button.focus.ring.width',
                variable: '--p-menubar-mobile-button-focus-ring-width',
                description: 'Focus ring width of mobile button'
            },
            {
                name: 'menubar.mobileButton.focusRing.style',
                token: 'menubar.mobile.button.focus.ring.style',
                variable: '--p-menubar-mobile-button-focus-ring-style',
                description: 'Focus ring style of mobile button'
            },
            {
                name: 'menubar.mobileButton.focusRing.color',
                token: 'menubar.mobile.button.focus.ring.color',
                variable: '--p-menubar-mobile-button-focus-ring-color',
                description: 'Focus ring color of mobile button'
            },
            {
                name: 'menubar.mobileButton.focusRing.offset',
                token: 'menubar.mobile.button.focus.ring.offset',
                variable: '--p-menubar-mobile-button-focus-ring-offset',
                description: 'Focus ring offset of mobile button'
            },
            {
                name: 'menubar.mobileButton.focusRing.shadow',
                token: 'menubar.mobile.button.focus.ring.shadow',
                variable: '--p-menubar-mobile-button-focus-ring-shadow',
                description: 'Focus ring shadow of mobile button'
            }
        ]
    },
    message: {
        description: 'Message Design Tokens',
        tokens: [
            {
                name: 'message.root.borderRadius',
                token: 'message.border.radius',
                variable: '--p-message-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'message.root.borderWidth',
                token: 'message.border.width',
                variable: '--p-message-border-width',
                description: 'Border width of root'
            },
            {
                name: 'message.root.transitionDuration',
                token: 'message.transition.duration',
                variable: '--p-message-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'message.content.padding',
                token: 'message.content.padding',
                variable: '--p-message-content-padding',
                description: 'Padding of content'
            },
            {
                name: 'message.content.gap',
                token: 'message.content.gap',
                variable: '--p-message-content-gap',
                description: 'Gap of content'
            },
            {
                name: 'message.content.sm.padding',
                token: 'message.content.sm.padding',
                variable: '--p-message-content-sm-padding',
                description: 'Sm padding of content'
            },
            {
                name: 'message.content.lg.padding',
                token: 'message.content.lg.padding',
                variable: '--p-message-content-lg-padding',
                description: 'Lg padding of content'
            },
            {
                name: 'message.text.fontSize',
                token: 'message.text.font.size',
                variable: '--p-message-text-font-size',
                description: 'Font size of text'
            },
            {
                name: 'message.text.fontWeight',
                token: 'message.text.font.weight',
                variable: '--p-message-text-font-weight',
                description: 'Font weight of text'
            },
            {
                name: 'message.text.sm.fontSize',
                token: 'message.text.sm.font.size',
                variable: '--p-message-text-sm-font-size',
                description: 'Sm font size of text'
            },
            {
                name: 'message.text.lg.fontSize',
                token: 'message.text.lg.font.size',
                variable: '--p-message-text-lg-font-size',
                description: 'Lg font size of text'
            },
            {
                name: 'message.icon.size',
                token: 'message.icon.size',
                variable: '--p-message-icon-size',
                description: 'Size of icon'
            },
            {
                name: 'message.icon.sm.size',
                token: 'message.icon.sm.size',
                variable: '--p-message-icon-sm-size',
                description: 'Sm size of icon'
            },
            {
                name: 'message.icon.lg.size',
                token: 'message.icon.lg.size',
                variable: '--p-message-icon-lg-size',
                description: 'Lg size of icon'
            },
            {
                name: 'message.closeButton.width',
                token: 'message.close.button.width',
                variable: '--p-message-close-button-width',
                description: 'Width of close button'
            },
            {
                name: 'message.closeButton.height',
                token: 'message.close.button.height',
                variable: '--p-message-close-button-height',
                description: 'Height of close button'
            },
            {
                name: 'message.closeButton.borderRadius',
                token: 'message.close.button.border.radius',
                variable: '--p-message-close-button-border-radius',
                description: 'Border radius of close button'
            },
            {
                name: 'message.closeButton.focusRing.width',
                token: 'message.close.button.focus.ring.width',
                variable: '--p-message-close-button-focus-ring-width',
                description: 'Focus ring width of close button'
            },
            {
                name: 'message.closeButton.focusRing.style',
                token: 'message.close.button.focus.ring.style',
                variable: '--p-message-close-button-focus-ring-style',
                description: 'Focus ring style of close button'
            },
            {
                name: 'message.closeButton.focusRing.offset',
                token: 'message.close.button.focus.ring.offset',
                variable: '--p-message-close-button-focus-ring-offset',
                description: 'Focus ring offset of close button'
            },
            {
                name: 'message.closeIcon.size',
                token: 'message.close.icon.size',
                variable: '--p-message-close-icon-size',
                description: 'Size of close icon'
            },
            {
                name: 'message.closeIcon.sm.size',
                token: 'message.close.icon.sm.size',
                variable: '--p-message-close-icon-sm-size',
                description: 'Sm size of close icon'
            },
            {
                name: 'message.closeIcon.lg.size',
                token: 'message.close.icon.lg.size',
                variable: '--p-message-close-icon-lg-size',
                description: 'Lg size of close icon'
            },
            {
                name: 'message.outlined.root.borderWidth',
                token: 'message.outlined.border.width',
                variable: '--p-message-outlined-border-width',
                description: 'Root border width of outlined'
            },
            {
                name: 'message.simple.content.padding',
                token: 'message.simple.content.padding',
                variable: '--p-message-simple-content-padding',
                description: 'Content padding of simple'
            },
            {
                name: 'message.info.background',
                token: 'message.info.background',
                variable: '--p-message-info-background',
                description: 'Background of info'
            },
            {
                name: 'message.info.borderColor',
                token: 'message.info.border.color',
                variable: '--p-message-info-border-color',
                description: 'Border color of info'
            },
            {
                name: 'message.info.color',
                token: 'message.info.color',
                variable: '--p-message-info-color',
                description: 'Color of info'
            },
            {
                name: 'message.info.shadow',
                token: 'message.info.shadow',
                variable: '--p-message-info-shadow',
                description: 'Shadow of info'
            },
            {
                name: 'message.info.closeButton.hoverBackground',
                token: 'message.info.close.button.hover.background',
                variable: '--p-message-info-close-button-hover-background',
                description: 'Close button hover background of info'
            },
            {
                name: 'message.info.closeButton.focusRing.color',
                token: 'message.info.close.button.focus.ring.color',
                variable: '--p-message-info-close-button-focus-ring-color',
                description: 'Close button focus ring color of info'
            },
            {
                name: 'message.info.closeButton.focusRing.shadow',
                token: 'message.info.close.button.focus.ring.shadow',
                variable: '--p-message-info-close-button-focus-ring-shadow',
                description: 'Close button focus ring shadow of info'
            },
            {
                name: 'message.info.outlined.color',
                token: 'message.info.outlined.color',
                variable: '--p-message-info-outlined-color',
                description: 'Outlined color of info'
            },
            {
                name: 'message.info.outlined.borderColor',
                token: 'message.info.outlined.border.color',
                variable: '--p-message-info-outlined-border-color',
                description: 'Outlined border color of info'
            },
            {
                name: 'message.info.simple.color',
                token: 'message.info.simple.color',
                variable: '--p-message-info-simple-color',
                description: 'Simple color of info'
            },
            {
                name: 'message.success.background',
                token: 'message.success.background',
                variable: '--p-message-success-background',
                description: 'Background of success'
            },
            {
                name: 'message.success.borderColor',
                token: 'message.success.border.color',
                variable: '--p-message-success-border-color',
                description: 'Border color of success'
            },
            {
                name: 'message.success.color',
                token: 'message.success.color',
                variable: '--p-message-success-color',
                description: 'Color of success'
            },
            {
                name: 'message.success.shadow',
                token: 'message.success.shadow',
                variable: '--p-message-success-shadow',
                description: 'Shadow of success'
            },
            {
                name: 'message.success.closeButton.hoverBackground',
                token: 'message.success.close.button.hover.background',
                variable: '--p-message-success-close-button-hover-background',
                description: 'Close button hover background of success'
            },
            {
                name: 'message.success.closeButton.focusRing.color',
                token: 'message.success.close.button.focus.ring.color',
                variable: '--p-message-success-close-button-focus-ring-color',
                description: 'Close button focus ring color of success'
            },
            {
                name: 'message.success.closeButton.focusRing.shadow',
                token: 'message.success.close.button.focus.ring.shadow',
                variable: '--p-message-success-close-button-focus-ring-shadow',
                description: 'Close button focus ring shadow of success'
            },
            {
                name: 'message.success.outlined.color',
                token: 'message.success.outlined.color',
                variable: '--p-message-success-outlined-color',
                description: 'Outlined color of success'
            },
            {
                name: 'message.success.outlined.borderColor',
                token: 'message.success.outlined.border.color',
                variable: '--p-message-success-outlined-border-color',
                description: 'Outlined border color of success'
            },
            {
                name: 'message.success.simple.color',
                token: 'message.success.simple.color',
                variable: '--p-message-success-simple-color',
                description: 'Simple color of success'
            },
            {
                name: 'message.warn.background',
                token: 'message.warn.background',
                variable: '--p-message-warn-background',
                description: 'Background of warn'
            },
            {
                name: 'message.warn.borderColor',
                token: 'message.warn.border.color',
                variable: '--p-message-warn-border-color',
                description: 'Border color of warn'
            },
            {
                name: 'message.warn.color',
                token: 'message.warn.color',
                variable: '--p-message-warn-color',
                description: 'Color of warn'
            },
            {
                name: 'message.warn.shadow',
                token: 'message.warn.shadow',
                variable: '--p-message-warn-shadow',
                description: 'Shadow of warn'
            },
            {
                name: 'message.warn.closeButton.hoverBackground',
                token: 'message.warn.close.button.hover.background',
                variable: '--p-message-warn-close-button-hover-background',
                description: 'Close button hover background of warn'
            },
            {
                name: 'message.warn.closeButton.focusRing.color',
                token: 'message.warn.close.button.focus.ring.color',
                variable: '--p-message-warn-close-button-focus-ring-color',
                description: 'Close button focus ring color of warn'
            },
            {
                name: 'message.warn.closeButton.focusRing.shadow',
                token: 'message.warn.close.button.focus.ring.shadow',
                variable: '--p-message-warn-close-button-focus-ring-shadow',
                description: 'Close button focus ring shadow of warn'
            },
            {
                name: 'message.warn.outlined.color',
                token: 'message.warn.outlined.color',
                variable: '--p-message-warn-outlined-color',
                description: 'Outlined color of warn'
            },
            {
                name: 'message.warn.outlined.borderColor',
                token: 'message.warn.outlined.border.color',
                variable: '--p-message-warn-outlined-border-color',
                description: 'Outlined border color of warn'
            },
            {
                name: 'message.warn.simple.color',
                token: 'message.warn.simple.color',
                variable: '--p-message-warn-simple-color',
                description: 'Simple color of warn'
            },
            {
                name: 'message.error.background',
                token: 'message.error.background',
                variable: '--p-message-error-background',
                description: 'Background of error'
            },
            {
                name: 'message.error.borderColor',
                token: 'message.error.border.color',
                variable: '--p-message-error-border-color',
                description: 'Border color of error'
            },
            {
                name: 'message.error.color',
                token: 'message.error.color',
                variable: '--p-message-error-color',
                description: 'Color of error'
            },
            {
                name: 'message.error.shadow',
                token: 'message.error.shadow',
                variable: '--p-message-error-shadow',
                description: 'Shadow of error'
            },
            {
                name: 'message.error.closeButton.hoverBackground',
                token: 'message.error.close.button.hover.background',
                variable: '--p-message-error-close-button-hover-background',
                description: 'Close button hover background of error'
            },
            {
                name: 'message.error.closeButton.focusRing.color',
                token: 'message.error.close.button.focus.ring.color',
                variable: '--p-message-error-close-button-focus-ring-color',
                description: 'Close button focus ring color of error'
            },
            {
                name: 'message.error.closeButton.focusRing.shadow',
                token: 'message.error.close.button.focus.ring.shadow',
                variable: '--p-message-error-close-button-focus-ring-shadow',
                description: 'Close button focus ring shadow of error'
            },
            {
                name: 'message.error.outlined.color',
                token: 'message.error.outlined.color',
                variable: '--p-message-error-outlined-color',
                description: 'Outlined color of error'
            },
            {
                name: 'message.error.outlined.borderColor',
                token: 'message.error.outlined.border.color',
                variable: '--p-message-error-outlined-border-color',
                description: 'Outlined border color of error'
            },
            {
                name: 'message.error.simple.color',
                token: 'message.error.simple.color',
                variable: '--p-message-error-simple-color',
                description: 'Simple color of error'
            },
            {
                name: 'message.secondary.background',
                token: 'message.secondary.background',
                variable: '--p-message-secondary-background',
                description: 'Background of secondary'
            },
            {
                name: 'message.secondary.borderColor',
                token: 'message.secondary.border.color',
                variable: '--p-message-secondary-border-color',
                description: 'Border color of secondary'
            },
            {
                name: 'message.secondary.color',
                token: 'message.secondary.color',
                variable: '--p-message-secondary-color',
                description: 'Color of secondary'
            },
            {
                name: 'message.secondary.shadow',
                token: 'message.secondary.shadow',
                variable: '--p-message-secondary-shadow',
                description: 'Shadow of secondary'
            },
            {
                name: 'message.secondary.closeButton.hoverBackground',
                token: 'message.secondary.close.button.hover.background',
                variable: '--p-message-secondary-close-button-hover-background',
                description: 'Close button hover background of secondary'
            },
            {
                name: 'message.secondary.closeButton.focusRing.color',
                token: 'message.secondary.close.button.focus.ring.color',
                variable: '--p-message-secondary-close-button-focus-ring-color',
                description: 'Close button focus ring color of secondary'
            },
            {
                name: 'message.secondary.closeButton.focusRing.shadow',
                token: 'message.secondary.close.button.focus.ring.shadow',
                variable: '--p-message-secondary-close-button-focus-ring-shadow',
                description: 'Close button focus ring shadow of secondary'
            },
            {
                name: 'message.secondary.outlined.color',
                token: 'message.secondary.outlined.color',
                variable: '--p-message-secondary-outlined-color',
                description: 'Outlined color of secondary'
            },
            {
                name: 'message.secondary.outlined.borderColor',
                token: 'message.secondary.outlined.border.color',
                variable: '--p-message-secondary-outlined-border-color',
                description: 'Outlined border color of secondary'
            },
            {
                name: 'message.secondary.simple.color',
                token: 'message.secondary.simple.color',
                variable: '--p-message-secondary-simple-color',
                description: 'Simple color of secondary'
            },
            {
                name: 'message.contrast.background',
                token: 'message.contrast.background',
                variable: '--p-message-contrast-background',
                description: 'Background of contrast'
            },
            {
                name: 'message.contrast.borderColor',
                token: 'message.contrast.border.color',
                variable: '--p-message-contrast-border-color',
                description: 'Border color of contrast'
            },
            {
                name: 'message.contrast.color',
                token: 'message.contrast.color',
                variable: '--p-message-contrast-color',
                description: 'Color of contrast'
            },
            {
                name: 'message.contrast.shadow',
                token: 'message.contrast.shadow',
                variable: '--p-message-contrast-shadow',
                description: 'Shadow of contrast'
            },
            {
                name: 'message.contrast.closeButton.hoverBackground',
                token: 'message.contrast.close.button.hover.background',
                variable: '--p-message-contrast-close-button-hover-background',
                description: 'Close button hover background of contrast'
            },
            {
                name: 'message.contrast.closeButton.focusRing.color',
                token: 'message.contrast.close.button.focus.ring.color',
                variable: '--p-message-contrast-close-button-focus-ring-color',
                description: 'Close button focus ring color of contrast'
            },
            {
                name: 'message.contrast.closeButton.focusRing.shadow',
                token: 'message.contrast.close.button.focus.ring.shadow',
                variable: '--p-message-contrast-close-button-focus-ring-shadow',
                description: 'Close button focus ring shadow of contrast'
            },
            {
                name: 'message.contrast.outlined.color',
                token: 'message.contrast.outlined.color',
                variable: '--p-message-contrast-outlined-color',
                description: 'Outlined color of contrast'
            },
            {
                name: 'message.contrast.outlined.borderColor',
                token: 'message.contrast.outlined.border.color',
                variable: '--p-message-contrast-outlined-border-color',
                description: 'Outlined border color of contrast'
            },
            {
                name: 'message.contrast.simple.color',
                token: 'message.contrast.simple.color',
                variable: '--p-message-contrast-simple-color',
                description: 'Simple color of contrast'
            }
        ]
    },
    metergroup: {
        description: 'MeterGroup Design Tokens',
        tokens: [
            {
                name: 'metergroup.root.borderRadius',
                token: 'metergroup.border.radius',
                variable: '--p-metergroup-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'metergroup.root.gap',
                token: 'metergroup.gap',
                variable: '--p-metergroup-gap',
                description: 'Gap of root'
            },
            {
                name: 'metergroup.meters.background',
                token: 'metergroup.meters.background',
                variable: '--p-metergroup-meters-background',
                description: 'Background of meters'
            },
            {
                name: 'metergroup.meters.size',
                token: 'metergroup.meters.size',
                variable: '--p-metergroup-meters-size',
                description: 'Size of meters'
            },
            {
                name: 'metergroup.label.gap',
                token: 'metergroup.label.gap',
                variable: '--p-metergroup-label-gap',
                description: 'Gap of label'
            },
            {
                name: 'metergroup.labelMarker.size',
                token: 'metergroup.label.marker.size',
                variable: '--p-metergroup-label-marker-size',
                description: 'Size of label marker'
            },
            {
                name: 'metergroup.labelIcon.size',
                token: 'metergroup.label.icon.size',
                variable: '--p-metergroup-label-icon-size',
                description: 'Size of label icon'
            },
            {
                name: 'metergroup.labelList.verticalGap',
                token: 'metergroup.label.list.vertical.gap',
                variable: '--p-metergroup-label-list-vertical-gap',
                description: 'Vertical gap of label list'
            },
            {
                name: 'metergroup.labelList.horizontalGap',
                token: 'metergroup.label.list.horizontal.gap',
                variable: '--p-metergroup-label-list-horizontal-gap',
                description: 'Horizontal gap of label list'
            }
        ]
    },
    multiselect: {
        description: 'MultiSelect Design Tokens',
        tokens: [
            {
                name: 'multiselect.root.background',
                token: 'multiselect.background',
                variable: '--p-multiselect-background',
                description: 'Background of root'
            },
            {
                name: 'multiselect.root.disabledBackground',
                token: 'multiselect.disabled.background',
                variable: '--p-multiselect-disabled-background',
                description: 'Disabled background of root'
            },
            {
                name: 'multiselect.root.filledBackground',
                token: 'multiselect.filled.background',
                variable: '--p-multiselect-filled-background',
                description: 'Filled background of root'
            },
            {
                name: 'multiselect.root.filledHoverBackground',
                token: 'multiselect.filled.hover.background',
                variable: '--p-multiselect-filled-hover-background',
                description: 'Filled hover background of root'
            },
            {
                name: 'multiselect.root.filledFocusBackground',
                token: 'multiselect.filled.focus.background',
                variable: '--p-multiselect-filled-focus-background',
                description: 'Filled focus background of root'
            },
            {
                name: 'multiselect.root.borderColor',
                token: 'multiselect.border.color',
                variable: '--p-multiselect-border-color',
                description: 'Border color of root'
            },
            {
                name: 'multiselect.root.hoverBorderColor',
                token: 'multiselect.hover.border.color',
                variable: '--p-multiselect-hover-border-color',
                description: 'Hover border color of root'
            },
            {
                name: 'multiselect.root.focusBorderColor',
                token: 'multiselect.focus.border.color',
                variable: '--p-multiselect-focus-border-color',
                description: 'Focus border color of root'
            },
            {
                name: 'multiselect.root.invalidBorderColor',
                token: 'multiselect.invalid.border.color',
                variable: '--p-multiselect-invalid-border-color',
                description: 'Invalid border color of root'
            },
            {
                name: 'multiselect.root.color',
                token: 'multiselect.color',
                variable: '--p-multiselect-color',
                description: 'Color of root'
            },
            {
                name: 'multiselect.root.disabledColor',
                token: 'multiselect.disabled.color',
                variable: '--p-multiselect-disabled-color',
                description: 'Disabled color of root'
            },
            {
                name: 'multiselect.root.placeholderColor',
                token: 'multiselect.placeholder.color',
                variable: '--p-multiselect-placeholder-color',
                description: 'Placeholder color of root'
            },
            {
                name: 'multiselect.root.invalidPlaceholderColor',
                token: 'multiselect.invalid.placeholder.color',
                variable: '--p-multiselect-invalid-placeholder-color',
                description: 'Invalid placeholder color of root'
            },
            {
                name: 'multiselect.root.shadow',
                token: 'multiselect.shadow',
                variable: '--p-multiselect-shadow',
                description: 'Shadow of root'
            },
            {
                name: 'multiselect.root.paddingX',
                token: 'multiselect.padding.x',
                variable: '--p-multiselect-padding-x',
                description: 'Padding x of root'
            },
            {
                name: 'multiselect.root.paddingY',
                token: 'multiselect.padding.y',
                variable: '--p-multiselect-padding-y',
                description: 'Padding y of root'
            },
            {
                name: 'multiselect.root.borderRadius',
                token: 'multiselect.border.radius',
                variable: '--p-multiselect-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'multiselect.root.focusRing.width',
                token: 'multiselect.focus.ring.width',
                variable: '--p-multiselect-focus-ring-width',
                description: 'Focus ring width of root'
            },
            {
                name: 'multiselect.root.focusRing.style',
                token: 'multiselect.focus.ring.style',
                variable: '--p-multiselect-focus-ring-style',
                description: 'Focus ring style of root'
            },
            {
                name: 'multiselect.root.focusRing.color',
                token: 'multiselect.focus.ring.color',
                variable: '--p-multiselect-focus-ring-color',
                description: 'Focus ring color of root'
            },
            {
                name: 'multiselect.root.focusRing.offset',
                token: 'multiselect.focus.ring.offset',
                variable: '--p-multiselect-focus-ring-offset',
                description: 'Focus ring offset of root'
            },
            {
                name: 'multiselect.root.focusRing.shadow',
                token: 'multiselect.focus.ring.shadow',
                variable: '--p-multiselect-focus-ring-shadow',
                description: 'Focus ring shadow of root'
            },
            {
                name: 'multiselect.root.transitionDuration',
                token: 'multiselect.transition.duration',
                variable: '--p-multiselect-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'multiselect.root.sm.fontSize',
                token: 'multiselect.sm.font.size',
                variable: '--p-multiselect-sm-font-size',
                description: 'Sm font size of root'
            },
            {
                name: 'multiselect.root.sm.paddingX',
                token: 'multiselect.sm.padding.x',
                variable: '--p-multiselect-sm-padding-x',
                description: 'Sm padding x of root'
            },
            {
                name: 'multiselect.root.sm.paddingY',
                token: 'multiselect.sm.padding.y',
                variable: '--p-multiselect-sm-padding-y',
                description: 'Sm padding y of root'
            },
            {
                name: 'multiselect.root.lg.fontSize',
                token: 'multiselect.lg.font.size',
                variable: '--p-multiselect-lg-font-size',
                description: 'Lg font size of root'
            },
            {
                name: 'multiselect.root.lg.paddingX',
                token: 'multiselect.lg.padding.x',
                variable: '--p-multiselect-lg-padding-x',
                description: 'Lg padding x of root'
            },
            {
                name: 'multiselect.root.lg.paddingY',
                token: 'multiselect.lg.padding.y',
                variable: '--p-multiselect-lg-padding-y',
                description: 'Lg padding y of root'
            },
            {
                name: 'multiselect.dropdown.width',
                token: 'multiselect.dropdown.width',
                variable: '--p-multiselect-dropdown-width',
                description: 'Width of dropdown'
            },
            {
                name: 'multiselect.dropdown.color',
                token: 'multiselect.dropdown.color',
                variable: '--p-multiselect-dropdown-color',
                description: 'Color of dropdown'
            },
            {
                name: 'multiselect.overlay.background',
                token: 'multiselect.overlay.background',
                variable: '--p-multiselect-overlay-background',
                description: 'Background of overlay'
            },
            {
                name: 'multiselect.overlay.borderColor',
                token: 'multiselect.overlay.border.color',
                variable: '--p-multiselect-overlay-border-color',
                description: 'Border color of overlay'
            },
            {
                name: 'multiselect.overlay.borderRadius',
                token: 'multiselect.overlay.border.radius',
                variable: '--p-multiselect-overlay-border-radius',
                description: 'Border radius of overlay'
            },
            {
                name: 'multiselect.overlay.color',
                token: 'multiselect.overlay.color',
                variable: '--p-multiselect-overlay-color',
                description: 'Color of overlay'
            },
            {
                name: 'multiselect.overlay.shadow',
                token: 'multiselect.overlay.shadow',
                variable: '--p-multiselect-overlay-shadow',
                description: 'Shadow of overlay'
            },
            {
                name: 'multiselect.list.padding',
                token: 'multiselect.list.padding',
                variable: '--p-multiselect-list-padding',
                description: 'Padding of list'
            },
            {
                name: 'multiselect.list.gap',
                token: 'multiselect.list.gap',
                variable: '--p-multiselect-list-gap',
                description: 'Gap of list'
            },
            {
                name: 'multiselect.list.header.padding',
                token: 'multiselect.list.header.padding',
                variable: '--p-multiselect-list-header-padding',
                description: 'Header padding of list'
            },
            {
                name: 'multiselect.option.focusBackground',
                token: 'multiselect.option.focus.background',
                variable: '--p-multiselect-option-focus-background',
                description: 'Focus background of option'
            },
            {
                name: 'multiselect.option.selectedBackground',
                token: 'multiselect.option.selected.background',
                variable: '--p-multiselect-option-selected-background',
                description: 'Selected background of option'
            },
            {
                name: 'multiselect.option.selectedFocusBackground',
                token: 'multiselect.option.selected.focus.background',
                variable: '--p-multiselect-option-selected-focus-background',
                description: 'Selected focus background of option'
            },
            {
                name: 'multiselect.option.color',
                token: 'multiselect.option.color',
                variable: '--p-multiselect-option-color',
                description: 'Color of option'
            },
            {
                name: 'multiselect.option.focusColor',
                token: 'multiselect.option.focus.color',
                variable: '--p-multiselect-option-focus-color',
                description: 'Focus color of option'
            },
            {
                name: 'multiselect.option.selectedColor',
                token: 'multiselect.option.selected.color',
                variable: '--p-multiselect-option-selected-color',
                description: 'Selected color of option'
            },
            {
                name: 'multiselect.option.selectedFocusColor',
                token: 'multiselect.option.selected.focus.color',
                variable: '--p-multiselect-option-selected-focus-color',
                description: 'Selected focus color of option'
            },
            {
                name: 'multiselect.option.padding',
                token: 'multiselect.option.padding',
                variable: '--p-multiselect-option-padding',
                description: 'Padding of option'
            },
            {
                name: 'multiselect.option.borderRadius',
                token: 'multiselect.option.border.radius',
                variable: '--p-multiselect-option-border-radius',
                description: 'Border radius of option'
            },
            {
                name: 'multiselect.option.gap',
                token: 'multiselect.option.gap',
                variable: '--p-multiselect-option-gap',
                description: 'Gap of option'
            },
            {
                name: 'multiselect.optionGroup.background',
                token: 'multiselect.option.group.background',
                variable: '--p-multiselect-option-group-background',
                description: 'Background of option group'
            },
            {
                name: 'multiselect.optionGroup.color',
                token: 'multiselect.option.group.color',
                variable: '--p-multiselect-option-group-color',
                description: 'Color of option group'
            },
            {
                name: 'multiselect.optionGroup.fontWeight',
                token: 'multiselect.option.group.font.weight',
                variable: '--p-multiselect-option-group-font-weight',
                description: 'Font weight of option group'
            },
            {
                name: 'multiselect.optionGroup.padding',
                token: 'multiselect.option.group.padding',
                variable: '--p-multiselect-option-group-padding',
                description: 'Padding of option group'
            },
            {
                name: 'multiselect.clearIcon.color',
                token: 'multiselect.clear.icon.color',
                variable: '--p-multiselect-clear-icon-color',
                description: 'Color of clear icon'
            },
            {
                name: 'multiselect.chip.borderRadius',
                token: 'multiselect.chip.border.radius',
                variable: '--p-multiselect-chip-border-radius',
                description: 'Border radius of chip'
            },
            {
                name: 'multiselect.emptyMessage.padding',
                token: 'multiselect.empty.message.padding',
                variable: '--p-multiselect-empty-message-padding',
                description: 'Padding of empty message'
            }
        ]
    },
    orderlist: {
        description: 'OrderList Design Tokens',
        tokens: [
            {
                name: 'orderlist.root.gap',
                token: 'orderlist.gap',
                variable: '--p-orderlist-gap',
                description: 'Gap of root'
            },
            {
                name: 'orderlist.controls.gap',
                token: 'orderlist.controls.gap',
                variable: '--p-orderlist-controls-gap',
                description: 'Gap of controls'
            }
        ]
    },
    organizationchart: {
        description: 'OrganizationChart Design Tokens',
        tokens: [
            {
                name: 'organizationchart.root.gutter',
                token: 'organizationchart.gutter',
                variable: '--p-organizationchart-gutter',
                description: 'Gutter of root'
            },
            {
                name: 'organizationchart.root.transitionDuration',
                token: 'organizationchart.transition.duration',
                variable: '--p-organizationchart-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'organizationchart.node.background',
                token: 'organizationchart.node.background',
                variable: '--p-organizationchart-node-background',
                description: 'Background of node'
            },
            {
                name: 'organizationchart.node.hoverBackground',
                token: 'organizationchart.node.hover.background',
                variable: '--p-organizationchart-node-hover-background',
                description: 'Hover background of node'
            },
            {
                name: 'organizationchart.node.selectedBackground',
                token: 'organizationchart.node.selected.background',
                variable: '--p-organizationchart-node-selected-background',
                description: 'Selected background of node'
            },
            {
                name: 'organizationchart.node.borderColor',
                token: 'organizationchart.node.border.color',
                variable: '--p-organizationchart-node-border-color',
                description: 'Border color of node'
            },
            {
                name: 'organizationchart.node.color',
                token: 'organizationchart.node.color',
                variable: '--p-organizationchart-node-color',
                description: 'Color of node'
            },
            {
                name: 'organizationchart.node.selectedColor',
                token: 'organizationchart.node.selected.color',
                variable: '--p-organizationchart-node-selected-color',
                description: 'Selected color of node'
            },
            {
                name: 'organizationchart.node.hoverColor',
                token: 'organizationchart.node.hover.color',
                variable: '--p-organizationchart-node-hover-color',
                description: 'Hover color of node'
            },
            {
                name: 'organizationchart.node.padding',
                token: 'organizationchart.node.padding',
                variable: '--p-organizationchart-node-padding',
                description: 'Padding of node'
            },
            {
                name: 'organizationchart.node.toggleablePadding',
                token: 'organizationchart.node.toggleable.padding',
                variable: '--p-organizationchart-node-toggleable-padding',
                description: 'Toggleable padding of node'
            },
            {
                name: 'organizationchart.node.borderRadius',
                token: 'organizationchart.node.border.radius',
                variable: '--p-organizationchart-node-border-radius',
                description: 'Border radius of node'
            },
            {
                name: 'organizationchart.nodeToggleButton.background',
                token: 'organizationchart.node.toggle.button.background',
                variable: '--p-organizationchart-node-toggle-button-background',
                description: 'Background of node toggle button'
            },
            {
                name: 'organizationchart.nodeToggleButton.hoverBackground',
                token: 'organizationchart.node.toggle.button.hover.background',
                variable: '--p-organizationchart-node-toggle-button-hover-background',
                description: 'Hover background of node toggle button'
            },
            {
                name: 'organizationchart.nodeToggleButton.borderColor',
                token: 'organizationchart.node.toggle.button.border.color',
                variable: '--p-organizationchart-node-toggle-button-border-color',
                description: 'Border color of node toggle button'
            },
            {
                name: 'organizationchart.nodeToggleButton.color',
                token: 'organizationchart.node.toggle.button.color',
                variable: '--p-organizationchart-node-toggle-button-color',
                description: 'Color of node toggle button'
            },
            {
                name: 'organizationchart.nodeToggleButton.hoverColor',
                token: 'organizationchart.node.toggle.button.hover.color',
                variable: '--p-organizationchart-node-toggle-button-hover-color',
                description: 'Hover color of node toggle button'
            },
            {
                name: 'organizationchart.nodeToggleButton.size',
                token: 'organizationchart.node.toggle.button.size',
                variable: '--p-organizationchart-node-toggle-button-size',
                description: 'Size of node toggle button'
            },
            {
                name: 'organizationchart.nodeToggleButton.borderRadius',
                token: 'organizationchart.node.toggle.button.border.radius',
                variable: '--p-organizationchart-node-toggle-button-border-radius',
                description: 'Border radius of node toggle button'
            },
            {
                name: 'organizationchart.nodeToggleButton.focusRing.width',
                token: 'organizationchart.node.toggle.button.focus.ring.width',
                variable: '--p-organizationchart-node-toggle-button-focus-ring-width',
                description: 'Focus ring width of node toggle button'
            },
            {
                name: 'organizationchart.nodeToggleButton.focusRing.style',
                token: 'organizationchart.node.toggle.button.focus.ring.style',
                variable: '--p-organizationchart-node-toggle-button-focus-ring-style',
                description: 'Focus ring style of node toggle button'
            },
            {
                name: 'organizationchart.nodeToggleButton.focusRing.color',
                token: 'organizationchart.node.toggle.button.focus.ring.color',
                variable: '--p-organizationchart-node-toggle-button-focus-ring-color',
                description: 'Focus ring color of node toggle button'
            },
            {
                name: 'organizationchart.nodeToggleButton.focusRing.offset',
                token: 'organizationchart.node.toggle.button.focus.ring.offset',
                variable: '--p-organizationchart-node-toggle-button-focus-ring-offset',
                description: 'Focus ring offset of node toggle button'
            },
            {
                name: 'organizationchart.nodeToggleButton.focusRing.shadow',
                token: 'organizationchart.node.toggle.button.focus.ring.shadow',
                variable: '--p-organizationchart-node-toggle-button-focus-ring-shadow',
                description: 'Focus ring shadow of node toggle button'
            },
            {
                name: 'organizationchart.connector.color',
                token: 'organizationchart.connector.color',
                variable: '--p-organizationchart-connector-color',
                description: 'Color of connector'
            },
            {
                name: 'organizationchart.connector.borderRadius',
                token: 'organizationchart.connector.border.radius',
                variable: '--p-organizationchart-connector-border-radius',
                description: 'Border radius of connector'
            },
            {
                name: 'organizationchart.connector.height',
                token: 'organizationchart.connector.height',
                variable: '--p-organizationchart-connector-height',
                description: 'Height of connector'
            }
        ]
    },
    overlaybadge: {
        description: 'OverlayBadge Design Tokens',
        tokens: [
            {
                name: 'overlaybadge.root.outline.width',
                token: 'overlaybadge.outline.width',
                variable: '--p-overlaybadge-outline-width',
                description: 'Outline width of root'
            },
            {
                name: 'overlaybadge.root.outline.color',
                token: 'overlaybadge.outline.color',
                variable: '--p-overlaybadge-outline-color',
                description: 'Outline color of root'
            }
        ]
    },
    paginator: {
        description: 'Paginator Design Tokens',
        tokens: [
            {
                name: 'paginator.root.padding',
                token: 'paginator.padding',
                variable: '--p-paginator-padding',
                description: 'Padding of root'
            },
            {
                name: 'paginator.root.gap',
                token: 'paginator.gap',
                variable: '--p-paginator-gap',
                description: 'Gap of root'
            },
            {
                name: 'paginator.root.borderRadius',
                token: 'paginator.border.radius',
                variable: '--p-paginator-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'paginator.root.background',
                token: 'paginator.background',
                variable: '--p-paginator-background',
                description: 'Background of root'
            },
            {
                name: 'paginator.root.color',
                token: 'paginator.color',
                variable: '--p-paginator-color',
                description: 'Color of root'
            },
            {
                name: 'paginator.root.transitionDuration',
                token: 'paginator.transition.duration',
                variable: '--p-paginator-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'paginator.navButton.background',
                token: 'paginator.nav.button.background',
                variable: '--p-paginator-nav-button-background',
                description: 'Background of nav button'
            },
            {
                name: 'paginator.navButton.hoverBackground',
                token: 'paginator.nav.button.hover.background',
                variable: '--p-paginator-nav-button-hover-background',
                description: 'Hover background of nav button'
            },
            {
                name: 'paginator.navButton.selectedBackground',
                token: 'paginator.nav.button.selected.background',
                variable: '--p-paginator-nav-button-selected-background',
                description: 'Selected background of nav button'
            },
            {
                name: 'paginator.navButton.color',
                token: 'paginator.nav.button.color',
                variable: '--p-paginator-nav-button-color',
                description: 'Color of nav button'
            },
            {
                name: 'paginator.navButton.hoverColor',
                token: 'paginator.nav.button.hover.color',
                variable: '--p-paginator-nav-button-hover-color',
                description: 'Hover color of nav button'
            },
            {
                name: 'paginator.navButton.selectedColor',
                token: 'paginator.nav.button.selected.color',
                variable: '--p-paginator-nav-button-selected-color',
                description: 'Selected color of nav button'
            },
            {
                name: 'paginator.navButton.width',
                token: 'paginator.nav.button.width',
                variable: '--p-paginator-nav-button-width',
                description: 'Width of nav button'
            },
            {
                name: 'paginator.navButton.height',
                token: 'paginator.nav.button.height',
                variable: '--p-paginator-nav-button-height',
                description: 'Height of nav button'
            },
            {
                name: 'paginator.navButton.borderRadius',
                token: 'paginator.nav.button.border.radius',
                variable: '--p-paginator-nav-button-border-radius',
                description: 'Border radius of nav button'
            },
            {
                name: 'paginator.navButton.focusRing.width',
                token: 'paginator.nav.button.focus.ring.width',
                variable: '--p-paginator-nav-button-focus-ring-width',
                description: 'Focus ring width of nav button'
            },
            {
                name: 'paginator.navButton.focusRing.style',
                token: 'paginator.nav.button.focus.ring.style',
                variable: '--p-paginator-nav-button-focus-ring-style',
                description: 'Focus ring style of nav button'
            },
            {
                name: 'paginator.navButton.focusRing.color',
                token: 'paginator.nav.button.focus.ring.color',
                variable: '--p-paginator-nav-button-focus-ring-color',
                description: 'Focus ring color of nav button'
            },
            {
                name: 'paginator.navButton.focusRing.offset',
                token: 'paginator.nav.button.focus.ring.offset',
                variable: '--p-paginator-nav-button-focus-ring-offset',
                description: 'Focus ring offset of nav button'
            },
            {
                name: 'paginator.navButton.focusRing.shadow',
                token: 'paginator.nav.button.focus.ring.shadow',
                variable: '--p-paginator-nav-button-focus-ring-shadow',
                description: 'Focus ring shadow of nav button'
            },
            {
                name: 'paginator.currentPageReport.color',
                token: 'paginator.current.page.report.color',
                variable: '--p-paginator-current-page-report-color',
                description: 'Color of current page report'
            },
            {
                name: 'paginator.jumpToPageInput.maxWidth',
                token: 'paginator.jump.to.page.input.max.width',
                variable: '--p-paginator-jump-to-page-input-max-width',
                description: 'Max width of jump to page input'
            }
        ]
    },
    panel: {
        description: 'Panel Design Tokens',
        tokens: [
            {
                name: 'panel.root.background',
                token: 'panel.background',
                variable: '--p-panel-background',
                description: 'Background of root'
            },
            {
                name: 'panel.root.borderColor',
                token: 'panel.border.color',
                variable: '--p-panel-border-color',
                description: 'Border color of root'
            },
            {
                name: 'panel.root.color',
                token: 'panel.color',
                variable: '--p-panel-color',
                description: 'Color of root'
            },
            {
                name: 'panel.root.borderRadius',
                token: 'panel.border.radius',
                variable: '--p-panel-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'panel.header.background',
                token: 'panel.header.background',
                variable: '--p-panel-header-background',
                description: 'Background of header'
            },
            {
                name: 'panel.header.color',
                token: 'panel.header.color',
                variable: '--p-panel-header-color',
                description: 'Color of header'
            },
            {
                name: 'panel.header.padding',
                token: 'panel.header.padding',
                variable: '--p-panel-header-padding',
                description: 'Padding of header'
            },
            {
                name: 'panel.header.borderColor',
                token: 'panel.header.border.color',
                variable: '--p-panel-header-border-color',
                description: 'Border color of header'
            },
            {
                name: 'panel.header.borderWidth',
                token: 'panel.header.border.width',
                variable: '--p-panel-header-border-width',
                description: 'Border width of header'
            },
            {
                name: 'panel.header.borderRadius',
                token: 'panel.header.border.radius',
                variable: '--p-panel-header-border-radius',
                description: 'Border radius of header'
            },
            {
                name: 'panel.toggleableHeader.padding',
                token: 'panel.toggleable.header.padding',
                variable: '--p-panel-toggleable-header-padding',
                description: 'Padding of toggleable header'
            },
            {
                name: 'panel.title.fontWeight',
                token: 'panel.title.font.weight',
                variable: '--p-panel-title-font-weight',
                description: 'Font weight of title'
            },
            {
                name: 'panel.content.padding',
                token: 'panel.content.padding',
                variable: '--p-panel-content-padding',
                description: 'Padding of content'
            },
            {
                name: 'panel.footer.padding',
                token: 'panel.footer.padding',
                variable: '--p-panel-footer-padding',
                description: 'Padding of footer'
            }
        ]
    },
    panelmenu: {
        description: 'PanelMenu Design Tokens',
        tokens: [
            {
                name: 'panelmenu.root.gap',
                token: 'panelmenu.gap',
                variable: '--p-panelmenu-gap',
                description: 'Gap of root'
            },
            {
                name: 'panelmenu.root.transitionDuration',
                token: 'panelmenu.transition.duration',
                variable: '--p-panelmenu-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'panelmenu.panel.background',
                token: 'panelmenu.panel.background',
                variable: '--p-panelmenu-panel-background',
                description: 'Background of panel'
            },
            {
                name: 'panelmenu.panel.borderColor',
                token: 'panelmenu.panel.border.color',
                variable: '--p-panelmenu-panel-border-color',
                description: 'Border color of panel'
            },
            {
                name: 'panelmenu.panel.borderWidth',
                token: 'panelmenu.panel.border.width',
                variable: '--p-panelmenu-panel-border-width',
                description: 'Border width of panel'
            },
            {
                name: 'panelmenu.panel.color',
                token: 'panelmenu.panel.color',
                variable: '--p-panelmenu-panel-color',
                description: 'Color of panel'
            },
            {
                name: 'panelmenu.panel.padding',
                token: 'panelmenu.panel.padding',
                variable: '--p-panelmenu-panel-padding',
                description: 'Padding of panel'
            },
            {
                name: 'panelmenu.panel.borderRadius',
                token: 'panelmenu.panel.border.radius',
                variable: '--p-panelmenu-panel-border-radius',
                description: 'Border radius of panel'
            },
            {
                name: 'panelmenu.panel.first.borderWidth',
                token: 'panelmenu.panel.first.border.width',
                variable: '--p-panelmenu-panel-first-border-width',
                description: 'First border width of panel'
            },
            {
                name: 'panelmenu.panel.first.topBorderRadius',
                token: 'panelmenu.panel.first.top.border.radius',
                variable: '--p-panelmenu-panel-first-top-border-radius',
                description: 'First top border radius of panel'
            },
            {
                name: 'panelmenu.panel.last.borderWidth',
                token: 'panelmenu.panel.last.border.width',
                variable: '--p-panelmenu-panel-last-border-width',
                description: 'Last border width of panel'
            },
            {
                name: 'panelmenu.panel.last.bottomBorderRadius',
                token: 'panelmenu.panel.last.bottom.border.radius',
                variable: '--p-panelmenu-panel-last-bottom-border-radius',
                description: 'Last bottom border radius of panel'
            },
            {
                name: 'panelmenu.item.focusBackground',
                token: 'panelmenu.item.focus.background',
                variable: '--p-panelmenu-item-focus-background',
                description: 'Focus background of item'
            },
            {
                name: 'panelmenu.item.color',
                token: 'panelmenu.item.color',
                variable: '--p-panelmenu-item-color',
                description: 'Color of item'
            },
            {
                name: 'panelmenu.item.focusColor',
                token: 'panelmenu.item.focus.color',
                variable: '--p-panelmenu-item-focus-color',
                description: 'Focus color of item'
            },
            {
                name: 'panelmenu.item.gap',
                token: 'panelmenu.item.gap',
                variable: '--p-panelmenu-item-gap',
                description: 'Gap of item'
            },
            {
                name: 'panelmenu.item.padding',
                token: 'panelmenu.item.padding',
                variable: '--p-panelmenu-item-padding',
                description: 'Padding of item'
            },
            {
                name: 'panelmenu.item.borderRadius',
                token: 'panelmenu.item.border.radius',
                variable: '--p-panelmenu-item-border-radius',
                description: 'Border radius of item'
            },
            {
                name: 'panelmenu.item.icon.color',
                token: 'panelmenu.item.icon.color',
                variable: '--p-panelmenu-item-icon-color',
                description: 'Icon color of item'
            },
            {
                name: 'panelmenu.item.icon.focusColor',
                token: 'panelmenu.item.icon.focus.color',
                variable: '--p-panelmenu-item-icon-focus-color',
                description: 'Icon focus color of item'
            },
            {
                name: 'panelmenu.submenu.indent',
                token: 'panelmenu.submenu.indent',
                variable: '--p-panelmenu-submenu-indent',
                description: 'Indent of submenu'
            },
            {
                name: 'panelmenu.submenuIcon.color',
                token: 'panelmenu.submenu.icon.color',
                variable: '--p-panelmenu-submenu-icon-color',
                description: 'Color of submenu icon'
            },
            {
                name: 'panelmenu.submenuIcon.focusColor',
                token: 'panelmenu.submenu.icon.focus.color',
                variable: '--p-panelmenu-submenu-icon-focus-color',
                description: 'Focus color of submenu icon'
            }
        ]
    },
    password: {
        description: 'Password Design Tokens',
        tokens: [
            {
                name: 'password.meter.background',
                token: 'password.meter.background',
                variable: '--p-password-meter-background',
                description: 'Background of meter'
            },
            {
                name: 'password.meter.borderRadius',
                token: 'password.meter.border.radius',
                variable: '--p-password-meter-border-radius',
                description: 'Border radius of meter'
            },
            {
                name: 'password.meter.height',
                token: 'password.meter.height',
                variable: '--p-password-meter-height',
                description: 'Height of meter'
            },
            {
                name: 'password.icon.color',
                token: 'password.icon.color',
                variable: '--p-password-icon-color',
                description: 'Color of icon'
            },
            {
                name: 'password.overlay.background',
                token: 'password.overlay.background',
                variable: '--p-password-overlay-background',
                description: 'Background of overlay'
            },
            {
                name: 'password.overlay.borderColor',
                token: 'password.overlay.border.color',
                variable: '--p-password-overlay-border-color',
                description: 'Border color of overlay'
            },
            {
                name: 'password.overlay.borderRadius',
                token: 'password.overlay.border.radius',
                variable: '--p-password-overlay-border-radius',
                description: 'Border radius of overlay'
            },
            {
                name: 'password.overlay.color',
                token: 'password.overlay.color',
                variable: '--p-password-overlay-color',
                description: 'Color of overlay'
            },
            {
                name: 'password.overlay.padding',
                token: 'password.overlay.padding',
                variable: '--p-password-overlay-padding',
                description: 'Padding of overlay'
            },
            {
                name: 'password.overlay.shadow',
                token: 'password.overlay.shadow',
                variable: '--p-password-overlay-shadow',
                description: 'Shadow of overlay'
            },
            {
                name: 'password.content.gap',
                token: 'password.content.gap',
                variable: '--p-password-content-gap',
                description: 'Gap of content'
            },
            {
                name: 'password.strength.weakBackground',
                token: 'password.strength.weak.background',
                variable: '--p-password-strength-weak-background',
                description: 'Weak background of strength'
            },
            {
                name: 'password.strength.mediumBackground',
                token: 'password.strength.medium.background',
                variable: '--p-password-strength-medium-background',
                description: 'Medium background of strength'
            },
            {
                name: 'password.strength.strongBackground',
                token: 'password.strength.strong.background',
                variable: '--p-password-strength-strong-background',
                description: 'Strong background of strength'
            }
        ]
    },
    picklist: {
        description: 'PickList Design Tokens',
        tokens: [
            {
                name: 'picklist.root.gap',
                token: 'picklist.gap',
                variable: '--p-picklist-gap',
                description: 'Gap of root'
            },
            {
                name: 'picklist.controls.gap',
                token: 'picklist.controls.gap',
                variable: '--p-picklist-controls-gap',
                description: 'Gap of controls'
            }
        ]
    },
    popover: {
        description: 'Popover Design Tokens',
        tokens: [
            {
                name: 'popover.root.background',
                token: 'popover.background',
                variable: '--p-popover-background',
                description: 'Background of root'
            },
            {
                name: 'popover.root.borderColor',
                token: 'popover.border.color',
                variable: '--p-popover-border-color',
                description: 'Border color of root'
            },
            {
                name: 'popover.root.color',
                token: 'popover.color',
                variable: '--p-popover-color',
                description: 'Color of root'
            },
            {
                name: 'popover.root.borderRadius',
                token: 'popover.border.radius',
                variable: '--p-popover-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'popover.root.shadow',
                token: 'popover.shadow',
                variable: '--p-popover-shadow',
                description: 'Shadow of root'
            },
            {
                name: 'popover.root.gutter',
                token: 'popover.gutter',
                variable: '--p-popover-gutter',
                description: 'Gutter of root'
            },
            {
                name: 'popover.root.arrowOffset',
                token: 'popover.arrow.offset',
                variable: '--p-popover-arrow-offset',
                description: 'Arrow offset of root'
            },
            {
                name: 'popover.content.padding',
                token: 'popover.content.padding',
                variable: '--p-popover-content-padding',
                description: 'Padding of content'
            }
        ]
    },
    progressbar: {
        description: 'ProgressBar Design Tokens',
        tokens: [
            {
                name: 'progressbar.root.background',
                token: 'progressbar.background',
                variable: '--p-progressbar-background',
                description: 'Background of root'
            },
            {
                name: 'progressbar.root.borderRadius',
                token: 'progressbar.border.radius',
                variable: '--p-progressbar-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'progressbar.root.height',
                token: 'progressbar.height',
                variable: '--p-progressbar-height',
                description: 'Height of root'
            },
            {
                name: 'progressbar.value.background',
                token: 'progressbar.value.background',
                variable: '--p-progressbar-value-background',
                description: 'Background of value'
            },
            {
                name: 'progressbar.label.color',
                token: 'progressbar.label.color',
                variable: '--p-progressbar-label-color',
                description: 'Color of label'
            },
            {
                name: 'progressbar.label.fontSize',
                token: 'progressbar.label.font.size',
                variable: '--p-progressbar-label-font-size',
                description: 'Font size of label'
            },
            {
                name: 'progressbar.label.fontWeight',
                token: 'progressbar.label.font.weight',
                variable: '--p-progressbar-label-font-weight',
                description: 'Font weight of label'
            }
        ]
    },
    progressspinner: {
        description: 'ProgressSpinner Design Tokens',
        tokens: [
            {
                name: 'progressspinner.root.colorOne',
                token: 'progressspinner.color.one',
                variable: '--p-progressspinner-color-one',
                description: 'Color one of root'
            },
            {
                name: 'progressspinner.root.colorTwo',
                token: 'progressspinner.color.two',
                variable: '--p-progressspinner-color-two',
                description: 'Color two of root'
            },
            {
                name: 'progressspinner.root.colorThree',
                token: 'progressspinner.color.three',
                variable: '--p-progressspinner-color-three',
                description: 'Color three of root'
            },
            {
                name: 'progressspinner.root.colorFour',
                token: 'progressspinner.color.four',
                variable: '--p-progressspinner-color-four',
                description: 'Color four of root'
            }
        ]
    },
    radiobutton: {
        description: 'RadioButton Design Tokens',
        tokens: [
            {
                name: 'radiobutton.root.width',
                token: 'radiobutton.width',
                variable: '--p-radiobutton-width',
                description: 'Width of root'
            },
            {
                name: 'radiobutton.root.height',
                token: 'radiobutton.height',
                variable: '--p-radiobutton-height',
                description: 'Height of root'
            },
            {
                name: 'radiobutton.root.background',
                token: 'radiobutton.background',
                variable: '--p-radiobutton-background',
                description: 'Background of root'
            },
            {
                name: 'radiobutton.root.checkedBackground',
                token: 'radiobutton.checked.background',
                variable: '--p-radiobutton-checked-background',
                description: 'Checked background of root'
            },
            {
                name: 'radiobutton.root.checkedHoverBackground',
                token: 'radiobutton.checked.hover.background',
                variable: '--p-radiobutton-checked-hover-background',
                description: 'Checked hover background of root'
            },
            {
                name: 'radiobutton.root.disabledBackground',
                token: 'radiobutton.disabled.background',
                variable: '--p-radiobutton-disabled-background',
                description: 'Disabled background of root'
            },
            {
                name: 'radiobutton.root.filledBackground',
                token: 'radiobutton.filled.background',
                variable: '--p-radiobutton-filled-background',
                description: 'Filled background of root'
            },
            {
                name: 'radiobutton.root.borderColor',
                token: 'radiobutton.border.color',
                variable: '--p-radiobutton-border-color',
                description: 'Border color of root'
            },
            {
                name: 'radiobutton.root.hoverBorderColor',
                token: 'radiobutton.hover.border.color',
                variable: '--p-radiobutton-hover-border-color',
                description: 'Hover border color of root'
            },
            {
                name: 'radiobutton.root.focusBorderColor',
                token: 'radiobutton.focus.border.color',
                variable: '--p-radiobutton-focus-border-color',
                description: 'Focus border color of root'
            },
            {
                name: 'radiobutton.root.checkedBorderColor',
                token: 'radiobutton.checked.border.color',
                variable: '--p-radiobutton-checked-border-color',
                description: 'Checked border color of root'
            },
            {
                name: 'radiobutton.root.checkedHoverBorderColor',
                token: 'radiobutton.checked.hover.border.color',
                variable: '--p-radiobutton-checked-hover-border-color',
                description: 'Checked hover border color of root'
            },
            {
                name: 'radiobutton.root.checkedFocusBorderColor',
                token: 'radiobutton.checked.focus.border.color',
                variable: '--p-radiobutton-checked-focus-border-color',
                description: 'Checked focus border color of root'
            },
            {
                name: 'radiobutton.root.checkedDisabledBorderColor',
                token: 'radiobutton.checked.disabled.border.color',
                variable: '--p-radiobutton-checked-disabled-border-color',
                description: 'Checked disabled border color of root'
            },
            {
                name: 'radiobutton.root.invalidBorderColor',
                token: 'radiobutton.invalid.border.color',
                variable: '--p-radiobutton-invalid-border-color',
                description: 'Invalid border color of root'
            },
            {
                name: 'radiobutton.root.shadow',
                token: 'radiobutton.shadow',
                variable: '--p-radiobutton-shadow',
                description: 'Shadow of root'
            },
            {
                name: 'radiobutton.root.focusRing.width',
                token: 'radiobutton.focus.ring.width',
                variable: '--p-radiobutton-focus-ring-width',
                description: 'Focus ring width of root'
            },
            {
                name: 'radiobutton.root.focusRing.style',
                token: 'radiobutton.focus.ring.style',
                variable: '--p-radiobutton-focus-ring-style',
                description: 'Focus ring style of root'
            },
            {
                name: 'radiobutton.root.focusRing.color',
                token: 'radiobutton.focus.ring.color',
                variable: '--p-radiobutton-focus-ring-color',
                description: 'Focus ring color of root'
            },
            {
                name: 'radiobutton.root.focusRing.offset',
                token: 'radiobutton.focus.ring.offset',
                variable: '--p-radiobutton-focus-ring-offset',
                description: 'Focus ring offset of root'
            },
            {
                name: 'radiobutton.root.focusRing.shadow',
                token: 'radiobutton.focus.ring.shadow',
                variable: '--p-radiobutton-focus-ring-shadow',
                description: 'Focus ring shadow of root'
            },
            {
                name: 'radiobutton.root.transitionDuration',
                token: 'radiobutton.transition.duration',
                variable: '--p-radiobutton-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'radiobutton.root.sm.width',
                token: 'radiobutton.sm.width',
                variable: '--p-radiobutton-sm-width',
                description: 'Sm width of root'
            },
            {
                name: 'radiobutton.root.sm.height',
                token: 'radiobutton.sm.height',
                variable: '--p-radiobutton-sm-height',
                description: 'Sm height of root'
            },
            {
                name: 'radiobutton.root.lg.width',
                token: 'radiobutton.lg.width',
                variable: '--p-radiobutton-lg-width',
                description: 'Lg width of root'
            },
            {
                name: 'radiobutton.root.lg.height',
                token: 'radiobutton.lg.height',
                variable: '--p-radiobutton-lg-height',
                description: 'Lg height of root'
            },
            {
                name: 'radiobutton.icon.size',
                token: 'radiobutton.icon.size',
                variable: '--p-radiobutton-icon-size',
                description: 'Size of icon'
            },
            {
                name: 'radiobutton.icon.checkedColor',
                token: 'radiobutton.icon.checked.color',
                variable: '--p-radiobutton-icon-checked-color',
                description: 'Checked color of icon'
            },
            {
                name: 'radiobutton.icon.checkedHoverColor',
                token: 'radiobutton.icon.checked.hover.color',
                variable: '--p-radiobutton-icon-checked-hover-color',
                description: 'Checked hover color of icon'
            },
            {
                name: 'radiobutton.icon.disabledColor',
                token: 'radiobutton.icon.disabled.color',
                variable: '--p-radiobutton-icon-disabled-color',
                description: 'Disabled color of icon'
            },
            {
                name: 'radiobutton.icon.sm.size',
                token: 'radiobutton.icon.sm.size',
                variable: '--p-radiobutton-icon-sm-size',
                description: 'Sm size of icon'
            },
            {
                name: 'radiobutton.icon.lg.size',
                token: 'radiobutton.icon.lg.size',
                variable: '--p-radiobutton-icon-lg-size',
                description: 'Lg size of icon'
            }
        ]
    },
    rating: {
        description: 'Rating Design Tokens',
        tokens: [
            {
                name: 'rating.root.gap',
                token: 'rating.gap',
                variable: '--p-rating-gap',
                description: 'Gap of root'
            },
            {
                name: 'rating.root.transitionDuration',
                token: 'rating.transition.duration',
                variable: '--p-rating-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'rating.root.focusRing.width',
                token: 'rating.focus.ring.width',
                variable: '--p-rating-focus-ring-width',
                description: 'Focus ring width of root'
            },
            {
                name: 'rating.root.focusRing.style',
                token: 'rating.focus.ring.style',
                variable: '--p-rating-focus-ring-style',
                description: 'Focus ring style of root'
            },
            {
                name: 'rating.root.focusRing.color',
                token: 'rating.focus.ring.color',
                variable: '--p-rating-focus-ring-color',
                description: 'Focus ring color of root'
            },
            {
                name: 'rating.root.focusRing.offset',
                token: 'rating.focus.ring.offset',
                variable: '--p-rating-focus-ring-offset',
                description: 'Focus ring offset of root'
            },
            {
                name: 'rating.root.focusRing.shadow',
                token: 'rating.focus.ring.shadow',
                variable: '--p-rating-focus-ring-shadow',
                description: 'Focus ring shadow of root'
            },
            {
                name: 'rating.icon.size',
                token: 'rating.icon.size',
                variable: '--p-rating-icon-size',
                description: 'Size of icon'
            },
            {
                name: 'rating.icon.color',
                token: 'rating.icon.color',
                variable: '--p-rating-icon-color',
                description: 'Color of icon'
            },
            {
                name: 'rating.icon.hoverColor',
                token: 'rating.icon.hover.color',
                variable: '--p-rating-icon-hover-color',
                description: 'Hover color of icon'
            },
            {
                name: 'rating.icon.activeColor',
                token: 'rating.icon.active.color',
                variable: '--p-rating-icon-active-color',
                description: 'Active color of icon'
            }
        ]
    },
    ripple: {
        description: 'Ripple Design Tokens',
        tokens: [
            {
                name: 'ripple.root.background',
                token: 'ripple.background',
                variable: '--p-ripple-background',
                description: 'Background of root'
            }
        ]
    },
    scrollpanel: {
        description: 'ScrollPanel Design Tokens',
        tokens: [
            {
                name: 'scrollpanel.root.transitionDuration',
                token: 'scrollpanel.transition.duration',
                variable: '--p-scrollpanel-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'scrollpanel.bar.size',
                token: 'scrollpanel.bar.size',
                variable: '--p-scrollpanel-bar-size',
                description: 'Size of bar'
            },
            {
                name: 'scrollpanel.bar.borderRadius',
                token: 'scrollpanel.bar.border.radius',
                variable: '--p-scrollpanel-bar-border-radius',
                description: 'Border radius of bar'
            },
            {
                name: 'scrollpanel.bar.focusRing.width',
                token: 'scrollpanel.bar.focus.ring.width',
                variable: '--p-scrollpanel-bar-focus-ring-width',
                description: 'Focus ring width of bar'
            },
            {
                name: 'scrollpanel.bar.focusRing.style',
                token: 'scrollpanel.bar.focus.ring.style',
                variable: '--p-scrollpanel-bar-focus-ring-style',
                description: 'Focus ring style of bar'
            },
            {
                name: 'scrollpanel.bar.focusRing.color',
                token: 'scrollpanel.bar.focus.ring.color',
                variable: '--p-scrollpanel-bar-focus-ring-color',
                description: 'Focus ring color of bar'
            },
            {
                name: 'scrollpanel.bar.focusRing.offset',
                token: 'scrollpanel.bar.focus.ring.offset',
                variable: '--p-scrollpanel-bar-focus-ring-offset',
                description: 'Focus ring offset of bar'
            },
            {
                name: 'scrollpanel.bar.focusRing.shadow',
                token: 'scrollpanel.bar.focus.ring.shadow',
                variable: '--p-scrollpanel-bar-focus-ring-shadow',
                description: 'Focus ring shadow of bar'
            },
            {
                name: 'scrollpanel.bar.background',
                token: 'scrollpanel.bar.background',
                variable: '--p-scrollpanel-bar-background',
                description: 'Background of bar'
            }
        ]
    },
    select: {
        description: 'Select Design Tokens',
        tokens: [
            {
                name: 'select.root.background',
                token: 'select.background',
                variable: '--p-select-background',
                description: 'Background of root'
            },
            {
                name: 'select.root.disabledBackground',
                token: 'select.disabled.background',
                variable: '--p-select-disabled-background',
                description: 'Disabled background of root'
            },
            {
                name: 'select.root.filledBackground',
                token: 'select.filled.background',
                variable: '--p-select-filled-background',
                description: 'Filled background of root'
            },
            {
                name: 'select.root.filledHoverBackground',
                token: 'select.filled.hover.background',
                variable: '--p-select-filled-hover-background',
                description: 'Filled hover background of root'
            },
            {
                name: 'select.root.filledFocusBackground',
                token: 'select.filled.focus.background',
                variable: '--p-select-filled-focus-background',
                description: 'Filled focus background of root'
            },
            {
                name: 'select.root.borderColor',
                token: 'select.border.color',
                variable: '--p-select-border-color',
                description: 'Border color of root'
            },
            {
                name: 'select.root.hoverBorderColor',
                token: 'select.hover.border.color',
                variable: '--p-select-hover-border-color',
                description: 'Hover border color of root'
            },
            {
                name: 'select.root.focusBorderColor',
                token: 'select.focus.border.color',
                variable: '--p-select-focus-border-color',
                description: 'Focus border color of root'
            },
            {
                name: 'select.root.invalidBorderColor',
                token: 'select.invalid.border.color',
                variable: '--p-select-invalid-border-color',
                description: 'Invalid border color of root'
            },
            {
                name: 'select.root.color',
                token: 'select.color',
                variable: '--p-select-color',
                description: 'Color of root'
            },
            {
                name: 'select.root.disabledColor',
                token: 'select.disabled.color',
                variable: '--p-select-disabled-color',
                description: 'Disabled color of root'
            },
            {
                name: 'select.root.placeholderColor',
                token: 'select.placeholder.color',
                variable: '--p-select-placeholder-color',
                description: 'Placeholder color of root'
            },
            {
                name: 'select.root.invalidPlaceholderColor',
                token: 'select.invalid.placeholder.color',
                variable: '--p-select-invalid-placeholder-color',
                description: 'Invalid placeholder color of root'
            },
            {
                name: 'select.root.shadow',
                token: 'select.shadow',
                variable: '--p-select-shadow',
                description: 'Shadow of root'
            },
            {
                name: 'select.root.paddingX',
                token: 'select.padding.x',
                variable: '--p-select-padding-x',
                description: 'Padding x of root'
            },
            {
                name: 'select.root.paddingY',
                token: 'select.padding.y',
                variable: '--p-select-padding-y',
                description: 'Padding y of root'
            },
            {
                name: 'select.root.borderRadius',
                token: 'select.border.radius',
                variable: '--p-select-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'select.root.focusRing.width',
                token: 'select.focus.ring.width',
                variable: '--p-select-focus-ring-width',
                description: 'Focus ring width of root'
            },
            {
                name: 'select.root.focusRing.style',
                token: 'select.focus.ring.style',
                variable: '--p-select-focus-ring-style',
                description: 'Focus ring style of root'
            },
            {
                name: 'select.root.focusRing.color',
                token: 'select.focus.ring.color',
                variable: '--p-select-focus-ring-color',
                description: 'Focus ring color of root'
            },
            {
                name: 'select.root.focusRing.offset',
                token: 'select.focus.ring.offset',
                variable: '--p-select-focus-ring-offset',
                description: 'Focus ring offset of root'
            },
            {
                name: 'select.root.focusRing.shadow',
                token: 'select.focus.ring.shadow',
                variable: '--p-select-focus-ring-shadow',
                description: 'Focus ring shadow of root'
            },
            {
                name: 'select.root.transitionDuration',
                token: 'select.transition.duration',
                variable: '--p-select-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'select.root.sm.fontSize',
                token: 'select.sm.font.size',
                variable: '--p-select-sm-font-size',
                description: 'Sm font size of root'
            },
            {
                name: 'select.root.sm.paddingX',
                token: 'select.sm.padding.x',
                variable: '--p-select-sm-padding-x',
                description: 'Sm padding x of root'
            },
            {
                name: 'select.root.sm.paddingY',
                token: 'select.sm.padding.y',
                variable: '--p-select-sm-padding-y',
                description: 'Sm padding y of root'
            },
            {
                name: 'select.root.lg.fontSize',
                token: 'select.lg.font.size',
                variable: '--p-select-lg-font-size',
                description: 'Lg font size of root'
            },
            {
                name: 'select.root.lg.paddingX',
                token: 'select.lg.padding.x',
                variable: '--p-select-lg-padding-x',
                description: 'Lg padding x of root'
            },
            {
                name: 'select.root.lg.paddingY',
                token: 'select.lg.padding.y',
                variable: '--p-select-lg-padding-y',
                description: 'Lg padding y of root'
            },
            {
                name: 'select.dropdown.width',
                token: 'select.dropdown.width',
                variable: '--p-select-dropdown-width',
                description: 'Width of dropdown'
            },
            {
                name: 'select.dropdown.color',
                token: 'select.dropdown.color',
                variable: '--p-select-dropdown-color',
                description: 'Color of dropdown'
            },
            {
                name: 'select.overlay.background',
                token: 'select.overlay.background',
                variable: '--p-select-overlay-background',
                description: 'Background of overlay'
            },
            {
                name: 'select.overlay.borderColor',
                token: 'select.overlay.border.color',
                variable: '--p-select-overlay-border-color',
                description: 'Border color of overlay'
            },
            {
                name: 'select.overlay.borderRadius',
                token: 'select.overlay.border.radius',
                variable: '--p-select-overlay-border-radius',
                description: 'Border radius of overlay'
            },
            {
                name: 'select.overlay.color',
                token: 'select.overlay.color',
                variable: '--p-select-overlay-color',
                description: 'Color of overlay'
            },
            {
                name: 'select.overlay.shadow',
                token: 'select.overlay.shadow',
                variable: '--p-select-overlay-shadow',
                description: 'Shadow of overlay'
            },
            {
                name: 'select.list.padding',
                token: 'select.list.padding',
                variable: '--p-select-list-padding',
                description: 'Padding of list'
            },
            {
                name: 'select.list.gap',
                token: 'select.list.gap',
                variable: '--p-select-list-gap',
                description: 'Gap of list'
            },
            {
                name: 'select.list.header.padding',
                token: 'select.list.header.padding',
                variable: '--p-select-list-header-padding',
                description: 'Header padding of list'
            },
            {
                name: 'select.option.focusBackground',
                token: 'select.option.focus.background',
                variable: '--p-select-option-focus-background',
                description: 'Focus background of option'
            },
            {
                name: 'select.option.selectedBackground',
                token: 'select.option.selected.background',
                variable: '--p-select-option-selected-background',
                description: 'Selected background of option'
            },
            {
                name: 'select.option.selectedFocusBackground',
                token: 'select.option.selected.focus.background',
                variable: '--p-select-option-selected-focus-background',
                description: 'Selected focus background of option'
            },
            {
                name: 'select.option.color',
                token: 'select.option.color',
                variable: '--p-select-option-color',
                description: 'Color of option'
            },
            {
                name: 'select.option.focusColor',
                token: 'select.option.focus.color',
                variable: '--p-select-option-focus-color',
                description: 'Focus color of option'
            },
            {
                name: 'select.option.selectedColor',
                token: 'select.option.selected.color',
                variable: '--p-select-option-selected-color',
                description: 'Selected color of option'
            },
            {
                name: 'select.option.selectedFocusColor',
                token: 'select.option.selected.focus.color',
                variable: '--p-select-option-selected-focus-color',
                description: 'Selected focus color of option'
            },
            {
                name: 'select.option.padding',
                token: 'select.option.padding',
                variable: '--p-select-option-padding',
                description: 'Padding of option'
            },
            {
                name: 'select.option.borderRadius',
                token: 'select.option.border.radius',
                variable: '--p-select-option-border-radius',
                description: 'Border radius of option'
            },
            {
                name: 'select.optionGroup.background',
                token: 'select.option.group.background',
                variable: '--p-select-option-group-background',
                description: 'Background of option group'
            },
            {
                name: 'select.optionGroup.color',
                token: 'select.option.group.color',
                variable: '--p-select-option-group-color',
                description: 'Color of option group'
            },
            {
                name: 'select.optionGroup.fontWeight',
                token: 'select.option.group.font.weight',
                variable: '--p-select-option-group-font-weight',
                description: 'Font weight of option group'
            },
            {
                name: 'select.optionGroup.padding',
                token: 'select.option.group.padding',
                variable: '--p-select-option-group-padding',
                description: 'Padding of option group'
            },
            {
                name: 'select.clearIcon.color',
                token: 'select.clear.icon.color',
                variable: '--p-select-clear-icon-color',
                description: 'Color of clear icon'
            },
            {
                name: 'select.checkmark.color',
                token: 'select.checkmark.color',
                variable: '--p-select-checkmark-color',
                description: 'Color of checkmark'
            },
            {
                name: 'select.checkmark.gutterStart',
                token: 'select.checkmark.gutter.start',
                variable: '--p-select-checkmark-gutter-start',
                description: 'Gutter start of checkmark'
            },
            {
                name: 'select.checkmark.gutterEnd',
                token: 'select.checkmark.gutter.end',
                variable: '--p-select-checkmark-gutter-end',
                description: 'Gutter end of checkmark'
            },
            {
                name: 'select.emptyMessage.padding',
                token: 'select.empty.message.padding',
                variable: '--p-select-empty-message-padding',
                description: 'Padding of empty message'
            }
        ]
    },
    selectbutton: {
        description: 'SelectButton Design Tokens',
        tokens: [
            {
                name: 'selectbutton.root.borderRadius',
                token: 'selectbutton.border.radius',
                variable: '--p-selectbutton-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'selectbutton.root.invalidBorderColor',
                token: 'selectbutton.invalid.border.color',
                variable: '--p-selectbutton-invalid-border-color',
                description: 'Invalid border color of root'
            }
        ]
    },
    skeleton: {
        description: 'Skeleton Design Tokens',
        tokens: [
            {
                name: 'skeleton.root.borderRadius',
                token: 'skeleton.border.radius',
                variable: '--p-skeleton-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'skeleton.root.background',
                token: 'skeleton.background',
                variable: '--p-skeleton-background',
                description: 'Background of root'
            },
            {
                name: 'skeleton.root.animationBackground',
                token: 'skeleton.animation.background',
                variable: '--p-skeleton-animation-background',
                description: 'Animation background of root'
            }
        ]
    },
    slider: {
        description: 'Slider Design Tokens',
        tokens: [
            {
                name: 'slider.root.transitionDuration',
                token: 'slider.transition.duration',
                variable: '--p-slider-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'slider.track.background',
                token: 'slider.track.background',
                variable: '--p-slider-track-background',
                description: 'Background of track'
            },
            {
                name: 'slider.track.borderRadius',
                token: 'slider.track.border.radius',
                variable: '--p-slider-track-border-radius',
                description: 'Border radius of track'
            },
            {
                name: 'slider.track.size',
                token: 'slider.track.size',
                variable: '--p-slider-track-size',
                description: 'Size of track'
            },
            {
                name: 'slider.range.background',
                token: 'slider.range.background',
                variable: '--p-slider-range-background',
                description: 'Background of range'
            },
            {
                name: 'slider.handle.width',
                token: 'slider.handle.width',
                variable: '--p-slider-handle-width',
                description: 'Width of handle'
            },
            {
                name: 'slider.handle.height',
                token: 'slider.handle.height',
                variable: '--p-slider-handle-height',
                description: 'Height of handle'
            },
            {
                name: 'slider.handle.borderRadius',
                token: 'slider.handle.border.radius',
                variable: '--p-slider-handle-border-radius',
                description: 'Border radius of handle'
            },
            {
                name: 'slider.handle.background',
                token: 'slider.handle.background',
                variable: '--p-slider-handle-background',
                description: 'Background of handle'
            },
            {
                name: 'slider.handle.hoverBackground',
                token: 'slider.handle.hover.background',
                variable: '--p-slider-handle-hover-background',
                description: 'Hover background of handle'
            },
            {
                name: 'slider.handle.content.borderRadius',
                token: 'slider.handle.content.border.radius',
                variable: '--p-slider-handle-content-border-radius',
                description: 'Content border radius of handle'
            },
            {
                name: 'slider.handle.content.background',
                token: 'slider.handle.content.background',
                variable: '--p-slider-handle-content-background',
                description: 'Background of handle'
            },
            {
                name: 'slider.handle.content.hoverBackground',
                token: 'slider.handle.content.hover.background',
                variable: '--p-slider-handle-content-hover-background',
                description: 'Content hover background of handle'
            },
            {
                name: 'slider.handle.content.width',
                token: 'slider.handle.content.width',
                variable: '--p-slider-handle-content-width',
                description: 'Content width of handle'
            },
            {
                name: 'slider.handle.content.height',
                token: 'slider.handle.content.height',
                variable: '--p-slider-handle-content-height',
                description: 'Content height of handle'
            },
            {
                name: 'slider.handle.content.shadow',
                token: 'slider.handle.content.shadow',
                variable: '--p-slider-handle-content-shadow',
                description: 'Content shadow of handle'
            },
            {
                name: 'slider.handle.focusRing.width',
                token: 'slider.handle.focus.ring.width',
                variable: '--p-slider-handle-focus-ring-width',
                description: 'Focus ring width of handle'
            },
            {
                name: 'slider.handle.focusRing.style',
                token: 'slider.handle.focus.ring.style',
                variable: '--p-slider-handle-focus-ring-style',
                description: 'Focus ring style of handle'
            },
            {
                name: 'slider.handle.focusRing.color',
                token: 'slider.handle.focus.ring.color',
                variable: '--p-slider-handle-focus-ring-color',
                description: 'Focus ring color of handle'
            },
            {
                name: 'slider.handle.focusRing.offset',
                token: 'slider.handle.focus.ring.offset',
                variable: '--p-slider-handle-focus-ring-offset',
                description: 'Focus ring offset of handle'
            },
            {
                name: 'slider.handle.focusRing.shadow',
                token: 'slider.handle.focus.ring.shadow',
                variable: '--p-slider-handle-focus-ring-shadow',
                description: 'Focus ring shadow of handle'
            }
        ]
    },
    speeddial: {
        description: 'SpeedDial Design Tokens',
        tokens: [
            {
                name: 'speeddial.root.gap',
                token: 'speeddial.gap',
                variable: '--p-speeddial-gap',
                description: 'Gap of root'
            },
            {
                name: 'speeddial.root.transitionDuration',
                token: 'speeddial.transition.duration',
                variable: '--p-speeddial-transition-duration',
                description: 'Transition duration of root'
            }
        ]
    },
    splitbutton: {
        description: 'SplitButton Design Tokens',
        tokens: [
            {
                name: 'splitbutton.root.borderRadius',
                token: 'splitbutton.border.radius',
                variable: '--p-splitbutton-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'splitbutton.root.roundedBorderRadius',
                token: 'splitbutton.rounded.border.radius',
                variable: '--p-splitbutton-rounded-border-radius',
                description: 'Rounded border radius of root'
            },
            {
                name: 'splitbutton.root.raisedShadow',
                token: 'splitbutton.raised.shadow',
                variable: '--p-splitbutton-raised-shadow',
                description: 'Raised shadow of root'
            }
        ]
    },
    splitter: {
        description: 'Splitter Design Tokens',
        tokens: [
            {
                name: 'splitter.root.background',
                token: 'splitter.background',
                variable: '--p-splitter-background',
                description: 'Background of root'
            },
            {
                name: 'splitter.root.borderColor',
                token: 'splitter.border.color',
                variable: '--p-splitter-border-color',
                description: 'Border color of root'
            },
            {
                name: 'splitter.root.color',
                token: 'splitter.color',
                variable: '--p-splitter-color',
                description: 'Color of root'
            },
            {
                name: 'splitter.root.transitionDuration',
                token: 'splitter.transition.duration',
                variable: '--p-splitter-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'splitter.gutter.background',
                token: 'splitter.gutter.background',
                variable: '--p-splitter-gutter-background',
                description: 'Background of gutter'
            },
            {
                name: 'splitter.handle.size',
                token: 'splitter.handle.size',
                variable: '--p-splitter-handle-size',
                description: 'Size of handle'
            },
            {
                name: 'splitter.handle.background',
                token: 'splitter.handle.background',
                variable: '--p-splitter-handle-background',
                description: 'Background of handle'
            },
            {
                name: 'splitter.handle.borderRadius',
                token: 'splitter.handle.border.radius',
                variable: '--p-splitter-handle-border-radius',
                description: 'Border radius of handle'
            },
            {
                name: 'splitter.handle.focusRing.width',
                token: 'splitter.handle.focus.ring.width',
                variable: '--p-splitter-handle-focus-ring-width',
                description: 'Focus ring width of handle'
            },
            {
                name: 'splitter.handle.focusRing.style',
                token: 'splitter.handle.focus.ring.style',
                variable: '--p-splitter-handle-focus-ring-style',
                description: 'Focus ring style of handle'
            },
            {
                name: 'splitter.handle.focusRing.color',
                token: 'splitter.handle.focus.ring.color',
                variable: '--p-splitter-handle-focus-ring-color',
                description: 'Focus ring color of handle'
            },
            {
                name: 'splitter.handle.focusRing.offset',
                token: 'splitter.handle.focus.ring.offset',
                variable: '--p-splitter-handle-focus-ring-offset',
                description: 'Focus ring offset of handle'
            },
            {
                name: 'splitter.handle.focusRing.shadow',
                token: 'splitter.handle.focus.ring.shadow',
                variable: '--p-splitter-handle-focus-ring-shadow',
                description: 'Focus ring shadow of handle'
            }
        ]
    },
    stepper: {
        description: 'Stepper Design Tokens',
        tokens: [
            {
                name: 'stepper.root.transitionDuration',
                token: 'stepper.transition.duration',
                variable: '--p-stepper-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'stepper.separator.background',
                token: 'stepper.separator.background',
                variable: '--p-stepper-separator-background',
                description: 'Background of separator'
            },
            {
                name: 'stepper.separator.activeBackground',
                token: 'stepper.separator.active.background',
                variable: '--p-stepper-separator-active-background',
                description: 'Active background of separator'
            },
            {
                name: 'stepper.separator.margin',
                token: 'stepper.separator.margin',
                variable: '--p-stepper-separator-margin',
                description: 'Margin of separator'
            },
            {
                name: 'stepper.separator.size',
                token: 'stepper.separator.size',
                variable: '--p-stepper-separator-size',
                description: 'Size of separator'
            },
            {
                name: 'stepper.step.padding',
                token: 'stepper.step.padding',
                variable: '--p-stepper-step-padding',
                description: 'Padding of step'
            },
            {
                name: 'stepper.step.gap',
                token: 'stepper.step.gap',
                variable: '--p-stepper-step-gap',
                description: 'Gap of step'
            },
            {
                name: 'stepper.stepHeader.padding',
                token: 'stepper.step.header.padding',
                variable: '--p-stepper-step-header-padding',
                description: 'Padding of step header'
            },
            {
                name: 'stepper.stepHeader.borderRadius',
                token: 'stepper.step.header.border.radius',
                variable: '--p-stepper-step-header-border-radius',
                description: 'Border radius of step header'
            },
            {
                name: 'stepper.stepHeader.focusRing.width',
                token: 'stepper.step.header.focus.ring.width',
                variable: '--p-stepper-step-header-focus-ring-width',
                description: 'Focus ring width of step header'
            },
            {
                name: 'stepper.stepHeader.focusRing.style',
                token: 'stepper.step.header.focus.ring.style',
                variable: '--p-stepper-step-header-focus-ring-style',
                description: 'Focus ring style of step header'
            },
            {
                name: 'stepper.stepHeader.focusRing.color',
                token: 'stepper.step.header.focus.ring.color',
                variable: '--p-stepper-step-header-focus-ring-color',
                description: 'Focus ring color of step header'
            },
            {
                name: 'stepper.stepHeader.focusRing.offset',
                token: 'stepper.step.header.focus.ring.offset',
                variable: '--p-stepper-step-header-focus-ring-offset',
                description: 'Focus ring offset of step header'
            },
            {
                name: 'stepper.stepHeader.focusRing.shadow',
                token: 'stepper.step.header.focus.ring.shadow',
                variable: '--p-stepper-step-header-focus-ring-shadow',
                description: 'Focus ring shadow of step header'
            },
            {
                name: 'stepper.stepHeader.gap',
                token: 'stepper.step.header.gap',
                variable: '--p-stepper-step-header-gap',
                description: 'Gap of step header'
            },
            {
                name: 'stepper.stepTitle.color',
                token: 'stepper.step.title.color',
                variable: '--p-stepper-step-title-color',
                description: 'Color of step title'
            },
            {
                name: 'stepper.stepTitle.activeColor',
                token: 'stepper.step.title.active.color',
                variable: '--p-stepper-step-title-active-color',
                description: 'Active color of step title'
            },
            {
                name: 'stepper.stepTitle.fontWeight',
                token: 'stepper.step.title.font.weight',
                variable: '--p-stepper-step-title-font-weight',
                description: 'Font weight of step title'
            },
            {
                name: 'stepper.stepNumber.background',
                token: 'stepper.step.number.background',
                variable: '--p-stepper-step-number-background',
                description: 'Background of step number'
            },
            {
                name: 'stepper.stepNumber.activeBackground',
                token: 'stepper.step.number.active.background',
                variable: '--p-stepper-step-number-active-background',
                description: 'Active background of step number'
            },
            {
                name: 'stepper.stepNumber.borderColor',
                token: 'stepper.step.number.border.color',
                variable: '--p-stepper-step-number-border-color',
                description: 'Border color of step number'
            },
            {
                name: 'stepper.stepNumber.activeBorderColor',
                token: 'stepper.step.number.active.border.color',
                variable: '--p-stepper-step-number-active-border-color',
                description: 'Active border color of step number'
            },
            {
                name: 'stepper.stepNumber.color',
                token: 'stepper.step.number.color',
                variable: '--p-stepper-step-number-color',
                description: 'Color of step number'
            },
            {
                name: 'stepper.stepNumber.activeColor',
                token: 'stepper.step.number.active.color',
                variable: '--p-stepper-step-number-active-color',
                description: 'Active color of step number'
            },
            {
                name: 'stepper.stepNumber.size',
                token: 'stepper.step.number.size',
                variable: '--p-stepper-step-number-size',
                description: 'Size of step number'
            },
            {
                name: 'stepper.stepNumber.fontSize',
                token: 'stepper.step.number.font.size',
                variable: '--p-stepper-step-number-font-size',
                description: 'Font size of step number'
            },
            {
                name: 'stepper.stepNumber.fontWeight',
                token: 'stepper.step.number.font.weight',
                variable: '--p-stepper-step-number-font-weight',
                description: 'Font weight of step number'
            },
            {
                name: 'stepper.stepNumber.borderRadius',
                token: 'stepper.step.number.border.radius',
                variable: '--p-stepper-step-number-border-radius',
                description: 'Border radius of step number'
            },
            {
                name: 'stepper.stepNumber.shadow',
                token: 'stepper.step.number.shadow',
                variable: '--p-stepper-step-number-shadow',
                description: 'Shadow of step number'
            },
            {
                name: 'stepper.steppanels.padding',
                token: 'stepper.steppanels.padding',
                variable: '--p-stepper-steppanels-padding',
                description: 'Padding of steppanels'
            },
            {
                name: 'stepper.steppanel.background',
                token: 'stepper.steppanel.background',
                variable: '--p-stepper-steppanel-background',
                description: 'Background of steppanel'
            },
            {
                name: 'stepper.steppanel.color',
                token: 'stepper.steppanel.color',
                variable: '--p-stepper-steppanel-color',
                description: 'Color of steppanel'
            },
            {
                name: 'stepper.steppanel.padding',
                token: 'stepper.steppanel.padding',
                variable: '--p-stepper-steppanel-padding',
                description: 'Padding of steppanel'
            },
            {
                name: 'stepper.steppanel.indent',
                token: 'stepper.steppanel.indent',
                variable: '--p-stepper-steppanel-indent',
                description: 'Indent of steppanel'
            }
        ]
    },
    steps: {
        description: 'Steps Design Tokens',
        tokens: [
            {
                name: 'steps.root.transitionDuration',
                token: 'steps.transition.duration',
                variable: '--p-steps-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'steps.separator.background',
                token: 'steps.separator.background',
                variable: '--p-steps-separator-background',
                description: 'Background of separator'
            },
            {
                name: 'steps.itemLink.borderRadius',
                token: 'steps.item.link.border.radius',
                variable: '--p-steps-item-link-border-radius',
                description: 'Border radius of item link'
            },
            {
                name: 'steps.itemLink.focusRing.width',
                token: 'steps.item.link.focus.ring.width',
                variable: '--p-steps-item-link-focus-ring-width',
                description: 'Focus ring width of item link'
            },
            {
                name: 'steps.itemLink.focusRing.style',
                token: 'steps.item.link.focus.ring.style',
                variable: '--p-steps-item-link-focus-ring-style',
                description: 'Focus ring style of item link'
            },
            {
                name: 'steps.itemLink.focusRing.color',
                token: 'steps.item.link.focus.ring.color',
                variable: '--p-steps-item-link-focus-ring-color',
                description: 'Focus ring color of item link'
            },
            {
                name: 'steps.itemLink.focusRing.offset',
                token: 'steps.item.link.focus.ring.offset',
                variable: '--p-steps-item-link-focus-ring-offset',
                description: 'Focus ring offset of item link'
            },
            {
                name: 'steps.itemLink.focusRing.shadow',
                token: 'steps.item.link.focus.ring.shadow',
                variable: '--p-steps-item-link-focus-ring-shadow',
                description: 'Focus ring shadow of item link'
            },
            {
                name: 'steps.itemLink.gap',
                token: 'steps.item.link.gap',
                variable: '--p-steps-item-link-gap',
                description: 'Gap of item link'
            },
            {
                name: 'steps.itemLabel.color',
                token: 'steps.item.label.color',
                variable: '--p-steps-item-label-color',
                description: 'Color of item label'
            },
            {
                name: 'steps.itemLabel.activeColor',
                token: 'steps.item.label.active.color',
                variable: '--p-steps-item-label-active-color',
                description: 'Active color of item label'
            },
            {
                name: 'steps.itemLabel.fontWeight',
                token: 'steps.item.label.font.weight',
                variable: '--p-steps-item-label-font-weight',
                description: 'Font weight of item label'
            },
            {
                name: 'steps.itemNumber.background',
                token: 'steps.item.number.background',
                variable: '--p-steps-item-number-background',
                description: 'Background of item number'
            },
            {
                name: 'steps.itemNumber.activeBackground',
                token: 'steps.item.number.active.background',
                variable: '--p-steps-item-number-active-background',
                description: 'Active background of item number'
            },
            {
                name: 'steps.itemNumber.borderColor',
                token: 'steps.item.number.border.color',
                variable: '--p-steps-item-number-border-color',
                description: 'Border color of item number'
            },
            {
                name: 'steps.itemNumber.activeBorderColor',
                token: 'steps.item.number.active.border.color',
                variable: '--p-steps-item-number-active-border-color',
                description: 'Active border color of item number'
            },
            {
                name: 'steps.itemNumber.color',
                token: 'steps.item.number.color',
                variable: '--p-steps-item-number-color',
                description: 'Color of item number'
            },
            {
                name: 'steps.itemNumber.activeColor',
                token: 'steps.item.number.active.color',
                variable: '--p-steps-item-number-active-color',
                description: 'Active color of item number'
            },
            {
                name: 'steps.itemNumber.size',
                token: 'steps.item.number.size',
                variable: '--p-steps-item-number-size',
                description: 'Size of item number'
            },
            {
                name: 'steps.itemNumber.fontSize',
                token: 'steps.item.number.font.size',
                variable: '--p-steps-item-number-font-size',
                description: 'Font size of item number'
            },
            {
                name: 'steps.itemNumber.fontWeight',
                token: 'steps.item.number.font.weight',
                variable: '--p-steps-item-number-font-weight',
                description: 'Font weight of item number'
            },
            {
                name: 'steps.itemNumber.borderRadius',
                token: 'steps.item.number.border.radius',
                variable: '--p-steps-item-number-border-radius',
                description: 'Border radius of item number'
            },
            {
                name: 'steps.itemNumber.shadow',
                token: 'steps.item.number.shadow',
                variable: '--p-steps-item-number-shadow',
                description: 'Shadow of item number'
            }
        ]
    },
    tabmenu: {
        description: 'Tabmenu Design Tokens',
        tokens: [
            {
                name: 'tabmenu.root.transitionDuration',
                token: 'tabmenu.transition.duration',
                variable: '--p-tabmenu-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'tabmenu.tablist.borderWidth',
                token: 'tabmenu.tablist.border.width',
                variable: '--p-tabmenu-tablist-border-width',
                description: 'Border width of tablist'
            },
            {
                name: 'tabmenu.tablist.background',
                token: 'tabmenu.tablist.background',
                variable: '--p-tabmenu-tablist-background',
                description: 'Background of tablist'
            },
            {
                name: 'tabmenu.tablist.borderColor',
                token: 'tabmenu.tablist.border.color',
                variable: '--p-tabmenu-tablist-border-color',
                description: 'Border color of tablist'
            },
            {
                name: 'tabmenu.item.background',
                token: 'tabmenu.item.background',
                variable: '--p-tabmenu-item-background',
                description: 'Background of item'
            },
            {
                name: 'tabmenu.item.hoverBackground',
                token: 'tabmenu.item.hover.background',
                variable: '--p-tabmenu-item-hover-background',
                description: 'Hover background of item'
            },
            {
                name: 'tabmenu.item.activeBackground',
                token: 'tabmenu.item.active.background',
                variable: '--p-tabmenu-item-active-background',
                description: 'Active background of item'
            },
            {
                name: 'tabmenu.item.borderWidth',
                token: 'tabmenu.item.border.width',
                variable: '--p-tabmenu-item-border-width',
                description: 'Border width of item'
            },
            {
                name: 'tabmenu.item.borderColor',
                token: 'tabmenu.item.border.color',
                variable: '--p-tabmenu-item-border-color',
                description: 'Border color of item'
            },
            {
                name: 'tabmenu.item.hoverBorderColor',
                token: 'tabmenu.item.hover.border.color',
                variable: '--p-tabmenu-item-hover-border-color',
                description: 'Hover border color of item'
            },
            {
                name: 'tabmenu.item.activeBorderColor',
                token: 'tabmenu.item.active.border.color',
                variable: '--p-tabmenu-item-active-border-color',
                description: 'Active border color of item'
            },
            {
                name: 'tabmenu.item.color',
                token: 'tabmenu.item.color',
                variable: '--p-tabmenu-item-color',
                description: 'Color of item'
            },
            {
                name: 'tabmenu.item.hoverColor',
                token: 'tabmenu.item.hover.color',
                variable: '--p-tabmenu-item-hover-color',
                description: 'Hover color of item'
            },
            {
                name: 'tabmenu.item.activeColor',
                token: 'tabmenu.item.active.color',
                variable: '--p-tabmenu-item-active-color',
                description: 'Active color of item'
            },
            {
                name: 'tabmenu.item.padding',
                token: 'tabmenu.item.padding',
                variable: '--p-tabmenu-item-padding',
                description: 'Padding of item'
            },
            {
                name: 'tabmenu.item.fontWeight',
                token: 'tabmenu.item.font.weight',
                variable: '--p-tabmenu-item-font-weight',
                description: 'Font weight of item'
            },
            {
                name: 'tabmenu.item.margin',
                token: 'tabmenu.item.margin',
                variable: '--p-tabmenu-item-margin',
                description: 'Margin of item'
            },
            {
                name: 'tabmenu.item.gap',
                token: 'tabmenu.item.gap',
                variable: '--p-tabmenu-item-gap',
                description: 'Gap of item'
            },
            {
                name: 'tabmenu.item.focusRing.width',
                token: 'tabmenu.item.focus.ring.width',
                variable: '--p-tabmenu-item-focus-ring-width',
                description: 'Focus ring width of item'
            },
            {
                name: 'tabmenu.item.focusRing.style',
                token: 'tabmenu.item.focus.ring.style',
                variable: '--p-tabmenu-item-focus-ring-style',
                description: 'Focus ring style of item'
            },
            {
                name: 'tabmenu.item.focusRing.color',
                token: 'tabmenu.item.focus.ring.color',
                variable: '--p-tabmenu-item-focus-ring-color',
                description: 'Focus ring color of item'
            },
            {
                name: 'tabmenu.item.focusRing.offset',
                token: 'tabmenu.item.focus.ring.offset',
                variable: '--p-tabmenu-item-focus-ring-offset',
                description: 'Focus ring offset of item'
            },
            {
                name: 'tabmenu.item.focusRing.shadow',
                token: 'tabmenu.item.focus.ring.shadow',
                variable: '--p-tabmenu-item-focus-ring-shadow',
                description: 'Focus ring shadow of item'
            },
            {
                name: 'tabmenu.itemIcon.color',
                token: 'tabmenu.item.icon.color',
                variable: '--p-tabmenu-item-icon-color',
                description: 'Color of item icon'
            },
            {
                name: 'tabmenu.itemIcon.hoverColor',
                token: 'tabmenu.item.icon.hover.color',
                variable: '--p-tabmenu-item-icon-hover-color',
                description: 'Hover color of item icon'
            },
            {
                name: 'tabmenu.itemIcon.activeColor',
                token: 'tabmenu.item.icon.active.color',
                variable: '--p-tabmenu-item-icon-active-color',
                description: 'Active color of item icon'
            },
            {
                name: 'tabmenu.activeBar.height',
                token: 'tabmenu.active.bar.height',
                variable: '--p-tabmenu-active-bar-height',
                description: 'Height of active bar'
            },
            {
                name: 'tabmenu.activeBar.bottom',
                token: 'tabmenu.active.bar.bottom',
                variable: '--p-tabmenu-active-bar-bottom',
                description: 'Bottom of active bar'
            },
            {
                name: 'tabmenu.activeBar.background',
                token: 'tabmenu.active.bar.background',
                variable: '--p-tabmenu-active-bar-background',
                description: 'Background of active bar'
            }
        ]
    },
    tabs: {
        description: 'Tabs Design Tokens',
        tokens: [
            {
                name: 'tabs.root.transitionDuration',
                token: 'tabs.transition.duration',
                variable: '--p-tabs-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'tabs.tablist.borderWidth',
                token: 'tabs.tablist.border.width',
                variable: '--p-tabs-tablist-border-width',
                description: 'Border width of tablist'
            },
            {
                name: 'tabs.tablist.background',
                token: 'tabs.tablist.background',
                variable: '--p-tabs-tablist-background',
                description: 'Background of tablist'
            },
            {
                name: 'tabs.tablist.borderColor',
                token: 'tabs.tablist.border.color',
                variable: '--p-tabs-tablist-border-color',
                description: 'Border color of tablist'
            },
            {
                name: 'tabs.tab.background',
                token: 'tabs.tab.background',
                variable: '--p-tabs-tab-background',
                description: 'Background of tab'
            },
            {
                name: 'tabs.tab.hoverBackground',
                token: 'tabs.tab.hover.background',
                variable: '--p-tabs-tab-hover-background',
                description: 'Hover background of tab'
            },
            {
                name: 'tabs.tab.activeBackground',
                token: 'tabs.tab.active.background',
                variable: '--p-tabs-tab-active-background',
                description: 'Active background of tab'
            },
            {
                name: 'tabs.tab.borderWidth',
                token: 'tabs.tab.border.width',
                variable: '--p-tabs-tab-border-width',
                description: 'Border width of tab'
            },
            {
                name: 'tabs.tab.borderColor',
                token: 'tabs.tab.border.color',
                variable: '--p-tabs-tab-border-color',
                description: 'Border color of tab'
            },
            {
                name: 'tabs.tab.hoverBorderColor',
                token: 'tabs.tab.hover.border.color',
                variable: '--p-tabs-tab-hover-border-color',
                description: 'Hover border color of tab'
            },
            {
                name: 'tabs.tab.activeBorderColor',
                token: 'tabs.tab.active.border.color',
                variable: '--p-tabs-tab-active-border-color',
                description: 'Active border color of tab'
            },
            {
                name: 'tabs.tab.color',
                token: 'tabs.tab.color',
                variable: '--p-tabs-tab-color',
                description: 'Color of tab'
            },
            {
                name: 'tabs.tab.hoverColor',
                token: 'tabs.tab.hover.color',
                variable: '--p-tabs-tab-hover-color',
                description: 'Hover color of tab'
            },
            {
                name: 'tabs.tab.activeColor',
                token: 'tabs.tab.active.color',
                variable: '--p-tabs-tab-active-color',
                description: 'Active color of tab'
            },
            {
                name: 'tabs.tab.padding',
                token: 'tabs.tab.padding',
                variable: '--p-tabs-tab-padding',
                description: 'Padding of tab'
            },
            {
                name: 'tabs.tab.fontWeight',
                token: 'tabs.tab.font.weight',
                variable: '--p-tabs-tab-font-weight',
                description: 'Font weight of tab'
            },
            {
                name: 'tabs.tab.margin',
                token: 'tabs.tab.margin',
                variable: '--p-tabs-tab-margin',
                description: 'Margin of tab'
            },
            {
                name: 'tabs.tab.gap',
                token: 'tabs.tab.gap',
                variable: '--p-tabs-tab-gap',
                description: 'Gap of tab'
            },
            {
                name: 'tabs.tab.focusRing.width',
                token: 'tabs.tab.focus.ring.width',
                variable: '--p-tabs-tab-focus-ring-width',
                description: 'Focus ring width of tab'
            },
            {
                name: 'tabs.tab.focusRing.style',
                token: 'tabs.tab.focus.ring.style',
                variable: '--p-tabs-tab-focus-ring-style',
                description: 'Focus ring style of tab'
            },
            {
                name: 'tabs.tab.focusRing.color',
                token: 'tabs.tab.focus.ring.color',
                variable: '--p-tabs-tab-focus-ring-color',
                description: 'Focus ring color of tab'
            },
            {
                name: 'tabs.tab.focusRing.offset',
                token: 'tabs.tab.focus.ring.offset',
                variable: '--p-tabs-tab-focus-ring-offset',
                description: 'Focus ring offset of tab'
            },
            {
                name: 'tabs.tab.focusRing.shadow',
                token: 'tabs.tab.focus.ring.shadow',
                variable: '--p-tabs-tab-focus-ring-shadow',
                description: 'Focus ring shadow of tab'
            },
            {
                name: 'tabs.tabpanel.background',
                token: 'tabs.tabpanel.background',
                variable: '--p-tabs-tabpanel-background',
                description: 'Background of tabpanel'
            },
            {
                name: 'tabs.tabpanel.color',
                token: 'tabs.tabpanel.color',
                variable: '--p-tabs-tabpanel-color',
                description: 'Color of tabpanel'
            },
            {
                name: 'tabs.tabpanel.padding',
                token: 'tabs.tabpanel.padding',
                variable: '--p-tabs-tabpanel-padding',
                description: 'Padding of tabpanel'
            },
            {
                name: 'tabs.tabpanel.focusRing.width',
                token: 'tabs.tabpanel.focus.ring.width',
                variable: '--p-tabs-tabpanel-focus-ring-width',
                description: 'Focus ring width of tabpanel'
            },
            {
                name: 'tabs.tabpanel.focusRing.style',
                token: 'tabs.tabpanel.focus.ring.style',
                variable: '--p-tabs-tabpanel-focus-ring-style',
                description: 'Focus ring style of tabpanel'
            },
            {
                name: 'tabs.tabpanel.focusRing.color',
                token: 'tabs.tabpanel.focus.ring.color',
                variable: '--p-tabs-tabpanel-focus-ring-color',
                description: 'Focus ring color of tabpanel'
            },
            {
                name: 'tabs.tabpanel.focusRing.offset',
                token: 'tabs.tabpanel.focus.ring.offset',
                variable: '--p-tabs-tabpanel-focus-ring-offset',
                description: 'Focus ring offset of tabpanel'
            },
            {
                name: 'tabs.tabpanel.focusRing.shadow',
                token: 'tabs.tabpanel.focus.ring.shadow',
                variable: '--p-tabs-tabpanel-focus-ring-shadow',
                description: 'Focus ring shadow of tabpanel'
            },
            {
                name: 'tabs.navButton.background',
                token: 'tabs.nav.button.background',
                variable: '--p-tabs-nav-button-background',
                description: 'Background of nav button'
            },
            {
                name: 'tabs.navButton.color',
                token: 'tabs.nav.button.color',
                variable: '--p-tabs-nav-button-color',
                description: 'Color of nav button'
            },
            {
                name: 'tabs.navButton.hoverColor',
                token: 'tabs.nav.button.hover.color',
                variable: '--p-tabs-nav-button-hover-color',
                description: 'Hover color of nav button'
            },
            {
                name: 'tabs.navButton.width',
                token: 'tabs.nav.button.width',
                variable: '--p-tabs-nav-button-width',
                description: 'Width of nav button'
            },
            {
                name: 'tabs.navButton.focusRing.width',
                token: 'tabs.nav.button.focus.ring.width',
                variable: '--p-tabs-nav-button-focus-ring-width',
                description: 'Focus ring width of nav button'
            },
            {
                name: 'tabs.navButton.focusRing.style',
                token: 'tabs.nav.button.focus.ring.style',
                variable: '--p-tabs-nav-button-focus-ring-style',
                description: 'Focus ring style of nav button'
            },
            {
                name: 'tabs.navButton.focusRing.color',
                token: 'tabs.nav.button.focus.ring.color',
                variable: '--p-tabs-nav-button-focus-ring-color',
                description: 'Focus ring color of nav button'
            },
            {
                name: 'tabs.navButton.focusRing.offset',
                token: 'tabs.nav.button.focus.ring.offset',
                variable: '--p-tabs-nav-button-focus-ring-offset',
                description: 'Focus ring offset of nav button'
            },
            {
                name: 'tabs.navButton.focusRing.shadow',
                token: 'tabs.nav.button.focus.ring.shadow',
                variable: '--p-tabs-nav-button-focus-ring-shadow',
                description: 'Focus ring shadow of nav button'
            },
            {
                name: 'tabs.navButton.shadow',
                token: 'tabs.nav.button.shadow',
                variable: '--p-tabs-nav-button-shadow',
                description: 'Shadow of nav button'
            },
            {
                name: 'tabs.activeBar.height',
                token: 'tabs.active.bar.height',
                variable: '--p-tabs-active-bar-height',
                description: 'Height of active bar'
            },
            {
                name: 'tabs.activeBar.bottom',
                token: 'tabs.active.bar.bottom',
                variable: '--p-tabs-active-bar-bottom',
                description: 'Bottom of active bar'
            },
            {
                name: 'tabs.activeBar.background',
                token: 'tabs.active.bar.background',
                variable: '--p-tabs-active-bar-background',
                description: 'Background of active bar'
            }
        ]
    },
    tabview: {
        description: 'TabView Design Tokens',
        tokens: [
            {
                name: 'tabview.root.transitionDuration',
                token: 'tabview.transition.duration',
                variable: '--p-tabview-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'tabview.tabList.background',
                token: 'tabview.tab.list.background',
                variable: '--p-tabview-tab-list-background',
                description: 'Background of tab list'
            },
            {
                name: 'tabview.tabList.borderColor',
                token: 'tabview.tab.list.border.color',
                variable: '--p-tabview-tab-list-border-color',
                description: 'Border color of tab list'
            },
            {
                name: 'tabview.tab.borderColor',
                token: 'tabview.tab.border.color',
                variable: '--p-tabview-tab-border-color',
                description: 'Border color of tab'
            },
            {
                name: 'tabview.tab.activeBorderColor',
                token: 'tabview.tab.active.border.color',
                variable: '--p-tabview-tab-active-border-color',
                description: 'Active border color of tab'
            },
            {
                name: 'tabview.tab.color',
                token: 'tabview.tab.color',
                variable: '--p-tabview-tab-color',
                description: 'Color of tab'
            },
            {
                name: 'tabview.tab.hoverColor',
                token: 'tabview.tab.hover.color',
                variable: '--p-tabview-tab-hover-color',
                description: 'Hover color of tab'
            },
            {
                name: 'tabview.tab.activeColor',
                token: 'tabview.tab.active.color',
                variable: '--p-tabview-tab-active-color',
                description: 'Active color of tab'
            },
            {
                name: 'tabview.tabPanel.background',
                token: 'tabview.tab.panel.background',
                variable: '--p-tabview-tab-panel-background',
                description: 'Background of tab panel'
            },
            {
                name: 'tabview.tabPanel.color',
                token: 'tabview.tab.panel.color',
                variable: '--p-tabview-tab-panel-color',
                description: 'Color of tab panel'
            },
            {
                name: 'tabview.navButton.background',
                token: 'tabview.nav.button.background',
                variable: '--p-tabview-nav-button-background',
                description: 'Background of nav button'
            },
            {
                name: 'tabview.navButton.color',
                token: 'tabview.nav.button.color',
                variable: '--p-tabview-nav-button-color',
                description: 'Color of nav button'
            },
            {
                name: 'tabview.navButton.hoverColor',
                token: 'tabview.nav.button.hover.color',
                variable: '--p-tabview-nav-button-hover-color',
                description: 'Hover color of nav button'
            },
            {
                name: 'tabview.navButton.shadow',
                token: 'tabview.nav.button.shadow',
                variable: '--p-tabview-nav-button-shadow',
                description: 'Shadow of nav button'
            }
        ]
    },
    tag: {
        description: 'Tag Design Tokens',
        tokens: [
            {
                name: 'tag.root.fontSize',
                token: 'tag.font.size',
                variable: '--p-tag-font-size',
                description: 'Font size of root'
            },
            {
                name: 'tag.root.fontWeight',
                token: 'tag.font.weight',
                variable: '--p-tag-font-weight',
                description: 'Font weight of root'
            },
            {
                name: 'tag.root.padding',
                token: 'tag.padding',
                variable: '--p-tag-padding',
                description: 'Padding of root'
            },
            {
                name: 'tag.root.gap',
                token: 'tag.gap',
                variable: '--p-tag-gap',
                description: 'Gap of root'
            },
            {
                name: 'tag.root.borderRadius',
                token: 'tag.border.radius',
                variable: '--p-tag-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'tag.root.roundedBorderRadius',
                token: 'tag.rounded.border.radius',
                variable: '--p-tag-rounded-border-radius',
                description: 'Rounded border radius of root'
            },
            {
                name: 'tag.icon.size',
                token: 'tag.icon.size',
                variable: '--p-tag-icon-size',
                description: 'Size of icon'
            },
            {
                name: 'tag.primary.background',
                token: 'tag.primary.background',
                variable: '--p-tag-primary-background',
                description: 'Background of primary'
            },
            {
                name: 'tag.primary.color',
                token: 'tag.primary.color',
                variable: '--p-tag-primary-color',
                description: 'Color of primary'
            },
            {
                name: 'tag.secondary.background',
                token: 'tag.secondary.background',
                variable: '--p-tag-secondary-background',
                description: 'Background of secondary'
            },
            {
                name: 'tag.secondary.color',
                token: 'tag.secondary.color',
                variable: '--p-tag-secondary-color',
                description: 'Color of secondary'
            },
            {
                name: 'tag.success.background',
                token: 'tag.success.background',
                variable: '--p-tag-success-background',
                description: 'Background of success'
            },
            {
                name: 'tag.success.color',
                token: 'tag.success.color',
                variable: '--p-tag-success-color',
                description: 'Color of success'
            },
            {
                name: 'tag.info.background',
                token: 'tag.info.background',
                variable: '--p-tag-info-background',
                description: 'Background of info'
            },
            {
                name: 'tag.info.color',
                token: 'tag.info.color',
                variable: '--p-tag-info-color',
                description: 'Color of info'
            },
            {
                name: 'tag.warn.background',
                token: 'tag.warn.background',
                variable: '--p-tag-warn-background',
                description: 'Background of warn'
            },
            {
                name: 'tag.warn.color',
                token: 'tag.warn.color',
                variable: '--p-tag-warn-color',
                description: 'Color of warn'
            },
            {
                name: 'tag.danger.background',
                token: 'tag.danger.background',
                variable: '--p-tag-danger-background',
                description: 'Background of danger'
            },
            {
                name: 'tag.danger.color',
                token: 'tag.danger.color',
                variable: '--p-tag-danger-color',
                description: 'Color of danger'
            },
            {
                name: 'tag.contrast.background',
                token: 'tag.contrast.background',
                variable: '--p-tag-contrast-background',
                description: 'Background of contrast'
            },
            {
                name: 'tag.contrast.color',
                token: 'tag.contrast.color',
                variable: '--p-tag-contrast-color',
                description: 'Color of contrast'
            }
        ]
    },
    terminal: {
        description: 'Terminal Design Tokens',
        tokens: [
            {
                name: 'terminal.root.background',
                token: 'terminal.background',
                variable: '--p-terminal-background',
                description: 'Background of root'
            },
            {
                name: 'terminal.root.borderColor',
                token: 'terminal.border.color',
                variable: '--p-terminal-border-color',
                description: 'Border color of root'
            },
            {
                name: 'terminal.root.color',
                token: 'terminal.color',
                variable: '--p-terminal-color',
                description: 'Color of root'
            },
            {
                name: 'terminal.root.height',
                token: 'terminal.height',
                variable: '--p-terminal-height',
                description: 'Height of root'
            },
            {
                name: 'terminal.root.padding',
                token: 'terminal.padding',
                variable: '--p-terminal-padding',
                description: 'Padding of root'
            },
            {
                name: 'terminal.root.borderRadius',
                token: 'terminal.border.radius',
                variable: '--p-terminal-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'terminal.prompt.gap',
                token: 'terminal.prompt.gap',
                variable: '--p-terminal-prompt-gap',
                description: 'Gap of prompt'
            },
            {
                name: 'terminal.commandResponse.margin',
                token: 'terminal.command.response.margin',
                variable: '--p-terminal-command-response-margin',
                description: 'Margin of command response'
            }
        ]
    },
    textarea: {
        description: 'Textarea Design Tokens',
        tokens: [
            {
                name: 'textarea.root.background',
                token: 'textarea.background',
                variable: '--p-textarea-background',
                description: 'Background of root'
            },
            {
                name: 'textarea.root.disabledBackground',
                token: 'textarea.disabled.background',
                variable: '--p-textarea-disabled-background',
                description: 'Disabled background of root'
            },
            {
                name: 'textarea.root.filledBackground',
                token: 'textarea.filled.background',
                variable: '--p-textarea-filled-background',
                description: 'Filled background of root'
            },
            {
                name: 'textarea.root.filledHoverBackground',
                token: 'textarea.filled.hover.background',
                variable: '--p-textarea-filled-hover-background',
                description: 'Filled hover background of root'
            },
            {
                name: 'textarea.root.filledFocusBackground',
                token: 'textarea.filled.focus.background',
                variable: '--p-textarea-filled-focus-background',
                description: 'Filled focus background of root'
            },
            {
                name: 'textarea.root.borderColor',
                token: 'textarea.border.color',
                variable: '--p-textarea-border-color',
                description: 'Border color of root'
            },
            {
                name: 'textarea.root.hoverBorderColor',
                token: 'textarea.hover.border.color',
                variable: '--p-textarea-hover-border-color',
                description: 'Hover border color of root'
            },
            {
                name: 'textarea.root.focusBorderColor',
                token: 'textarea.focus.border.color',
                variable: '--p-textarea-focus-border-color',
                description: 'Focus border color of root'
            },
            {
                name: 'textarea.root.invalidBorderColor',
                token: 'textarea.invalid.border.color',
                variable: '--p-textarea-invalid-border-color',
                description: 'Invalid border color of root'
            },
            {
                name: 'textarea.root.color',
                token: 'textarea.color',
                variable: '--p-textarea-color',
                description: 'Color of root'
            },
            {
                name: 'textarea.root.disabledColor',
                token: 'textarea.disabled.color',
                variable: '--p-textarea-disabled-color',
                description: 'Disabled color of root'
            },
            {
                name: 'textarea.root.placeholderColor',
                token: 'textarea.placeholder.color',
                variable: '--p-textarea-placeholder-color',
                description: 'Placeholder color of root'
            },
            {
                name: 'textarea.root.invalidPlaceholderColor',
                token: 'textarea.invalid.placeholder.color',
                variable: '--p-textarea-invalid-placeholder-color',
                description: 'Invalid placeholder color of root'
            },
            {
                name: 'textarea.root.shadow',
                token: 'textarea.shadow',
                variable: '--p-textarea-shadow',
                description: 'Shadow of root'
            },
            {
                name: 'textarea.root.paddingX',
                token: 'textarea.padding.x',
                variable: '--p-textarea-padding-x',
                description: 'Padding x of root'
            },
            {
                name: 'textarea.root.paddingY',
                token: 'textarea.padding.y',
                variable: '--p-textarea-padding-y',
                description: 'Padding y of root'
            },
            {
                name: 'textarea.root.borderRadius',
                token: 'textarea.border.radius',
                variable: '--p-textarea-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'textarea.root.focusRing.width',
                token: 'textarea.focus.ring.width',
                variable: '--p-textarea-focus-ring-width',
                description: 'Focus ring width of root'
            },
            {
                name: 'textarea.root.focusRing.style',
                token: 'textarea.focus.ring.style',
                variable: '--p-textarea-focus-ring-style',
                description: 'Focus ring style of root'
            },
            {
                name: 'textarea.root.focusRing.color',
                token: 'textarea.focus.ring.color',
                variable: '--p-textarea-focus-ring-color',
                description: 'Focus ring color of root'
            },
            {
                name: 'textarea.root.focusRing.offset',
                token: 'textarea.focus.ring.offset',
                variable: '--p-textarea-focus-ring-offset',
                description: 'Focus ring offset of root'
            },
            {
                name: 'textarea.root.focusRing.shadow',
                token: 'textarea.focus.ring.shadow',
                variable: '--p-textarea-focus-ring-shadow',
                description: 'Focus ring shadow of root'
            },
            {
                name: 'textarea.root.transitionDuration',
                token: 'textarea.transition.duration',
                variable: '--p-textarea-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'textarea.root.sm.fontSize',
                token: 'textarea.sm.font.size',
                variable: '--p-textarea-sm-font-size',
                description: 'Sm font size of root'
            },
            {
                name: 'textarea.root.sm.paddingX',
                token: 'textarea.sm.padding.x',
                variable: '--p-textarea-sm-padding-x',
                description: 'Sm padding x of root'
            },
            {
                name: 'textarea.root.sm.paddingY',
                token: 'textarea.sm.padding.y',
                variable: '--p-textarea-sm-padding-y',
                description: 'Sm padding y of root'
            },
            {
                name: 'textarea.root.lg.fontSize',
                token: 'textarea.lg.font.size',
                variable: '--p-textarea-lg-font-size',
                description: 'Lg font size of root'
            },
            {
                name: 'textarea.root.lg.paddingX',
                token: 'textarea.lg.padding.x',
                variable: '--p-textarea-lg-padding-x',
                description: 'Lg padding x of root'
            },
            {
                name: 'textarea.root.lg.paddingY',
                token: 'textarea.lg.padding.y',
                variable: '--p-textarea-lg-padding-y',
                description: 'Lg padding y of root'
            }
        ]
    },
    tieredmenu: {
        description: 'TieredMenu Design Tokens',
        tokens: [
            {
                name: 'tieredmenu.root.background',
                token: 'tieredmenu.background',
                variable: '--p-tieredmenu-background',
                description: 'Background of root'
            },
            {
                name: 'tieredmenu.root.borderColor',
                token: 'tieredmenu.border.color',
                variable: '--p-tieredmenu-border-color',
                description: 'Border color of root'
            },
            {
                name: 'tieredmenu.root.color',
                token: 'tieredmenu.color',
                variable: '--p-tieredmenu-color',
                description: 'Color of root'
            },
            {
                name: 'tieredmenu.root.borderRadius',
                token: 'tieredmenu.border.radius',
                variable: '--p-tieredmenu-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'tieredmenu.root.shadow',
                token: 'tieredmenu.shadow',
                variable: '--p-tieredmenu-shadow',
                description: 'Shadow of root'
            },
            {
                name: 'tieredmenu.root.transitionDuration',
                token: 'tieredmenu.transition.duration',
                variable: '--p-tieredmenu-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'tieredmenu.list.padding',
                token: 'tieredmenu.list.padding',
                variable: '--p-tieredmenu-list-padding',
                description: 'Padding of list'
            },
            {
                name: 'tieredmenu.list.gap',
                token: 'tieredmenu.list.gap',
                variable: '--p-tieredmenu-list-gap',
                description: 'Gap of list'
            },
            {
                name: 'tieredmenu.item.focusBackground',
                token: 'tieredmenu.item.focus.background',
                variable: '--p-tieredmenu-item-focus-background',
                description: 'Focus background of item'
            },
            {
                name: 'tieredmenu.item.activeBackground',
                token: 'tieredmenu.item.active.background',
                variable: '--p-tieredmenu-item-active-background',
                description: 'Active background of item'
            },
            {
                name: 'tieredmenu.item.color',
                token: 'tieredmenu.item.color',
                variable: '--p-tieredmenu-item-color',
                description: 'Color of item'
            },
            {
                name: 'tieredmenu.item.focusColor',
                token: 'tieredmenu.item.focus.color',
                variable: '--p-tieredmenu-item-focus-color',
                description: 'Focus color of item'
            },
            {
                name: 'tieredmenu.item.activeColor',
                token: 'tieredmenu.item.active.color',
                variable: '--p-tieredmenu-item-active-color',
                description: 'Active color of item'
            },
            {
                name: 'tieredmenu.item.padding',
                token: 'tieredmenu.item.padding',
                variable: '--p-tieredmenu-item-padding',
                description: 'Padding of item'
            },
            {
                name: 'tieredmenu.item.borderRadius',
                token: 'tieredmenu.item.border.radius',
                variable: '--p-tieredmenu-item-border-radius',
                description: 'Border radius of item'
            },
            {
                name: 'tieredmenu.item.gap',
                token: 'tieredmenu.item.gap',
                variable: '--p-tieredmenu-item-gap',
                description: 'Gap of item'
            },
            {
                name: 'tieredmenu.item.icon.color',
                token: 'tieredmenu.item.icon.color',
                variable: '--p-tieredmenu-item-icon-color',
                description: 'Icon color of item'
            },
            {
                name: 'tieredmenu.item.icon.focusColor',
                token: 'tieredmenu.item.icon.focus.color',
                variable: '--p-tieredmenu-item-icon-focus-color',
                description: 'Icon focus color of item'
            },
            {
                name: 'tieredmenu.item.icon.activeColor',
                token: 'tieredmenu.item.icon.active.color',
                variable: '--p-tieredmenu-item-icon-active-color',
                description: 'Icon active color of item'
            },
            {
                name: 'tieredmenu.submenu.mobileIndent',
                token: 'tieredmenu.submenu.mobile.indent',
                variable: '--p-tieredmenu-submenu-mobile-indent',
                description: 'Mobile indent of submenu'
            },
            {
                name: 'tieredmenu.submenuIcon.size',
                token: 'tieredmenu.submenu.icon.size',
                variable: '--p-tieredmenu-submenu-icon-size',
                description: 'Size of submenu icon'
            },
            {
                name: 'tieredmenu.submenuIcon.color',
                token: 'tieredmenu.submenu.icon.color',
                variable: '--p-tieredmenu-submenu-icon-color',
                description: 'Color of submenu icon'
            },
            {
                name: 'tieredmenu.submenuIcon.focusColor',
                token: 'tieredmenu.submenu.icon.focus.color',
                variable: '--p-tieredmenu-submenu-icon-focus-color',
                description: 'Focus color of submenu icon'
            },
            {
                name: 'tieredmenu.submenuIcon.activeColor',
                token: 'tieredmenu.submenu.icon.active.color',
                variable: '--p-tieredmenu-submenu-icon-active-color',
                description: 'Active color of submenu icon'
            },
            {
                name: 'tieredmenu.separator.borderColor',
                token: 'tieredmenu.separator.border.color',
                variable: '--p-tieredmenu-separator-border-color',
                description: 'Border color of separator'
            }
        ]
    },
    timeline: {
        description: 'Timeline Design Tokens',
        tokens: [
            {
                name: 'timeline.event.minHeight',
                token: 'timeline.event.min.height',
                variable: '--p-timeline-event-min-height',
                description: 'Min height of event'
            },
            {
                name: 'timeline.horizontal.eventContent.padding',
                token: 'timeline.horizontal.event.content.padding',
                variable: '--p-timeline-horizontal-event-content-padding',
                description: 'Event content padding of horizontal'
            },
            {
                name: 'timeline.vertical.eventContent.padding',
                token: 'timeline.vertical.event.content.padding',
                variable: '--p-timeline-vertical-event-content-padding',
                description: 'Event content padding of vertical'
            },
            {
                name: 'timeline.eventMarker.size',
                token: 'timeline.event.marker.size',
                variable: '--p-timeline-event-marker-size',
                description: 'Size of event marker'
            },
            {
                name: 'timeline.eventMarker.borderRadius',
                token: 'timeline.event.marker.border.radius',
                variable: '--p-timeline-event-marker-border-radius',
                description: 'Border radius of event marker'
            },
            {
                name: 'timeline.eventMarker.borderWidth',
                token: 'timeline.event.marker.border.width',
                variable: '--p-timeline-event-marker-border-width',
                description: 'Border width of event marker'
            },
            {
                name: 'timeline.eventMarker.background',
                token: 'timeline.event.marker.background',
                variable: '--p-timeline-event-marker-background',
                description: 'Background of event marker'
            },
            {
                name: 'timeline.eventMarker.borderColor',
                token: 'timeline.event.marker.border.color',
                variable: '--p-timeline-event-marker-border-color',
                description: 'Border color of event marker'
            },
            {
                name: 'timeline.eventMarker.content.borderRadius',
                token: 'timeline.event.marker.content.border.radius',
                variable: '--p-timeline-event-marker-content-border-radius',
                description: 'Content border radius of event marker'
            },
            {
                name: 'timeline.eventMarker.content.size',
                token: 'timeline.event.marker.content.size',
                variable: '--p-timeline-event-marker-content-size',
                description: 'Content size of event marker'
            },
            {
                name: 'timeline.eventMarker.content.background',
                token: 'timeline.event.marker.content.background',
                variable: '--p-timeline-event-marker-content-background',
                description: 'Content background of event marker'
            },
            {
                name: 'timeline.eventMarker.content.insetShadow',
                token: 'timeline.event.marker.content.inset.shadow',
                variable: '--p-timeline-event-marker-content-inset-shadow',
                description: 'Content inset shadow of event marker'
            },
            {
                name: 'timeline.eventConnector.color',
                token: 'timeline.event.connector.color',
                variable: '--p-timeline-event-connector-color',
                description: 'Color of event connector'
            },
            {
                name: 'timeline.eventConnector.size',
                token: 'timeline.event.connector.size',
                variable: '--p-timeline-event-connector-size',
                description: 'Size of event connector'
            }
        ]
    },
    toast: {
        description: 'Toast Design Tokens',
        tokens: [
            {
                name: 'toast.toastDesignTokens.blur',
                token: 'toast.blur',
                variable: '--p-toast-blur',
                description: 'Used to pass tokens of the blur section'
            },
            {
                name: 'toast.root.width',
                token: 'toast.width',
                variable: '--p-toast-width',
                description: 'Width of root'
            },
            {
                name: 'toast.root.borderRadius',
                token: 'toast.border.radius',
                variable: '--p-toast-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'toast.root.borderWidth',
                token: 'toast.border.width',
                variable: '--p-toast-border-width',
                description: 'Border width of root'
            },
            {
                name: 'toast.root.transitionDuration',
                token: 'toast.transition.duration',
                variable: '--p-toast-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'toast.icon.size',
                token: 'toast.icon.size',
                variable: '--p-toast-icon-size',
                description: 'Size of icon'
            },
            {
                name: 'toast.content.padding',
                token: 'toast.content.padding',
                variable: '--p-toast-content-padding',
                description: 'Padding of content'
            },
            {
                name: 'toast.content.gap',
                token: 'toast.content.gap',
                variable: '--p-toast-content-gap',
                description: 'Gap of content'
            },
            {
                name: 'toast.text.gap',
                token: 'toast.text.gap',
                variable: '--p-toast-text-gap',
                description: 'Gap of text'
            },
            {
                name: 'toast.summary.fontWeight',
                token: 'toast.summary.font.weight',
                variable: '--p-toast-summary-font-weight',
                description: 'Font weight of summary'
            },
            {
                name: 'toast.summary.fontSize',
                token: 'toast.summary.font.size',
                variable: '--p-toast-summary-font-size',
                description: 'Font size of summary'
            },
            {
                name: 'toast.detail.fontWeight',
                token: 'toast.detail.font.weight',
                variable: '--p-toast-detail-font-weight',
                description: 'Font weight of detail'
            },
            {
                name: 'toast.detail.fontSize',
                token: 'toast.detail.font.size',
                variable: '--p-toast-detail-font-size',
                description: 'Font size of detail'
            },
            {
                name: 'toast.closeButton.width',
                token: 'toast.close.button.width',
                variable: '--p-toast-close-button-width',
                description: 'Width of close button'
            },
            {
                name: 'toast.closeButton.height',
                token: 'toast.close.button.height',
                variable: '--p-toast-close-button-height',
                description: 'Height of close button'
            },
            {
                name: 'toast.closeButton.borderRadius',
                token: 'toast.close.button.border.radius',
                variable: '--p-toast-close-button-border-radius',
                description: 'Border radius of close button'
            },
            {
                name: 'toast.closeButton.focusRing.width',
                token: 'toast.close.button.focus.ring.width',
                variable: '--p-toast-close-button-focus-ring-width',
                description: 'Focus ring width of close button'
            },
            {
                name: 'toast.closeButton.focusRing.style',
                token: 'toast.close.button.focus.ring.style',
                variable: '--p-toast-close-button-focus-ring-style',
                description: 'Focus ring style of close button'
            },
            {
                name: 'toast.closeButton.focusRing.offset',
                token: 'toast.close.button.focus.ring.offset',
                variable: '--p-toast-close-button-focus-ring-offset',
                description: 'Focus ring offset of close button'
            },
            {
                name: 'toast.closeIcon.size',
                token: 'toast.close.icon.size',
                variable: '--p-toast-close-icon-size',
                description: 'Size of close icon'
            },
            {
                name: 'toast.info.background',
                token: 'toast.info.background',
                variable: '--p-toast-info-background',
                description: 'Background of info'
            },
            {
                name: 'toast.info.borderColor',
                token: 'toast.info.border.color',
                variable: '--p-toast-info-border-color',
                description: 'Border color of info'
            },
            {
                name: 'toast.info.color',
                token: 'toast.info.color',
                variable: '--p-toast-info-color',
                description: 'Color of info'
            },
            {
                name: 'toast.info.detailColor',
                token: 'toast.info.detail.color',
                variable: '--p-toast-info-detail-color',
                description: 'Detail color of info'
            },
            {
                name: 'toast.info.shadow',
                token: 'toast.info.shadow',
                variable: '--p-toast-info-shadow',
                description: 'Shadow of info'
            },
            {
                name: 'toast.info.closeButton.hoverBackground',
                token: 'toast.info.close.button.hover.background',
                variable: '--p-toast-info-close-button-hover-background',
                description: 'Close button hover background of info'
            },
            {
                name: 'toast.info.closeButton.focusRing.color',
                token: 'toast.info.close.button.focus.ring.color',
                variable: '--p-toast-info-close-button-focus-ring-color',
                description: 'Close button focus ring color of info'
            },
            {
                name: 'toast.info.closeButton.focusRing.shadow',
                token: 'toast.info.close.button.focus.ring.shadow',
                variable: '--p-toast-info-close-button-focus-ring-shadow',
                description: 'Close button focus ring shadow of info'
            },
            {
                name: 'toast.success.background',
                token: 'toast.success.background',
                variable: '--p-toast-success-background',
                description: 'Background of success'
            },
            {
                name: 'toast.success.borderColor',
                token: 'toast.success.border.color',
                variable: '--p-toast-success-border-color',
                description: 'Border color of success'
            },
            {
                name: 'toast.success.color',
                token: 'toast.success.color',
                variable: '--p-toast-success-color',
                description: 'Color of success'
            },
            {
                name: 'toast.success.detailColor',
                token: 'toast.success.detail.color',
                variable: '--p-toast-success-detail-color',
                description: 'Detail color of success'
            },
            {
                name: 'toast.success.shadow',
                token: 'toast.success.shadow',
                variable: '--p-toast-success-shadow',
                description: 'Shadow of success'
            },
            {
                name: 'toast.success.closeButton.hoverBackground',
                token: 'toast.success.close.button.hover.background',
                variable: '--p-toast-success-close-button-hover-background',
                description: 'Close button hover background of success'
            },
            {
                name: 'toast.success.closeButton.focusRing.color',
                token: 'toast.success.close.button.focus.ring.color',
                variable: '--p-toast-success-close-button-focus-ring-color',
                description: 'Close button focus ring color of success'
            },
            {
                name: 'toast.success.closeButton.focusRing.shadow',
                token: 'toast.success.close.button.focus.ring.shadow',
                variable: '--p-toast-success-close-button-focus-ring-shadow',
                description: 'Close button focus ring shadow of success'
            },
            {
                name: 'toast.warn.background',
                token: 'toast.warn.background',
                variable: '--p-toast-warn-background',
                description: 'Background of warn'
            },
            {
                name: 'toast.warn.borderColor',
                token: 'toast.warn.border.color',
                variable: '--p-toast-warn-border-color',
                description: 'Border color of warn'
            },
            {
                name: 'toast.warn.color',
                token: 'toast.warn.color',
                variable: '--p-toast-warn-color',
                description: 'Color of warn'
            },
            {
                name: 'toast.warn.detailColor',
                token: 'toast.warn.detail.color',
                variable: '--p-toast-warn-detail-color',
                description: 'Detail color of warn'
            },
            {
                name: 'toast.warn.shadow',
                token: 'toast.warn.shadow',
                variable: '--p-toast-warn-shadow',
                description: 'Shadow of warn'
            },
            {
                name: 'toast.warn.closeButton.hoverBackground',
                token: 'toast.warn.close.button.hover.background',
                variable: '--p-toast-warn-close-button-hover-background',
                description: 'Close button hover background of warn'
            },
            {
                name: 'toast.warn.closeButton.focusRing.color',
                token: 'toast.warn.close.button.focus.ring.color',
                variable: '--p-toast-warn-close-button-focus-ring-color',
                description: 'Close button focus ring color of warn'
            },
            {
                name: 'toast.warn.closeButton.focusRing.shadow',
                token: 'toast.warn.close.button.focus.ring.shadow',
                variable: '--p-toast-warn-close-button-focus-ring-shadow',
                description: 'Close button focus ring shadow of warn'
            },
            {
                name: 'toast.error.background',
                token: 'toast.error.background',
                variable: '--p-toast-error-background',
                description: 'Background of error'
            },
            {
                name: 'toast.error.borderColor',
                token: 'toast.error.border.color',
                variable: '--p-toast-error-border-color',
                description: 'Border color of error'
            },
            {
                name: 'toast.error.color',
                token: 'toast.error.color',
                variable: '--p-toast-error-color',
                description: 'Color of error'
            },
            {
                name: 'toast.error.detailColor',
                token: 'toast.error.detail.color',
                variable: '--p-toast-error-detail-color',
                description: 'Detail color of error'
            },
            {
                name: 'toast.error.shadow',
                token: 'toast.error.shadow',
                variable: '--p-toast-error-shadow',
                description: 'Shadow of error'
            },
            {
                name: 'toast.error.closeButton.hoverBackground',
                token: 'toast.error.close.button.hover.background',
                variable: '--p-toast-error-close-button-hover-background',
                description: 'Close button hover background of error'
            },
            {
                name: 'toast.error.closeButton.focusRing.color',
                token: 'toast.error.close.button.focus.ring.color',
                variable: '--p-toast-error-close-button-focus-ring-color',
                description: 'Close button focus ring color of error'
            },
            {
                name: 'toast.error.closeButton.focusRing.shadow',
                token: 'toast.error.close.button.focus.ring.shadow',
                variable: '--p-toast-error-close-button-focus-ring-shadow',
                description: 'Close button focus ring shadow of error'
            },
            {
                name: 'toast.secondary.background',
                token: 'toast.secondary.background',
                variable: '--p-toast-secondary-background',
                description: 'Background of secondary'
            },
            {
                name: 'toast.secondary.borderColor',
                token: 'toast.secondary.border.color',
                variable: '--p-toast-secondary-border-color',
                description: 'Border color of secondary'
            },
            {
                name: 'toast.secondary.color',
                token: 'toast.secondary.color',
                variable: '--p-toast-secondary-color',
                description: 'Color of secondary'
            },
            {
                name: 'toast.secondary.detailColor',
                token: 'toast.secondary.detail.color',
                variable: '--p-toast-secondary-detail-color',
                description: 'Detail color of secondary'
            },
            {
                name: 'toast.secondary.shadow',
                token: 'toast.secondary.shadow',
                variable: '--p-toast-secondary-shadow',
                description: 'Shadow of secondary'
            },
            {
                name: 'toast.secondary.closeButton.hoverBackground',
                token: 'toast.secondary.close.button.hover.background',
                variable: '--p-toast-secondary-close-button-hover-background',
                description: 'Close button hover background of secondary'
            },
            {
                name: 'toast.secondary.closeButton.focusRing.color',
                token: 'toast.secondary.close.button.focus.ring.color',
                variable: '--p-toast-secondary-close-button-focus-ring-color',
                description: 'Close button focus ring color of secondary'
            },
            {
                name: 'toast.secondary.closeButton.focusRing.shadow',
                token: 'toast.secondary.close.button.focus.ring.shadow',
                variable: '--p-toast-secondary-close-button-focus-ring-shadow',
                description: 'Close button focus ring shadow of secondary'
            },
            {
                name: 'toast.contrast.background',
                token: 'toast.contrast.background',
                variable: '--p-toast-contrast-background',
                description: 'Background of contrast'
            },
            {
                name: 'toast.contrast.borderColor',
                token: 'toast.contrast.border.color',
                variable: '--p-toast-contrast-border-color',
                description: 'Border color of contrast'
            },
            {
                name: 'toast.contrast.color',
                token: 'toast.contrast.color',
                variable: '--p-toast-contrast-color',
                description: 'Color of contrast'
            },
            {
                name: 'toast.contrast.detailColor',
                token: 'toast.contrast.detail.color',
                variable: '--p-toast-contrast-detail-color',
                description: 'Detail color of contrast'
            },
            {
                name: 'toast.contrast.shadow',
                token: 'toast.contrast.shadow',
                variable: '--p-toast-contrast-shadow',
                description: 'Shadow of contrast'
            },
            {
                name: 'toast.contrast.closeButton.hoverBackground',
                token: 'toast.contrast.close.button.hover.background',
                variable: '--p-toast-contrast-close-button-hover-background',
                description: 'Close button hover background of contrast'
            },
            {
                name: 'toast.contrast.closeButton.focusRing.color',
                token: 'toast.contrast.close.button.focus.ring.color',
                variable: '--p-toast-contrast-close-button-focus-ring-color',
                description: 'Close button focus ring color of contrast'
            },
            {
                name: 'toast.contrast.closeButton.focusRing.shadow',
                token: 'toast.contrast.close.button.focus.ring.shadow',
                variable: '--p-toast-contrast-close-button-focus-ring-shadow',
                description: 'Close button focus ring shadow of contrast'
            }
        ]
    },
    togglebutton: {
        description: 'ToggleButton Design Tokens',
        tokens: [
            {
                name: 'togglebutton.root.padding',
                token: 'togglebutton.padding',
                variable: '--p-togglebutton-padding',
                description: 'Padding of root'
            },
            {
                name: 'togglebutton.root.borderRadius',
                token: 'togglebutton.border.radius',
                variable: '--p-togglebutton-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'togglebutton.root.gap',
                token: 'togglebutton.gap',
                variable: '--p-togglebutton-gap',
                description: 'Gap of root'
            },
            {
                name: 'togglebutton.root.fontWeight',
                token: 'togglebutton.font.weight',
                variable: '--p-togglebutton-font-weight',
                description: 'Font weight of root'
            },
            {
                name: 'togglebutton.root.disabledBackground',
                token: 'togglebutton.disabled.background',
                variable: '--p-togglebutton-disabled-background',
                description: 'Disabled background of root'
            },
            {
                name: 'togglebutton.root.disabledBorderColor',
                token: 'togglebutton.disabled.border.color',
                variable: '--p-togglebutton-disabled-border-color',
                description: 'Disabled border color of root'
            },
            {
                name: 'togglebutton.root.disabledColor',
                token: 'togglebutton.disabled.color',
                variable: '--p-togglebutton-disabled-color',
                description: 'Disabled color of root'
            },
            {
                name: 'togglebutton.root.invalidBorderColor',
                token: 'togglebutton.invalid.border.color',
                variable: '--p-togglebutton-invalid-border-color',
                description: 'Invalid border color of root'
            },
            {
                name: 'togglebutton.root.focusRing.width',
                token: 'togglebutton.focus.ring.width',
                variable: '--p-togglebutton-focus-ring-width',
                description: 'Focus ring width of root'
            },
            {
                name: 'togglebutton.root.focusRing.style',
                token: 'togglebutton.focus.ring.style',
                variable: '--p-togglebutton-focus-ring-style',
                description: 'Focus ring style of root'
            },
            {
                name: 'togglebutton.root.focusRing.color',
                token: 'togglebutton.focus.ring.color',
                variable: '--p-togglebutton-focus-ring-color',
                description: 'Focus ring color of root'
            },
            {
                name: 'togglebutton.root.focusRing.offset',
                token: 'togglebutton.focus.ring.offset',
                variable: '--p-togglebutton-focus-ring-offset',
                description: 'Focus ring offset of root'
            },
            {
                name: 'togglebutton.root.focusRing.shadow',
                token: 'togglebutton.focus.ring.shadow',
                variable: '--p-togglebutton-focus-ring-shadow',
                description: 'Focus ring shadow of root'
            },
            {
                name: 'togglebutton.root.transitionDuration',
                token: 'togglebutton.transition.duration',
                variable: '--p-togglebutton-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'togglebutton.root.sm.fontSize',
                token: 'togglebutton.sm.font.size',
                variable: '--p-togglebutton-sm-font-size',
                description: 'Sm font size of root'
            },
            {
                name: 'togglebutton.root.sm.padding',
                token: 'togglebutton.sm.padding',
                variable: '--p-togglebutton-sm-padding',
                description: 'Sm padding of root'
            },
            {
                name: 'togglebutton.root.lg.fontSize',
                token: 'togglebutton.lg.font.size',
                variable: '--p-togglebutton-lg-font-size',
                description: 'Lg font size of root'
            },
            {
                name: 'togglebutton.root.lg.padding',
                token: 'togglebutton.lg.padding',
                variable: '--p-togglebutton-lg-padding',
                description: 'Lg padding of root'
            },
            {
                name: 'togglebutton.root.background',
                token: 'togglebutton.background',
                variable: '--p-togglebutton-background',
                description: 'Background of root'
            },
            {
                name: 'togglebutton.root.checkedBackground',
                token: 'togglebutton.checked.background',
                variable: '--p-togglebutton-checked-background',
                description: 'Checked background of root'
            },
            {
                name: 'togglebutton.root.hoverBackground',
                token: 'togglebutton.hover.background',
                variable: '--p-togglebutton-hover-background',
                description: 'Hover background of root'
            },
            {
                name: 'togglebutton.root.borderColor',
                token: 'togglebutton.border.color',
                variable: '--p-togglebutton-border-color',
                description: 'Border color of root'
            },
            {
                name: 'togglebutton.root.color',
                token: 'togglebutton.color',
                variable: '--p-togglebutton-color',
                description: 'Color of root'
            },
            {
                name: 'togglebutton.root.hoverColor',
                token: 'togglebutton.hover.color',
                variable: '--p-togglebutton-hover-color',
                description: 'Hover color of root'
            },
            {
                name: 'togglebutton.root.checkedColor',
                token: 'togglebutton.checked.color',
                variable: '--p-togglebutton-checked-color',
                description: 'Checked color of root'
            },
            {
                name: 'togglebutton.root.checkedBorderColor',
                token: 'togglebutton.checked.border.color',
                variable: '--p-togglebutton-checked-border-color',
                description: 'Checked border color of root'
            },
            {
                name: 'togglebutton.icon.disabledColor',
                token: 'togglebutton.icon.disabled.color',
                variable: '--p-togglebutton-icon-disabled-color',
                description: 'Disabled color of icon'
            },
            {
                name: 'togglebutton.icon.color',
                token: 'togglebutton.icon.color',
                variable: '--p-togglebutton-icon-color',
                description: 'Color of icon'
            },
            {
                name: 'togglebutton.icon.hoverColor',
                token: 'togglebutton.icon.hover.color',
                variable: '--p-togglebutton-icon-hover-color',
                description: 'Hover color of icon'
            },
            {
                name: 'togglebutton.icon.checkedColor',
                token: 'togglebutton.icon.checked.color',
                variable: '--p-togglebutton-icon-checked-color',
                description: 'Checked color of icon'
            },
            {
                name: 'togglebutton.content.padding',
                token: 'togglebutton.content.padding',
                variable: '--p-togglebutton-content-padding',
                description: 'Padding of content'
            },
            {
                name: 'togglebutton.content.borderRadius',
                token: 'togglebutton.content.border.radius',
                variable: '--p-togglebutton-content-border-radius',
                description: 'Border radius of content'
            },
            {
                name: 'togglebutton.content.checkedShadow',
                token: 'togglebutton.content.checked.shadow',
                variable: '--p-togglebutton-content-checked-shadow',
                description: 'Checked shadow of content'
            },
            {
                name: 'togglebutton.content.sm.padding',
                token: 'togglebutton.content.sm.padding',
                variable: '--p-togglebutton-content-sm-padding',
                description: 'Sm padding of content'
            },
            {
                name: 'togglebutton.content.lg.padding',
                token: 'togglebutton.content.lg.padding',
                variable: '--p-togglebutton-content-lg-padding',
                description: 'Lg padding of content'
            },
            {
                name: 'togglebutton.content.checkedBackground',
                token: 'togglebutton.content.checked.background',
                variable: '--p-togglebutton-content-checked-background',
                description: 'Checked background of content'
            }
        ]
    },
    toggleswitch: {
        description: 'ToggleSwitch Design Tokens',
        tokens: [
            {
                name: 'toggleswitch.root.width',
                token: 'toggleswitch.width',
                variable: '--p-toggleswitch-width',
                description: 'Width of root'
            },
            {
                name: 'toggleswitch.root.height',
                token: 'toggleswitch.height',
                variable: '--p-toggleswitch-height',
                description: 'Height of root'
            },
            {
                name: 'toggleswitch.root.borderRadius',
                token: 'toggleswitch.border.radius',
                variable: '--p-toggleswitch-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'toggleswitch.root.gap',
                token: 'toggleswitch.gap',
                variable: '--p-toggleswitch-gap',
                description: 'Gap of root'
            },
            {
                name: 'toggleswitch.root.shadow',
                token: 'toggleswitch.shadow',
                variable: '--p-toggleswitch-shadow',
                description: 'Shadow of root'
            },
            {
                name: 'toggleswitch.root.focusRing.width',
                token: 'toggleswitch.focus.ring.width',
                variable: '--p-toggleswitch-focus-ring-width',
                description: 'Focus ring width of root'
            },
            {
                name: 'toggleswitch.root.focusRing.style',
                token: 'toggleswitch.focus.ring.style',
                variable: '--p-toggleswitch-focus-ring-style',
                description: 'Focus ring style of root'
            },
            {
                name: 'toggleswitch.root.focusRing.color',
                token: 'toggleswitch.focus.ring.color',
                variable: '--p-toggleswitch-focus-ring-color',
                description: 'Focus ring color of root'
            },
            {
                name: 'toggleswitch.root.focusRing.offset',
                token: 'toggleswitch.focus.ring.offset',
                variable: '--p-toggleswitch-focus-ring-offset',
                description: 'Focus ring offset of root'
            },
            {
                name: 'toggleswitch.root.focusRing.shadow',
                token: 'toggleswitch.focus.ring.shadow',
                variable: '--p-toggleswitch-focus-ring-shadow',
                description: 'Focus ring shadow of root'
            },
            {
                name: 'toggleswitch.root.borderWidth',
                token: 'toggleswitch.border.width',
                variable: '--p-toggleswitch-border-width',
                description: 'Border width of root'
            },
            {
                name: 'toggleswitch.root.borderColor',
                token: 'toggleswitch.border.color',
                variable: '--p-toggleswitch-border-color',
                description: 'Border color of root'
            },
            {
                name: 'toggleswitch.root.hoverBorderColor',
                token: 'toggleswitch.hover.border.color',
                variable: '--p-toggleswitch-hover-border-color',
                description: 'Hover border color of root'
            },
            {
                name: 'toggleswitch.root.checkedBorderColor',
                token: 'toggleswitch.checked.border.color',
                variable: '--p-toggleswitch-checked-border-color',
                description: 'Checked border color of root'
            },
            {
                name: 'toggleswitch.root.checkedHoverBorderColor',
                token: 'toggleswitch.checked.hover.border.color',
                variable: '--p-toggleswitch-checked-hover-border-color',
                description: 'Checked hover border color of root'
            },
            {
                name: 'toggleswitch.root.invalidBorderColor',
                token: 'toggleswitch.invalid.border.color',
                variable: '--p-toggleswitch-invalid-border-color',
                description: 'Invalid border color of root'
            },
            {
                name: 'toggleswitch.root.transitionDuration',
                token: 'toggleswitch.transition.duration',
                variable: '--p-toggleswitch-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'toggleswitch.root.slideDuration',
                token: 'toggleswitch.slide.duration',
                variable: '--p-toggleswitch-slide-duration',
                description: 'Slide duration of root'
            },
            {
                name: 'toggleswitch.root.background',
                token: 'toggleswitch.background',
                variable: '--p-toggleswitch-background',
                description: 'Background of root'
            },
            {
                name: 'toggleswitch.root.disabledBackground',
                token: 'toggleswitch.disabled.background',
                variable: '--p-toggleswitch-disabled-background',
                description: 'Disabled background of root'
            },
            {
                name: 'toggleswitch.root.hoverBackground',
                token: 'toggleswitch.hover.background',
                variable: '--p-toggleswitch-hover-background',
                description: 'Hover background of root'
            },
            {
                name: 'toggleswitch.root.checkedBackground',
                token: 'toggleswitch.checked.background',
                variable: '--p-toggleswitch-checked-background',
                description: 'Checked background of root'
            },
            {
                name: 'toggleswitch.root.checkedHoverBackground',
                token: 'toggleswitch.checked.hover.background',
                variable: '--p-toggleswitch-checked-hover-background',
                description: 'Checked hover background of root'
            },
            {
                name: 'toggleswitch.handle.borderRadius',
                token: 'toggleswitch.handle.border.radius',
                variable: '--p-toggleswitch-handle-border-radius',
                description: 'Border radius of handle'
            },
            {
                name: 'toggleswitch.handle.size',
                token: 'toggleswitch.handle.size',
                variable: '--p-toggleswitch-handle-size',
                description: 'Size of handle'
            },
            {
                name: 'toggleswitch.handle.background',
                token: 'toggleswitch.handle.background',
                variable: '--p-toggleswitch-handle-background',
                description: 'Background of handle'
            },
            {
                name: 'toggleswitch.handle.disabledBackground',
                token: 'toggleswitch.handle.disabled.background',
                variable: '--p-toggleswitch-handle-disabled-background',
                description: 'Disabled background of handle'
            },
            {
                name: 'toggleswitch.handle.hoverBackground',
                token: 'toggleswitch.handle.hover.background',
                variable: '--p-toggleswitch-handle-hover-background',
                description: 'Hover background of handle'
            },
            {
                name: 'toggleswitch.handle.checkedBackground',
                token: 'toggleswitch.handle.checked.background',
                variable: '--p-toggleswitch-handle-checked-background',
                description: 'Checked background of handle'
            },
            {
                name: 'toggleswitch.handle.checkedHoverBackground',
                token: 'toggleswitch.handle.checked.hover.background',
                variable: '--p-toggleswitch-handle-checked-hover-background',
                description: 'Checked hover background of handle'
            },
            {
                name: 'toggleswitch.handle.color',
                token: 'toggleswitch.handle.color',
                variable: '--p-toggleswitch-handle-color',
                description: 'Color of handle'
            },
            {
                name: 'toggleswitch.handle.hoverColor',
                token: 'toggleswitch.handle.hover.color',
                variable: '--p-toggleswitch-handle-hover-color',
                description: 'Hover color of handle'
            },
            {
                name: 'toggleswitch.handle.checkedColor',
                token: 'toggleswitch.handle.checked.color',
                variable: '--p-toggleswitch-handle-checked-color',
                description: 'Checked color of handle'
            },
            {
                name: 'toggleswitch.handle.checkedHoverColor',
                token: 'toggleswitch.handle.checked.hover.color',
                variable: '--p-toggleswitch-handle-checked-hover-color',
                description: 'Checked hover color of handle'
            }
        ]
    },
    toolbar: {
        description: 'Toolbar Design Tokens',
        tokens: [
            {
                name: 'toolbar.root.background',
                token: 'toolbar.background',
                variable: '--p-toolbar-background',
                description: 'Background of root'
            },
            {
                name: 'toolbar.root.borderColor',
                token: 'toolbar.border.color',
                variable: '--p-toolbar-border-color',
                description: 'Border color of root'
            },
            {
                name: 'toolbar.root.borderRadius',
                token: 'toolbar.border.radius',
                variable: '--p-toolbar-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'toolbar.root.color',
                token: 'toolbar.color',
                variable: '--p-toolbar-color',
                description: 'Color of root'
            },
            {
                name: 'toolbar.root.gap',
                token: 'toolbar.gap',
                variable: '--p-toolbar-gap',
                description: 'Gap of root'
            },
            {
                name: 'toolbar.root.padding',
                token: 'toolbar.padding',
                variable: '--p-toolbar-padding',
                description: 'Padding of root'
            }
        ]
    },
    tooltip: {
        description: 'Tooltip Design Tokens',
        tokens: [
            {
                name: 'tooltip.root.maxWidth',
                token: 'tooltip.max.width',
                variable: '--p-tooltip-max-width',
                description: 'Max width of root'
            },
            {
                name: 'tooltip.root.gutter',
                token: 'tooltip.gutter',
                variable: '--p-tooltip-gutter',
                description: 'Gutter of root'
            },
            {
                name: 'tooltip.root.shadow',
                token: 'tooltip.shadow',
                variable: '--p-tooltip-shadow',
                description: 'Shadow of root'
            },
            {
                name: 'tooltip.root.padding',
                token: 'tooltip.padding',
                variable: '--p-tooltip-padding',
                description: 'Padding of root'
            },
            {
                name: 'tooltip.root.borderRadius',
                token: 'tooltip.border.radius',
                variable: '--p-tooltip-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'tooltip.root.background',
                token: 'tooltip.background',
                variable: '--p-tooltip-background',
                description: 'Background of root'
            },
            {
                name: 'tooltip.root.color',
                token: 'tooltip.color',
                variable: '--p-tooltip-color',
                description: 'Color of root'
            }
        ]
    },
    tree: {
        description: 'Tree Design Tokens',
        tokens: [
            {
                name: 'tree.root.background',
                token: 'tree.background',
                variable: '--p-tree-background',
                description: 'Background of root'
            },
            {
                name: 'tree.root.color',
                token: 'tree.color',
                variable: '--p-tree-color',
                description: 'Color of root'
            },
            {
                name: 'tree.root.padding',
                token: 'tree.padding',
                variable: '--p-tree-padding',
                description: 'Padding of root'
            },
            {
                name: 'tree.root.gap',
                token: 'tree.gap',
                variable: '--p-tree-gap',
                description: 'Gap of root'
            },
            {
                name: 'tree.root.indent',
                token: 'tree.indent',
                variable: '--p-tree-indent',
                description: 'Indent of root'
            },
            {
                name: 'tree.root.transitionDuration',
                token: 'tree.transition.duration',
                variable: '--p-tree-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'tree.node.padding',
                token: 'tree.node.padding',
                variable: '--p-tree-node-padding',
                description: 'Padding of node'
            },
            {
                name: 'tree.node.borderRadius',
                token: 'tree.node.border.radius',
                variable: '--p-tree-node-border-radius',
                description: 'Border radius of node'
            },
            {
                name: 'tree.node.hoverBackground',
                token: 'tree.node.hover.background',
                variable: '--p-tree-node-hover-background',
                description: 'Hover background of node'
            },
            {
                name: 'tree.node.selectedBackground',
                token: 'tree.node.selected.background',
                variable: '--p-tree-node-selected-background',
                description: 'Selected background of node'
            },
            {
                name: 'tree.node.color',
                token: 'tree.node.color',
                variable: '--p-tree-node-color',
                description: 'Color of node'
            },
            {
                name: 'tree.node.hoverColor',
                token: 'tree.node.hover.color',
                variable: '--p-tree-node-hover-color',
                description: 'Hover color of node'
            },
            {
                name: 'tree.node.selectedColor',
                token: 'tree.node.selected.color',
                variable: '--p-tree-node-selected-color',
                description: 'Selected color of node'
            },
            {
                name: 'tree.node.focusRing.width',
                token: 'tree.node.focus.ring.width',
                variable: '--p-tree-node-focus-ring-width',
                description: 'Focus ring width of node'
            },
            {
                name: 'tree.node.focusRing.style',
                token: 'tree.node.focus.ring.style',
                variable: '--p-tree-node-focus-ring-style',
                description: 'Focus ring style of node'
            },
            {
                name: 'tree.node.focusRing.color',
                token: 'tree.node.focus.ring.color',
                variable: '--p-tree-node-focus-ring-color',
                description: 'Focus ring color of node'
            },
            {
                name: 'tree.node.focusRing.offset',
                token: 'tree.node.focus.ring.offset',
                variable: '--p-tree-node-focus-ring-offset',
                description: 'Focus ring offset of node'
            },
            {
                name: 'tree.node.focusRing.shadow',
                token: 'tree.node.focus.ring.shadow',
                variable: '--p-tree-node-focus-ring-shadow',
                description: 'Focus ring shadow of node'
            },
            {
                name: 'tree.node.gap',
                token: 'tree.node.gap',
                variable: '--p-tree-node-gap',
                description: 'Gap of node'
            },
            {
                name: 'tree.nodeIcon.color',
                token: 'tree.node.icon.color',
                variable: '--p-tree-node-icon-color',
                description: 'Color of node icon'
            },
            {
                name: 'tree.nodeIcon.hoverColor',
                token: 'tree.node.icon.hover.color',
                variable: '--p-tree-node-icon-hover-color',
                description: 'Hover color of node icon'
            },
            {
                name: 'tree.nodeIcon.selectedColor',
                token: 'tree.node.icon.selected.color',
                variable: '--p-tree-node-icon-selected-color',
                description: 'Selected color of node icon'
            },
            {
                name: 'tree.nodeToggleButton.borderRadius',
                token: 'tree.node.toggle.button.border.radius',
                variable: '--p-tree-node-toggle-button-border-radius',
                description: 'Border radius of node toggle button'
            },
            {
                name: 'tree.nodeToggleButton.size',
                token: 'tree.node.toggle.button.size',
                variable: '--p-tree-node-toggle-button-size',
                description: 'Size of node toggle button'
            },
            {
                name: 'tree.nodeToggleButton.hoverBackground',
                token: 'tree.node.toggle.button.hover.background',
                variable: '--p-tree-node-toggle-button-hover-background',
                description: 'Hover background of node toggle button'
            },
            {
                name: 'tree.nodeToggleButton.selectedHoverBackground',
                token: 'tree.node.toggle.button.selected.hover.background',
                variable: '--p-tree-node-toggle-button-selected-hover-background',
                description: 'Selected hover background of node toggle button'
            },
            {
                name: 'tree.nodeToggleButton.color',
                token: 'tree.node.toggle.button.color',
                variable: '--p-tree-node-toggle-button-color',
                description: 'Color of node toggle button'
            },
            {
                name: 'tree.nodeToggleButton.hoverColor',
                token: 'tree.node.toggle.button.hover.color',
                variable: '--p-tree-node-toggle-button-hover-color',
                description: 'Hover color of node toggle button'
            },
            {
                name: 'tree.nodeToggleButton.selectedHoverColor',
                token: 'tree.node.toggle.button.selected.hover.color',
                variable: '--p-tree-node-toggle-button-selected-hover-color',
                description: 'Selected hover color of node toggle button'
            },
            {
                name: 'tree.nodeToggleButton.focusRing.width',
                token: 'tree.node.toggle.button.focus.ring.width',
                variable: '--p-tree-node-toggle-button-focus-ring-width',
                description: 'Focus ring width of node toggle button'
            },
            {
                name: 'tree.nodeToggleButton.focusRing.style',
                token: 'tree.node.toggle.button.focus.ring.style',
                variable: '--p-tree-node-toggle-button-focus-ring-style',
                description: 'Focus ring style of node toggle button'
            },
            {
                name: 'tree.nodeToggleButton.focusRing.color',
                token: 'tree.node.toggle.button.focus.ring.color',
                variable: '--p-tree-node-toggle-button-focus-ring-color',
                description: 'Focus ring color of node toggle button'
            },
            {
                name: 'tree.nodeToggleButton.focusRing.offset',
                token: 'tree.node.toggle.button.focus.ring.offset',
                variable: '--p-tree-node-toggle-button-focus-ring-offset',
                description: 'Focus ring offset of node toggle button'
            },
            {
                name: 'tree.nodeToggleButton.focusRing.shadow',
                token: 'tree.node.toggle.button.focus.ring.shadow',
                variable: '--p-tree-node-toggle-button-focus-ring-shadow',
                description: 'Focus ring shadow of node toggle button'
            },
            {
                name: 'tree.loadingIcon.size',
                token: 'tree.loading.icon.size',
                variable: '--p-tree-loading-icon-size',
                description: 'Size of loading icon'
            },
            {
                name: 'tree.filter.margin',
                token: 'tree.filter.margin',
                variable: '--p-tree-filter-margin',
                description: 'Margin of filter'
            }
        ]
    },
    treeselect: {
        description: 'TreeSelect Design Tokens',
        tokens: [
            {
                name: 'treeselect.root.background',
                token: 'treeselect.background',
                variable: '--p-treeselect-background',
                description: 'Background of root'
            },
            {
                name: 'treeselect.root.disabledBackground',
                token: 'treeselect.disabled.background',
                variable: '--p-treeselect-disabled-background',
                description: 'Disabled background of root'
            },
            {
                name: 'treeselect.root.filledBackground',
                token: 'treeselect.filled.background',
                variable: '--p-treeselect-filled-background',
                description: 'Filled background of root'
            },
            {
                name: 'treeselect.root.filledHoverBackground',
                token: 'treeselect.filled.hover.background',
                variable: '--p-treeselect-filled-hover-background',
                description: 'Filled hover background of root'
            },
            {
                name: 'treeselect.root.filledFocusBackground',
                token: 'treeselect.filled.focus.background',
                variable: '--p-treeselect-filled-focus-background',
                description: 'Filled focus background of root'
            },
            {
                name: 'treeselect.root.borderColor',
                token: 'treeselect.border.color',
                variable: '--p-treeselect-border-color',
                description: 'Border color of root'
            },
            {
                name: 'treeselect.root.hoverBorderColor',
                token: 'treeselect.hover.border.color',
                variable: '--p-treeselect-hover-border-color',
                description: 'Hover border color of root'
            },
            {
                name: 'treeselect.root.focusBorderColor',
                token: 'treeselect.focus.border.color',
                variable: '--p-treeselect-focus-border-color',
                description: 'Focus border color of root'
            },
            {
                name: 'treeselect.root.invalidBorderColor',
                token: 'treeselect.invalid.border.color',
                variable: '--p-treeselect-invalid-border-color',
                description: 'Invalid border color of root'
            },
            {
                name: 'treeselect.root.color',
                token: 'treeselect.color',
                variable: '--p-treeselect-color',
                description: 'Color of root'
            },
            {
                name: 'treeselect.root.disabledColor',
                token: 'treeselect.disabled.color',
                variable: '--p-treeselect-disabled-color',
                description: 'Disabled color of root'
            },
            {
                name: 'treeselect.root.placeholderColor',
                token: 'treeselect.placeholder.color',
                variable: '--p-treeselect-placeholder-color',
                description: 'Placeholder color of root'
            },
            {
                name: 'treeselect.root.invalidPlaceholderColor',
                token: 'treeselect.invalid.placeholder.color',
                variable: '--p-treeselect-invalid-placeholder-color',
                description: 'Invalid placeholder color of root'
            },
            {
                name: 'treeselect.root.shadow',
                token: 'treeselect.shadow',
                variable: '--p-treeselect-shadow',
                description: 'Shadow of root'
            },
            {
                name: 'treeselect.root.paddingX',
                token: 'treeselect.padding.x',
                variable: '--p-treeselect-padding-x',
                description: 'Padding x of root'
            },
            {
                name: 'treeselect.root.paddingY',
                token: 'treeselect.padding.y',
                variable: '--p-treeselect-padding-y',
                description: 'Padding y of root'
            },
            {
                name: 'treeselect.root.borderRadius',
                token: 'treeselect.border.radius',
                variable: '--p-treeselect-border-radius',
                description: 'Border radius of root'
            },
            {
                name: 'treeselect.root.focusRing.width',
                token: 'treeselect.focus.ring.width',
                variable: '--p-treeselect-focus-ring-width',
                description: 'Focus ring width of root'
            },
            {
                name: 'treeselect.root.focusRing.style',
                token: 'treeselect.focus.ring.style',
                variable: '--p-treeselect-focus-ring-style',
                description: 'Focus ring style of root'
            },
            {
                name: 'treeselect.root.focusRing.color',
                token: 'treeselect.focus.ring.color',
                variable: '--p-treeselect-focus-ring-color',
                description: 'Focus ring color of root'
            },
            {
                name: 'treeselect.root.focusRing.offset',
                token: 'treeselect.focus.ring.offset',
                variable: '--p-treeselect-focus-ring-offset',
                description: 'Focus ring offset of root'
            },
            {
                name: 'treeselect.root.focusRing.shadow',
                token: 'treeselect.focus.ring.shadow',
                variable: '--p-treeselect-focus-ring-shadow',
                description: 'Focus ring shadow of root'
            },
            {
                name: 'treeselect.root.transitionDuration',
                token: 'treeselect.transition.duration',
                variable: '--p-treeselect-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'treeselect.root.sm.fontSize',
                token: 'treeselect.sm.font.size',
                variable: '--p-treeselect-sm-font-size',
                description: 'Sm font size of root'
            },
            {
                name: 'treeselect.root.sm.paddingX',
                token: 'treeselect.sm.padding.x',
                variable: '--p-treeselect-sm-padding-x',
                description: 'Sm padding x of root'
            },
            {
                name: 'treeselect.root.sm.paddingY',
                token: 'treeselect.sm.padding.y',
                variable: '--p-treeselect-sm-padding-y',
                description: 'Sm padding y of root'
            },
            {
                name: 'treeselect.root.lg.fontSize',
                token: 'treeselect.lg.font.size',
                variable: '--p-treeselect-lg-font-size',
                description: 'Lg font size of root'
            },
            {
                name: 'treeselect.root.lg.paddingX',
                token: 'treeselect.lg.padding.x',
                variable: '--p-treeselect-lg-padding-x',
                description: 'Lg padding x of root'
            },
            {
                name: 'treeselect.root.lg.paddingY',
                token: 'treeselect.lg.padding.y',
                variable: '--p-treeselect-lg-padding-y',
                description: 'Lg padding y of root'
            },
            {
                name: 'treeselect.dropdown.width',
                token: 'treeselect.dropdown.width',
                variable: '--p-treeselect-dropdown-width',
                description: 'Width of dropdown'
            },
            {
                name: 'treeselect.dropdown.color',
                token: 'treeselect.dropdown.color',
                variable: '--p-treeselect-dropdown-color',
                description: 'Color of dropdown'
            },
            {
                name: 'treeselect.overlay.background',
                token: 'treeselect.overlay.background',
                variable: '--p-treeselect-overlay-background',
                description: 'Background of overlay'
            },
            {
                name: 'treeselect.overlay.borderColor',
                token: 'treeselect.overlay.border.color',
                variable: '--p-treeselect-overlay-border-color',
                description: 'Border color of overlay'
            },
            {
                name: 'treeselect.overlay.borderRadius',
                token: 'treeselect.overlay.border.radius',
                variable: '--p-treeselect-overlay-border-radius',
                description: 'Border radius of overlay'
            },
            {
                name: 'treeselect.overlay.color',
                token: 'treeselect.overlay.color',
                variable: '--p-treeselect-overlay-color',
                description: 'Color of overlay'
            },
            {
                name: 'treeselect.overlay.shadow',
                token: 'treeselect.overlay.shadow',
                variable: '--p-treeselect-overlay-shadow',
                description: 'Shadow of overlay'
            },
            {
                name: 'treeselect.tree.padding',
                token: 'treeselect.tree.padding',
                variable: '--p-treeselect-tree-padding',
                description: 'Padding of tree'
            },
            {
                name: 'treeselect.clearIcon.color',
                token: 'treeselect.clear.icon.color',
                variable: '--p-treeselect-clear-icon-color',
                description: 'Color of clear icon'
            },
            {
                name: 'treeselect.emptyMessage.padding',
                token: 'treeselect.empty.message.padding',
                variable: '--p-treeselect-empty-message-padding',
                description: 'Padding of empty message'
            },
            {
                name: 'treeselect.chip.borderRadius',
                token: 'treeselect.chip.border.radius',
                variable: '--p-treeselect-chip-border-radius',
                description: 'Border radius of chip'
            }
        ]
    },
    treetable: {
        description: 'TreeTable Design Tokens',
        tokens: [
            {
                name: 'treetable.root.transitionDuration',
                token: 'treetable.transition.duration',
                variable: '--p-treetable-transition-duration',
                description: 'Transition duration of root'
            },
            {
                name: 'treetable.root.borderColor',
                token: 'treetable.border.color',
                variable: '--p-treetable-border-color',
                description: 'Border color of root'
            },
            {
                name: 'treetable.header.background',
                token: 'treetable.header.background',
                variable: '--p-treetable-header-background',
                description: 'Background of header'
            },
            {
                name: 'treetable.header.borderColor',
                token: 'treetable.header.border.color',
                variable: '--p-treetable-header-border-color',
                description: 'Border color of header'
            },
            {
                name: 'treetable.header.color',
                token: 'treetable.header.color',
                variable: '--p-treetable-header-color',
                description: 'Color of header'
            },
            {
                name: 'treetable.header.borderWidth',
                token: 'treetable.header.border.width',
                variable: '--p-treetable-header-border-width',
                description: 'Border width of header'
            },
            {
                name: 'treetable.header.padding',
                token: 'treetable.header.padding',
                variable: '--p-treetable-header-padding',
                description: 'Padding of header'
            },
            {
                name: 'treetable.headerCell.background',
                token: 'treetable.header.cell.background',
                variable: '--p-treetable-header-cell-background',
                description: 'Background of header cell'
            },
            {
                name: 'treetable.headerCell.hoverBackground',
                token: 'treetable.header.cell.hover.background',
                variable: '--p-treetable-header-cell-hover-background',
                description: 'Hover background of header cell'
            },
            {
                name: 'treetable.headerCell.selectedBackground',
                token: 'treetable.header.cell.selected.background',
                variable: '--p-treetable-header-cell-selected-background',
                description: 'Selected background of header cell'
            },
            {
                name: 'treetable.headerCell.borderColor',
                token: 'treetable.header.cell.border.color',
                variable: '--p-treetable-header-cell-border-color',
                description: 'Border color of header cell'
            },
            {
                name: 'treetable.headerCell.color',
                token: 'treetable.header.cell.color',
                variable: '--p-treetable-header-cell-color',
                description: 'Color of header cell'
            },
            {
                name: 'treetable.headerCell.hoverColor',
                token: 'treetable.header.cell.hover.color',
                variable: '--p-treetable-header-cell-hover-color',
                description: 'Hover color of header cell'
            },
            {
                name: 'treetable.headerCell.selectedColor',
                token: 'treetable.header.cell.selected.color',
                variable: '--p-treetable-header-cell-selected-color',
                description: 'Selected color of header cell'
            },
            {
                name: 'treetable.headerCell.gap',
                token: 'treetable.header.cell.gap',
                variable: '--p-treetable-header-cell-gap',
                description: 'Gap of header cell'
            },
            {
                name: 'treetable.headerCell.padding',
                token: 'treetable.header.cell.padding',
                variable: '--p-treetable-header-cell-padding',
                description: 'Padding of header cell'
            },
            {
                name: 'treetable.headerCell.focusRing.width',
                token: 'treetable.header.cell.focus.ring.width',
                variable: '--p-treetable-header-cell-focus-ring-width',
                description: 'Focus ring width of header cell'
            },
            {
                name: 'treetable.headerCell.focusRing.style',
                token: 'treetable.header.cell.focus.ring.style',
                variable: '--p-treetable-header-cell-focus-ring-style',
                description: 'Focus ring style of header cell'
            },
            {
                name: 'treetable.headerCell.focusRing.color',
                token: 'treetable.header.cell.focus.ring.color',
                variable: '--p-treetable-header-cell-focus-ring-color',
                description: 'Focus ring color of header cell'
            },
            {
                name: 'treetable.headerCell.focusRing.offset',
                token: 'treetable.header.cell.focus.ring.offset',
                variable: '--p-treetable-header-cell-focus-ring-offset',
                description: 'Focus ring offset of header cell'
            },
            {
                name: 'treetable.headerCell.focusRing.shadow',
                token: 'treetable.header.cell.focus.ring.shadow',
                variable: '--p-treetable-header-cell-focus-ring-shadow',
                description: 'Focus ring shadow of header cell'
            },
            {
                name: 'treetable.columnTitle.fontWeight',
                token: 'treetable.column.title.font.weight',
                variable: '--p-treetable-column-title-font-weight',
                description: 'Font weight of column title'
            },
            {
                name: 'treetable.row.background',
                token: 'treetable.row.background',
                variable: '--p-treetable-row-background',
                description: 'Background of row'
            },
            {
                name: 'treetable.row.hoverBackground',
                token: 'treetable.row.hover.background',
                variable: '--p-treetable-row-hover-background',
                description: 'Hover background of row'
            },
            {
                name: 'treetable.row.selectedBackground',
                token: 'treetable.row.selected.background',
                variable: '--p-treetable-row-selected-background',
                description: 'Selected background of row'
            },
            {
                name: 'treetable.row.color',
                token: 'treetable.row.color',
                variable: '--p-treetable-row-color',
                description: 'Color of row'
            },
            {
                name: 'treetable.row.hoverColor',
                token: 'treetable.row.hover.color',
                variable: '--p-treetable-row-hover-color',
                description: 'Hover color of row'
            },
            {
                name: 'treetable.row.selectedColor',
                token: 'treetable.row.selected.color',
                variable: '--p-treetable-row-selected-color',
                description: 'Selected color of row'
            },
            {
                name: 'treetable.row.focusRing.width',
                token: 'treetable.row.focus.ring.width',
                variable: '--p-treetable-row-focus-ring-width',
                description: 'Focus ring width of row'
            },
            {
                name: 'treetable.row.focusRing.style',
                token: 'treetable.row.focus.ring.style',
                variable: '--p-treetable-row-focus-ring-style',
                description: 'Focus ring style of row'
            },
            {
                name: 'treetable.row.focusRing.color',
                token: 'treetable.row.focus.ring.color',
                variable: '--p-treetable-row-focus-ring-color',
                description: 'Focus ring color of row'
            },
            {
                name: 'treetable.row.focusRing.offset',
                token: 'treetable.row.focus.ring.offset',
                variable: '--p-treetable-row-focus-ring-offset',
                description: 'Focus ring offset of row'
            },
            {
                name: 'treetable.row.focusRing.shadow',
                token: 'treetable.row.focus.ring.shadow',
                variable: '--p-treetable-row-focus-ring-shadow',
                description: 'Focus ring shadow of row'
            },
            {
                name: 'treetable.bodyCell.borderColor',
                token: 'treetable.body.cell.border.color',
                variable: '--p-treetable-body-cell-border-color',
                description: 'Border color of body cell'
            },
            {
                name: 'treetable.bodyCell.padding',
                token: 'treetable.body.cell.padding',
                variable: '--p-treetable-body-cell-padding',
                description: 'Padding of body cell'
            },
            {
                name: 'treetable.bodyCell.gap',
                token: 'treetable.body.cell.gap',
                variable: '--p-treetable-body-cell-gap',
                description: 'Gap of body cell'
            },
            {
                name: 'treetable.bodyCell.selectedBorderColor',
                token: 'treetable.body.cell.selected.border.color',
                variable: '--p-treetable-body-cell-selected-border-color',
                description: 'Selected border color of body cell'
            },
            {
                name: 'treetable.footerCell.background',
                token: 'treetable.footer.cell.background',
                variable: '--p-treetable-footer-cell-background',
                description: 'Background of footer cell'
            },
            {
                name: 'treetable.footerCell.borderColor',
                token: 'treetable.footer.cell.border.color',
                variable: '--p-treetable-footer-cell-border-color',
                description: 'Border color of footer cell'
            },
            {
                name: 'treetable.footerCell.color',
                token: 'treetable.footer.cell.color',
                variable: '--p-treetable-footer-cell-color',
                description: 'Color of footer cell'
            },
            {
                name: 'treetable.footerCell.padding',
                token: 'treetable.footer.cell.padding',
                variable: '--p-treetable-footer-cell-padding',
                description: 'Padding of footer cell'
            },
            {
                name: 'treetable.columnFooter.fontWeight',
                token: 'treetable.column.footer.font.weight',
                variable: '--p-treetable-column-footer-font-weight',
                description: 'Font weight of column footer'
            },
            {
                name: 'treetable.footer.background',
                token: 'treetable.footer.background',
                variable: '--p-treetable-footer-background',
                description: 'Background of footer'
            },
            {
                name: 'treetable.footer.borderColor',
                token: 'treetable.footer.border.color',
                variable: '--p-treetable-footer-border-color',
                description: 'Border color of footer'
            },
            {
                name: 'treetable.footer.color',
                token: 'treetable.footer.color',
                variable: '--p-treetable-footer-color',
                description: 'Color of footer'
            },
            {
                name: 'treetable.footer.borderWidth',
                token: 'treetable.footer.border.width',
                variable: '--p-treetable-footer-border-width',
                description: 'Border width of footer'
            },
            {
                name: 'treetable.footer.padding',
                token: 'treetable.footer.padding',
                variable: '--p-treetable-footer-padding',
                description: 'Padding of footer'
            },
            {
                name: 'treetable.columnResizer.width',
                token: 'treetable.column.resizer.width',
                variable: '--p-treetable-column-resizer-width',
                description: 'Width of column resizer'
            },
            {
                name: 'treetable.resizeIndicator.width',
                token: 'treetable.resize.indicator.width',
                variable: '--p-treetable-resize-indicator-width',
                description: 'Width of resize indicator'
            },
            {
                name: 'treetable.resizeIndicator.color',
                token: 'treetable.resize.indicator.color',
                variable: '--p-treetable-resize-indicator-color',
                description: 'Color of resize indicator'
            },
            {
                name: 'treetable.sortIcon.color',
                token: 'treetable.sort.icon.color',
                variable: '--p-treetable-sort-icon-color',
                description: 'Color of sort icon'
            },
            {
                name: 'treetable.sortIcon.hoverColor',
                token: 'treetable.sort.icon.hover.color',
                variable: '--p-treetable-sort-icon-hover-color',
                description: 'Hover color of sort icon'
            },
            {
                name: 'treetable.sortIcon.size',
                token: 'treetable.sort.icon.size',
                variable: '--p-treetable-sort-icon-size',
                description: 'Size of sort icon'
            },
            {
                name: 'treetable.loadingIcon.size',
                token: 'treetable.loading.icon.size',
                variable: '--p-treetable-loading-icon-size',
                description: 'Size of loading icon'
            },
            {
                name: 'treetable.nodeToggleButton.hoverBackground',
                token: 'treetable.node.toggle.button.hover.background',
                variable: '--p-treetable-node-toggle-button-hover-background',
                description: 'Hover background of node toggle button'
            },
            {
                name: 'treetable.nodeToggleButton.selectedHoverBackground',
                token: 'treetable.node.toggle.button.selected.hover.background',
                variable: '--p-treetable-node-toggle-button-selected-hover-background',
                description: 'Selected hover background of node toggle button'
            },
            {
                name: 'treetable.nodeToggleButton.color',
                token: 'treetable.node.toggle.button.color',
                variable: '--p-treetable-node-toggle-button-color',
                description: 'Color of node toggle button'
            },
            {
                name: 'treetable.nodeToggleButton.hoverColor',
                token: 'treetable.node.toggle.button.hover.color',
                variable: '--p-treetable-node-toggle-button-hover-color',
                description: 'Hover color of node toggle button'
            },
            {
                name: 'treetable.nodeToggleButton.selectedHoverColor',
                token: 'treetable.node.toggle.button.selected.hover.color',
                variable: '--p-treetable-node-toggle-button-selected-hover-color',
                description: 'Selected hover color of node toggle button'
            },
            {
                name: 'treetable.nodeToggleButton.size',
                token: 'treetable.node.toggle.button.size',
                variable: '--p-treetable-node-toggle-button-size',
                description: 'Size of node toggle button'
            },
            {
                name: 'treetable.nodeToggleButton.borderRadius',
                token: 'treetable.node.toggle.button.border.radius',
                variable: '--p-treetable-node-toggle-button-border-radius',
                description: 'Border radius of node toggle button'
            },
            {
                name: 'treetable.nodeToggleButton.focusRing.width',
                token: 'treetable.node.toggle.button.focus.ring.width',
                variable: '--p-treetable-node-toggle-button-focus-ring-width',
                description: 'Focus ring width of node toggle button'
            },
            {
                name: 'treetable.nodeToggleButton.focusRing.style',
                token: 'treetable.node.toggle.button.focus.ring.style',
                variable: '--p-treetable-node-toggle-button-focus-ring-style',
                description: 'Focus ring style of node toggle button'
            },
            {
                name: 'treetable.nodeToggleButton.focusRing.color',
                token: 'treetable.node.toggle.button.focus.ring.color',
                variable: '--p-treetable-node-toggle-button-focus-ring-color',
                description: 'Focus ring color of node toggle button'
            },
            {
                name: 'treetable.nodeToggleButton.focusRing.offset',
                token: 'treetable.node.toggle.button.focus.ring.offset',
                variable: '--p-treetable-node-toggle-button-focus-ring-offset',
                description: 'Focus ring offset of node toggle button'
            },
            {
                name: 'treetable.nodeToggleButton.focusRing.shadow',
                token: 'treetable.node.toggle.button.focus.ring.shadow',
                variable: '--p-treetable-node-toggle-button-focus-ring-shadow',
                description: 'Focus ring shadow of node toggle button'
            },
            {
                name: 'treetable.paginatorTop.borderColor',
                token: 'treetable.paginator.top.border.color',
                variable: '--p-treetable-paginator-top-border-color',
                description: 'Border color of paginator top'
            },
            {
                name: 'treetable.paginatorTop.borderWidth',
                token: 'treetable.paginator.top.border.width',
                variable: '--p-treetable-paginator-top-border-width',
                description: 'Border width of paginator top'
            },
            {
                name: 'treetable.paginatorBottom.borderColor',
                token: 'treetable.paginator.bottom.border.color',
                variable: '--p-treetable-paginator-bottom-border-color',
                description: 'Border color of paginator bottom'
            },
            {
                name: 'treetable.paginatorBottom.borderWidth',
                token: 'treetable.paginator.bottom.border.width',
                variable: '--p-treetable-paginator-bottom-border-width',
                description: 'Border width of paginator bottom'
            }
        ]
    },
    virtualscroller: {
        description: 'VirtualScroller Design Tokens',
        tokens: [
            {
                name: 'virtualscroller.loader.mask.background',
                token: 'virtualscroller.loader.mask.background',
                variable: '--p-virtualscroller-loader-mask-background',
                description: 'Background of loader mask'
            },
            {
                name: 'virtualscroller.loader.mask.color',
                token: 'virtualscroller.loader.mask.color',
                variable: '--p-virtualscroller-loader-mask-color',
                description: 'Color of loader mask'
            },
            {
                name: 'virtualscroller.loader.icon.size',
                token: 'virtualscroller.loader.icon.size',
                variable: '--p-virtualscroller-loader-icon-size',
                description: 'Size of the loader icon'
            }
        ]
    }
} as Tokens;
